/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type AcdCallInput = {
  contactId?: string | null | undefined;
  status?: AcdCallStatus | null | undefined;
};

export type AcdCallResult = "CONNECTED" | "DECLINED" | "NONE" | "REDIRECTED";

export type AcdCallStatus = "CANCELED" | "DONE" | "NEW";

export type ApiKeyInput = {
  customerId?: string | null | undefined;
  name?: string | null | undefined;
  userId?: string | null | undefined;
  validUntil?: string | null | undefined;
};

export type ApiKeysSortField =
  "INSERTED_AT" | "NAME" | "REVOKED_AT" | "VALID_UNTIL";

export type Applicable = "NO" | "NOT_APPLICABLE" | "YES";

export type AppointmentStatsFilters = {
  start: string;
  stop: string;
};

export type ArchiveTodoInput = {
  attrs?: Record<string, unknown> | null | undefined;
  doneText?: string | null | undefined;
  fupTodo?: TodoInput | null | undefined;
};

export type CallDirectionOption = "INBOUND" | "OUTBOUND";

export type CallHistoriesListFilters = {
  allDone?: boolean | null | undefined;
  callDirection?: CallDirectionOption | null | undefined;
  connected?: boolean | null | undefined;
  direction?: SortDirectionOption;
  htype?: HistoryType | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  order?: HistorySortColumn;
  search?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  userId?: string | null | undefined;
};

export type CallResultInput = {
  name?: string | null | undefined;
};

export type ChangeRequestChildInput = {
  birthdate?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
};

export type ChangeRequestInput = {
  additionalJobs?: string | null | undefined;
  address?: string | null | undefined;
  bic?: string | null | undefined;
  birthdate?: string | null | undefined;
  childTaxAllowance?: number | null | undefined;
  children?: Array<ChangeRequestChildInput> | null | undefined;
  city?: string | null | undefined;
  civilStatus?: EmployeeCivilStatus | null | undefined;
  countryOfBirth?: string | null | undefined;
  denomination?: string | null | undefined;
  disability?: boolean | null | undefined;
  disabilityLevel?: number | null | undefined;
  email?: string | null | undefined;
  emergencyContactName?: string | null | undefined;
  emergencyContactPhone?: string | null | undefined;
  employeeId?: string | null | undefined;
  firstname?: string | null | undefined;
  gender?: EmployeeGender | null | undefined;
  healthInsurance?: string | null | undefined;
  iban?: string | null | undefined;
  landline?: string | null | undefined;
  languagesFluent?: Array<string> | null | undefined;
  languagesNative?: Array<string> | null | undefined;
  lastname?: string | null | undefined;
  nationality?: string | null | undefined;
  phone?: string | null | undefined;
  placeOfBirth?: string | null | undefined;
  requestComment?: string | null | undefined;
  returnComment?: string | null | undefined;
  salutation?: string | null | undefined;
  socialSecurityNumber?: string | null | undefined;
  status?: ChangeRequestStatus | null | undefined;
  taxId?: string | null | undefined;
  taxLevel?: number | null | undefined;
  zip?: string | null | undefined;
};

export type ChangeRequestListFilters = {
  employeeId?: string | null | undefined;
  ends?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  starts?: string | null | undefined;
  states?: Array<ChangeRequestStatus> | null | undefined;
  userId?: string | null | undefined;
};

export type ChangeRequestStatus =
  | "APPROVED"
  | "AWAITING_CONFIRMATION"
  | "NEW"
  | "REJECTED"
  | "REQUEST"
  | "RETURNED";

export type CivilStatus = "DIVORCED" | "MARRIED" | "UNMARRIED" | "WIDOWED";

export type CoachingInput = {
  attrs?: Record<string, unknown> | null | undefined;
  description?: string | null | undefined;
  employeeInput?: string | null | undefined;
  nextAppointment?: string | null | undefined;
  relevantCustomerId?: string | null | undefined;
  relevantProjectId?: string | null | undefined;
  signed?: boolean | null | undefined;
  userId?: string | null | undefined;
};

export type CommunicationFilters = {
  identifier?: string | null | undefined;
  limit?: string;
  offset?: string | null | undefined;
  type?: string | null | undefined;
};

export type CommunicationInput = {
  identifier?: string | null | undefined;
  lists?: Array<string> | null | undefined;
  teams?: Array<string> | null | undefined;
  type?: string | null | undefined;
};

export type CommunicationListFilters = {
  limit?: string;
  offset?: string | null | undefined;
};

export type CommunicationListInput = {
  addresses?: Array<string> | null | undefined;
  name?: string | null | undefined;
};

export type CompanyNewsInput = {
  content?: string | null | undefined;
  image?: File | null | undefined;
  validUntil?: string | null | undefined;
};

export type CompanyNewsListFilters = {
  limit?: string;
  offset?: string | null | undefined;
};

export type ContactAddfieldInput = {
  automatic?: boolean | null | undefined;
  id?: string | null | undefined;
  identifier?: string | null | undefined;
  name?: string | null | undefined;
  required?: boolean | null | undefined;
};

export type ContactAddfieldListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type ContactAddressInput = {
  address?: string | null | undefined;
  atype?: ContactAddressType | null | undefined;
  city?: string | null | undefined;
  cityPart?: string | null | undefined;
  country?: string | null | undefined;
  description?: string | null | undefined;
  id?: string | null | undefined;
  zip?: string | null | undefined;
};

export type ContactAddressType =
  "BILLING" | "DELIVERY" | "OTHER" | "PRIMARY" | "PRIVATE" | "WORK";

export type ContactAttachmentInput = {
  description?: string | null | undefined;
  file?: File | null | undefined;
};

export type ContactBatchAction = "DELETE" | "UPDATE";

export type ContactBatchInput = {
  attrs?: Record<string, unknown> | null | undefined;
  birthdate?: string | null | undefined;
  civilStatus?: CivilStatus | null | undefined;
  companyName?: string | null | undefined;
  ctype?: ContactType | null | undefined;
  firstname?: string | null | undefined;
  isCompany?: boolean | null | undefined;
  lastname?: string | null | undefined;
  ownerId?: string | null | undefined;
  placeOfBirth?: string | null | undefined;
  position?: string | null | undefined;
  salutation?: string | null | undefined;
  statusId?: string | null | undefined;
};

export type ContactGroupInput = {
  attrs?: Record<string, unknown> | null | undefined;
  contacts?: Array<string> | null | undefined;
  gtype?: ContactGroupType | null | undefined;
  name?: string | null | undefined;
};

export type ContactGroupType = "DYNAMIC" | "STATIC";

export type ContactImportConfig = {
  args: Record<string, unknown>;
  checkForDuplicates: boolean;
  duplicateHandling: ImportDuplicateHandling;
  fields: Array<ContactsImportJobField | null | undefined>;
  groupName: string;
  hasHeader: boolean;
  idFields: Array<number>;
  ignoreErrors: boolean;
  separator: string;
};

export type ContactInfoInput = {
  description?: string | null | undefined;
  id?: string | null | undefined;
  itype?: ContactInfoType | null | undefined;
  value?: string | null | undefined;
};

export type ContactInfoType =
  | "EMAIL"
  | "EMERGENCY_CONTACT"
  | "FAX"
  | "INVOICE_EMAIL"
  | "MOBILE_PHONE"
  | "OTHER"
  | "PRIVATE_EMAIL"
  | "PRIVATE_PHONE"
  | "WEBSITE"
  | "WORK_EMAIL"
  | "WORK_PHONE";

export type ContactInput = {
  addresses?: Array<ContactAddressInput> | null | undefined;
  attrs?: Record<string, unknown> | null | undefined;
  birthdate?: string | null | undefined;
  civilStatus?: CivilStatus | null | undefined;
  companyName?: string | null | undefined;
  ctype?: ContactType | null | undefined;
  firstname?: string | null | undefined;
  id?: string | null | undefined;
  infos?: Array<ContactInfoInput> | null | undefined;
  isCompany?: boolean | null | undefined;
  lastname?: string | null | undefined;
  parentId?: string | null | undefined;
  placeOfBirth?: string | null | undefined;
  position?: string | null | undefined;
  salutation?: string | null | undefined;
  statusId?: string | null | undefined;
  subContacts?: Array<ContactInput> | null | undefined;
};

export type ContactPipelineFilters = {
  filterAttrs?: Record<string, unknown> | null | undefined;
};

export type ContactStatesFilterDate = "INSERTED_AT" | "UPDATED_AT";

export type ContactStatesListFilters = {
  allowedAfterCall?: boolean | null | undefined;
  enforceFollowup?: boolean | null | undefined;
  followupEventTypeId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type ContactStatesStats = {
  contactGroupId?: string | null | undefined;
  filterAttrs?: Record<string, unknown> | null | undefined;
  filterDate?: ContactStatesFilterDate | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  teamId?: string | null | undefined;
};

export type ContactStatusInput = {
  allowedAfterCall?: boolean | null | undefined;
  defaultFollowupDays?: number | null | undefined;
  defaultFollowupSubject?: string | null | undefined;
  enforceFollowup?: boolean | null | undefined;
  followupEventTypeId?: string | null | undefined;
  name?: string | null | undefined;
  position?: number | null | undefined;
};

export type ContactStatusUpdateInput = {
  afterDays?: number | null | undefined;
  fromId?: string | null | undefined;
  toId?: string | null | undefined;
};

export type ContactStatusUpdateListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type ContactType = "MAIN" | "SUB" | "USER";

export type ContactsAddfieldFilters = {
  start?: string | null | undefined;
  stop?: string | null | undefined;
  teamId?: string | null | undefined;
};

export type ContactsAttachmentsListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type ContactsEventFilter = "WITHOUT_EVENT" | "WITH_EVENT";

export type ContactsExportJobField = {
  addfieldId?: string | null | undefined;
  field: ContactsExportJobFieldType;
};

export type ContactsExportJobFieldType =
  | "ADDFIELD"
  | "ADDRESS"
  | "BIRTHDATE"
  | "CITY"
  | "CITY_PART"
  | "CIVIL_STATUS"
  | "COMPANY_NAME"
  | "COUNTRY"
  | "CREATOR_ID"
  | "EDITOR_ID"
  | "EMAIL"
  | "EMERGENCY_CONTACT"
  | "FAX"
  | "FIRSTNAME"
  | "ID"
  | "INSERTED_AT"
  | "IS_COMPANY"
  | "LASTNAME"
  | "LAST_CONTACT_ID"
  | "MOBILE_PHONE"
  | "NEXT_FOLLOWUP_ID"
  | "OTHER"
  | "OWNER_ID"
  | "PLACE_OF_BIRTH"
  | "POSITION"
  | "PRIVATE_EMAIL"
  | "PRIVATE_PHONE"
  | "SALUTATION"
  | "STATUS_ID"
  | "UPDATED_AT"
  | "WEBSITE"
  | "WORK_PHONE"
  | "ZIP";

export type ContactsImportJobField = {
  addfield?: string | null | undefined;
  field: ContactsImportJobFieldType;
};

export type ContactsImportJobFieldType =
  | "ADDFIELD"
  | "ADDRESS"
  | "BIRTHDATE"
  | "CITY"
  | "CITY_PART"
  | "COMPANY_NAME"
  | "COUNTRY"
  | "EMAIL"
  | "EMERGENCY_CONTACT"
  | "FAX"
  | "FIRSTNAME"
  | "LASTNAME"
  | "MOBILE_PHONE"
  | "OTHER"
  | "PRIVATE_EMAIL"
  | "PRIVATE_PHONE"
  | "SALUTATION"
  | "STATUS_ID"
  | "WEBSITE"
  | "WORK_PHONE"
  | "ZIP";

export type ContactsListFilters = {
  ctype?: ContactType | null | undefined;
  direction?: SortDirectionOption;
  eventStatus?: ContactsEventFilter | null | undefined;
  filterAttrs?: Record<string, unknown> | null | undefined;
  groupId?: string | null | undefined;
  ids?: Array<string> | null | undefined;
  ignoreProject?: boolean;
  insertedAtEnd?: string | null | undefined;
  insertedAtStart?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  order?: ContactsOrderColumn;
  orderAddfield?: string | null | undefined;
  orderAttr?: string | null | undefined;
  ownerId?: string | null | undefined;
  parentId?: string | null | undefined;
  predefinedFilters?: Array<PredefinedFilter> | null | undefined;
  search?: string | null | undefined;
  start?: string | null | undefined;
  statusId?: string | null | undefined;
  stop?: string | null | undefined;
};

export type ContactsOrderColumn =
  | "ADDFIELD"
  | "ATTR"
  | "INSERTED_AT"
  | "LAST_CONTACT"
  | "NAME"
  | "NEXT_FOLLOWUP"
  | "PRIMARY_ADDRESS"
  | "STATUS"
  | "UPDATED_AT";

export type ContactsPrioListFilters = {
  args?: Record<string, unknown> | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type ContractAdaption =
  | "EXTENSION"
  | "HOLIDAYS"
  | "HOURLY_WAGE"
  | "HOURS"
  | "LIMITATION_REMOVAL"
  | "MONTHLY_WAGE"
  | "POSITION"
  | "PROBATION";

export type ContractAdaptionInput = {
  adaptions: Array<ContractAdaption>;
  contractDate: string;
  endDate?: string | null | undefined;
  holidays?: number | null | undefined;
  hourlyWage?: number | null | undefined;
  hours?: number | null | undefined;
  monthlyWage?: number | null | undefined;
  position?: string | null | undefined;
  signatureBy: string;
  validFrom: string;
};

export type ContractInput = {
  ends?: string | null | undefined;
  holidays?: number | null | undefined;
  hourlyWage?: number | null | undefined;
  hours?: number | null | undefined;
  monthlyWage?: number | null | undefined;
  nullifyEnds?: boolean | null | undefined;
  starts?: string | null | undefined;
  taxBracket?: number | null | undefined;
  userId?: string | null | undefined;
};

export type ContractListOptions = {
  date?: string | null | undefined;
  ends?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  starts?: string | null | undefined;
  userId?: string | null | undefined;
};

export type CountCoachingsFilters = {
  creatorId?: string | null | undefined;
  relevantCustomerId?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  userId?: string | null | undefined;
};

export type CountFeastdaysFilters = {
  starts?: string | null | undefined;
  stops?: string | null | undefined;
};

export type CountHotseatRequestsFilters = {
  category?: string | null | undefined;
  creatorId?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  subCategory?: string | null | undefined;
  userId?: string | null | undefined;
};

export type CountKnowledgebaseQuestionsFilters = {
  archived?: boolean | null | undefined;
  attributeFilter?: Record<string, unknown> | null | undefined;
  term?: string | null | undefined;
};

export type CountLogFilters = {
  action?: string | null | undefined;
  logTypes?: Array<LogType> | null | undefined;
  relation?: string | null | undefined;
  relid?: string | null | undefined;
  search?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  userId?: string | null | undefined;
};

export type CountMessagesFilters = {
  customerId?: string | null | undefined;
  features?: Array<string> | null | undefined;
  filterAttrs?: Record<string, unknown> | null | undefined;
  projectId?: string | null | undefined;
  search?: string | null | undefined;
  seen?: boolean | null | undefined;
  senderId?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
};

export type CountProjectsFilters = {
  active?: boolean | null | undefined;
  search?: string | null | undefined;
};

export type CountPunchlistEntriesFilters = {
  category?: Array<string> | null | undefined;
  projectId?: string | null | undefined;
  search?: string | null | undefined;
  starts?: string | null | undefined;
  status?: Array<PunchlistEntryStatus> | null | undefined;
  stops?: string | null | undefined;
  userId?: string | null | undefined;
};

export type CountWorkerJobsFilters = {
  finishedAtEnds?: string | null | undefined;
  finishedAtStarts?: string | null | undefined;
  insertedAtEnds?: string | null | undefined;
  insertedAtStarts?: string | null | undefined;
  kind?: string | null | undefined;
  queue?: string | null | undefined;
  runAtEnds?: string | null | undefined;
  runAtStarts?: string | null | undefined;
  startedAtEnds?: string | null | undefined;
  startedAtStarts?: string | null | undefined;
  status?: JobStatus | null | undefined;
};

export type CustomerFeedbackAnnotationInput = {
  details: string;
};

export type CustomerFeedbackClassifyInput = {
  attrs?: Record<string, unknown> | null | undefined;
  comment?: string | null | undefined;
  description?: string | null | undefined;
  state: CustomerFeedbackState;
  topicId?: string | null | undefined;
  userId?: string | null | undefined;
};

export type CustomerFeedbackListFilters = {
  filterAttrs?: Record<string, unknown> | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  predefinedFilters?: Array<PredefinedFilter> | null | undefined;
  selfAssessmentStates?: Array<CustomerFeedbackState> | null | undefined;
  start?: string | null | undefined;
  states?: Array<CustomerFeedbackState> | null | undefined;
  stop?: string | null | undefined;
  topicIds?: Array<string> | null | undefined;
  userIds?: Array<string> | null | undefined;
};

export type CustomerFeedbackSelfClassifyInput = {
  attrs?: Record<string, unknown> | null | undefined;
  state: CustomerFeedbackState;
};

export type CustomerFeedbackState =
  "JUSTIFIED" | "NONE" | "UNCLEAR" | "UNJUSTIFIED";

export type CustomerFeedbackTopicInput = {
  active?: boolean | null | undefined;
  color?: string | null | undefined;
  name?: string | null | undefined;
};

export type CustomerFeedbackTopicsListFilters = {
  active?: boolean | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type CustomerInput = {
  active?: boolean | null | undefined;
  attrs?: Record<string, unknown> | null | undefined;
  customerAdministrators?: Array<string> | null | undefined;
  customerUsers?: Array<string> | null | undefined;
  defaultProjectId?: string | null | undefined;
  identifier?: string | null | undefined;
  logo?: File | null | undefined;
  name?: string | null | undefined;
};

export type CustomersListFilter = {
  active?: boolean | null | undefined;
  feature?: string | null | undefined;
  forUserId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type DashboardStatsFilters = {
  args?: Record<string, unknown> | null | undefined;
  contactGroupId?: string | null | undefined;
  start: string;
  stop: string;
};

export type DataPoolStatsFilters = {
  filterAttrs?: Record<string, unknown> | null | undefined;
};

export type DigitalSignatureEnvelopeInput = {
  name?: string | null | undefined;
  status?: EnvelopeStatus | null | undefined;
};

export type DigitalSignatureEnvelopeListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  status?: EnvelopeStatus | null | undefined;
};

export type DigitalSignatureFieldInput = {
  digitalSignatureFileId?: string | null | undefined;
  email?: string | null | undefined;
  height?: number | null | undefined;
  id?: string | null | undefined;
  pageNo?: number | null | undefined;
  width?: number | null | undefined;
  x?: number | null | undefined;
  y?: number | null | undefined;
};

export type DigitalSignatureFileInput = {
  file?: File | null | undefined;
  filename?: string | null | undefined;
  id?: string | null | undefined;
};

export type DocumentAttachmentInput = {
  file: File;
};

export type DocumentInput = {
  keywords?: Array<string> | null | undefined;
  mdContent?: string | null | undefined;
  relevantProjectId?: string | null | undefined;
  signatureDue?: number | null | undefined;
  signatureType?: SignatureType | null | undefined;
  subject?: string | null | undefined;
  type?: DocumentType | null | undefined;
  validFrom?: string | null | undefined;
  validUntil?: string | null | undefined;
  visible?: boolean | null | undefined;
};

export type DocumentSignatureSignatureType = "CONFIRMED" | "SEEN" | "SIGNATURE";

export type DocumentType =
  | "CUSTOMER_DOCUMENT"
  | "FAQ"
  | "INFORMATION"
  | "OCCUPATIONAL_HEALTH"
  | "OCCUPATIONAL_SAFETY"
  | "PROJECT_INFORMATION"
  | "WORKING_INSTRUCTION";

export type EmployeeChildInput = {
  birthdate?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
};

export type EmployeeCivilStatus =
  "DIVORCED" | "MARRIED" | "UNMARRIED" | "WIDOWED";

export type EmployeeCouponInput = {
  amount?: number | null | undefined;
  claimed?: boolean | null | undefined;
  month?: string | null | undefined;
  userId?: string | null | undefined;
};

export type EmployeeCouponsCountOptions = {
  month?: string | null | undefined;
  search?: string | null | undefined;
  userId?: string | null | undefined;
};

export type EmployeeCouponsListOptions = {
  limit?: string | null | undefined;
  month?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
  userId?: string | null | undefined;
};

export type EmployeeDeletedFilter = "ALL" | "DELETED" | "UNDELETED";

export type EmployeeGender = "DIVERSE" | "FEMALE" | "MALE";

export type EmployeeInput = {
  active?: boolean | null | undefined;
  additionalJobs?: string | null | undefined;
  bic?: string | null | undefined;
  childTaxAllowance?: number | null | undefined;
  children?: Array<EmployeeChildInput> | null | undefined;
  civilStatus?: EmployeeCivilStatus | null | undefined;
  countryOfBirth?: string | null | undefined;
  cpsNumber?: string | null | undefined;
  dataProtectionTrainingCompletedAt?: string | null | undefined;
  datevEmployeeNo?: string | null | undefined;
  deleted?: boolean | null | undefined;
  denomination?: string | null | undefined;
  disability?: boolean | null | undefined;
  disabilityLevel?: number | null | undefined;
  employeeName?: string | null | undefined;
  entering?: string | null | undefined;
  gender?: EmployeeGender | null | undefined;
  headset?: string | null | undefined;
  healthInsurance?: string | null | undefined;
  iban?: string | null | undefined;
  languagesFluent?: Array<string> | null | undefined;
  languagesNative?: Array<string> | null | undefined;
  leaving?: string | null | undefined;
  levels?: Array<Level> | null | undefined;
  nationality?: string | null | undefined;
  notes?: string | null | undefined;
  placeOfBirth?: string | null | undefined;
  position?: string | null | undefined;
  probationEnding?: string | null | undefined;
  sickDaysLimit?: number | null | undefined;
  socialSecurityNumber?: string | null | undefined;
  standardBonus?: number | null | undefined;
  taxId?: string | null | undefined;
  taxLevel?: number | null | undefined;
  userId?: string | null | undefined;
};

export type EmployeePerformanceListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
  start: string;
  stop: string;
  teamId?: string | null | undefined;
};

export type EmployeePerformanceShowFilters = {
  start: string;
  stop: string;
};

export type EmployeesListFilters = {
  active?: boolean | null | undefined;
  deleted?: EmployeeDeletedFilter | null | undefined;
  entering?: string | null | undefined;
  filter?: string | null | undefined;
  leaving?: string | null | undefined;
  level?: Level | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type EmploymentRelationship =
  "FIXED_TERM" | "FIXED_TERM_PURPOSE" | "PERMANENT";

export type EnvelopeStatus = "NEW" | "PENDING" | "SIGNED";

export type EventFeedbackInput = {
  attrs?: Record<string, unknown> | null | undefined;
  details?: string | null | undefined;
  done?: boolean | null | undefined;
  eventId?: string | null | undefined;
  name?: string | null | undefined;
  ownerId?: string | null | undefined;
  tookPlace?: boolean | null | undefined;
  type?: FeedbackType | null | undefined;
};

export type EventFeedbackListFilters = {
  attrFilter?: Record<string, unknown> | null | undefined;
  creatorId?: string | null | undefined;
  done?: boolean | null | undefined;
  eventCreatorId?: string | null | undefined;
  eventId?: string | null | undefined;
  eventOwnerId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  ownerId?: string | null | undefined;
  sortBy?: EventFeedbackSortColumn | null | undefined;
  sortDir?: SortDirectionOption | null | undefined;
  teamId?: string | null | undefined;
  tookPlace?: boolean | null | undefined;
  type?: EventFeedbackType | null | undefined;
};

export type EventFeedbackSortColumn = "INSERTED_AT" | "OWNER" | "TOOK_PLACE";

export type EventFeedbackType = "FEEDBACK" | "STORNO";

export type EventInput = {
  allDay?: boolean | null | undefined;
  attrs?: Record<string, unknown> | null | undefined;
  contactId?: string | null | undefined;
  details?: string | null | undefined;
  endTime?: string | null | undefined;
  ownerId?: string | null | undefined;
  shifted?: boolean | null | undefined;
  startTime?: string | null | undefined;
  subject?: string | null | undefined;
  typeId?: string | null | undefined;
};

export type EventStatus =
  | "ACCEPTED"
  | "CLEARED"
  | "FEEDBACK_WANTED"
  | "NOT_ACCEPTED"
  | "NOT_CLEARED"
  | "NOT_STORNO"
  | "NOT_TAKEN_PLACE"
  | "SHIFTED"
  | "STORNO"
  | "TAKEN_PLACE";

export type EventTypeInput = {
  mayForeign?: boolean | null | undefined;
  name?: string | null | undefined;
  type?: EventTypeType | null | undefined;
};

export type EventTypeType =
  | "BLOCK_TIME"
  | "EVENT"
  | "FOLLOWUP"
  | "ONLINE_EVENT"
  | "PHONE_EVENT"
  | "QUALIFIED_FOLLOWUP";

export type EventTypesListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type EventsListFilters = {
  canceled?: boolean | null | undefined;
  canceledAtEnd?: string | null | undefined;
  canceledAtStart?: string | null | undefined;
  cleared?: boolean | null | undefined;
  creatorId?: string | null | undefined;
  endTime?: string | null | undefined;
  eventStatus?: EventStatus | null | undefined;
  eventType?: EventTypeType | null | undefined;
  insertedAtEnd?: string | null | undefined;
  insertedAtStart?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  ownerId?: string | null | undefined;
  sent?: boolean | null | undefined;
  shiftedAtEnd?: string | null | undefined;
  shiftedAtStart?: string | null | undefined;
  sortBy?: SortColumn | null | undefined;
  sortDir?: SortDirectionOption | null | undefined;
  startTime?: string | null | undefined;
  teamId?: string | null | undefined;
  typeId?: Array<string> | null | undefined;
  updatedAtEnd?: string | null | undefined;
  updatedAtStart?: string | null | undefined;
};

export type FeastdayInput = {
  day?: string | null | undefined;
  name?: string | null | undefined;
};

export type FeedbackType = "FEEDBACK" | "STORNO";

export type FileExchangeEntryInput = {
  comment?: string | null | undefined;
  file?: File | null | undefined;
  ownerId?: string | null | undefined;
  status?: FileExchangeStatus | null | undefined;
};

export type FileExchangeListFilters = {
  limit?: string;
  offset?: string | null | undefined;
  ownerId?: string | null | undefined;
  search?: string | null | undefined;
  status?: FileExchangeStatus | null | undefined;
};

export type FileExchangeStatus = "DONE" | "PENDING";

export type FinanceReportCorrectionInput = {
  day?: string | null | undefined;
  earnings?: string | null | undefined;
  expenses?: string | null | undefined;
  hours?: string | null | undefined;
  userId?: string | null | undefined;
  wholeMonth?: boolean | null | undefined;
};

export type FinanceReportCorrectionListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  starts?: string | null | undefined;
  stops?: string | null | undefined;
  userId?: string | null | undefined;
};

export type FinanceReportEntrySource = "DATA" | "DATEV";

export type FinanceReportListFilters = {
  customerId?: string | null | undefined;
  filter?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  source?: FinanceReportEntrySource | null | undefined;
  starts?: string | null | undefined;
  stops?: string | null | undefined;
};

export type FteGoalInput = {
  date: string;
  teamId: string;
  wantedFte: number;
};

export type GenContractInput = {
  position: string;
  signatureBy: string;
};

export type HistoriesListFilters = {
  contactId?: string | null | undefined;
  direction?: SortDirectionOption;
  eventId?: string | null | undefined;
  firstPerDay?: boolean | null | undefined;
  htype?: HistoryType | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  order?: HistorySortColumn;
  pinned?: boolean | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
};

export type HistoryAnnotationInput = {
  details?: string | null | undefined;
  done?: boolean | null | undefined;
};

export type HistoryAuditLogAction = "CREATE" | "UPDATE";

export type HistoryAuditLogFilters = {
  contactId?: string | null | undefined;
  eventId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type HistoryInput = {
  callResultId?: string | null | undefined;
  details?: string | null | undefined;
  htype?: HistoryType | null | undefined;
  meta?: Record<string, unknown> | null | undefined;
  subject?: string | null | undefined;
};

export type HistorySortColumn =
  "INSERTED_AT" | "NAME" | "PINNED" | "UPDATED_AT" | "USERNAME";

export type HistoryType =
  | "ATTACHMENT_CREATED"
  | "BILLED"
  | "CALL"
  | "CALL_INCOMING"
  | "CALL_OUTGOING"
  | "CUSTOMER_CONTACT"
  | "EMAIL_SENT"
  | "EVENT"
  | "EVENT_CANCELED"
  | "EVENT_CLEARED"
  | "EVENT_CONFIRMED"
  | "EVENT_SENT"
  | "HISTORY_CREATED"
  | "INFO"
  | "MAIL_THREAD_ASSIGNED"
  | "RECORDING"
  | "TODO_CREATED"
  | "TODO_DONE";

export type HotseatRequestFilters = {
  category?: string | null | undefined;
  creatorId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  subCategory?: string | null | undefined;
  userId?: string | null | undefined;
};

export type HotseatRequestInput = {
  attrs?: Record<string, unknown> | null | undefined;
  category?: string | null | undefined;
  url?: string | null | undefined;
  userId?: string | null | undefined;
};

export type HotseatStatsFilters = {
  start: string;
  stop: string;
};

export type HourOrderInput = {
  adminHours?: number | null | undefined;
  comment?: string | null | undefined;
  month?: string | null | undefined;
  overCapacityHours?: number | null | undefined;
  predictableHolidayHours?: number | null | undefined;
  productiveHours?: number | null | undefined;
};

export type HourOrderListFilters = {
  from?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  to?: string | null | undefined;
};

export type ImportDuplicateHandling = "IGNORE" | "MERGE";

export type IndeedStatsEntryInput = {
  spend?: number | null | undefined;
  time?: string | null | undefined;
};

export type IndeedStatsListOptions = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
};

export type InventoryHandback = {
  comment?: string | null | undefined;
  items: Array<InventoryHandbackItem>;
  userId: string;
  withHandoverProtocol: boolean;
};

export type InventoryHandbackCondition = "BROKEN" | "FINE";

export type InventoryHandbackItem = {
  condition: InventoryHandbackCondition;
  itemId: string;
};

export type InventoryHandover = {
  items: Array<string>;
  userId: string;
  withHandoverProtocol: boolean;
};

export type InventoryItemCheckFilters = {
  deploymentInfo?: InventoryItemDeploymentInfo | null | undefined;
  itemTypeId?: string | null | undefined;
  limit?: string | null | undefined;
  month?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type InventoryItemDeploymentInfo = "HOMEOFFICE" | "OFFICE" | "STOCK";

export type InventoryItemFilters = {
  attrFilter?: Record<string, unknown> | null | undefined;
  deploymentInfo?: InventoryItemDeploymentInfo | null | undefined;
  itemTypeId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  online?: boolean | null | undefined;
  osName?: string | null | undefined;
  osVersion?: string | null | undefined;
  search?: string | null | undefined;
  sortDirection?: SortDirectionOption;
  sortField?: InventoryItemSortField;
  status?: InventoryItemStatus | null | undefined;
  userId?: string | null | undefined;
};

export type InventoryItemInput = {
  attrs?: Record<string, unknown> | null | undefined;
  checkInterval?: number | null | undefined;
  deploymentInfo?: InventoryItemDeploymentInfo | null | undefined;
  itemTypeId?: string | null | undefined;
  location?: string | null | undefined;
  name?: string | null | undefined;
  needsCheck?: boolean | null | undefined;
  notes?: string | null | undefined;
  serial?: string | null | undefined;
  status?: InventoryItemStatus | null | undefined;
  userId?: string | null | undefined;
};

export type InventoryItemSortField =
  "FIRST_SEEN" | "LAST_SEEN" | "LOCATION" | "NAME";

export type InventoryItemStatus = "BROKEN" | "DISABLED" | "LOST" | "READY";

export type InventoryItemTimelineEntryInput = {
  attrs?: Record<string, unknown> | null | undefined;
  comment?: string | null | undefined;
  type?: InventoryTimelineType | null | undefined;
  userId?: string | null | undefined;
};

export type InventoryItemTimelineImportInput = {
  attrs?: Record<string, unknown> | null | undefined;
  comment?: string | null | undefined;
  inventoryItemId: string;
  type: InventoryTimelineType;
  userId?: string | null | undefined;
};

export type InventoryItemTypeFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
  type?: InventoryItemTypeType | null | undefined;
};

export type InventoryItemTypeInput = {
  attrs?: Record<string, unknown> | null | undefined;
  itemsWanted?: number | null | undefined;
  name?: string | null | undefined;
  needsCheck?: boolean | null | undefined;
  type?: InventoryItemTypeType | null | undefined;
};

export type InventoryItemTypeType =
  "HARDWARE" | "HOUSEHOLD" | "NOTEBOOK" | "SOFTWARE" | "WORKSTATION";

export type InventoryReservationFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type InventoryReservationInput = {
  done?: number | null | undefined;
  inventorySetId?: string | null | undefined;
  quantity?: number | null | undefined;
  reservedForIds?: Array<string> | null | undefined;
};

export type InventorySetFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type InventorySetInput = {
  items?: Array<InventorySetItemInput> | null | undefined;
  name?: string | null | undefined;
};

export type InventorySetItemInput = {
  inventoryItemTypeId?: string | null | undefined;
  inventorySetId?: string | null | undefined;
  quantity?: number | null | undefined;
};

export type InventoryTimelineFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
  type?: InventoryTimelineType | null | undefined;
};

export type InventoryTimelineType =
  "COMMENT" | "DGUV_CHECK" | "HANDBACK" | "HANDOVER" | "INCOMING" | "OUTGOING";

export type InvoiceInput = {
  periodEnd?: string | null | undefined;
  periodStart?: string | null | undefined;
  positions?: Array<InvoicePositionInput> | null | undefined;
  projectId?: string | null | undefined;
};

export type InvoiceListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  projectId?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
};

export type InvoicePositionInput = {
  details?: Record<string, unknown> | null | undefined;
  pos?: number | null | undefined;
};

export type JobResultsOrderBy = "INSERTED_AT" | "UPDATED_AT" | "USER";

export type JobStatus = "FAILED" | "PENDING" | "RUNNING" | "SUCCEEDED";

export type KnowledgebaseAttachmentInput = {
  file?: File | null | undefined;
};

export type KnowledgebaseNgArticleFilters = {
  articleType?: Array<KnowledgebaseNgArticleType> | null | undefined;
  categories?: Array<string> | null | undefined;
  customerId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  ownerId?: string | null | undefined;
  projectId?: string | null | undefined;
  search?: string | null | undefined;
  status?: Array<KnowledgebaseNgArticleStatus> | null | undefined;
  tags?: Array<string> | null | undefined;
};

export type KnowledgebaseNgArticleInput = {
  articleType?: KnowledgebaseNgArticleType | null | undefined;
  categoryIds?: Array<string> | null | undefined;
  changelog?: string | null | undefined;
  content?: string | null | undefined;
  customerId?: string | null | undefined;
  igorSync?: boolean | null | undefined;
  linkedArticleIds?: Array<string> | null | undefined;
  ownerId?: string | null | undefined;
  projectId?: string | null | undefined;
  status?: KnowledgebaseNgArticleStatus | null | undefined;
  tags?: Array<string> | null | undefined;
  teamId?: string | null | undefined;
  timeless?: boolean | null | undefined;
  title?: string | null | undefined;
  validFrom?: string | null | undefined;
  validUntil?: string | null | undefined;
  visibleForExternals?: boolean | null | undefined;
};

export type KnowledgebaseNgArticleStatus =
  | "DRAFT"
  | "EXPIRED"
  | "NEEDS_REVIEW"
  | "PRE_CREATE"
  | "PUBLISHED"
  | "REJECTED";

export type KnowledgebaseNgArticleType =
  "DOCUMENTATION" | "ENCYCLOPEDIA" | "TUTORIAL";

export type KnowledgebaseNgCategoryFilters = {
  articleId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  onlyLeafs?: boolean | null | undefined;
  search?: string | null | undefined;
};

export type KnowledgebaseNgCategoryInput = {
  name?: string | null | undefined;
  parentId?: string | null | undefined;
};

export type KnowledgebaseNgReviewInput = {
  articleId?: string | null | undefined;
  comment?: string | null | undefined;
  result?: KnowledgebaseNgReviewResult | null | undefined;
  reviewerId?: string | null | undefined;
};

export type KnowledgebaseNgReviewResult =
  "APPROVED" | "CHANGES_REQUESTED" | "REJECTED" | "REQUESTED";

export type KnowledgebaseQuestionInput = {
  archived?: boolean | null | undefined;
  creatorId?: number | null | undefined;
  customerId?: number | null | undefined;
  document?: Record<string, unknown> | null | undefined;
  editorId?: number | null | undefined;
  projectId?: number | null | undefined;
  search?: string | null | undefined;
};

export type KnowledgebaseQuestionSortField =
  "ID" | "INSERTED_AT" | "UPDATED_AT";

export type LateNoteInput = {
  estimatedMinutesLate?: number | null | undefined;
  eta?: string | null | undefined;
  lateReason?: string | null | undefined;
  userId?: string | null | undefined;
};

export type LateNoteListFilters = {
  ends?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  starts?: string | null | undefined;
  userId?: string | null | undefined;
};

export type Level =
  | "ADMINISTRATION"
  | "EMPLOYEE"
  | "IT"
  | "MANAGEMENT"
  | "SPECIALIST"
  | "TEAMLEAD";

export type ListAcdCallsFilters = {
  acdIds?: Array<string> | null | undefined;
  calledNo?: string | null | undefined;
  direction?: CallDirectionOption | null | undefined;
  ends?: string | null | undefined;
  initiator?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  result?: AcdCallResult | null | undefined;
  starts?: string | null | undefined;
  status?: AcdCallStatus | null | undefined;
};

export type ListApiKeysFilters = {
  customerId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  revoked?: boolean | null | undefined;
  search?: string | null | undefined;
  sortDirection?: SortDirectionOption;
  sortField?: ApiKeysSortField;
  userId?: string | null | undefined;
};

export type ListCoachingsFilters = {
  creatorId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  relevantCustomerId?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  userId?: string | null | undefined;
};

export type ListDocumentsFilters = {
  archived?: boolean | null | undefined;
  customerId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  projectId?: string | null | undefined;
  relevantProjectId?: string | null | undefined;
  search?: string | null | undefined;
  signatureMissing?: boolean | null | undefined;
  starts?: string | null | undefined;
  stops?: string | null | undefined;
  type?: DocumentType | null | undefined;
  visible?: boolean | null | undefined;
};

export type ListFeastdaysFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  starts?: string | null | undefined;
  stops?: string | null | undefined;
};

export type ListJobResultsFilters = {
  limit?: string;
  offset?: string;
  order?: SortDirectionOption | null | undefined;
  orderBy?: JobResultsOrderBy | null | undefined;
  seen?: boolean | null | undefined;
};

export type ListKnowledgebaseQuestionsFilters = {
  archived?: boolean | null | undefined;
  attributeFilter?: Record<string, unknown> | null | undefined;
  limit: string;
  offset: string;
  sortDirection?: SortDirectionOption | null | undefined;
  sortField?: KnowledgebaseQuestionSortField | null | undefined;
  term?: string | null | undefined;
};

export type ListMessagesFilters = {
  customerId?: string | null | undefined;
  features?: Array<string> | null | undefined;
  filterAttrs?: Record<string, unknown> | null | undefined;
  limit: string;
  offset: string;
  projectId?: string | null | undefined;
  search?: string | null | undefined;
  seen?: boolean | null | undefined;
  senderId?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
};

export type ListProjectAttachmentsFilters = {
  limit: string;
  offset: string;
};

export type ListProjectNewsFilters = {
  active?: boolean | null | undefined;
  limit?: string;
  offset?: string;
  order?: SortDirectionOption | null | undefined;
  orderBy?: ProjectNewsSortOptions | null | undefined;
  visible?: boolean | null | undefined;
};

export type ListProjectUploadsFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type ListProjectsFilters = {
  active?: boolean | null | undefined;
  direction?: SortDirectionOption | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  order?: ProjectSortOption | null | undefined;
  search?: string | null | undefined;
  userId?: string | null | undefined;
};

export type ListPunchlistEntriesFilters = {
  category?: Array<string> | null | undefined;
  limit: string;
  offset: string;
  projectId?: string | null | undefined;
  search?: string | null | undefined;
  starts?: string | null | undefined;
  status?: Array<PunchlistEntryStatus> | null | undefined;
  stops?: string | null | undefined;
  userId?: string | null | undefined;
};

export type ListSecretsFilters = {
  customerId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
  sortDirection?: SortDirectionOption;
  sortField?: SecretsSortField;
};

export type LogFilters = {
  action?: string | null | undefined;
  limit: string;
  logTypes?: Array<LogType> | null | undefined;
  offset: string;
  relation?: string | null | undefined;
  relid?: string | null | undefined;
  search?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  userId?: string | null | undefined;
};

export type LogType =
  | "COMMUNICATION"
  | "CUSTOMERS_PROJECTS"
  | "SECRETS"
  | "USERS_RIGHTS"
  | "WORKTIMES";

export type MailAttachmentInput = {
  cntAttId?: string | null | undefined;
  file?: File | null | undefined;
  forwardAttId?: string | null | undefined;
  id?: string | null | undefined;
};

export type MailDirection = "INCOMING" | "OUTGOING";

export type MailInput = {
  account?: string | null | undefined;
  attachments?: Array<MailAttachmentInput> | null | undefined;
  attrs?: Record<string, unknown> | null | undefined;
  bcc?: string | null | undefined;
  cc?: string | null | undefined;
  contactId?: string | null | undefined;
  content?: string | null | undefined;
  direction?: MailDirection | null | undefined;
  folder?: string | null | undefined;
  from?: string | null | undefined;
  htmlContent?: string | null | undefined;
  labels?: Array<string> | null | undefined;
  mdContent?: string | null | undefined;
  originalMail?: string | null | undefined;
  quoteText?: string | null | undefined;
  receivedAt?: string | null | undefined;
  subject?: string | null | undefined;
  threadId?: string | null | undefined;
  to?: string | null | undefined;
};

export type MailListFilters = {
  account?: string | null | undefined;
  attrField?: string | null | undefined;
  attrFilter?: Record<string, unknown> | null | undefined;
  contactId?: string | null | undefined;
  folder?: string | null | undefined;
  from?: string | null | undefined;
  isSpam?: boolean | null | undefined;
  labels?: Array<string> | null | undefined;
  limit?: string | null | undefined;
  mailDirection?: MailDirection | null | undefined;
  offset?: string | null | undefined;
  orderBy?: MailSortField | null | undefined;
  ownerId?: string | null | undefined;
  predefinedFilters?: Array<PredefinedFilter> | null | undefined;
  recipient?: string | null | undefined;
  search?: string | null | undefined;
  sender?: string | null | undefined;
  sortDirection?: SortDirectionOption | null | undefined;
  states?: Array<MailStatus> | null | undefined;
  threadId?: string | null | undefined;
  to?: string | null | undefined;
};

export type MailSortField =
  | "ATTRS"
  | "CONTACT"
  | "EDITOR"
  | "INSERTED_AT"
  | "OWNER"
  | "RECEIVED_AT"
  | "SENT_AT"
  | "UPDATED_AT";

export type MailStatus = "DONE" | "NOT_DONE" | "WAITING";

export type MailTemplateAttachmentInput = {
  attachByDefault?: boolean | null | undefined;
  file?: File | null | undefined;
  name?: string | null | undefined;
};

export type MailTemplateAttachmentListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type MailTemplateInput = {
  bcc?: string | null | undefined;
  cc?: string | null | undefined;
  content?: string | null | undefined;
  from?: string | null | undefined;
  mdContent?: string | null | undefined;
  name?: string | null | undefined;
  subject?: string | null | undefined;
  to?: string | null | undefined;
};

export type MailTemplateListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type MailThreadListFilters = {
  attrFilter?: Record<string, unknown> | null | undefined;
  contactId?: string | null | undefined;
  direction?: SortDirectionOption | null | undefined;
  from?: string | null | undefined;
  limit?: string | null | undefined;
  mailDirection?: MailDirection | null | undefined;
  offset?: string | null | undefined;
  orderAttr?: string | null | undefined;
  orderBy?: MailThreadSortField | null | undefined;
  recipient?: string | null | undefined;
  search?: string | null | undefined;
  sender?: string | null | undefined;
  states?: Array<MailStatus> | null | undefined;
  to?: string | null | undefined;
};

export type MailThreadSortField =
  | "ATTR"
  | "CONTACT"
  | "EDITOR"
  | "INSERTED_AT"
  | "OWNER"
  | "RECEIVED_AT"
  | "UPDATED_AT";

export type MarkUploadDoneInput = {
  imported?: number | null | undefined;
  message?: string | null | undefined;
  status: UploadStatus;
};

export type Maybe = "MAYBE" | "NO" | "YES";

export type MessageFormat = "HTML" | "LOCALIZED" | "PLAIN";

export type MessageInput = {
  content?: string | null | undefined;
  subject?: string | null | undefined;
  userId?: string | null | undefined;
};

export type MissingPersonalFileTypesFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type MoveContactStatusDirection = "DOWN" | "UP";

export type NoticePeriodUnit =
  "CALENDAR_DAYS" | "MONTHS" | "WEEKS" | "WORK_DAYS";

export type NoticeType = "ORDINARY" | "PROBATION" | "WO_NOTICE";

export type OauthTokenInput = {
  appId?: string | null | undefined;
  clientId?: string | null | undefined;
  clientSecret?: string | null | undefined;
  description?: string | null | undefined;
  grantType?: string | null | undefined;
  name?: string | null | undefined;
  scopes?: string | null | undefined;
  tokenQuery?: string | null | undefined;
  url?: string | null | undefined;
  useBasicAuth?: boolean | null | undefined;
};

export type PayrollPdfImportAssignErrorValues = {
  date: string;
  datevEmployeeNo?: string | null | undefined;
  employeeId: string;
};

export type PayrollPdfImportErrorStatus = "NEW" | "RESOLVED";

export type PayrollPdfImportInput = {
  file?: File | null | undefined;
  importType?: PayrollPdfImportType | null | undefined;
  month?: string | null | undefined;
  status?: PayrollPdfImportStatus | null | undefined;
};

export type PayrollPdfImportListFilters = {
  importType?: PayrollPdfImportType | null | undefined;
  limit?: string;
  offset?: string | null | undefined;
  status?: PayrollPdfImportStatus | null | undefined;
};

export type PayrollPdfImportStatus =
  "DONE" | "ERROR" | "PENDING" | "PROCESSING";

export type PayrollPdfImportType = "PAYROLL" | "TAX_CERTIFICATE";

export type PersonalFileInput = {
  description?: string | null | undefined;
  file?: File | null | undefined;
  personalFileTypeId?: string | null | undefined;
  pubDate?: string | null | undefined;
  read?: boolean | null | undefined;
  userId?: string | null | undefined;
};

export type PersonalFileListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  personalFileTypeId?: string | null | undefined;
  read?: boolean | null | undefined;
  search?: string | null | undefined;
  userId?: string | null | undefined;
};

export type PersonalFileTypeInput = {
  category?: string | null | undefined;
  name?: string | null | undefined;
  required?: boolean | null | undefined;
};

export type PersonalFileTypeListFilters = {
  category?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  required?: boolean | null | undefined;
  search?: string | null | undefined;
};

export type PredefinedFilter = {
  name: string;
  params?: Record<string, unknown> | null | undefined;
};

export type PresettlementEntryInput = {
  feastDayHours?: number | null | undefined;
  hourlyWage?: number | null | undefined;
  id?: string | null | undefined;
  illnessHours?: number | null | undefined;
  partialWage?: number | null | undefined;
  regularHours?: number | null | undefined;
  sundayHours?: number | null | undefined;
  userId?: string | null | undefined;
  vacationHours?: number | null | undefined;
  wage?: number | null | undefined;
};

export type PresettlementInput = {
  entries?: Array<PresettlementEntryInput> | null | undefined;
  month?: string | null | undefined;
  wageModifications?:
    Array<PresettlementWageModificationInput> | null | undefined;
};

export type PresettlementListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type PresettlementWageModificationInput = {
  id?: string | null | undefined;
  modification?: number | null | undefined;
  userId?: string | null | undefined;
};

export type ProductiveHourGoalInput = {
  customerId?: string | null | undefined;
  endDate?: string | null | undefined;
  period?: ProductiveHourGoalPeriod | null | undefined;
  projectId?: string | null | undefined;
  startDate?: string | null | undefined;
  wantedHours?: number | null | undefined;
};

export type ProductiveHourGoalListOptions = {
  customerId?: string | null | undefined;
  date?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  projectId?: string | null | undefined;
};

export type ProductiveHourGoalPeriod = "MONTHLY" | "TOTAL";

export type ProductiveHourGoalValidationInput = {
  endDate?: string | null | undefined;
  id?: string | null | undefined;
  relevantCustomerId: string;
  relevantProjectId?: string | null | undefined;
  startDate: string;
};

export type ProfileInput = {
  attrs?: Record<string, unknown> | null | undefined;
  name?: string | null | undefined;
  userIds?: Array<string> | null | undefined;
};

export type ProjectAttachmentInput = {
  creatorId?: string | null | undefined;
  customerId?: string | null | undefined;
  editorId?: string | null | undefined;
  file?: File | null | undefined;
  identifier?: string | null | undefined;
  projectId?: string | null | undefined;
};

export type ProjectInput = {
  active?: boolean | null | undefined;
  attrs?: Record<string, unknown> | null | undefined;
  identifier?: string | null | undefined;
  name?: string | null | undefined;
  users?: Array<string> | null | undefined;
};

export type ProjectNewsAttachmentInput = {
  file: File;
};

export type ProjectNewsInput = {
  active?: boolean | null | undefined;
  content?: string | null | undefined;
  subject?: string | null | undefined;
};

export type ProjectNewsSortOptions = "INSERTED_AT" | "UPDATED_AT";

export type ProjectReportInput = {
  month?: string | null | undefined;
  reportData?: Record<string, unknown> | null | undefined;
  reportType?: string | null | undefined;
  subject?: string | null | undefined;
};

export type ProjectReportListFilters = {
  limit?: string | null | undefined;
  month?: string | null | undefined;
  offset?: string | null | undefined;
  reportType?: string | null | undefined;
};

export type ProjectSortOption = "INSERTED_AT" | "NAME" | "UPDATED_AT";

export type ProjectStatsFilters = {
  start: string;
  stop: string;
};

export type ProjectUploadInput = {
  comment?: string | null | undefined;
  doneAt?: string | null | undefined;
  doneById?: string | null | undefined;
  file?: File | null | undefined;
  message?: string | null | undefined;
  ownerId?: string | null | undefined;
  status?: UploadStatus | null | undefined;
  visible?: boolean | null | undefined;
};

export type PunchlistEntryCommentInput = {
  comment?: string | null | undefined;
};

export type PunchlistEntryInput = {
  category?: string | null | undefined;
  description?: string | null | undefined;
  errorDate?: string | null | undefined;
  historyId?: string | null | undefined;
  status?: PunchlistEntryStatus | null | undefined;
  subject?: string | null | undefined;
  url?: string | null | undefined;
  userId?: string | null | undefined;
};

export type PunchlistEntryStatus = "CHECKED" | "NEW" | "QUERY" | "RESOLVED";

export type ReferenceDate =
  | "END_OF_HALF_YEAR"
  | "END_OF_MONTH"
  | "END_OF_QUARTER"
  | "END_OF_WEEK"
  | "END_OF_YEAR"
  | "FIFTEENTH"
  | "NO_END";

export type ReminderFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type ReminderInput = {
  identifier?: string | null | undefined;
  name?: string | null | undefined;
  userIds?: Array<string> | null | undefined;
};

export type ReminderNotificationFilters = {
  done?: boolean | null | undefined;
  due?: boolean | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type ResidualLeaveInput = {
  daysLeft?: number | null | undefined;
  userId?: string | null | undefined;
  year?: number | null | undefined;
};

export type ResidualLeaveListOptions = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  userId?: string | null | undefined;
  year?: number | null | undefined;
};

export type RosterAttendanceFilters = {
  attendanceType?: RosterAttendanceTypeType | null | undefined;
  groupIds?: Array<string> | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  teamId?: string | null | undefined;
  userId?: string | null | undefined;
};

export type RosterAttendanceInput = {
  attendanceTypeId?: string | null | undefined;
  day?: string | null | undefined;
  userId?: string | null | undefined;
};

export type RosterAttendanceTypeFilters = {
  archived?: boolean | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
  type?: RosterAttendanceTypeType | null | undefined;
};

export type RosterAttendanceTypeInput = {
  archived?: boolean | null | undefined;
  char?: string | null | undefined;
  color?: string | null | undefined;
  ignoreForSickNotes?: boolean | null | undefined;
  isStandard?: boolean | null | undefined;
  location?: RosterLocationType | null | undefined;
  name?: string | null | undefined;
  type?: RosterAttendanceTypeType | null | undefined;
};

export type RosterAttendanceTypeType =
  | "ABSENT_WO_PERMISSION"
  | "COMPENSATION"
  | "FREE"
  | "FREE_UNPAID"
  | "HOLIDAYS"
  | "ILLNESS"
  | "WORK";

export type RosterGroupFilters = {
  allCustomers?: boolean | null | undefined;
  forUserId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type RosterGroupInput = {
  name?: string | null | undefined;
  users?: Array<string> | null | undefined;
};

export type RosterHourFilters = {
  allCustomers?: boolean | null | undefined;
  groupIds?: Array<string> | null | undefined;
  onlyVisible?: boolean | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  userId?: string | null | undefined;
};

export type RosterHourInput = {
  hour?: string | null | undefined;
  taskId?: string | null | undefined;
  userId?: string | null | undefined;
};

export type RosterLocationType =
  "HOME" | "OFFICE" | "SCHOOL" | "UNKNOWN" | "UNPLANNED_HOME";

export type RosterMonthFilters = {
  allCustomers: boolean;
  groupIds?: Array<string> | null | undefined;
  userId?: string | null | undefined;
};

export type RosterNotificationFilters = {
  done?: boolean | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type RosterStandardAttendanceFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  userId?: string | null | undefined;
};

export type RosterStandardAttendanceInput = {
  attendanceTypeId?: string | null | undefined;
  userId?: string | null | undefined;
  weekDay?: number | null | undefined;
};

export type RosterStandardDayFilters = {
  attendanceTypeId?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  userId?: string | null | undefined;
  weekDay?: number | null | undefined;
};

export type RosterStandardDayHourInput = {
  hour?: string | null | undefined;
  id?: string | null | undefined;
  standardDayId?: string | null | undefined;
  taskId?: string | null | undefined;
};

export type RosterStandardDayInput = {
  attendanceTypeId?: string | null | undefined;
  hours?: Array<RosterStandardDayHourInput> | null | undefined;
  userId?: string | null | undefined;
  weekDay?: number | null | undefined;
};

export type RosterTaskFilters = {
  allCustomers?: boolean | null | undefined;
  archived?: boolean | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  search?: string | null | undefined;
};

export type RosterTaskInput = {
  archived?: boolean | null | undefined;
  char?: string | null | undefined;
  color?: string | null | undefined;
  name?: string | null | undefined;
  notifyMinutes?: number | null | undefined;
  notifyUser?: boolean | null | undefined;
  type?: RosterTaskType | null | undefined;
};

export type RosterTaskType = "PAUSE" | "WORK";

export type SecretInput = {
  customerId?: string | null | undefined;
  description?: string | null | undefined;
  name?: string | null | undefined;
  secret?: string | null | undefined;
  validUntil?: string | null | undefined;
};

export type SecretsSortField = "INSERTED_AT" | "NAME" | "VALID_UNTIL";

export type SettlementCorrectionInput = {
  contractId?: string | null | undefined;
  description?: string | null | undefined;
  hours?: number | null | undefined;
  id?: string | null | undefined;
  month?: string | null | undefined;
  taskId?: string | null | undefined;
};

export type SettlementInput = {
  comment?: string | null | undefined;
  corrections?: Array<SettlementCorrectionInput> | null | undefined;
  couponBonus?: number | null | undefined;
  inflationBonus?: number | null | undefined;
  isVisible?: boolean | null | undefined;
  month?: string | null | undefined;
  positions?: Array<SettlementPositionInput> | null | undefined;
  read?: boolean | null | undefined;
  ticketBonus?: number | null | undefined;
  travelCosts?: number | null | undefined;
  userId?: string | null | undefined;
};

export type SettlementPositionInput = {
  comment?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  posType?: SettlementPositionType | null | undefined;
  value?: number | null | undefined;
};

export type SettlementPositionType = "ADVANCE" | "BONUS" | "DEDUCTION";

export type SettlementsListOptions = {
  isVisible?: boolean | null | undefined;
  limit?: string | null | undefined;
  month?: string | null | undefined;
  offset?: string | null | undefined;
  read?: boolean | null | undefined;
  userId?: string | null | undefined;
};

export type ShiftEventInput = {
  attrs: Record<string, unknown>;
  endTime: string;
  startTime: string;
};

export type SickNoteCertificateType = "DIGITAL" | "WRITTEN";

export type SickNoteInput = {
  childSick?: boolean | null | undefined;
  ends?: string | null | undefined;
  file?: File | null | undefined;
  hasSickCertificate?: boolean | null | undefined;
  sickCertificateType?: SickNoteCertificateType | null | undefined;
  starts?: string | null | undefined;
  status?: SickNoteStatus | null | undefined;
  userId?: string | null | undefined;
  voucherType?: SickNoteVoucherType | null | undefined;
};

export type SickNoteListFilters = {
  ends?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  starts?: string | null | undefined;
  status?: Array<SickNoteStatus> | null | undefined;
  userId?: string | null | undefined;
};

export type SickNoteStatus =
  "CERTIFICATE_GIVEN" | "CERTIFICATE_WANTED" | "CONFIRMED" | "DECLINED" | "NEW";

export type SickNoteVoucherType = "FIRST" | "SECOND";

export type SignatureType = "CONFIRM" | "NONE" | "SIGN";

export type SortColumn =
  "END_TIME" | "INSERTED_AT" | "START_TIME" | "UPDATED_AT";

export type SortDirectionOption = "ASC" | "DESC";

export type StaffAbsenceOverviewFilters = {
  search?: string | null | undefined;
  teamId?: string | null | undefined;
};

export type StaffHistoriesListOptions = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  userId?: string | null | undefined;
};

export type StaffHistoryInput = {
  date?: string | null | undefined;
  htype?: StaffHistoryType | null | undefined;
  nextTalk?: string | null | undefined;
  text?: string | null | undefined;
  userId?: string | null | undefined;
};

export type StaffHistoryType = "MISC" | "TALK" | "WARNING" | "WRITTEN_WARNING";

export type StaffPaymentInfoInput = {
  cost?: number | null | undefined;
  employeeId?: string | null | undefined;
  gross?: number | null | undefined;
  month?: string | null | undefined;
  net?: number | null | undefined;
  paid?: number | null | undefined;
  positions?: Array<StaffPaymentInfoPositionInput> | null | undefined;
};

export type StaffPaymentInfoListFilters = {
  employeeId?: string | null | undefined;
  limit?: string;
  month?: string | null | undefined;
  offset?: string | null | undefined;
  payrollImportJobId?: string | null | undefined;
  userId?: string | null | undefined;
};

export type StaffPaymentInfoPositionInput = {
  amount?: number | null | undefined;
  factor?: number | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  percent?: number | null | undefined;
  positionType?: string | null | undefined;
  sum?: number | null | undefined;
  unit?: string | null | undefined;
};

export type StaffShareLinkFileInput = {
  id?: string | null | undefined;
  personalFileId?: string | null | undefined;
  shareLinkId?: string | null | undefined;
};

export type StaffShareLinkInput = {
  code?: string | null | undefined;
  files?: Array<StaffShareLinkFileInput> | null | undefined;
  note?: string | null | undefined;
  validForDays?: number | null | undefined;
};

export type StaffShareLinkSendInput = {
  email: string;
  mobile: string;
};

export type Status = "ACCEPTED" | "REJECTED";

export type SupervisorFilters = {
  day: string;
  teamId?: string | null | undefined;
};

export type TaskAttrStatsFilters = {
  attr?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
};

export type TaskInput = {
  attrs?: Record<string, unknown> | null | undefined;
  contactId?: string | null | undefined;
  contactType?: string | null | undefined;
  description?: string | null | undefined;
  questionnaireType?: string | null | undefined;
  reactionNeeded?: boolean | null | undefined;
  type?: TaskType | null | undefined;
};

export type TaskListFilters = {
  attributeFilter?: Record<string, unknown> | null | undefined;
  contactId?: string | null | undefined;
  contactType?: string | null | undefined;
  creatorId?: string | null | undefined;
  direction?: SortDirectionOption;
  editorId?: string | null | undefined;
  limit?: string;
  offset?: string | null | undefined;
  order?: TaskSortField;
  orderAttr?: string | null | undefined;
  predefinedFilters?: Array<PredefinedFilter> | null | undefined;
  reactionNeeded?: boolean | null | undefined;
  search?: string | null | undefined;
  sent?: boolean | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
  teamId?: number | null | undefined;
  updatedAtStart?: string | null | undefined;
  updatedAtStop?: string | null | undefined;
};

export type TaskOfferInput = {
  ends?: string | null | undefined;
  name?: string | null | undefined;
  start?: string | null | undefined;
};

export type TaskOfferListFilters = {
  active?: boolean | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
};

export type TaskProductInput = {
  name?: string | null | undefined;
  price?: number | null | undefined;
};

export type TaskProductListFilters = {
  limit?: string | null | undefined;
  names?: Array<string> | null | undefined;
  offerId?: string | null | undefined;
  offset?: string | null | undefined;
};

export type TaskSortField =
  | "ATTRS"
  | "CONTACT_TYPE"
  | "INSERTED_AT"
  | "NAME"
  | "REACTION_NEEDED"
  | "UPDATED_AT";

export type TaskStatsField = "ATTR" | "CONTACT_TYPE" | "REACTION_NEEDED";

export type TaskStatsFilters = {
  attr?: string | null | undefined;
  start?: string | null | undefined;
  stop?: string | null | undefined;
};

export type TaskType = "CONTACT" | "QUESTIONNAIRE";

export type TeamInput = {
  attrs?: Record<string, unknown> | null | undefined;
  foreignLeaders?: Array<string> | null | undefined;
  foreignUsers?: Array<string> | null | undefined;
  leaders?: Array<string> | null | undefined;
  name?: string | null | undefined;
  users?: Array<string> | null | undefined;
};

export type TeamsListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  onlyAsLeader?: boolean | null | undefined;
};

export type TerminateEmployeeInput = {
  actions: Array<TerminationAction>;
  exemptionEndDate?: string | null | undefined;
  exemptionStartDate?: string | null | undefined;
  giveBackDate?: string | null | undefined;
  leavingDate: string;
  noticeType: NoticeType;
  questionnaire?: TerminationQuestionnaireInput | null | undefined;
  signatureBy: string;
  terminatedBy: TerminatedBy;
  vacationLeft: number;
  vacationPayout: boolean;
  withExemption: boolean;
};

export type TerminatedBy = "EMPLOYEE" | "EMPLOYER";

export type TerminationAction =
  | "CONFIRMATION"
  | "NOTICE"
  | "NOTIFY_TEAM_LEADERS"
  | "QUESTIONNAIRE"
  | "TERMINATION_AGREEMENT"
  | "UPDATE_EMPLOYEE";

export type TerminationQuestionnaireInput = {
  additionalTerminationAgreements?: boolean | null | undefined;
  conditionsForTerminationForGoodCauseAvailable?: boolean | null | undefined;
  earlyRetirementAmount?: number | null | undefined;
  earlyRetirementPaidAfterTermination?: Maybe | null | undefined;
  earlyRetirementStarted?: string | null | undefined;
  employeeFiledAction?: Maybe | null | undefined;
  employeeWouldHaveGivenNoticeDate?: string | null | undefined;
  employeeWouldHaveGivenNoticeLeaving?: string | null | undefined;
  epmloymentRelationship?: EmploymentRelationship | null | undefined;
  exemptionIsAvailable?: boolean | null | undefined;
  extensionContractLastAt?: string | null | undefined;
  extensionContractLastUntil?: string | null | undefined;
  fixedTermAt?: string | null | undefined;
  fixedTermAtLeastTwoMonths?: boolean | null | undefined;
  fixedTermTo?: string | null | undefined;
  legalExclusion?: boolean | null | undefined;
  legalTerminationOnlyWithSeverance?: boolean | null | undefined;
  nameOrNumberEmploymentOffice?: string | null | undefined;
  noticePeriod: number;
  noticePeriodUnit: NoticePeriodUnit;
  paymentsAfterTermination?: Maybe | null | undefined;
  reasonForUncertainty?: UncertaintyReason | null | undefined;
  referenceDate?: ReferenceDate | null | undefined;
  severanceAmount?: number | null | undefined;
  severancePaidAfterTermination?: Maybe | null | undefined;
  severanceUpToHalfMonthlySalary?: boolean | null | undefined;
  severanceWouldvePaidWhenNoticeByEmployee?: boolean | null | undefined;
  socialSelectionBy?: string | null | undefined;
  socialSelectionDone?: Applicable | null | undefined;
  terminatedBy: string;
  terminationBreachOfContract?: boolean | null | undefined;
  terminationDate?: string | null | undefined;
  terminationOperationalReasons?: boolean | null | undefined;
  terminationWritten?: boolean | null | undefined;
  timeBoundTermination?: boolean | null | undefined;
  timelyExclusion?: boolean | null | undefined;
  transferWay: string;
  vacationDaysNotTaken?: number | null | undefined;
  vacationPaidAfterTermination?: Maybe | null | undefined;
  vacationPaymentAmount?: number | null | undefined;
  vacationWouldveLastedUntil?: string | null | undefined;
  wagePaidAfterTermination?: Maybe | null | undefined;
  wagePaidUntil?: string | null | undefined;
  waiverOfClaims?: WaiverOfClaims | null | undefined;
  writtenTerminationOfFixedTermContract?: boolean | null | undefined;
  writtenWarningDate?: string | null | undefined;
};

export type TermitelContractAttachmentInput = {
  documentType?: TermitelContractDocumentType | null | undefined;
  file?: File | null | undefined;
};

export type TermitelContractDeletionPeriodType = "MONTHS" | "NONE" | "WEEKS";

export type TermitelContractDocumentType =
  | "CONTRACT"
  | "LETTER_OF_INDEMNITY"
  | "MISC"
  | "ORDER"
  | "ORDER_DATA_PROCESSING";

export type TermitelContractFileStatus = "NO" | "YES" | "YES_WO_SIGNATURE";

export type TermitelContractInput = {
  contract?: TermitelContractFileStatus | null | undefined;
  deletionPeriod?: number | null | undefined;
  deletionPeriodType?: TermitelContractDeletionPeriodType | null | undefined;
  ends?: string | null | undefined;
  letterOfIndemnity?: TermitelContractFileStatus | null | undefined;
  noticePeriod?: number | null | undefined;
  noticePeriodType?: TermitelContractNoticePeriodType | null | undefined;
  orderDataProcessing?: TermitelContractFileStatus | null | undefined;
  paymentGoal?: number | null | undefined;
  paymentGoalType?: TermitelContractPaymentGoalType | null | undefined;
  runtime?: number | null | undefined;
  runtimeType?: TermitelContractRuntimeType | null | undefined;
  starts?: string | null | undefined;
};

export type TermitelContractNoticePeriodType =
  | "AUTOMATIC_AFTER_RUNTIME"
  | "MONTHS"
  | "MONTHS_END"
  | "UNDEFINED"
  | "WEEKS"
  | "WEEKS_TO_END_OF_QUARTER";

export type TermitelContractPaymentGoalType =
  "DAYS" | "END_OF_NEXT_MONTH" | "UNDEFINED";

export type TermitelContractRuntimeType =
  "MONTHS" | "NONE" | "UNKNOWN" | "UNLIMITED" | "WEEKS";

export type TicketCategory =
  | "BUG"
  | "CHANGE"
  | "CONTRACT"
  | "DATA_IMPORT"
  | "ENHANCEMENT"
  | "HARDWARE"
  | "INFRASTRUCTURE"
  | "IT_QUESTION"
  | "MIGRATION"
  | "REFACTORING"
  | "RIGHTS"
  | "SYS_ADMINISTRATION"
  | "TECHNICAL_PROBLEM"
  | "USBINTERFACE"
  | "USERS"
  | "WORKTIME";

export type TicketCountFilters = {
  category?: TicketCategory | null | undefined;
  customerId?: string | null | undefined;
  doneStart?: string | null | undefined;
  doneStop?: string | null | undefined;
  dueStart?: string | null | undefined;
  dueStop?: string | null | undefined;
  filterAttrs?: Record<string, unknown> | null | undefined;
  insertedStart?: string | null | undefined;
  insertedStop?: string | null | undefined;
  nextStepById?: string | null | undefined;
  ownerIds?: Array<string> | null | undefined;
  priority?: string | null | undefined;
  reporterIds?: Array<string> | null | undefined;
  search?: string | null | undefined;
  solution?: TicketSolution | null | undefined;
  status?: Array<TicketState> | null | undefined;
  teamId?: string | null | undefined;
  visible?: boolean | null | undefined;
};

export type TicketInput = {
  attrs?: Record<string, unknown> | null | undefined;
  category?: TicketCategory | null | undefined;
  description?: string | null | undefined;
  document?: Record<string, unknown> | null | undefined;
  dueDate?: string | null | undefined;
  forecastedEffort?: number | null | undefined;
  mdContent?: string | null | undefined;
  nextStepById?: string | null | undefined;
  ownerId?: string | null | undefined;
  priority?: number | null | undefined;
  relevantCustomerId?: string | null | undefined;
  relevantProjectId?: string | null | undefined;
  solution?: TicketSolution | null | undefined;
  status?: TicketState | null | undefined;
  subject?: string | null | undefined;
  url?: string | null | undefined;
  visible?: boolean | null | undefined;
  watchers?: Array<string> | null | undefined;
};

export type TicketListFilters = {
  category?: TicketCategory | null | undefined;
  customerId?: string | null | undefined;
  direction?: SortDirectionOption | null | undefined;
  doneStart?: string | null | undefined;
  doneStop?: string | null | undefined;
  dueStart?: string | null | undefined;
  dueStop?: string | null | undefined;
  filterAttrs?: Record<string, unknown> | null | undefined;
  insertedStart?: string | null | undefined;
  insertedStop?: string | null | undefined;
  limit: string;
  nextStepById?: string | null | undefined;
  offset?: string | null | undefined;
  order?: TicketSortField | null | undefined;
  ownerIds?: Array<string> | null | undefined;
  priority?: string | null | undefined;
  reporterIds?: Array<string> | null | undefined;
  search?: string | null | undefined;
  solution?: TicketSolution | null | undefined;
  status?: Array<TicketState> | null | undefined;
  teamId?: string | null | undefined;
  visible?: boolean | null | undefined;
};

export type TicketSolution =
  | "BUG_FIX"
  | "HARDWARE_REPLACED"
  | "IMPLEMENTED"
  | "PEBKAC"
  | "SETTINGS_CORRECTED"
  | "WIRING_CORRECTED";

export type TicketSortField =
  "DUE_DATE" | "ID" | "INSERTED_AT" | "PRIORITY" | "UPDATED_AT";

export type TicketState =
  | "ACCEPTED"
  | "DUPLICATE"
  | "IN_PROGRESS"
  | "NEW"
  | "NOTABUG"
  | "ONHOLD"
  | "QUESTION"
  | "RESOLVED"
  | "REVIEWED"
  | "WONTFIX";

export type TicketTimelineEntryInput = {
  content?: string | null | undefined;
  effort?: number | null | undefined;
  file?: File | null | undefined;
  nextStepById?: string | null | undefined;
  type?: TimelineEntryType | null | undefined;
};

export type TimelineEntryType =
  "COMMENT" | "EFFORT" | "FILE" | "INLINE_ATTACHMENT" | "STATUS_CHANGE";

export type TodoInput = {
  attrs?: Record<string, unknown> | null | undefined;
  contactId?: string | null | undefined;
  description?: string | null | undefined;
  file?: File | null | undefined;
  mailId?: string | null | undefined;
  ownerId?: string | null | undefined;
  parentId?: string | null | undefined;
  taskId?: string | null | undefined;
};

export type TodoListFilters = {
  contactId?: string | null | undefined;
  creatorId?: string | null | undefined;
  doneById?: string | null | undefined;
  editorId?: string | null | undefined;
  ends?: string | null | undefined;
  filterAttrs?: Record<string, unknown> | null | undefined;
  hasComment?: boolean | null | undefined;
  limit?: string;
  offset?: string | null | undefined;
  ownerId?: string | null | undefined;
  predefinedFilters?: Array<PredefinedFilter> | null | undefined;
  search?: string | null | undefined;
  sortAttr?: string | null | undefined;
  sortField?: TodoSortField | null | undefined;
  sortOrder?: SortDirectionOption | null | undefined;
  starts?: string | null | undefined;
  state?: TodoState | null | undefined;
  teamId?: string | null | undefined;
  todoStatus?: TodoListStatus | null | undefined;
};

export type TodoListStatus = "ACCEPTED" | "REJECTED" | "UNDECIDED";

export type TodoNoteInput = {
  file?: File | null | undefined;
  text?: string | null | undefined;
};

export type TodoSortField =
  "ATTR" | "CONTACT" | "INSERTED_AT" | "OWNER" | "UPDATED_AT";

export type TodoState = "ACCEPTED" | "DONE" | "NOT_ACCEPTED" | "NOT_DONE";

export type UncertaintyReason =
  "IN_DISPUTE" | "MISCELLANOUS" | "SETTLEMENT_NOT_YET_COMPLETED" | "UNCLEAR";

export type UploadStatus = "DONE" | "INVALID" | "NEW";

export type UserContactInput = {
  birthdate?: string | null | undefined;
  companyName?: string | null | undefined;
  firstname?: string | null | undefined;
  isCompany: boolean;
  lastname?: string | null | undefined;
  mobile?: string | null | undefined;
  salutation?: string | null | undefined;
};

export type UserInput = {
  active?: boolean | null | undefined;
  adminCustomers?: Array<string> | null | undefined;
  attrs?: Record<string, unknown> | null | undefined;
  avatar?: File | null | undefined;
  billableCustomerId?: string | null | undefined;
  billableCustomerIds?: Array<string> | null | undefined;
  bio?: string | null | undefined;
  contact?: UserContactInput | null | undefined;
  defaultProjectId?: string | null | undefined;
  email?: string | null | undefined;
  emailLang?: string | null | undefined;
  foreignLeaderTeams?: Array<string> | null | undefined;
  foreignUserTeams?: Array<string> | null | undefined;
  isJumper?: boolean | null | undefined;
  leaderTeams?: Array<string> | null | undefined;
  password?: string | null | undefined;
  profiles?: Array<string> | null | undefined;
  projects?: Array<string> | null | undefined;
  retired?: boolean | null | undefined;
  role?: UserRole | null | undefined;
  userCustomers?: Array<string> | null | undefined;
  userTeams?: Array<string> | null | undefined;
  username?: string | null | undefined;
};

export type UserMutationOptions = {
  addAcdEndpoint: boolean;
  addLdapUser: boolean;
  emailLang?: string | null | undefined;
  sendAs: UserPasswortSendAs;
  sendCredentialsMail: boolean;
};

export type UserPasswordMailType = "CREDENTIALS" | "PASSWORD_RESET";

export type UserPasswortSendAs = "MAIL" | "SMS";

export type UserRole = "ADMIN" | "CUSTOMER_ADMIN" | "ROOT" | "USER";

export type UserSortOption =
  "INSERTED_AT" | "LAST_SEEN_AT" | "NAME" | "UPDATED_AT";

export type UsersCountFilter = {
  active?: boolean | null | undefined;
  allCustomerUsers?: boolean | null | undefined;
  customerId?: string | null | undefined;
  excludeSelf?: boolean | null | undefined;
  feature?: string | null | undefined;
  hasE164?: boolean | null | undefined;
  isJumper?: boolean | null | undefined;
  onlyAsLeader?: boolean | null | undefined;
  onlyCustomer?: boolean | null | undefined;
  onlyForeign?: boolean | null | undefined;
  onlyOnline?: boolean | null | undefined;
  phones?: Array<string> | null | undefined;
  projectId?: string | null | undefined;
  projectIds?: Array<string> | null | undefined;
  retired?: boolean | null | undefined;
  role?: UserRole | null | undefined;
  search?: string | null | undefined;
  sudo?: boolean | null | undefined;
  teamId?: string | null | undefined;
  userIds?: Array<string> | null | undefined;
};

export type UsersListFilter = {
  active?: boolean | null | undefined;
  allCustomerUsers?: boolean | null | undefined;
  customerId?: string | null | undefined;
  direction?: SortDirectionOption | null | undefined;
  excludeSelf?: boolean | null | undefined;
  feature?: string | null | undefined;
  hasE164?: boolean | null | undefined;
  isJumper?: boolean | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  onlyAsLeader?: boolean | null | undefined;
  onlyCustomer?: boolean | null | undefined;
  onlyForeign?: boolean | null | undefined;
  onlyOnline?: boolean | null | undefined;
  order?: UserSortOption | null | undefined;
  phones?: Array<string> | null | undefined;
  projectId?: string | null | undefined;
  projectIds?: Array<string> | null | undefined;
  retired?: boolean | null | undefined;
  role?: UserRole | null | undefined;
  search?: string | null | undefined;
  sudo?: boolean | null | undefined;
  teamId?: string | null | undefined;
  userIds?: Array<string> | null | undefined;
};

export type VacationAvailableInput = {
  from: string;
  halfDay: boolean;
  to: string;
  type: VacationRequestType;
};

export type VacationOverviewFilters = {
  search?: string | null | undefined;
  teamId?: string | null | undefined;
};

export type VacationPlanFilters = {
  search?: string | null | undefined;
  teamId?: string | null | undefined;
};

export type VacationRequestInput = {
  adminComment?: string | null | undefined;
  comment?: string | null | undefined;
  endTime?: string | null | undefined;
  from?: string | null | undefined;
  halfDay?: boolean | null | undefined;
  startTime?: string | null | undefined;
  status?: VacationRequestStatus | null | undefined;
  to?: string | null | undefined;
  type?: VacationRequestType | null | undefined;
  userId?: string | null | undefined;
};

export type VacationRequestListOptions = {
  direction?: SortDirectionOption | null | undefined;
  from?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  open?: boolean | null | undefined;
  requestType?: VacationRequestType | null | undefined;
  sortBy?: VacationRequestSortBy | null | undefined;
  status?: VacationRequestStatus | null | undefined;
  teamId?: string | null | undefined;
  to?: string | null | undefined;
  userId?: string | null | undefined;
};

export type VacationRequestSortBy =
  "FROM" | "INSERTED_AT" | "TO" | "UPDATED_AT" | "USER";

export type VacationRequestStatus =
  "APPROVED" | "AWAITING" | "QUERY" | "REJECTED";

export type VacationRequestStatusInput = {
  comment?: string | null | undefined;
  status: VacationRequestStatus;
};

export type VacationRequestType = "COMPENSATION" | "PAID" | "STORNO" | "UNPAID";

export type WaiverOfClaims =
  "SEVERANCE" | "VACATION_COMPENSATION" | "WAGE_AFTER_TERMINATION";

export type WorkerJobsFilters = {
  finishedAtEnds?: string | null | undefined;
  finishedAtStarts?: string | null | undefined;
  insertedAtEnds?: string | null | undefined;
  insertedAtStarts?: string | null | undefined;
  kind?: string | null | undefined;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  order?: SortDirectionOption;
  orderBy?: WorkerJobsOrderBy;
  queue?: string | null | undefined;
  runAtEnds?: string | null | undefined;
  runAtStarts?: string | null | undefined;
  startedAtEnds?: string | null | undefined;
  startedAtStarts?: string | null | undefined;
  status?: JobStatus | null | undefined;
};

export type WorkerJobsOrderBy =
  | "ATTEMPTS"
  | "FINISHED_AT"
  | "ID"
  | "INSERTED_AT"
  | "KIND"
  | "QUEUE"
  | "RUN_AT"
  | "STARTED_AT"
  | "STATUS"
  | "UPDATED_AT";

export type WorkerStatsFilters = {
  attrs?: Record<string, unknown> | null | undefined;
  category?: string | null | undefined;
  contactGroupId?: string | null | undefined;
  start: string;
  stop: string;
  teamId?: string | null | undefined;
  userId?: string | null | undefined;
};

export type WorktimeInput = {
  billingCustomerId?: string | null | undefined;
  comment?: string | null | undefined;
  starts?: string | null | undefined;
  stops?: string | null | undefined;
  taskId?: string | null | undefined;
  userId?: string | null | undefined;
};

export type WorktimeValidationInput = {
  byContract: boolean;
  days?: number | null | undefined;
  id?: string | null | undefined;
  starts: string;
  stops?: string | null | undefined;
  userId: string;
};

export type WorktimesByCustomerFilters = {
  paid?: boolean | null | undefined;
  productive?: boolean | null | undefined;
  starts: string;
  stops: string;
  teamId?: string | null | undefined;
};

export type WorktimesChangeRequestEntryInput = {
  billingCustomerId?: string | null | undefined;
  id?: string | null | undefined;
  starts?: string | null | undefined;
  stops?: string | null | undefined;
  taskId?: string | null | undefined;
};

export type WorktimesChangeRequestInput = {
  adminComment?: string | null | undefined;
  comment?: string | null | undefined;
  entries?: Array<WorktimesChangeRequestEntryInput> | null | undefined;
};

export type WorktimesChangeRequestListFilters = {
  limit?: string | null | undefined;
  offset?: string | null | undefined;
  starts?: string | null | undefined;
  states?: Array<WorktimesChangeRequestStatus> | null | undefined;
  stops?: string | null | undefined;
  userId?: string | null | undefined;
};

export type WorktimesChangeRequestStatus =
  "APPROVED" | "PENDING" | "REJECTED" | "REQUEST";

export type WorktimesCustomerInput = {
  customerId: string;
  starts: string;
  stops: string;
};

export type WorktimesListFilters = {
  billingCustomerId?: string | null | undefined;
  customerReviewDone?: boolean | null | undefined;
  declined?: boolean | null | undefined;
  direction?: SortDirectionOption | null | undefined;
  limit?: string | null | undefined;
  modified?: boolean | null | undefined;
  offset?: string | null | undefined;
  order?: Array<WorktimesSortBy> | null | undefined;
  paid?: boolean | null | undefined;
  review?: boolean | null | undefined;
  starts?: string | null | undefined;
  stops?: string | null | undefined;
  taskId?: string | null | undefined;
  teamId?: string | null | undefined;
  unassigned?: boolean | null | undefined;
  unconfirmed?: boolean | null | undefined;
  userId?: string | null | undefined;
  worktimeType?: WorktimesTaskType | null | undefined;
};

export type WorktimesSortBy =
  "INSERTED_AT" | "NAME" | "STARTS" | "STOPS" | "UPDATED_AT";

export type WorktimesTaskInput = {
  acdId?: string | null | undefined;
  allowInCorrections?: boolean | null | undefined;
  name?: string | null | undefined;
  paid?: boolean | null | undefined;
  position?: number | null | undefined;
  productive?: boolean | null | undefined;
  sidebar?: boolean | null | undefined;
  type?: WorktimesTaskType | null | undefined;
};

export type WorktimesTaskType =
  | "CHILD_SICK"
  | "COMPENSATION"
  | "FEAST_DAY"
  | "HOLIDAYS"
  | "ILLNESS"
  | "MINUS"
  | "NOT_AVAILABLE"
  | "PAUSE"
  | "SICK_NO_PAYMENT"
  | "WORK";

export type AcdCallTimeFragment = {
  __typename: "AcdCallTime";
  id: string;
  acdId: string;
  callTime: string;
  direction: CallDirectionOption;
  initiator: string | null;
  calledNo: string | null;
  peerNos: Array<string>;
  duration: number;
  waiting: number;
  callResult: AcdCallResult;
  connectedPeer: string | null;
};

export type AcdCallListItemFragment = {
  __typename: "AcdCall";
  id: string;
  status: AcdCallStatus;
  direction: CallDirectionOption;
  initiator: string | null;
  calledNo: string | null;
  peerNos: Array<string>;
  duration: number;
  waiting: number;
  callResult: AcdCallResult;
  connectedPeer: string | null;
  noCalls: number;
  firstCall: string | null;
  lastCall: string | null;
  contact: { __typename: "Contact"; id: string; displayName: string } | null;
};

export type AcdCallFragment = {
  __typename: "AcdCall";
  id: string;
  status: AcdCallStatus;
  direction: CallDirectionOption;
  initiator: string | null;
  calledNo: string | null;
  peerNos: Array<string>;
  duration: number;
  waiting: number;
  callResult: AcdCallResult;
  connectedPeer: string | null;
  noCalls: number;
  firstCall: string | null;
  lastCall: string | null;
  callTimes: Array<{
    __typename: "AcdCallTime";
    id: string;
    acdId: string;
    callTime: string;
    direction: CallDirectionOption;
    initiator: string | null;
    calledNo: string | null;
    peerNos: Array<string>;
    duration: number;
    waiting: number;
    callResult: AcdCallResult;
    connectedPeer: string | null;
  }>;
  contact: { __typename: "Contact"; id: string; displayName: string } | null;
};

export type ApiKeyFragment = {
  __typename: "ApiKey";
  id: string;
  customerId: string;
  userId: string;
  name: string;
  validUntil: string;
  revokedAt: string | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  customer: {
    __typename: "Customer";
    id: string;
    name: string;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  };
};

export type LogEntryFragment = {
  __typename: "LogEntry";
  id: string;
  relid: string;
  relation: string;
  action: string;
  previousContents: Record<string, unknown> | null;
  contents: Record<string, unknown> | null;
  userId: string | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type ChangeRequestFragment = {
  __typename: "ChangeRequest";
  id: string;
  customerId: string;
  employeeId: string | null;
  salutation: string | null;
  firstname: string | null;
  lastname: string | null;
  gender: EmployeeGender | null;
  nationality: string | null;
  placeOfBirth: string | null;
  countryOfBirth: string | null;
  civilStatus: EmployeeCivilStatus | null;
  disability: boolean | null;
  disabilityLevel: number | null;
  taxLevel: number | null;
  childTaxAllowance: number | null;
  denomination: string | null;
  additionalJobs: string | null;
  address: string | null;
  zip: string | null;
  city: string | null;
  email: string | null;
  phone: string | null;
  landline: string | null;
  emergencyContactName: string | null;
  emergencyContactPhone: string | null;
  birthdate: string | null;
  iban: string | null;
  bic: string | null;
  taxId: string | null;
  socialSecurityNumber: string | null;
  healthInsurance: string | null;
  languagesFluent: Array<string> | null;
  languagesNative: Array<string> | null;
  emailConfirmationToken: string | null;
  emailConfirmed: boolean;
  requestComment: string | null;
  returnComment: string | null;
  status: ChangeRequestStatus;
  insertedAt: string;
  updatedAt: string;
  employee: {
    __typename: "Employee";
    id: string;
    entering: string;
    leaving: string | null;
    active: boolean;
    datevEmployeeNo: string | null;
    deleted: boolean;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    standardBonus: number | null;
    dataProtectionTrainingCompletedAt: string | null;
    cpsNumber: string | null;
    headset: string | null;
    healthInsurance: string | null;
    notes: string | null;
    probationEnding: string | null;
    employeeName: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    additionalJobs: string | null;
    denomination: string | null;
    languagesFluent: Array<string>;
    languagesNative: Array<string>;
    position: string | null;
    levels: Array<Level>;
    sickDaysLimit: number | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    children: Array<{
      __typename: "EmployeeChild";
      id: string;
      name: string;
      birthdate: string;
    }>;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      contact: {
        __typename: "Contact";
        id: string;
        customerId: string;
        projectId: string;
        salutation: string | null;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
        infos: Array<{
          __typename: "ContactInfo";
          id: string;
          description: string | null;
          itype: ContactInfoType;
          normalizedValue: string | null;
          value: string | null;
          confirmedAt: string | null;
          confirmationSentAt: string | null;
          insertedAt: string;
          updatedAt: string;
        }>;
        addresses: Array<{
          __typename: "ContactAddress";
          id: string;
          address: string | null;
          atype: ContactAddressType;
          city: string | null;
          cityPart: string | null;
          country: string | null;
          description: string | null;
          zip: string | null;
        }>;
      } | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  } | null;
  children: Array<{
    __typename: "Child";
    id: string;
    name: string;
    birthdate: string;
  }>;
};

export type CommunicationListFragment = {
  __typename: "CommunicationList";
  id: string;
  name: string;
  addresses: Array<string>;
};

export type CommunicationFragment = {
  __typename: "Communication";
  id: string;
  identifier: string | null;
  type: string;
  insertedAt: string;
  updatedAt: string;
  lists: Array<{ __typename: "CommunicationList"; id: string; name: string }>;
  teams: Array<{ __typename: "Team"; id: string; name: string }>;
};

export type CompanyNewsFragment = {
  __typename: "CompanyNews";
  id: string;
  content: string | null;
  validUntil: string;
  customerId: string;
  insertedAt: string;
  updatedAt: string;
  image: {
    __typename: "CompanyNewsImage";
    thumb: string | null;
    medium: string | null;
    original: string | null;
  };
};

export type ContactOfferFragment = {
  __typename: "ContactOffer";
  id: string;
  customerId: string;
  projectId: string;
  contactId: string;
  token: string;
  insertedAt: string;
  updatedAt: string;
  views: Array<{
    __typename: "ContactOfferView";
    id: string;
    offerId: string;
    userAgent: string | null;
    viewedAt: string;
  }>;
};

export type StatusUpdateFragment = {
  __typename: "ContactStatusUpdate";
  id: string;
  fromId: string;
  toId: string;
  afterDays: number;
  from: { __typename: "ContactStatus"; id: string; name: string };
  to: { __typename: "ContactStatus"; id: string; name: string };
};

export type ContactStatusFragment = {
  __typename: "ContactStatus";
  id: string;
  name: string;
  projectId: string;
  position: number;
  insertedAt: string;
  updatedAt: string;
  allowedAfterCall: boolean;
  enforceFollowup: boolean;
  followupEventTypeId: string | null;
  defaultFollowupSubject: string | null;
  defaultFollowupDays: number | null;
};

export type ContactGroupDetailFragment = {
  __typename: "ContactGroup";
  id: string;
  name: string;
  gtype: ContactGroupType;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
};

export type ContactAddfieldFragment = {
  __typename: "ContactAddfield";
  id: string;
  name: string;
  identifier: string;
  automatic: boolean;
  required: boolean;
};

export type ContactInfoFragment = {
  __typename: "ContactInfo";
  id: string;
  description: string | null;
  itype: ContactInfoType;
  normalizedValue: string | null;
  value: string | null;
  confirmedAt: string | null;
  confirmationSentAt: string | null;
  insertedAt: string;
  updatedAt: string;
};

export type ContactAddressFragment = {
  __typename: "ContactAddress";
  id: string;
  address: string | null;
  atype: ContactAddressType;
  city: string | null;
  cityPart: string | null;
  country: string | null;
  description: string | null;
  zip: string | null;
};

export type ContactDetailFragment = {
  __typename: "Contact";
  id: string;
  parentId: string | null;
  ctype: ContactType;
  displayName: string;
  isCompany: boolean;
  salutation: string | null;
  firstname: string | null;
  lastname: string | null;
  companyName: string | null;
  position: string | null;
  birthdate: string | null;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  statusId: string | null;
  lockedAt: string | null;
  lockRefreshedAt: string | null;
  lockerId: string | null;
  placeOfBirth: string | null;
  civilStatus: CivilStatus | null;
};

export type EventDetailWoContactFragment = {
  __typename: "Event";
  id: string;
  subject: string;
  allDay: boolean;
  startTime: string;
  endTime: string;
  details: string | null;
  attrs: Record<string, unknown>;
  canceled: boolean;
  cleared: boolean;
  sent: boolean;
  sentAt: string | null;
  shifted: boolean;
  contactId: string | null;
  typeId: string;
  insertedAt: string;
  updatedAt: string;
  ownerId: string;
  creatorId: string;
  type: {
    __typename: "EventType";
    id: string;
    name: string;
    type: EventTypeType;
  } | null;
  replacementForEvent: {
    __typename: "Event";
    id: string;
    subject: string;
    startTime: string;
  } | null;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  feedbacks: Array<{
    __typename: "EventFeedback";
    id: string;
    tookPlace: boolean | null;
    insertedAt: string;
    attrs: Record<string, unknown>;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type ContactFragmentFragment = {
  __typename: "Contact";
  ownerId: string;
  id: string;
  parentId: string | null;
  ctype: ContactType;
  displayName: string;
  isCompany: boolean;
  salutation: string | null;
  firstname: string | null;
  lastname: string | null;
  companyName: string | null;
  position: string | null;
  birthdate: string | null;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  statusId: string | null;
  lockedAt: string | null;
  lockRefreshedAt: string | null;
  lockerId: string | null;
  placeOfBirth: string | null;
  civilStatus: CivilStatus | null;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  locker: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  children: Array<{
    __typename: "Contact";
    id: string;
    parentId: string | null;
    ctype: ContactType;
    displayName: string;
    isCompany: boolean;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    position: string | null;
    birthdate: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    statusId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
    lockerId: string | null;
    placeOfBirth: string | null;
    civilStatus: CivilStatus | null;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    }>;
  }>;
  status: { __typename: "ContactStatus"; id: string; name: string } | null;
  infos: Array<{
    __typename: "ContactInfo";
    id: string;
    description: string | null;
    itype: ContactInfoType;
    normalizedValue: string | null;
    value: string | null;
    confirmedAt: string | null;
    confirmationSentAt: string | null;
    insertedAt: string;
    updatedAt: string;
  }>;
  addresses: Array<{
    __typename: "ContactAddress";
    id: string;
    address: string | null;
    atype: ContactAddressType;
    city: string | null;
    cityPart: string | null;
    country: string | null;
    description: string | null;
    zip: string | null;
  }>;
  primaryAddress: {
    __typename: "ContactAddress";
    id: string;
    address: string | null;
    atype: ContactAddressType;
    city: string | null;
    cityPart: string | null;
    country: string | null;
    description: string | null;
    zip: string | null;
  } | null;
  events: Array<{
    __typename: "Event";
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    contactId: string | null;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  }>;
};

export type ContactAttachmentFragment = {
  __typename: "ContactAttachment";
  id: string;
  file: string;
  mimeType: string;
  description: string;
  contactId: string;
  insertedAt: string;
  updatedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type ContactListItemFragment = {
  __typename: "Contact";
  id: string;
  ctype: ContactType;
  parentId: string | null;
  displayName: string;
  firstname: string | null;
  lastname: string | null;
  companyName: string | null;
  isCompany: boolean;
  attrs: Record<string, unknown>;
  statusId: string | null;
  lockerId: string | null;
  insertedAt: string;
  updatedAt: string;
  parent: {
    __typename: "Contact";
    ownerId: string;
    id: string;
    parentId: string | null;
    ctype: ContactType;
    displayName: string;
    isCompany: boolean;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    position: string | null;
    birthdate: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    statusId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
    lockerId: string | null;
    placeOfBirth: string | null;
    civilStatus: CivilStatus | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    children: Array<{
      __typename: "Contact";
      id: string;
      parentId: string | null;
      ctype: ContactType;
      displayName: string;
      isCompany: boolean;
      salutation: string | null;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      position: string | null;
      birthdate: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      statusId: string | null;
      lockedAt: string | null;
      lockRefreshedAt: string | null;
      lockerId: string | null;
      placeOfBirth: string | null;
      civilStatus: CivilStatus | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        description: string | null;
        itype: ContactInfoType;
        normalizedValue: string | null;
        value: string | null;
        confirmedAt: string | null;
        confirmationSentAt: string | null;
        insertedAt: string;
        updatedAt: string;
      }>;
      addresses: Array<{
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      }>;
    }>;
    status: { __typename: "ContactStatus"; id: string; name: string } | null;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    }>;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    } | null;
    events: Array<{
      __typename: "Event";
      id: string;
      subject: string;
      allDay: boolean;
      startTime: string;
      endTime: string;
      details: string | null;
      attrs: Record<string, unknown>;
      canceled: boolean;
      cleared: boolean;
      sent: boolean;
      sentAt: string | null;
      shifted: boolean;
      contactId: string | null;
      typeId: string;
      insertedAt: string;
      updatedAt: string;
      ownerId: string;
      creatorId: string;
      type: {
        __typename: "EventType";
        id: string;
        name: string;
        type: EventTypeType;
      } | null;
      replacementForEvent: {
        __typename: "Event";
        id: string;
        subject: string;
        startTime: string;
      } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      feedbacks: Array<{
        __typename: "EventFeedback";
        id: string;
        tookPlace: boolean | null;
        insertedAt: string;
        attrs: Record<string, unknown>;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
      }>;
    }>;
  } | null;
  lastContact: { __typename: "History"; id: string; insertedAt: string } | null;
  nextFollowup: {
    __typename: "Event";
    id: string;
    allDay: boolean;
    startTime: string;
  } | null;
  primaryAddress: {
    __typename: "ContactAddress";
    id: string;
    address: string | null;
    zip: string | null;
    city: string | null;
  } | null;
  status: { __typename: "ContactStatus"; id: string; name: string } | null;
  project: {
    __typename: "MinimalProject";
    id: string;
    name: string;
    identifier: string;
  } | null;
  locker: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type ContactWithInfosListItemFragment = {
  __typename: "Contact";
  id: string;
  parentId: string | null;
  displayName: string;
  salutation: string | null;
  firstname: string | null;
  lastname: string | null;
  companyName: string | null;
  isCompany: boolean;
  position: string | null;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  infos: Array<{
    __typename: "ContactInfo";
    id: string;
    description: string | null;
    itype: ContactInfoType;
    normalizedValue: string | null;
    value: string | null;
    confirmedAt: string | null;
    confirmationSentAt: string | null;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type ContactWithInfosAndAddressesListItemFragment = {
  __typename: "Contact";
  id: string;
  parentId: string | null;
  displayName: string;
  firstname: string | null;
  lastname: string | null;
  companyName: string | null;
  isCompany: boolean;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  infos: Array<{
    __typename: "ContactInfo";
    id: string;
    description: string | null;
    itype: ContactInfoType;
    normalizedValue: string | null;
    value: string | null;
    confirmedAt: string | null;
    confirmationSentAt: string | null;
    insertedAt: string;
    updatedAt: string;
  }>;
  addresses: Array<{
    __typename: "ContactAddress";
    id: string;
    address: string | null;
    atype: ContactAddressType;
    city: string | null;
    cityPart: string | null;
    country: string | null;
    description: string | null;
    zip: string | null;
  }>;
  events: Array<{
    __typename: "Event";
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    contactId: string | null;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  }>;
  children: Array<{
    __typename: "Contact";
    id: string;
    displayName: string;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    }>;
  }>;
};

export type EmployeeCouponFragment = {
  __typename: "EmployeeCoupon";
  id: string;
  customerId: string;
  userId: string;
  month: string;
  amount: number;
  claimed: boolean;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type CustomerFeedbackFragment = {
  __typename: "CustomerFeedback";
  id: string;
  identifier: string;
  attrs: Record<string, unknown>;
  description: string | null;
  state: CustomerFeedbackState;
  selfAssessmentState: CustomerFeedbackState;
  allDone: boolean;
  userId: string;
  topicId: string | null;
  customerId: string;
  projectId: string;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  topic: { __typename: "CustomerFeedbackTopic"; name: string } | null;
};

export type CustomerFeedbackAnnotationFragment = {
  __typename: "CustomerFeedbackAnnotation";
  id: string;
  done: boolean;
  details: string;
  customerFeedbackId: string;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type CustomerFeedbackTopicFragment = {
  __typename: "CustomerFeedbackTopic";
  id: string;
  name: string;
  active: boolean;
  color: string | null;
  customerId: string;
  projectId: string;
  insertedAt: string;
  updatedAt: string;
};

export type CustomerLogoFragment = {
  __typename: "CustomerLogo";
  thumb: string;
  medium: string;
  original: string;
};

export type CustomerListItemFragment = {
  __typename: "Customer";
  id: string;
  name: string;
  identifier: string;
  active: boolean;
  inDeletion: boolean;
  attrs: Record<string, unknown>;
  logo: {
    __typename: "CustomerLogo";
    thumb: string;
    medium: string;
    original: string;
  };
};

export type CustomerFullFragment = {
  __typename: "Customer";
  id: string;
  name: string;
  active: boolean;
  inDeletion: boolean;
  identifier: string;
  defaultProjectId: string | null;
  attrs: Record<string, unknown>;
  logo: {
    __typename: "CustomerLogo";
    thumb: string;
    medium: string;
    original: string;
  };
  projects: Array<{
    __typename: "Project";
    id: string;
    name: string;
    identifier: string;
    active: boolean;
  }>;
  customerUsers: Array<{
    __typename: "User";
    id: string;
    username: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
  }>;
  customerAdministrators: Array<{
    __typename: "User";
    id: string;
    username: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
  }>;
};

export type DigitalSignatureEnvelopeFragment = {
  __typename: "DigitalSignatureEnvelope";
  id: string;
  name: string;
  status: EnvelopeStatus;
  customerId: string;
  projectId: string;
  creatorId: string;
  editorId: string;
  insertedAt: string;
  updatedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type DigitalSignatureFileFragment = {
  __typename: "DigitalSignatureFile";
  id: string;
  digitalSignatureId: string;
  filename: string;
  status: EnvelopeStatus;
  insertedAt: string;
  updatedAt: string;
};

export type DigitalSignatureFieldFragment = {
  __typename: "DigitalSignatureField";
  id: string;
  email: string;
  digitalSignatureFileId: string;
  pageNo: number;
  x: number;
  y: number;
  width: number;
  height: number;
};

export type DocumentSignatureFragment = {
  __typename: "DocumentSignature";
  id: string;
  type: DocumentSignatureSignatureType;
  userId: string;
  documentId: string;
  insertedAt: string;
  updatedAt: string;
};

export type DocumentAttachmentFragment = {
  __typename: "DocumentAttachment";
  id: string;
  documentId: string;
  file: string;
};

export type DocumentFragment = {
  __typename: "Document";
  id: string;
  subject: string;
  type: DocumentType;
  keywords: Array<string>;
  visible: boolean;
  signatureType: SignatureType;
  validFrom: string | null;
  validUntil: string | null;
  relevantProjectId: string | null;
  signatureDue: number | null;
  creatorId: string;
  editorId: string;
  insertedAt: string;
  updatedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type DocumentListItemFragment = {
  __typename: "Document";
  customerId: string;
  projectId: string;
  id: string;
  subject: string;
  type: DocumentType;
  keywords: Array<string>;
  visible: boolean;
  signatureType: SignatureType;
  validFrom: string | null;
  validUntil: string | null;
  relevantProjectId: string | null;
  signatureDue: number | null;
  creatorId: string;
  editorId: string;
  insertedAt: string;
  updatedAt: string;
  customer: {
    __typename: "MinimalCustomer";
    id: string;
    identifier: string;
    name: string;
  };
  project: {
    __typename: "MinimalProject";
    id: string;
    identifier: string;
    name: string;
    attrs: Record<string, unknown>;
  };
  relevantProject: {
    __typename: "MinimalProject";
    id: string;
    identifier: string;
    name: string;
    attrs: Record<string, unknown>;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type DetailDocumentFragment = {
  __typename: "Document";
  document: Record<string, unknown>;
  mdContent: string | null;
  customerId: string;
  projectId: string;
  id: string;
  subject: string;
  type: DocumentType;
  keywords: Array<string>;
  visible: boolean;
  signatureType: SignatureType;
  validFrom: string | null;
  validUntil: string | null;
  relevantProjectId: string | null;
  signatureDue: number | null;
  creatorId: string;
  editorId: string;
  insertedAt: string;
  updatedAt: string;
  attachments: Array<{
    __typename: "DocumentAttachment";
    id: string;
    documentId: string;
    file: string;
  }>;
  missingSignatures: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
  signatures: Array<{
    __typename: "DocumentSignature";
    id: string;
    type: DocumentSignatureSignatureType;
    userId: string;
    documentId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
  customer: {
    __typename: "MinimalCustomer";
    id: string;
    identifier: string;
    name: string;
  };
  project: {
    __typename: "MinimalProject";
    id: string;
    identifier: string;
    name: string;
    attrs: Record<string, unknown>;
  };
  relevantProject: {
    __typename: "MinimalProject";
    id: string;
    identifier: string;
    name: string;
    attrs: Record<string, unknown>;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type EmployeeListItemFragment = {
  __typename: "Employee";
  id: string;
  employeeName: string | null;
  entering: string;
  leaving: string | null;
  probationEnding: string | null;
  active: boolean;
  headset: string | null;
  deleted: boolean;
  position: string | null;
  levels: Array<Level>;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type EmployeeFullFragment = {
  __typename: "Employee";
  id: string;
  entering: string;
  leaving: string | null;
  active: boolean;
  datevEmployeeNo: string | null;
  deleted: boolean;
  iban: string | null;
  bic: string | null;
  taxId: string | null;
  socialSecurityNumber: string | null;
  standardBonus: number | null;
  dataProtectionTrainingCompletedAt: string | null;
  cpsNumber: string | null;
  headset: string | null;
  healthInsurance: string | null;
  notes: string | null;
  probationEnding: string | null;
  employeeName: string | null;
  gender: EmployeeGender | null;
  nationality: string | null;
  placeOfBirth: string | null;
  countryOfBirth: string | null;
  civilStatus: EmployeeCivilStatus | null;
  disability: boolean;
  disabilityLevel: number | null;
  taxLevel: number | null;
  childTaxAllowance: number | null;
  additionalJobs: string | null;
  denomination: string | null;
  languagesFluent: Array<string>;
  languagesNative: Array<string>;
  position: string | null;
  levels: Array<Level>;
  sickDaysLimit: number | null;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  children: Array<{
    __typename: "EmployeeChild";
    id: string;
    name: string;
    birthdate: string;
  }>;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    contact: {
      __typename: "Contact";
      id: string;
      customerId: string;
      projectId: string;
      salutation: string | null;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        description: string | null;
        itype: ContactInfoType;
        normalizedValue: string | null;
        value: string | null;
        confirmedAt: string | null;
        confirmationSentAt: string | null;
        insertedAt: string;
        updatedAt: string;
      }>;
      addresses: Array<{
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      }>;
    } | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
  };
};

export type EventTypeFragment = {
  __typename: "EventType";
  id: string;
  name: string;
  type: EventTypeType;
  mayForeign: boolean;
};

export type EventDetailFragment = {
  __typename: "Event";
  contactId: string | null;
  id: string;
  subject: string;
  allDay: boolean;
  startTime: string;
  endTime: string;
  details: string | null;
  attrs: Record<string, unknown>;
  canceled: boolean;
  cleared: boolean;
  sent: boolean;
  sentAt: string | null;
  shifted: boolean;
  typeId: string;
  insertedAt: string;
  updatedAt: string;
  ownerId: string;
  creatorId: string;
  contact: { __typename: "Contact"; id: string; displayName: string } | null;
  type: {
    __typename: "EventType";
    id: string;
    name: string;
    type: EventTypeType;
  } | null;
  replacementForEvent: {
    __typename: "Event";
    id: string;
    subject: string;
    startTime: string;
  } | null;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  feedbacks: Array<{
    __typename: "EventFeedback";
    id: string;
    tookPlace: boolean | null;
    insertedAt: string;
    attrs: Record<string, unknown>;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type EventListItemFragment = {
  __typename: "Event";
  id: string;
  subject: string;
  details: string | null;
  startTime: string;
  endTime: string;
  allDay: boolean;
  canceled: boolean;
  cleared: boolean;
  sent: boolean;
  shifted: boolean;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  customerId: string;
  projectId: string;
  contactId: string | null;
  ownerId: string;
  typeId: string;
  type: {
    __typename: "EventType";
    id: string;
    name: string;
    type: EventTypeType;
  } | null;
  contact: { __typename: "Contact"; id: string; displayName: string } | null;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  customer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
    identifier: string;
  } | null;
  project: {
    __typename: "MinimalProject";
    id: string;
    name: string;
    identifier: string;
  } | null;
};

export type EventFeedbackEventFragment = {
  __typename: "Event";
  id: string;
  subject: string;
  details: string | null;
  startTime: string;
  endTime: string;
  canceled: boolean;
  cleared: boolean;
  allDay: boolean;
  contact: { __typename: "Contact"; id: string; displayName: string } | null;
  type: { __typename: "EventType"; id: string; name: string } | null;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type EventFeedbackDetailFragment = {
  __typename: "EventFeedback";
  id: string;
  type: FeedbackType;
  details: string | null;
  tookPlace: boolean | null;
  done: boolean;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  eventId: string;
  ownerId: string;
  creatorId: string;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  event: {
    __typename: "Event";
    id: string;
    subject: string;
    details: string | null;
    startTime: string;
    endTime: string;
    canceled: boolean;
    cleared: boolean;
    allDay: boolean;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: { __typename: "EventType"; id: string; name: string } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  } | null;
};

export type FileExchangeEntryFragment = {
  __typename: "FileExchangeEntry";
  id: string;
  filename: string;
  comment: string | null;
  status: FileExchangeStatus;
  customerId: string;
  projectId: string;
  ownerId: string;
  creatorId: string;
  insertedAt: string;
  updatedAt: string;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type FinanceReportCorrectionFragment = {
  __typename: "FinanceReportCorrection";
  id: string;
  userId: string;
  day: string;
  hours: number | null;
  earnings: string | null;
  expenses: string | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type HistoryAuditLogEntryFragment = {
  __typename: "HistoryAuditLogEntry";
  id: string;
  contactId: string | null;
  action: HistoryAuditLogAction;
  meta: Record<string, unknown>;
  original: Record<string, unknown>;
  changes: Record<string, unknown>;
  insertedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type HistoryFragment = {
  __typename: "History";
  id: string;
  htype: HistoryType;
  subject: string;
  details: string | null;
  meta: Record<string, unknown>;
  contactId: string | null;
  pinned: boolean;
  insertedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type HistoryCallResultFragment = {
  __typename: "CallResult";
  id: string;
  name: string;
};

export type HistoryFileAttachmentFragment = {
  __typename: "HistoryAttachment";
  id: string;
  file: string;
  title: string;
  deleted: boolean;
  deletionReason: string | null;
  deletedBy: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type HistoryAnnotationFragment = {
  __typename: "HistoryAnnotation";
  id: string;
  historyId: string;
  details: string;
  insertedAt: string;
  done: boolean;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type HotseatRequestFragment = {
  __typename: "HotseatRequest";
  id: string;
  url: string | null;
  category: string;
  attrs: Record<string, unknown>;
  customerId: string | null;
  projectId: string | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  customer: { __typename: "MinimalCustomer"; id: string; name: string } | null;
  project: { __typename: "MinimalProject"; id: string; name: string } | null;
};

export type HourOrderFragment = {
  __typename: "HourOrder";
  id: string;
  customerId: string;
  month: string;
  productiveHours: number;
  adminHours: number;
  overCapacityHours: number;
  predictableHolidayHours: number;
  comment: string | null;
  insertedAt: string;
  updatedAt: string;
};

export type IndeedStatsEntryFragment = {
  __typename: "IndeedStatsEntry";
  id: string;
  time: string;
  spend: number;
  insertedAt: string;
  updatedAt: string;
};

export type InventoryItemTypeFragment = {
  __typename: "InventoryItemType";
  id: string;
  customerId: string;
  name: string;
  type: InventoryItemTypeType;
  itemsWanted: number;
  needsCheck: boolean;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
};

export type InventoryTimelineEntryFragment = {
  __typename: "InventoryTimelineEntry";
  id: string;
  inventoryItemId: string;
  creatorId: string;
  userId: string | null;
  type: InventoryTimelineType;
  comment: string | null;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type InventoryItemFragment = {
  __typename: "InventoryItem";
  id: string;
  customerId: string;
  itemTypeId: string;
  lastBeaconId: string | null;
  lastDguvCheckId: string | null;
  name: string;
  serial: string | null;
  location: string | null;
  userId: string | null;
  deploymentInfo: InventoryItemDeploymentInfo;
  status: InventoryItemStatus;
  notes: string | null;
  attrs: Record<string, unknown>;
  needsCheck: boolean | null;
  checkInterval: number;
  insertedAt: string;
  updatedAt: string;
  itemType: {
    __typename: "InventoryItemType";
    id: string;
    type: InventoryItemTypeType;
  } | null;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  lastBeacon: {
    __typename: "InventoryItemBeacon";
    id: string;
    ip: string;
    mouse: boolean;
    keyboard: boolean;
    adapter: boolean;
    webcam: boolean;
    osName: string | null;
    osVersion: string | null;
    lastUser: string | null;
    insertedAt: string;
  } | null;
  lastDguvCheck: {
    __typename: "InventoryTimelineEntry";
    id: string;
    inventoryItemId: string;
    creatorId: string;
    userId: string | null;
    type: InventoryTimelineType;
    comment: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type InventoryItemAttachmentFragment = {
  __typename: "InventoryItemAttachment";
  id: string;
  file: string;
  inventoryItemId: string;
  insertedAt: string;
  updatedAt: string;
};

export type InventorySetFragment = {
  __typename: "InventorySet";
  id: string;
  customerId: string;
  name: string;
  insertedAt: string;
  updatedAt: string;
};

export type InventoryReservationFragment = {
  __typename: "InventoryReservation";
  id: string;
  customerId: string;
  inventorySetId: string;
  quantity: number;
  done: number;
  insertedAt: string;
  updatedAt: string;
  reservedFor: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
  set: { __typename: "InventorySet"; id: string; name: string };
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type InvoiceFragment = {
  __typename: "Invoice";
  id: string;
  periodStart: string;
  periodEnd: string;
  preview: boolean;
  details: Record<string, unknown>;
  locked: boolean;
  lockedById: string | null;
  projectId: string | null;
  insertedAt: string;
  updatedAt: string;
  project: { __typename: "MinimalProject"; id: string; name: string } | null;
  positions: Array<{
    __typename: "InvoicePosition";
    id: string;
    pos: number;
    details: Record<string, unknown>;
  }>;
  attachments: Array<{
    __typename: "InvoiceAttachment";
    id: string;
    file: string;
  }>;
};

export type JobResultFragment = {
  __typename: "JobResult";
  id: string;
  module: string;
  done: boolean;
  seen: boolean;
  hasAttachment: boolean;
  filename: string | null;
  userId: string;
  report: Record<string, unknown> | null;
  insertedAt: string;
  updatedAt: string;
};

export type KnowledgebaseQuestionFragment = {
  __typename: "KnowledgebaseQuestion";
  id: string;
  document: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type KnowledgebaseAttachmentFragment = {
  __typename: "KnowledgebaseAttachment";
  id: string;
  file: string;
  insertedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type KnowledgebaseNgCategoryFragment = {
  __typename: "KnowledgebaseNgCategory";
  id: string;
  name: string;
  parentId: string | null;
  customerId: string;
  insertedAt: string;
  updatedAt: string;
  path: Array<{
    __typename: "KnowledgebaseNgCategory";
    id: string;
    name: string;
  }>;
};

export type KnowledgebaseNgArticleFragment = {
  __typename: "KnowledgebaseNgArticle";
  id: string;
  title: string;
  content: string;
  articleType: KnowledgebaseNgArticleType;
  status: KnowledgebaseNgArticleStatus;
  validFrom: string;
  validUntil: string | null;
  nextReview: string;
  timeless: boolean;
  visibleForExternals: boolean;
  igorSync: boolean;
  tags: Array<string>;
  teamId: string | null;
  ownerId: string;
  creatorId: string;
  editorId: string;
  customerId: string;
  projectId: string;
  insertedAt: string;
  updatedAt: string;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  categories: Array<{
    __typename: "KnowledgebaseNgCategory";
    id: string;
    name: string;
  }>;
  categoryPaths: Array<
    Array<{ __typename: "KnowledgebaseNgCategory"; id: string; name: string }>
  >;
  customer: { __typename: "MinimalCustomer"; id: string; name: string } | null;
  project: { __typename: "MinimalProject"; id: string; name: string } | null;
  team: { __typename: "Team"; id: string; name: string } | null;
  linkedArticles: Array<{
    __typename: "KnowledgebaseNgArticle";
    id: string;
    title: string;
  }>;
};

export type KnowledgebaseNgReviewFragment = {
  __typename: "KnowledgebaseNgReview";
  id: string;
  articleId: string;
  reviewerId: string;
  result: KnowledgebaseNgReviewResult;
  comment: string | null;
  reviewedAt: string | null;
  insertedAt: string;
  updatedAt: string;
  reviewer: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type MailTemplateFragment = {
  __typename: "MailTemplate";
  id: string;
  name: string;
  from: string | null;
  to: string | null;
  cc: string | null;
  bcc: string | null;
  subject: string;
  content: string | null;
  slateContent: Record<string, unknown>;
  mdContent: string;
  insertedAt: string;
  updatedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type MailTemplateAttachmentFragment = {
  __typename: "MailTemplateAttachment";
  id: string;
  name: string;
  attachByDefault: boolean;
  file: string;
  insertedAt: string;
  updatedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type MailFragment = {
  __typename: "Mail";
  id: string;
  threadId: string;
  from: string;
  to: string;
  cc: string | null;
  bcc: string | null;
  isSpam: boolean;
  direction: MailDirection;
  sent: boolean;
  sentAt: string | null;
  status: MailStatus;
  doneAt: string | null;
  receivedAt: string | null;
  attrs: Record<string, unknown>;
  subject: string;
  content: string | null;
  htmlContent: string | null;
  labels: Array<string>;
  folder: string | null;
  account: string | null;
  insertedAt: string;
  updatedAt: string;
  ownerId: string | null;
  editorId: string | null;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  sender: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type MessageFragment = {
  __typename: "Message";
  id: string;
  subject: string | null;
  subjectI18nId: string | null;
  subjectParams: Record<string, unknown> | null;
  seen: boolean;
  format: MessageFormat;
  userId: string;
  insertedAt: string;
  sender: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type OauthTokenFragment = {
  __typename: "OauthToken";
  name: string;
  description: string | null;
  id: string;
  appId: string | null;
  clientId: string | null;
  clientSecret: string | null;
  scopes: string | null;
  grantType: string | null;
  url: string;
  tokenQuery: string;
  accessToken: string | null;
  expires: string | null;
  useBasicAuth: boolean;
  insertedAt: string;
  updatedAt: string;
};

export type StaffPaymentInfoFragment = {
  __typename: "StaffPaymentInfo";
  id: string;
  customerId: string;
  payrollImportJobId: string;
  employeeId: string;
  month: string;
  gross: number;
  net: number;
  paid: number;
  cost: number;
  insertedAt: string;
  updatedAt: string;
  employee: {
    __typename: "Employee";
    id: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
  positions: Array<{
    __typename: "StaffPaymentInfoPosition";
    id: string;
    paymentInfoId: string;
    positionType: string;
    name: string;
    unit: string | null;
    amount: number | null;
    factor: number | null;
    percent: number | null;
    sum: number;
  }>;
};

export type PayrollPdfImportFragment = {
  __typename: "PayrollPdfImport";
  id: string;
  month: string;
  status: PayrollPdfImportStatus;
  importType: PayrollPdfImportType;
  insertedAt: string;
  updatedAt: string;
};

export type PayrollPdfImportErrorFragment = {
  __typename: "PayrollPdfImportError";
  id: string;
  payrollImportJobId: string;
  message: string | null;
  status: PayrollPdfImportErrorStatus;
};

export type PersonalFileFragment = {
  __typename: "PersonalFile";
  id: string;
  file: string;
  mimeType: string;
  description: string | null;
  userId: string;
  read: boolean;
  personalFileTypeId: string | null;
  pubDate: string;
  insertedAt: string;
  updatedAt: string;
  fileType: {
    __typename: "PersonalFileType";
    id: string;
    name: string;
    required: boolean;
    category: string;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type PersonalFileTypeFragment = {
  __typename: "PersonalFileType";
  id: string;
  name: string;
  required: boolean;
  category: string;
  insertedAt: string;
  updatedAt: string;
};

export type ProjectNewsFragment = {
  __typename: "ProjectNews";
  id: string;
  subject: string;
  content: string;
  active: boolean;
  customerId: string;
  projectId: string;
  insertedAt: string;
  updatedAt: string;
};

export type ProjectReportFragment = {
  __typename: "ProjectReport";
  id: string;
  subject: string | null;
  month: string | null;
  reportType: string;
  insertedAt: string;
  updatedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type ProjectListItemFragment = {
  __typename: "Project";
  id: string;
  customerId: string;
  name: string;
  identifier: string;
  active: boolean;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
};

export type ProjectWithCustomerFragment = {
  __typename: "Project";
  id: string;
  customerId: string;
  name: string;
  active: boolean;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  customer: { __typename: "MinimalCustomer"; id: string; name: string } | null;
};

export type ProjectFullFragment = {
  __typename: "Project";
  id: string;
  customerId: string;
  name: string;
  identifier: string;
  active: boolean;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  customer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
    identifier: string;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  } | null;
  users: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
};

export type ProjectAttachmentFragment = {
  __typename: "ProjectAttachment";
  id: string;
  file: string;
  identifier: string;
  insertedAt: string;
  updatedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type PunchlistEntryFragment = {
  __typename: "PunchlistEntry";
  id: string;
  subject: string;
  category: string | null;
  url: string | null;
  description: string;
  status: PunchlistEntryStatus;
  errorDate: string;
  historyId: string | null;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type PunchlistEntryCommentFragment = {
  __typename: "PunchlistEntryComment";
  id: string;
  comment: string;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type PunchlistEntryWithProjectFragment = {
  __typename: "PunchlistEntry";
  id: string;
  subject: string;
  category: string | null;
  url: string | null;
  description: string;
  status: PunchlistEntryStatus;
  errorDate: string;
  historyId: string | null;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  project: {
    __typename: "Project";
    id: string;
    identifier: string;
    name: string;
  };
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type ReminderFragment = {
  __typename: "Reminder";
  id: string;
  name: string;
  identifier: string;
  customerId: string;
  insertedAt: string;
  updatedAt: string;
  recipients: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
};

export type ReminderNotificationFragment = {
  __typename: "ReminderNotification";
  id: string;
  content: string;
  done: boolean;
  doneAt: string | null;
  dueAt: string | null;
  doneById: string | null;
  reminderId: string;
  customerId: string;
  insertedAt: string;
  updatedAt: string;
  doneBy: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  reminder: {
    __typename: "Reminder";
    id: string;
    name: string;
    identifier: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    recipients: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  } | null;
};

export type ResidualLeaveFragment = {
  __typename: "ResidualLeave";
  id: string;
  year: number;
  daysLeft: number;
  userId: string;
  insertedAt: string;
  updatedAt: string;
};

export type RosterAttendanceTypeFragment = {
  __typename: "RosterAttendanceType";
  id: string;
  name: string;
  type: RosterAttendanceTypeType;
  char: string;
  color: string;
  location: RosterLocationType;
  isStandard: boolean;
  ignoreForSickNotes: boolean;
  insertedAt: string;
  updatedAt: string;
};

export type RosterTaskFragment = {
  __typename: "RosterTask";
  id: string;
  name: string;
  type: RosterTaskType;
  char: string;
  color: string;
  notifyUser: boolean;
  notifyMinutes: number | null;
  insertedAt: string;
  updatedAt: string;
  customer: { __typename: "MinimalCustomer"; id: string; name: string };
};

export type RosterGroupFragment = {
  __typename: "RosterGroup";
  id: string;
  name: string;
  insertedAt: string;
  updatedAt: string;
  users: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
  customer: { __typename: "MinimalCustomer"; id: string; name: string };
};

export type RosterStandardAttendanceFragment = {
  __typename: "RosterStandardAttendance";
  id: string;
  weekDay: number;
  attendanceTypeId: string;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  type: {
    __typename: "RosterAttendanceType";
    id: string;
    name: string;
    type: RosterAttendanceTypeType;
    char: string;
    color: string;
    location: RosterLocationType;
    isStandard: boolean;
    ignoreForSickNotes: boolean;
    insertedAt: string;
    updatedAt: string;
  };
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type RosterStandardHourFragment = {
  __typename: "RosterStandardHour";
  id: string;
  hour: string;
  taskId: string;
  task: {
    __typename: "RosterTask";
    id: string;
    name: string;
    type: RosterTaskType;
    char: string;
    color: string;
    notifyUser: boolean;
    notifyMinutes: number | null;
    insertedAt: string;
    updatedAt: string;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  };
};

export type RosterStandardDayFragment = {
  __typename: "RosterStandardDay";
  id: string;
  weekDay: number;
  attendanceTypeId: string | null;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  type: {
    __typename: "RosterAttendanceType";
    id: string;
    name: string;
    type: RosterAttendanceTypeType;
    char: string;
    color: string;
    location: RosterLocationType;
    isStandard: boolean;
    ignoreForSickNotes: boolean;
    insertedAt: string;
    updatedAt: string;
  } | null;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  hours: Array<{
    __typename: "RosterStandardHour";
    id: string;
    hour: string;
    taskId: string;
    task: {
      __typename: "RosterTask";
      id: string;
      name: string;
      type: RosterTaskType;
      char: string;
      color: string;
      notifyUser: boolean;
      notifyMinutes: number | null;
      insertedAt: string;
      updatedAt: string;
      customer: { __typename: "MinimalCustomer"; id: string; name: string };
    };
  }>;
};

export type RosterAttendanceFragment = {
  __typename: "RosterAttendance";
  id: string;
  day: string;
  visible: boolean;
  toBeDeleted: boolean;
  attendanceTypeId: string;
  userId: string;
  insertedAt: string;
  updatedAt: string;
};

export type RosterHourFragment = {
  __typename: "RosterHour";
  id: string;
  hour: string;
  visible: boolean;
  toBeDeleted: boolean;
  taskId: string;
  userId: string;
  insertedAt: string;
  updatedAt: string;
};

export type RosterNotificationFragment = {
  __typename: "RosterNotification";
  id: string;
  content: string;
  done: boolean;
  customerId: string;
  insertedAt: string;
  updatedAt: string;
};

export type SecretFragment = {
  __typename: "Secret";
  id: string;
  customerId: string;
  name: string;
  description: string | null;
  validUntil: string | null;
  insertedAt: string;
  updatedAt: string;
  customer: {
    __typename: "Customer";
    id: string;
    name: string;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  };
};

export type SessionUserFragment = {
  __typename: "User";
  id: string;
  customerId: string;
  username: string;
  email: string | null;
  role: UserRole;
  flags: Array<string>;
  teamLeader: boolean;
  isJumper: boolean;
  billableCustomerId: string | null;
  billableCustomerIds: Array<string>;
  currentBillingCustomerId: string | null;
  defaultProjectId: string | null;
  attrs: Record<string, unknown>;
  passwordReset: string | null;
  otp: boolean;
  currentBillingCustomer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  } | null;
  billableCustomers: Array<{
    __typename: "MinimalCustomer";
    id: string;
    name: string;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  }>;
  avatar: {
    __typename: "UserAvatar";
    thumb: string;
    medium: string;
    original: string;
  };
  contact: {
    __typename: "Contact";
    id: string;
    displayName: string;
    birthdate: string | null;
  } | null;
  projects: Array<{
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    identifier: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  }>;
  customer: {
    __typename: "Customer";
    id: string;
    identifier: string;
    attrs: Record<string, unknown>;
    defaultProject: {
      __typename: "Project";
      id: string;
      identifier: string;
      attrs: Record<string, unknown>;
    } | null;
  } | null;
};

export type SessionProjectFragment = {
  __typename: "Project";
  id: string;
  customerId: string;
  name: string;
  identifier: string;
  active: boolean;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
};

export type SessionCustomerFragment = {
  __typename: "Customer";
  id: string;
  name: string;
  identifier: string;
  defaultProjectId: string | null;
  attrs: Record<string, unknown>;
  logo: {
    __typename: "CustomerLogo";
    thumb: string;
    medium: string;
    original: string;
  };
  projects: Array<{
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    identifier: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  }>;
  customerAdministrators: Array<{
    __typename: "User";
    id: string;
    username: string;
  }>;
};

export type PresettlementFragment = {
  __typename: "Presettlement";
  id: string;
  month: string;
  insertedAt: string;
  updatedAt: string;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  entries: Array<{
    __typename: "PresettlementEntry";
    id: string;
    hourlyWage: number;
    wage: number;
    partialWage: number;
    regularHours: number;
    illnessHours: number;
    vacationHours: number;
    sundayHours: number;
    feastDayHours: number;
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
  wageModifications: Array<{
    __typename: "PresettlementWageModification";
    id: string;
    modification: number;
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type SettlementFragment = {
  __typename: "Settlement";
  id: string;
  month: string;
  isVisible: boolean;
  read: boolean;
  comment: string | null;
  inflationBonus: number | null;
  couponBonus: number | null;
  ticketBonus: number | null;
  travelCosts: number | null;
  userId: string;
  creatorId: string;
  editorId: string;
  insertedAt: string;
  updatedAt: string;
  visibleAt: string | null;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  positions: Array<{
    __typename: "SettlementPosition";
    id: string;
    name: string;
    value: number;
    comment: string | null;
    posType: SettlementPositionType;
  }>;
  corrections: Array<{
    __typename: "SettlementCorrection";
    id: string;
    taskId: string;
    hours: number;
    month: string;
    contractId: string;
    description: string | null;
  }>;
};

export type StaffShareLinkFileFragment = {
  __typename: "StaffShareLinkFile";
  id: string;
  personalFile: {
    __typename: "PersonalFile";
    id: string;
    file: string;
    mimeType: string;
    description: string | null;
    userId: string;
    read: boolean;
    personalFileTypeId: string | null;
    pubDate: string;
    insertedAt: string;
    updatedAt: string;
    fileType: {
      __typename: "PersonalFileType";
      id: string;
      name: string;
      required: boolean;
      category: string;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type StaffShareLinkFragment = {
  __typename: "StaffShareLink";
  id: string;
  customerId: string;
  shareId: string;
  validForDays: number;
  note: string | null;
  insertedAt: string;
  updatedAt: string;
  files: Array<{
    __typename: "StaffShareLinkFile";
    id: string;
    personalFile: {
      __typename: "PersonalFile";
      id: string;
      file: string;
      mimeType: string;
      description: string | null;
      userId: string;
      read: boolean;
      personalFileTypeId: string | null;
      pubDate: string;
      insertedAt: string;
      updatedAt: string;
      fileType: {
        __typename: "PersonalFileType";
        id: string;
        name: string;
        required: boolean;
        category: string;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    };
  }>;
};

export type StaffHistoryFragment = {
  __typename: "StaffHistory";
  id: string;
  htype: StaffHistoryType;
  text: string;
  date: string;
  nextTalk: string | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type TaskListFragmentFragment = {
  __typename: "Task";
  id: string;
  contactType: string;
  type: TaskType;
  questionnaireType: string | null;
  attrs: Record<string, unknown>;
  reactionNeeded: boolean;
  description: string | null;
  sent: boolean;
  accepted: boolean | null;
  reason: string | null;
  points: number;
  wantedPoints: number;
  insertedAt: string;
  updatedAt: string;
  contactId: string | null;
  creatorId: string;
  editorId: string;
  contact: {
    __typename: "Contact";
    id: string;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    displayName: string;
    attrs: Record<string, unknown>;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type TaskProductFragmentFragment = {
  __typename: "TaskProduct";
  id: string;
  name: string;
  price: number;
};

export type TaskOfferFragmentFragment = {
  __typename: "TaskOffer";
  id: string;
  name: string;
  start: string;
  ends: string | null;
};

export type TaskOfferWithProductsFragmentFragment = {
  __typename: "TaskOffer";
  id: string;
  name: string;
  start: string;
  ends: string | null;
  products: Array<{
    __typename: "TaskProduct";
    id: string;
    name: string;
    price: number;
  }>;
};

export type TaskProductWithOfferFragmentFragment = {
  __typename: "TaskProduct";
  id: string;
  name: string;
  price: number;
  offer: {
    __typename: "TaskOffer";
    id: string;
    name: string;
    start: string;
    ends: string | null;
  };
};

export type TaskFragmentFragment = {
  __typename: "Task";
  id: string;
  contactType: string;
  type: TaskType;
  questionnaireType: string | null;
  attrs: Record<string, unknown>;
  reactionNeeded: boolean;
  description: string | null;
  sent: boolean;
  insertedAt: string;
  updatedAt: string;
  contactId: string | null;
  contact: {
    __typename: "Contact";
    id: string;
    displayName: string;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    isCompany: boolean;
    statusId: string | null;
    attrs: Record<string, unknown>;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      atype: ContactAddressType;
      description: string | null;
      address: string | null;
      zip: string | null;
      city: string | null;
      cityPart: string | null;
      country: string | null;
    } | null;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      itype: ContactInfoType;
      value: string | null;
      confirmedAt: string | null;
    }>;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type TeamListItemFragment = {
  __typename: "Team";
  id: string;
  name: string;
  insertedAt: string;
  updatedAt: string;
  project: {
    __typename: "MinimalProject";
    id: string;
    name: string;
    identifier: string;
  };
};

export type RecruitingSummaryFragment = {
  __typename: "RecruitingSummary";
  name: string;
  teamId: string;
  wanted: number;
  planned: number;
  employed: number;
};

export type TeamWithUsersFragment = {
  __typename: "Team";
  id: string;
  name: string;
  users: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
};

export type TeamWithUsersAndForeignUsersFragment = {
  __typename: "Team";
  id: string;
  name: string;
  users: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
  foreignUsers: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
};

export type TeamDetailFragment = {
  __typename: "Team";
  id: string;
  name: string;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  users: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
  leaders: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
  foreignUsers: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
  foreignLeaders: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
};

export type TermitelContractAttachmentFragment = {
  __typename: "TermitelContractAttachment";
  id: string;
  contractId: string;
  documentType: TermitelContractDocumentType;
  filename: string;
  insertedAt: string;
  updatedAt: string;
};

export type TermitelContractFragment = {
  __typename: "TermitelContract";
  id: string;
  contactId: string;
  starts: string;
  ends: string | null;
  contract: TermitelContractFileStatus;
  orderDataProcessing: TermitelContractFileStatus;
  letterOfIndemnity: TermitelContractFileStatus;
  runtime: number | null;
  runtimeType: TermitelContractRuntimeType;
  noticePeriod: number | null;
  noticePeriodType: TermitelContractNoticePeriodType;
  paymentGoal: number | null;
  paymentGoalType: TermitelContractPaymentGoalType;
  deletionPeriod: number | null;
  deletionPeriodType: TermitelContractDeletionPeriodType;
  insertedAt: string;
  updatedAt: string;
  nextPossibleTermination: string | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  documents: Array<{
    __typename: "TermitelContractAttachment";
    id: string;
    contractId: string;
    documentType: TermitelContractDocumentType;
    filename: string;
    insertedAt: string;
    updatedAt: string;
  }>;
  contact: { __typename: "Contact"; id: string; displayName: string };
};

export type TimelineEntryFragment = {
  __typename: "TicketTimelineEntry";
  id: string;
  type: TimelineEntryType;
  effort: number | null;
  content: string | null;
  file: string | null;
  userId: string;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type TicketFragment = {
  __typename: "Ticket";
  id: string;
  priority: number | null;
  subject: string;
  description: string | null;
  status: TicketState;
  url: string | null;
  category: TicketCategory | null;
  forecastedEffort: number | null;
  realEffort: number;
  solution: TicketSolution | null;
  attrs: Record<string, unknown>;
  document: Record<string, unknown>;
  mdContent: string;
  visible: boolean | null;
  doneAt: string | null;
  dueDate: string | null;
  insertedAt: string;
  updatedAt: string;
  reporterId: string | null;
  ownerId: string | null;
  orderedById: string | null;
  nextStepById: string | null;
  relevantCustomerId: string | null;
  relevantProjectId: string | null;
  reporter: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  orderedBy: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  nextStepBy: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  relevantCustomer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
    identifier: string;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  } | null;
  relevantProject: {
    __typename: "MinimalProject";
    id: string;
    identifier: string;
    name: string;
  } | null;
};

export type TimesheetYearOverviewDayFragment = {
  __typename: "TimesheetYearOverviewDay";
  date: string;
  type: string;
};

export type TodoDetailFragmentFragment = {
  __typename: "Todo";
  id: string;
  parentId: string | null;
  description: string;
  file: string | null;
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  allDone: boolean;
  done: boolean;
  doneAt: string | null;
  doneText: string | null;
  sent: boolean;
  status: Status | null;
  statusAssignedAt: string | null;
  statusAttrs: Record<string, unknown>;
  ownerId: string | null;
  contactId: string | null;
  creatorId: string;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  contact: {
    __typename: "Contact";
    id: string;
    firstname: string | null;
    lastname: string | null;
    displayName: string;
    attrs: Record<string, unknown>;
  } | null;
  doneBy: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  todos: Array<{
    __typename: "Todo";
    id: string;
    parentId: string | null;
    attrs: Record<string, unknown>;
    description: string;
    file: string | null;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    insertedAt: string;
    updatedAt: string;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
  notes: Array<{
    __typename: "TodoNote";
    id: string;
    text: string | null;
    file: string | null;
    insertedAt: string;
    todoId: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type UploadFragment = {
  __typename: "ProjectUpload";
  id: string;
  file: string;
  comment: string | null;
  status: UploadStatus;
  message: string | null;
  imported: number | null;
  insertedAt: string;
  updatedAt: string;
  doneAt: string | null;
  owner: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  doneBy: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type UserAvatarFragment = {
  __typename: "UserAvatar";
  thumb: string;
  medium: string;
  original: string;
};

export type UserFragment = {
  __typename: "User";
  id: string;
  username: string;
  email: string | null;
  active: boolean;
  retired: boolean;
  role: UserRole;
  homeoffice: boolean;
  bio: string | null;
  customerId: string;
  attrs: Record<string, unknown>;
  lastSeenAt: string | null;
  passwordReset: string | null;
  otp: boolean;
  billableCustomerId: string | null;
  defaultProjectId: string | null;
  avatar: {
    __typename: "UserAvatar";
    thumb: string;
    medium: string;
    original: string;
  };
  contact: {
    __typename: "Contact";
    id: string;
    firstname: string | null;
    lastname: string | null;
    displayName: string;
    companyName: string | null;
    birthdate: string | null;
  } | null;
};

export type UserWithBillingFragment = {
  __typename: "User";
  id: string;
  username: string;
  email: string | null;
  active: boolean;
  retired: boolean;
  role: UserRole;
  homeoffice: boolean;
  bio: string | null;
  customerId: string;
  attrs: Record<string, unknown>;
  lastSeenAt: string | null;
  passwordReset: string | null;
  otp: boolean;
  billableCustomerId: string | null;
  defaultProjectId: string | null;
  billableCustomer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
  } | null;
  billableCustomers: Array<{
    __typename: "MinimalCustomer";
    id: string;
    name: string;
  }>;
  currentBillingCustomer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
  } | null;
  avatar: {
    __typename: "UserAvatar";
    thumb: string;
    medium: string;
    original: string;
  };
  contact: {
    __typename: "Contact";
    id: string;
    firstname: string | null;
    lastname: string | null;
    displayName: string;
    companyName: string | null;
    birthdate: string | null;
  } | null;
};

export type UserWithDetailsFragment = {
  __typename: "User";
  isJumper: boolean;
  billableCustomerIds: Array<string>;
  id: string;
  username: string;
  email: string | null;
  active: boolean;
  retired: boolean;
  role: UserRole;
  homeoffice: boolean;
  bio: string | null;
  customerId: string;
  attrs: Record<string, unknown>;
  lastSeenAt: string | null;
  passwordReset: string | null;
  otp: boolean;
  billableCustomerId: string | null;
  defaultProjectId: string | null;
  contact: {
    __typename: "Contact";
    isCompany: boolean;
    salutation: string | null;
    id: string;
    firstname: string | null;
    lastname: string | null;
    displayName: string;
    companyName: string | null;
    birthdate: string | null;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      itype: ContactInfoType;
      value: string | null;
      normalizedValue: string | null;
    }>;
  } | null;
  profiles: Array<{
    __typename: "Profile";
    id: string;
    name: string;
    attrs: Record<string, unknown>;
  }>;
  projects: Array<{
    __typename: "Project";
    id: string;
    name: string;
    customerId: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
  }>;
  userCustomers: Array<{ __typename: "Customer"; id: string; name: string }>;
  adminCustomers: Array<{ __typename: "Customer"; id: string; name: string }>;
  userTeams: Array<{ __typename: "Team"; id: string }>;
  leaderTeams: Array<{ __typename: "Team"; id: string }>;
  foreignUserTeams: Array<{ __typename: "Team"; id: string }>;
  foreignLeaderTeams: Array<{ __typename: "Team"; id: string }>;
  avatar: {
    __typename: "UserAvatar";
    thumb: string;
    medium: string;
    original: string;
  };
};

export type WorktimeTaskFragment = {
  __typename: "WorktimesTask";
  id: string;
  name: string;
  type: WorktimesTaskType;
  paid: boolean;
  productive: boolean;
  sidebar: boolean;
  allowInCorrections: boolean;
  position: number;
  acdId: string | null;
};

export type WorktimeWoUserFragment = {
  __typename: "Worktime";
  id: string;
  starts: string;
  stops: string | null;
  userId: string;
  comment: string | null;
  declined: boolean;
  declineReason: string | null;
  billingCustomerId: string | null;
  customerId: string;
  task: {
    __typename: "WorktimesTask";
    id: string;
    name: string;
    type: WorktimesTaskType;
    paid: boolean;
  };
  billingCustomer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
  } | null;
};

export type WorktimeFragment = {
  __typename: "Worktime";
  id: string;
  starts: string;
  stops: string | null;
  comment: string | null;
  declined: boolean;
  declineReason: string | null;
  acdId: string | null;
  customerId: string;
  billingCustomerId: string | null;
  customerReviewDone: boolean;
  userId: string;
  taskId: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  task: {
    __typename: "WorktimesTask";
    id: string;
    type: WorktimesTaskType;
    name: string;
    paid: boolean;
  };
};

export type WorktimesChangeRequestTaskFragment = {
  __typename: "WorktimesTask";
  id: string;
  name: string;
  paid: boolean;
  productive: boolean;
  sidebar: boolean;
  allowInCorrections: boolean;
  position: number;
  type: WorktimesTaskType;
  acdId: string | null;
};

export type WorktimesChangeRequestFragment = {
  __typename: "WorktimesChangeRequest";
  id: string;
  userId: string;
  status: WorktimesChangeRequestStatus;
  comment: string | null;
  adminComment: string | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type WorktimesChangeRequestEntryFragment = {
  __typename: "WorktimesChangeRequestEntry";
  id: string;
  starts: string;
  stops: string;
  billingCustomerId: string | null;
  task: {
    __typename: "WorktimesTask";
    id: string;
    name: string;
    paid: boolean;
    productive: boolean;
    sidebar: boolean;
    allowInCorrections: boolean;
    position: number;
    type: WorktimesTaskType;
    acdId: string | null;
  };
  billingCustomer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
  } | null;
};

export type AcdCallsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListAcdCallsFilters | null | undefined;
}>;

export type AcdCallsQuery = {
  __typename: "QueryRoot";
  acdCalls: Array<{
    __typename: "AcdCall";
    id: string;
    status: AcdCallStatus;
    direction: CallDirectionOption;
    initiator: string | null;
    calledNo: string | null;
    peerNos: Array<string>;
    duration: number;
    waiting: number;
    callResult: AcdCallResult;
    connectedPeer: string | null;
    noCalls: number;
    firstCall: string | null;
    lastCall: string | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
  }>;
};

export type CountAcdCallsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListAcdCallsFilters | null | undefined;
}>;

export type CountAcdCallsQuery = {
  __typename: "QueryRoot";
  countAcdCalls: string;
};

export type AcdCallQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type AcdCallQuery = {
  __typename: "QueryRoot";
  acdCall: {
    __typename: "AcdCall";
    id: string;
    status: AcdCallStatus;
    direction: CallDirectionOption;
    initiator: string | null;
    calledNo: string | null;
    peerNos: Array<string>;
    duration: number;
    waiting: number;
    callResult: AcdCallResult;
    connectedPeer: string | null;
    noCalls: number;
    firstCall: string | null;
    lastCall: string | null;
    callTimes: Array<{
      __typename: "AcdCallTime";
      id: string;
      acdId: string;
      callTime: string;
      direction: CallDirectionOption;
      initiator: string | null;
      calledNo: string | null;
      peerNos: Array<string>;
      duration: number;
      waiting: number;
      callResult: AcdCallResult;
      connectedPeer: string | null;
    }>;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
  } | null;
};

export type AcdCallTimesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type AcdCallTimesQuery = {
  __typename: "QueryRoot";
  acdCallTimes: Array<{
    __typename: "AcdCallTime";
    id: string;
    acdId: string;
    callTime: string;
    direction: CallDirectionOption;
    initiator: string | null;
    calledNo: string | null;
    peerNos: Array<string>;
    duration: number;
    waiting: number;
    callResult: AcdCallResult;
    connectedPeer: string | null;
  }>;
};

export type MutateAcdCallMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  call: AcdCallInput;
}>;

export type MutateAcdCallMutation = {
  __typename: "MutationRoot";
  mutateAcdCall: {
    __typename: "AcdCall";
    id: string;
    status: AcdCallStatus;
    direction: CallDirectionOption;
    initiator: string | null;
    calledNo: string | null;
    peerNos: Array<string>;
    duration: number;
    waiting: number;
    callResult: AcdCallResult;
    connectedPeer: string | null;
    noCalls: number;
    firstCall: string | null;
    lastCall: string | null;
    callTimes: Array<{
      __typename: "AcdCallTime";
      id: string;
      acdId: string;
      callTime: string;
      direction: CallDirectionOption;
      initiator: string | null;
      calledNo: string | null;
      peerNos: Array<string>;
      duration: number;
      waiting: number;
      callResult: AcdCallResult;
      connectedPeer: string | null;
    }>;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
  };
};

export type ContactsRegenStatusChangesMutationVariables = Exact<{
  start: string;
  stop: string;
}>;

export type ContactsRegenStatusChangesMutation = {
  __typename: "MutationRoot";
  contactsRegenStatusChanges: boolean;
};

export type ApiKeysQueryVariables = Exact<{
  filters?: ListApiKeysFilters | null | undefined;
}>;

export type ApiKeysQuery = {
  __typename: "QueryRoot";
  apiKeys: Array<{
    __typename: "ApiKey";
    id: string;
    customerId: string;
    userId: string;
    name: string;
    validUntil: string;
    revokedAt: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    customer: {
      __typename: "Customer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  }>;
};

export type CountApiKeysQueryVariables = Exact<{
  filters?: ListApiKeysFilters | null | undefined;
}>;

export type CountApiKeysQuery = {
  __typename: "QueryRoot";
  countApiKeys: string;
};

export type CreateApiKeyMutationVariables = Exact<{
  values: ApiKeyInput;
}>;

export type CreateApiKeyMutation = {
  __typename: "MutationRoot";
  createApiKey: {
    __typename: "CreateApiKeyResult";
    token: string;
    apiKey: {
      __typename: "ApiKey";
      id: string;
      customerId: string;
      userId: string;
      name: string;
      validUntil: string;
      revokedAt: string | null;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
      customer: {
        __typename: "Customer";
        id: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    };
  };
};

export type RevokeApiKeyMutationVariables = Exact<{
  id: string;
}>;

export type RevokeApiKeyMutation = {
  __typename: "MutationRoot";
  revokeApiKey: {
    __typename: "ApiKey";
    id: string;
    customerId: string;
    userId: string;
    name: string;
    validUntil: string;
    revokedAt: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    customer: {
      __typename: "Customer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  };
};

export type LogEntriesQueryVariables = Exact<{
  filters: LogFilters;
}>;

export type LogEntriesQuery = {
  __typename: "QueryRoot";
  logEntries: Array<{
    __typename: "LogEntry";
    id: string;
    relid: string;
    relation: string;
    action: string;
    previousContents: Record<string, unknown> | null;
    contents: Record<string, unknown> | null;
    userId: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type CountLogEntriesQueryVariables = Exact<{
  filters: CountLogFilters;
}>;

export type CountLogEntriesQuery = {
  __typename: "QueryRoot";
  countLogEntries: string;
};

export type LogEntryQueryVariables = Exact<{
  id: string;
}>;

export type LogEntryQuery = {
  __typename: "QueryRoot";
  logEntry: {
    __typename: "LogEntry";
    id: string;
    relid: string;
    relation: string;
    action: string;
    previousContents: Record<string, unknown> | null;
    contents: Record<string, unknown> | null;
    userId: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  } | null;
};

export type ChangeRequestsQueryVariables = Exact<{
  customerId: string;
  filters?: ChangeRequestListFilters | null | undefined;
}>;

export type ChangeRequestsQuery = {
  __typename: "QueryRoot";
  changeRequests: Array<{
    __typename: "ChangeRequest";
    id: string;
    customerId: string;
    employeeId: string | null;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    email: string | null;
    status: ChangeRequestStatus;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      entering: string;
      leaving: string | null;
      active: boolean;
      datevEmployeeNo: string | null;
      deleted: boolean;
      iban: string | null;
      bic: string | null;
      taxId: string | null;
      socialSecurityNumber: string | null;
      standardBonus: number | null;
      dataProtectionTrainingCompletedAt: string | null;
      cpsNumber: string | null;
      headset: string | null;
      healthInsurance: string | null;
      notes: string | null;
      probationEnding: string | null;
      employeeName: string | null;
      gender: EmployeeGender | null;
      nationality: string | null;
      placeOfBirth: string | null;
      countryOfBirth: string | null;
      civilStatus: EmployeeCivilStatus | null;
      disability: boolean;
      disabilityLevel: number | null;
      taxLevel: number | null;
      childTaxAllowance: number | null;
      additionalJobs: string | null;
      denomination: string | null;
      languagesFluent: Array<string>;
      languagesNative: Array<string>;
      position: string | null;
      levels: Array<Level>;
      sickDaysLimit: number | null;
      userId: string;
      insertedAt: string;
      updatedAt: string;
      children: Array<{
        __typename: "EmployeeChild";
        id: string;
        name: string;
        birthdate: string;
      }>;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        contact: {
          __typename: "Contact";
          id: string;
          customerId: string;
          projectId: string;
          salutation: string | null;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
          infos: Array<{
            __typename: "ContactInfo";
            id: string;
            description: string | null;
            itype: ContactInfoType;
            normalizedValue: string | null;
            value: string | null;
            confirmedAt: string | null;
            confirmationSentAt: string | null;
            insertedAt: string;
            updatedAt: string;
          }>;
          addresses: Array<{
            __typename: "ContactAddress";
            id: string;
            address: string | null;
            atype: ContactAddressType;
            city: string | null;
            cityPart: string | null;
            country: string | null;
            description: string | null;
            zip: string | null;
          }>;
        } | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
  }>;
};

export type CountChangeRequestsQueryVariables = Exact<{
  customerId: string;
  filters?: ChangeRequestListFilters | null | undefined;
}>;

export type CountChangeRequestsQuery = {
  __typename: "QueryRoot";
  countChangeRequests: string;
};

export type ChangeRequestQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ChangeRequestQuery = {
  __typename: "QueryRoot";
  changeRequest: {
    __typename: "ChangeRequest";
    id: string;
    customerId: string;
    employeeId: string | null;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean | null;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    denomination: string | null;
    additionalJobs: string | null;
    address: string | null;
    zip: string | null;
    city: string | null;
    email: string | null;
    phone: string | null;
    landline: string | null;
    emergencyContactName: string | null;
    emergencyContactPhone: string | null;
    birthdate: string | null;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    healthInsurance: string | null;
    languagesFluent: Array<string> | null;
    languagesNative: Array<string> | null;
    emailConfirmationToken: string | null;
    emailConfirmed: boolean;
    requestComment: string | null;
    returnComment: string | null;
    status: ChangeRequestStatus;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      entering: string;
      leaving: string | null;
      active: boolean;
      datevEmployeeNo: string | null;
      deleted: boolean;
      iban: string | null;
      bic: string | null;
      taxId: string | null;
      socialSecurityNumber: string | null;
      standardBonus: number | null;
      dataProtectionTrainingCompletedAt: string | null;
      cpsNumber: string | null;
      headset: string | null;
      healthInsurance: string | null;
      notes: string | null;
      probationEnding: string | null;
      employeeName: string | null;
      gender: EmployeeGender | null;
      nationality: string | null;
      placeOfBirth: string | null;
      countryOfBirth: string | null;
      civilStatus: EmployeeCivilStatus | null;
      disability: boolean;
      disabilityLevel: number | null;
      taxLevel: number | null;
      childTaxAllowance: number | null;
      additionalJobs: string | null;
      denomination: string | null;
      languagesFluent: Array<string>;
      languagesNative: Array<string>;
      position: string | null;
      levels: Array<Level>;
      sickDaysLimit: number | null;
      userId: string;
      insertedAt: string;
      updatedAt: string;
      children: Array<{
        __typename: "EmployeeChild";
        id: string;
        name: string;
        birthdate: string;
      }>;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        contact: {
          __typename: "Contact";
          id: string;
          customerId: string;
          projectId: string;
          salutation: string | null;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
          infos: Array<{
            __typename: "ContactInfo";
            id: string;
            description: string | null;
            itype: ContactInfoType;
            normalizedValue: string | null;
            value: string | null;
            confirmedAt: string | null;
            confirmationSentAt: string | null;
            insertedAt: string;
            updatedAt: string;
          }>;
          addresses: Array<{
            __typename: "ContactAddress";
            id: string;
            address: string | null;
            atype: ContactAddressType;
            city: string | null;
            cityPart: string | null;
            country: string | null;
            description: string | null;
            zip: string | null;
          }>;
        } | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    children: Array<{
      __typename: "Child";
      id: string;
      name: string;
      birthdate: string;
    }>;
  } | null;
};

export type ChangeRequestByTokenQueryVariables = Exact<{
  token: string;
}>;

export type ChangeRequestByTokenQuery = {
  __typename: "QueryRoot";
  changeRequestByToken: {
    __typename: "ChangeRequest";
    id: string;
    customerId: string;
    employeeId: string | null;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean | null;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    denomination: string | null;
    additionalJobs: string | null;
    address: string | null;
    zip: string | null;
    city: string | null;
    email: string | null;
    phone: string | null;
    landline: string | null;
    emergencyContactName: string | null;
    emergencyContactPhone: string | null;
    birthdate: string | null;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    healthInsurance: string | null;
    languagesFluent: Array<string> | null;
    languagesNative: Array<string> | null;
    emailConfirmationToken: string | null;
    emailConfirmed: boolean;
    requestComment: string | null;
    returnComment: string | null;
    status: ChangeRequestStatus;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      entering: string;
      leaving: string | null;
      active: boolean;
      datevEmployeeNo: string | null;
      deleted: boolean;
      iban: string | null;
      bic: string | null;
      taxId: string | null;
      socialSecurityNumber: string | null;
      standardBonus: number | null;
      dataProtectionTrainingCompletedAt: string | null;
      cpsNumber: string | null;
      headset: string | null;
      healthInsurance: string | null;
      notes: string | null;
      probationEnding: string | null;
      employeeName: string | null;
      gender: EmployeeGender | null;
      nationality: string | null;
      placeOfBirth: string | null;
      countryOfBirth: string | null;
      civilStatus: EmployeeCivilStatus | null;
      disability: boolean;
      disabilityLevel: number | null;
      taxLevel: number | null;
      childTaxAllowance: number | null;
      additionalJobs: string | null;
      denomination: string | null;
      languagesFluent: Array<string>;
      languagesNative: Array<string>;
      position: string | null;
      levels: Array<Level>;
      sickDaysLimit: number | null;
      userId: string;
      insertedAt: string;
      updatedAt: string;
      children: Array<{
        __typename: "EmployeeChild";
        id: string;
        name: string;
        birthdate: string;
      }>;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        contact: {
          __typename: "Contact";
          id: string;
          customerId: string;
          projectId: string;
          salutation: string | null;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
          infos: Array<{
            __typename: "ContactInfo";
            id: string;
            description: string | null;
            itype: ContactInfoType;
            normalizedValue: string | null;
            value: string | null;
            confirmedAt: string | null;
            confirmationSentAt: string | null;
            insertedAt: string;
            updatedAt: string;
          }>;
          addresses: Array<{
            __typename: "ContactAddress";
            id: string;
            address: string | null;
            atype: ContactAddressType;
            city: string | null;
            cityPart: string | null;
            country: string | null;
            description: string | null;
            zip: string | null;
          }>;
        } | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    children: Array<{
      __typename: "Child";
      id: string;
      name: string;
      birthdate: string;
    }>;
  } | null;
};

export type DeleteChangeRequestMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteChangeRequestMutation = {
  __typename: "MutationRoot";
  deleteChangeRequest: { __typename: "ChangeRequest"; id: string };
};

export type MutateChangeRequestMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: ChangeRequestInput;
}>;

export type MutateChangeRequestMutation = {
  __typename: "MutationRoot";
  mutateChangeRequest: {
    __typename: "ChangeRequest";
    id: string;
    customerId: string;
    employeeId: string | null;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean | null;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    denomination: string | null;
    additionalJobs: string | null;
    address: string | null;
    zip: string | null;
    city: string | null;
    email: string | null;
    phone: string | null;
    landline: string | null;
    emergencyContactName: string | null;
    emergencyContactPhone: string | null;
    birthdate: string | null;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    healthInsurance: string | null;
    languagesFluent: Array<string> | null;
    languagesNative: Array<string> | null;
    emailConfirmationToken: string | null;
    emailConfirmed: boolean;
    requestComment: string | null;
    returnComment: string | null;
    status: ChangeRequestStatus;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      entering: string;
      leaving: string | null;
      active: boolean;
      datevEmployeeNo: string | null;
      deleted: boolean;
      iban: string | null;
      bic: string | null;
      taxId: string | null;
      socialSecurityNumber: string | null;
      standardBonus: number | null;
      dataProtectionTrainingCompletedAt: string | null;
      cpsNumber: string | null;
      headset: string | null;
      healthInsurance: string | null;
      notes: string | null;
      probationEnding: string | null;
      employeeName: string | null;
      gender: EmployeeGender | null;
      nationality: string | null;
      placeOfBirth: string | null;
      countryOfBirth: string | null;
      civilStatus: EmployeeCivilStatus | null;
      disability: boolean;
      disabilityLevel: number | null;
      taxLevel: number | null;
      childTaxAllowance: number | null;
      additionalJobs: string | null;
      denomination: string | null;
      languagesFluent: Array<string>;
      languagesNative: Array<string>;
      position: string | null;
      levels: Array<Level>;
      sickDaysLimit: number | null;
      userId: string;
      insertedAt: string;
      updatedAt: string;
      children: Array<{
        __typename: "EmployeeChild";
        id: string;
        name: string;
        birthdate: string;
      }>;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        contact: {
          __typename: "Contact";
          id: string;
          customerId: string;
          projectId: string;
          salutation: string | null;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
          infos: Array<{
            __typename: "ContactInfo";
            id: string;
            description: string | null;
            itype: ContactInfoType;
            normalizedValue: string | null;
            value: string | null;
            confirmedAt: string | null;
            confirmationSentAt: string | null;
            insertedAt: string;
            updatedAt: string;
          }>;
          addresses: Array<{
            __typename: "ContactAddress";
            id: string;
            address: string | null;
            atype: ContactAddressType;
            city: string | null;
            cityPart: string | null;
            country: string | null;
            description: string | null;
            zip: string | null;
          }>;
        } | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    children: Array<{
      __typename: "Child";
      id: string;
      name: string;
      birthdate: string;
    }>;
  };
};

export type MutateChangeRequestByTokenMutationVariables = Exact<{
  token: string;
  values: ChangeRequestInput;
}>;

export type MutateChangeRequestByTokenMutation = {
  __typename: "MutationRoot";
  mutateChangeRequestByToken: {
    __typename: "ChangeRequest";
    id: string;
    customerId: string;
    employeeId: string | null;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean | null;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    denomination: string | null;
    additionalJobs: string | null;
    address: string | null;
    zip: string | null;
    city: string | null;
    email: string | null;
    phone: string | null;
    landline: string | null;
    emergencyContactName: string | null;
    emergencyContactPhone: string | null;
    birthdate: string | null;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    healthInsurance: string | null;
    languagesFluent: Array<string> | null;
    languagesNative: Array<string> | null;
    emailConfirmationToken: string | null;
    emailConfirmed: boolean;
    requestComment: string | null;
    returnComment: string | null;
    status: ChangeRequestStatus;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      entering: string;
      leaving: string | null;
      active: boolean;
      datevEmployeeNo: string | null;
      deleted: boolean;
      iban: string | null;
      bic: string | null;
      taxId: string | null;
      socialSecurityNumber: string | null;
      standardBonus: number | null;
      dataProtectionTrainingCompletedAt: string | null;
      cpsNumber: string | null;
      headset: string | null;
      healthInsurance: string | null;
      notes: string | null;
      probationEnding: string | null;
      employeeName: string | null;
      gender: EmployeeGender | null;
      nationality: string | null;
      placeOfBirth: string | null;
      countryOfBirth: string | null;
      civilStatus: EmployeeCivilStatus | null;
      disability: boolean;
      disabilityLevel: number | null;
      taxLevel: number | null;
      childTaxAllowance: number | null;
      additionalJobs: string | null;
      denomination: string | null;
      languagesFluent: Array<string>;
      languagesNative: Array<string>;
      position: string | null;
      levels: Array<Level>;
      sickDaysLimit: number | null;
      userId: string;
      insertedAt: string;
      updatedAt: string;
      children: Array<{
        __typename: "EmployeeChild";
        id: string;
        name: string;
        birthdate: string;
      }>;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        contact: {
          __typename: "Contact";
          id: string;
          customerId: string;
          projectId: string;
          salutation: string | null;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
          infos: Array<{
            __typename: "ContactInfo";
            id: string;
            description: string | null;
            itype: ContactInfoType;
            normalizedValue: string | null;
            value: string | null;
            confirmedAt: string | null;
            confirmationSentAt: string | null;
            insertedAt: string;
            updatedAt: string;
          }>;
          addresses: Array<{
            __typename: "ContactAddress";
            id: string;
            address: string | null;
            atype: ContactAddressType;
            city: string | null;
            cityPart: string | null;
            country: string | null;
            description: string | null;
            zip: string | null;
          }>;
        } | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    children: Array<{
      __typename: "Child";
      id: string;
      name: string;
      birthdate: string;
    }>;
  };
};

export type SendChangeRequestMutationVariables = Exact<{
  customerId: string;
  email: string;
  date: string;
}>;

export type SendChangeRequestMutation = {
  __typename: "MutationRoot";
  sendChangeRequest: {
    __typename: "ChangeRequest";
    id: string;
    customerId: string;
    employeeId: string | null;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean | null;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    denomination: string | null;
    additionalJobs: string | null;
    address: string | null;
    zip: string | null;
    city: string | null;
    email: string | null;
    phone: string | null;
    landline: string | null;
    emergencyContactName: string | null;
    emergencyContactPhone: string | null;
    birthdate: string | null;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    healthInsurance: string | null;
    languagesFluent: Array<string> | null;
    languagesNative: Array<string> | null;
    emailConfirmationToken: string | null;
    emailConfirmed: boolean;
    requestComment: string | null;
    returnComment: string | null;
    status: ChangeRequestStatus;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      entering: string;
      leaving: string | null;
      active: boolean;
      datevEmployeeNo: string | null;
      deleted: boolean;
      iban: string | null;
      bic: string | null;
      taxId: string | null;
      socialSecurityNumber: string | null;
      standardBonus: number | null;
      dataProtectionTrainingCompletedAt: string | null;
      cpsNumber: string | null;
      headset: string | null;
      healthInsurance: string | null;
      notes: string | null;
      probationEnding: string | null;
      employeeName: string | null;
      gender: EmployeeGender | null;
      nationality: string | null;
      placeOfBirth: string | null;
      countryOfBirth: string | null;
      civilStatus: EmployeeCivilStatus | null;
      disability: boolean;
      disabilityLevel: number | null;
      taxLevel: number | null;
      childTaxAllowance: number | null;
      additionalJobs: string | null;
      denomination: string | null;
      languagesFluent: Array<string>;
      languagesNative: Array<string>;
      position: string | null;
      levels: Array<Level>;
      sickDaysLimit: number | null;
      userId: string;
      insertedAt: string;
      updatedAt: string;
      children: Array<{
        __typename: "EmployeeChild";
        id: string;
        name: string;
        birthdate: string;
      }>;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        contact: {
          __typename: "Contact";
          id: string;
          customerId: string;
          projectId: string;
          salutation: string | null;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
          infos: Array<{
            __typename: "ContactInfo";
            id: string;
            description: string | null;
            itype: ContactInfoType;
            normalizedValue: string | null;
            value: string | null;
            confirmedAt: string | null;
            confirmationSentAt: string | null;
            insertedAt: string;
            updatedAt: string;
          }>;
          addresses: Array<{
            __typename: "ContactAddress";
            id: string;
            address: string | null;
            atype: ContactAddressType;
            city: string | null;
            cityPart: string | null;
            country: string | null;
            description: string | null;
            zip: string | null;
          }>;
        } | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    children: Array<{
      __typename: "Child";
      id: string;
      name: string;
      birthdate: string;
    }>;
  };
};

export type CoachingFragment = {
  __typename: "Coaching";
  id: string;
  description: string | null;
  employeeInput: string | null;
  attrs: Record<string, unknown>;
  signed: boolean;
  nextAppointment: string | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  relevantCustomer: {
    __typename: "MinimalCustomer";
    id: string;
    name: string;
    identifier: string;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  } | null;
  relevantProject: {
    __typename: "MinimalProject";
    id: string;
    name: string;
    identifier: string;
  } | null;
};

export type CoachingsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListCoachingsFilters | null | undefined;
}>;

export type CoachingsQuery = {
  __typename: "QueryRoot";
  coachings: Array<{
    __typename: "Coaching";
    id: string;
    description: string | null;
    employeeInput: string | null;
    attrs: Record<string, unknown>;
    signed: boolean;
    nextAppointment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    relevantCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
  }>;
};

export type CountCoachingsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CountCoachingsFilters | null | undefined;
}>;

export type CountCoachingsQuery = {
  __typename: "QueryRoot";
  countCoachings: string;
};

export type CoachingQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type CoachingQuery = {
  __typename: "QueryRoot";
  coaching: {
    __typename: "Coaching";
    id: string;
    description: string | null;
    employeeInput: string | null;
    attrs: Record<string, unknown>;
    signed: boolean;
    nextAppointment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    relevantCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
  } | null;
};

export type MutateCoachingMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  coaching: CoachingInput;
  id?: string | null | undefined;
}>;

export type MutateCoachingMutation = {
  __typename: "MutationRoot";
  mutateCoaching: {
    __typename: "Coaching";
    id: string;
    description: string | null;
    employeeInput: string | null;
    attrs: Record<string, unknown>;
    signed: boolean;
    nextAppointment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    relevantCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
  };
};

export type DeleteCoachingMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteCoachingMutation = {
  __typename: "MutationRoot";
  deleteCoaching: { __typename: "Coaching"; id: string };
};

export type ConfirmCoachingMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ConfirmCoachingMutation = {
  __typename: "MutationRoot";
  confirmCoaching: {
    __typename: "Coaching";
    id: string;
    description: string | null;
    employeeInput: string | null;
    attrs: Record<string, unknown>;
    signed: boolean;
    nextAppointment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    relevantCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
  };
};

export type CommunicationListsQueryVariables = Exact<{
  customerId: string;
  filters?: CommunicationListFilters | null | undefined;
}>;

export type CommunicationListsQuery = {
  __typename: "QueryRoot";
  communicationLists: Array<{
    __typename: "CommunicationList";
    id: string;
    name: string;
    addresses: Array<string>;
  }>;
};

export type CountCommunicationListsQueryVariables = Exact<{
  customerId: string;
}>;

export type CountCommunicationListsQuery = {
  __typename: "QueryRoot";
  countCommunicationLists: string;
};

export type CommunicationListQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type CommunicationListQuery = {
  __typename: "QueryRoot";
  communicationList: {
    __typename: "CommunicationList";
    id: string;
    name: string;
    addresses: Array<string>;
  } | null;
};

export type MutateCommunicationListMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: CommunicationListInput;
}>;

export type MutateCommunicationListMutation = {
  __typename: "MutationRoot";
  mutateCommunicationList: {
    __typename: "CommunicationList";
    id: string;
    name: string;
    addresses: Array<string>;
  };
};

export type DeleteCommunicationListMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteCommunicationListMutation = {
  __typename: "MutationRoot";
  deleteCommunicationList: { __typename: "CommunicationList"; id: string };
};

export type CommunicationsQueryVariables = Exact<{
  customerId: string;
  filters?: CommunicationFilters | null | undefined;
}>;

export type CommunicationsQuery = {
  __typename: "QueryRoot";
  communications: Array<{
    __typename: "Communication";
    id: string;
    identifier: string | null;
    type: string;
    insertedAt: string;
    updatedAt: string;
    lists: Array<{ __typename: "CommunicationList"; id: string; name: string }>;
    teams: Array<{ __typename: "Team"; id: string; name: string }>;
  }>;
};

export type CountCommunicationsQueryVariables = Exact<{
  customerId: string;
  filters?: CommunicationFilters | null | undefined;
}>;

export type CountCommunicationsQuery = {
  __typename: "QueryRoot";
  countCommunications: string;
};

export type CommunicationQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type CommunicationQuery = {
  __typename: "QueryRoot";
  communication: {
    __typename: "Communication";
    id: string;
    identifier: string | null;
    type: string;
    insertedAt: string;
    updatedAt: string;
    lists: Array<{ __typename: "CommunicationList"; id: string; name: string }>;
    teams: Array<{ __typename: "Team"; id: string; name: string }>;
  } | null;
};

export type MutateCommunicationMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: CommunicationInput;
}>;

export type MutateCommunicationMutation = {
  __typename: "MutationRoot";
  mutateCommunication: {
    __typename: "Communication";
    id: string;
    identifier: string | null;
    type: string;
    insertedAt: string;
    updatedAt: string;
    lists: Array<{ __typename: "CommunicationList"; id: string; name: string }>;
    teams: Array<{ __typename: "Team"; id: string; name: string }>;
  };
};

export type DeleteCommunicationMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteCommunicationMutation = {
  __typename: "MutationRoot";
  deleteCommunication: { __typename: "Communication"; id: string };
};

export type LastCompanyNewsPostQueryVariables = Exact<{
  customerId: string;
}>;

export type LastCompanyNewsPostQuery = {
  __typename: "QueryRoot";
  lastCompanyNewsPost: {
    __typename: "CompanyNews";
    id: string;
    content: string | null;
    validUntil: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    image: {
      __typename: "CompanyNewsImage";
      thumb: string | null;
      medium: string | null;
      original: string | null;
    };
  } | null;
};

export type CompanyNewsQueryVariables = Exact<{
  customerId: string;
  filters?: CompanyNewsListFilters | null | undefined;
}>;

export type CompanyNewsQuery = {
  __typename: "QueryRoot";
  companyNews: Array<{
    __typename: "CompanyNews";
    id: string;
    content: string | null;
    validUntil: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    image: {
      __typename: "CompanyNewsImage";
      thumb: string | null;
      medium: string | null;
      original: string | null;
    };
  }>;
};

export type CountCompanyNewsQueryVariables = Exact<{
  customerId: string;
}>;

export type CountCompanyNewsQuery = {
  __typename: "QueryRoot";
  countCompanyNews: string;
};

export type MutateCompanyNewsMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: CompanyNewsInput;
}>;

export type MutateCompanyNewsMutation = {
  __typename: "MutationRoot";
  mutateCompanyNews: {
    __typename: "CompanyNews";
    id: string;
    content: string | null;
    validUntil: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    image: {
      __typename: "CompanyNewsImage";
      thumb: string | null;
      medium: string | null;
      original: string | null;
    };
  };
};

export type DeleteCompanyNewsMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteCompanyNewsMutation = {
  __typename: "MutationRoot";
  deleteCompanyNews: { __typename: "CompanyNews"; id: string };
};

export type CompanyNewsPostQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type CompanyNewsPostQuery = {
  __typename: "QueryRoot";
  companyNewsPost: {
    __typename: "CompanyNews";
    id: string;
    content: string | null;
    validUntil: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    image: {
      __typename: "CompanyNewsImage";
      thumb: string | null;
      medium: string | null;
      original: string | null;
    };
  } | null;
};

export type ContactOfferQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
}>;

export type ContactOfferQuery = {
  __typename: "QueryRoot";
  contactOffer: {
    __typename: "ContactOffer";
    id: string;
    customerId: string;
    projectId: string;
    contactId: string;
    token: string;
    insertedAt: string;
    updatedAt: string;
    views: Array<{
      __typename: "ContactOfferView";
      id: string;
      offerId: string;
      userAgent: string | null;
      viewedAt: string;
    }>;
  } | null;
};

export type MutateContactOfferMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  token: string;
}>;

export type MutateContactOfferMutation = {
  __typename: "MutationRoot";
  mutateContactOffer: {
    __typename: "ContactOffer";
    id: string;
    customerId: string;
    projectId: string;
    contactId: string;
    token: string;
    insertedAt: string;
    updatedAt: string;
    views: Array<{
      __typename: "ContactOfferView";
      id: string;
      offerId: string;
      userAgent: string | null;
      viewedAt: string;
    }>;
  };
};

export type DeleteContactOfferMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
}>;

export type DeleteContactOfferMutation = {
  __typename: "MutationRoot";
  deleteContactOffer: {
    __typename: "ContactOffer";
    id: string;
    customerId: string;
    projectId: string;
    contactId: string;
    token: string;
    insertedAt: string;
    updatedAt: string;
    views: Array<{
      __typename: "ContactOfferView";
      id: string;
      offerId: string;
      userAgent: string | null;
      viewedAt: string;
    }>;
  };
};

export type CountPipelineContactsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactPipelineFilters | null | undefined;
}>;

export type CountPipelineContactsQuery = {
  __typename: "QueryRoot";
  countPipelineContacts: string;
};

export type NextContactQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactPipelineFilters | null | undefined;
}>;

export type NextContactQuery = {
  __typename: "QueryRoot";
  nextContact: {
    __typename: "Contact";
    id: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
    } | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
    } | null;
  } | null;
};

export type ContactStatusUpdatesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactStatusUpdateListFilters | null | undefined;
}>;

export type ContactStatusUpdatesQuery = {
  __typename: "QueryRoot";
  contactStatusUpdates: Array<{
    __typename: "ContactStatusUpdate";
    id: string;
    fromId: string;
    toId: string;
    afterDays: number;
    from: { __typename: "ContactStatus"; id: string; name: string };
    to: { __typename: "ContactStatus"; id: string; name: string };
  }>;
};

export type CountContactStatusUpdatesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type CountContactStatusUpdatesQuery = {
  __typename: "QueryRoot";
  countContactStatusUpdates: string;
};

export type ContactStatusUpdateQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ContactStatusUpdateQuery = {
  __typename: "QueryRoot";
  contactStatusUpdate: {
    __typename: "ContactStatusUpdate";
    id: string;
    fromId: string;
    toId: string;
    afterDays: number;
    from: { __typename: "ContactStatus"; id: string; name: string };
    to: { __typename: "ContactStatus"; id: string; name: string };
  } | null;
};

export type MutateContactStatusUpdateMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  values: ContactStatusUpdateInput;
  id?: string | null | undefined;
}>;

export type MutateContactStatusUpdateMutation = {
  __typename: "MutationRoot";
  mutateContactStatusUpdate: {
    __typename: "ContactStatusUpdate";
    id: string;
    fromId: string;
    toId: string;
    afterDays: number;
    from: { __typename: "ContactStatus"; id: string; name: string };
    to: { __typename: "ContactStatus"; id: string; name: string };
  };
};

export type DeleteContactStatusUpdateMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteContactStatusUpdateMutation = {
  __typename: "MutationRoot";
  deleteContactStatusUpdate: {
    __typename: "ContactStatusUpdate";
    id: string;
    fromId: string;
    toId: string;
    afterDays: number;
    from: { __typename: "ContactStatus"; id: string; name: string };
    to: { __typename: "ContactStatus"; id: string; name: string };
  };
};

export type ContactStatesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactStatesListFilters | null | undefined;
}>;

export type ContactStatesQuery = {
  __typename: "QueryRoot";
  contactStates: Array<{
    __typename: "ContactStatus";
    id: string;
    name: string;
    projectId: string;
    position: number;
    insertedAt: string;
    updatedAt: string;
    allowedAfterCall: boolean;
    enforceFollowup: boolean;
    followupEventTypeId: string | null;
    defaultFollowupSubject: string | null;
    defaultFollowupDays: number | null;
  }>;
};

export type CountContactStatesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactStatesListFilters | null | undefined;
}>;

export type CountContactStatesQuery = {
  __typename: "QueryRoot";
  countContactStates: string;
};

export type ContactStatusQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ContactStatusQuery = {
  __typename: "QueryRoot";
  contactStatus: {
    __typename: "ContactStatus";
    id: string;
    name: string;
    projectId: string;
    position: number;
    insertedAt: string;
    updatedAt: string;
    allowedAfterCall: boolean;
    enforceFollowup: boolean;
    followupEventTypeId: string | null;
    defaultFollowupSubject: string | null;
    defaultFollowupDays: number | null;
  } | null;
};

export type MutateContactStatusMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  status: ContactStatusInput;
  id?: string | null | undefined;
}>;

export type MutateContactStatusMutation = {
  __typename: "MutationRoot";
  mutateContactStatus: {
    __typename: "ContactStatus";
    id: string;
    name: string;
    projectId: string;
    position: number;
    insertedAt: string;
    updatedAt: string;
    allowedAfterCall: boolean;
    enforceFollowup: boolean;
    followupEventTypeId: string | null;
    defaultFollowupSubject: string | null;
    defaultFollowupDays: number | null;
  };
};

export type MoveContactStatusMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  direction: MoveContactStatusDirection;
}>;

export type MoveContactStatusMutation = {
  __typename: "MutationRoot";
  moveContactStatus: {
    __typename: "ContactStatus";
    id: string;
    name: string;
    projectId: string;
    position: number;
    insertedAt: string;
    updatedAt: string;
    allowedAfterCall: boolean;
    enforceFollowup: boolean;
    followupEventTypeId: string | null;
    defaultFollowupSubject: string | null;
    defaultFollowupDays: number | null;
  };
};

export type DeleteContactStatusMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteContactStatusMutation = {
  __typename: "MutationRoot";
  deleteContactStatus: {
    __typename: "ContactStatus";
    id: string;
    name: string;
    projectId: string;
    position: number;
    insertedAt: string;
    updatedAt: string;
    allowedAfterCall: boolean;
    enforceFollowup: boolean;
    followupEventTypeId: string | null;
    defaultFollowupSubject: string | null;
    defaultFollowupDays: number | null;
  };
};

export type ContactGroupsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type ContactGroupsQuery = {
  __typename: "QueryRoot";
  contactGroups: Array<{
    __typename: "ContactGroup";
    id: string;
    name: string;
    gtype: ContactGroupType;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type ContactGroupQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ContactGroupQuery = {
  __typename: "QueryRoot";
  contactGroup: {
    __typename: "ContactGroup";
    id: string;
    name: string;
    gtype: ContactGroupType;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type MutateContactGroupMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  group: ContactGroupInput;
  id?: string | null | undefined;
}>;

export type MutateContactGroupMutation = {
  __typename: "MutationRoot";
  mutateContactGroup: {
    __typename: "ContactGroup";
    id: string;
    name: string;
    gtype: ContactGroupType;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteContactGroupMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  withContacts: boolean;
}>;

export type DeleteContactGroupMutation = {
  __typename: "MutationRoot";
  deleteContactGroup: { __typename: "ContactGroup"; id: string };
};

export type ContactAddfieldsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactAddfieldListFilters | null | undefined;
}>;

export type ContactAddfieldsQuery = {
  __typename: "QueryRoot";
  contactAddfields: Array<{
    __typename: "ContactAddfield";
    id: string;
    name: string;
    identifier: string;
    automatic: boolean;
    required: boolean;
  }>;
};

export type CountContactAddfieldsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type CountContactAddfieldsQuery = {
  __typename: "QueryRoot";
  countContactAddfields: string;
};

export type ContactAddfieldQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ContactAddfieldQuery = {
  __typename: "QueryRoot";
  contactAddfield: {
    __typename: "ContactAddfield";
    id: string;
    name: string;
    identifier: string;
    automatic: boolean;
    required: boolean;
  } | null;
};

export type MutateContactAddfieldMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: ContactAddfieldInput;
}>;

export type MutateContactAddfieldMutation = {
  __typename: "MutationRoot";
  mutateContactAddfield: {
    __typename: "ContactAddfield";
    id: string;
    name: string;
    identifier: string;
    automatic: boolean;
    required: boolean;
  };
};

export type DeleteContactAddfieldMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteContactAddfieldMutation = {
  __typename: "MutationRoot";
  deleteContactAddfield: {
    __typename: "ContactAddfield";
    id: string;
    name: string;
    identifier: string;
    automatic: boolean;
    required: boolean;
  };
};

export type CountContactsPrioListQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactsPrioListFilters | null | undefined;
}>;

export type CountContactsPrioListQuery = {
  __typename: "QueryRoot";
  countContactsPrioList: string;
};

export type ContactTransferMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  ownerId: string;
}>;

export type ContactTransferMutation = {
  __typename: "MutationRoot";
  transferContact: {
    __typename: "Contact";
    ownerId: string;
    id: string;
    parentId: string | null;
    ctype: ContactType;
    displayName: string;
    isCompany: boolean;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    position: string | null;
    birthdate: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    statusId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
    lockerId: string | null;
    placeOfBirth: string | null;
    civilStatus: CivilStatus | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    children: Array<{
      __typename: "Contact";
      id: string;
      parentId: string | null;
      ctype: ContactType;
      displayName: string;
      isCompany: boolean;
      salutation: string | null;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      position: string | null;
      birthdate: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      statusId: string | null;
      lockedAt: string | null;
      lockRefreshedAt: string | null;
      lockerId: string | null;
      placeOfBirth: string | null;
      civilStatus: CivilStatus | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        description: string | null;
        itype: ContactInfoType;
        normalizedValue: string | null;
        value: string | null;
        confirmedAt: string | null;
        confirmationSentAt: string | null;
        insertedAt: string;
        updatedAt: string;
      }>;
      addresses: Array<{
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      }>;
    }>;
    status: { __typename: "ContactStatus"; id: string; name: string } | null;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    }>;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    } | null;
    events: Array<{
      __typename: "Event";
      id: string;
      subject: string;
      allDay: boolean;
      startTime: string;
      endTime: string;
      details: string | null;
      attrs: Record<string, unknown>;
      canceled: boolean;
      cleared: boolean;
      sent: boolean;
      sentAt: string | null;
      shifted: boolean;
      contactId: string | null;
      typeId: string;
      insertedAt: string;
      updatedAt: string;
      ownerId: string;
      creatorId: string;
      type: {
        __typename: "EventType";
        id: string;
        name: string;
        type: EventTypeType;
      } | null;
      replacementForEvent: {
        __typename: "Event";
        id: string;
        subject: string;
        startTime: string;
      } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      feedbacks: Array<{
        __typename: "EventFeedback";
        id: string;
        tookPlace: boolean | null;
        insertedAt: string;
        attrs: Record<string, unknown>;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
      }>;
    }>;
  };
};

export type ContactLockMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ContactLockMutation = {
  __typename: "MutationRoot";
  lockContact: {
    __typename: "ContactLockResult";
    contactId: string;
    lockerId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
  } | null;
};

export type ContactUnlockMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ContactUnlockMutation = {
  __typename: "MutationRoot";
  unlockContact: {
    __typename: "ContactLockResult";
    contactId: string;
    lockerId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
  } | null;
};

export type ContactsMergeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  merge: Array<string> | string;
}>;

export type ContactsMergeMutation = {
  __typename: "MutationRoot";
  mergeContacts: { __typename: "Contact"; id: string };
};

export type ContactsPrioListContactBaseFragment = {
  __typename: "Contact";
  id: string;
  parentId: string | null;
  displayName: string;
  firstname: string | null;
  lastname: string | null;
  companyName: string | null;
  isCompany: boolean;
  attrs: Record<string, unknown>;
  nextCallWindow: number | null;
  statusId: string | null;
  lockedAt: string | null;
  lockRefreshedAt: string | null;
  insertedAt: string;
  updatedAt: string;
  lastContact: { __typename: "History"; id: string; insertedAt: string } | null;
  primaryAddress: {
    __typename: "ContactAddress";
    id: string;
    address: string | null;
    zip: string | null;
    city: string | null;
  } | null;
  status: { __typename: "ContactStatus"; id: string; name: string } | null;
  project: {
    __typename: "MinimalProject";
    id: string;
    name: string;
    identifier: string;
  } | null;
  locker: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type ContactsPrioListQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactsPrioListFilters | null | undefined;
  followupDate?: string | null | undefined;
  followupCleared?: boolean | null | undefined;
  followupCanceled?: boolean | null | undefined;
}>;

export type ContactsPrioListQuery = {
  __typename: "QueryRoot";
  contactsPrioList: Array<{
    __typename: "Contact";
    id: string;
    parentId: string | null;
    displayName: string;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    isCompany: boolean;
    attrs: Record<string, unknown>;
    nextCallWindow: number | null;
    statusId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
    insertedAt: string;
    updatedAt: string;
    followups: Array<{
      __typename: "Event";
      id: string;
      allDay: boolean;
      startTime: string;
    }>;
    lastContact: {
      __typename: "History";
      id: string;
      insertedAt: string;
    } | null;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      zip: string | null;
      city: string | null;
    } | null;
    status: { __typename: "ContactStatus"; id: string; name: string } | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type ContactsPrioListWoFollowupsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactsPrioListFilters | null | undefined;
}>;

export type ContactsPrioListWoFollowupsQuery = {
  __typename: "QueryRoot";
  contactsPrioList: Array<{
    __typename: "Contact";
    id: string;
    parentId: string | null;
    displayName: string;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    isCompany: boolean;
    attrs: Record<string, unknown>;
    nextCallWindow: number | null;
    statusId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
    insertedAt: string;
    updatedAt: string;
    nextFollowup: {
      __typename: "Event";
      id: string;
      allDay: boolean;
      startTime: string;
    } | null;
    lastContact: {
      __typename: "History";
      id: string;
      insertedAt: string;
    } | null;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      zip: string | null;
      city: string | null;
    } | null;
    status: { __typename: "ContactStatus"; id: string; name: string } | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type ContactDeleteMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ContactDeleteMutation = {
  __typename: "MutationRoot";
  deleteContact: { __typename: "Contact"; id: string; parentId: string | null };
};

export type ContactsSubscriptionSubscriptionVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type ContactsSubscriptionSubscription = {
  __typename: "SubscriptionRoot";
  contacts: {
    __typename: "Contact";
    statusId: string | null;
    editorId: string;
    ownerId: string;
    id: string;
    parentId: string | null;
    ctype: ContactType;
    displayName: string;
    isCompany: boolean;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    position: string | null;
    birthdate: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
    lockerId: string | null;
    placeOfBirth: string | null;
    civilStatus: CivilStatus | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    children: Array<{
      __typename: "Contact";
      id: string;
      parentId: string | null;
      ctype: ContactType;
      displayName: string;
      isCompany: boolean;
      salutation: string | null;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      position: string | null;
      birthdate: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      statusId: string | null;
      lockedAt: string | null;
      lockRefreshedAt: string | null;
      lockerId: string | null;
      placeOfBirth: string | null;
      civilStatus: CivilStatus | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        description: string | null;
        itype: ContactInfoType;
        normalizedValue: string | null;
        value: string | null;
        confirmedAt: string | null;
        confirmationSentAt: string | null;
        insertedAt: string;
        updatedAt: string;
      }>;
      addresses: Array<{
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      }>;
    }>;
    status: { __typename: "ContactStatus"; id: string; name: string } | null;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    }>;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    } | null;
    events: Array<{
      __typename: "Event";
      id: string;
      subject: string;
      allDay: boolean;
      startTime: string;
      endTime: string;
      details: string | null;
      attrs: Record<string, unknown>;
      canceled: boolean;
      cleared: boolean;
      sent: boolean;
      sentAt: string | null;
      shifted: boolean;
      contactId: string | null;
      typeId: string;
      insertedAt: string;
      updatedAt: string;
      ownerId: string;
      creatorId: string;
      type: {
        __typename: "EventType";
        id: string;
        name: string;
        type: EventTypeType;
      } | null;
      replacementForEvent: {
        __typename: "Event";
        id: string;
        subject: string;
        startTime: string;
      } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      feedbacks: Array<{
        __typename: "EventFeedback";
        id: string;
        tookPlace: boolean | null;
        insertedAt: string;
        attrs: Record<string, unknown>;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
      }>;
    }>;
  };
};

export type ContactsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactsListFilters | null | undefined;
}>;

export type ContactsQuery = {
  __typename: "QueryRoot";
  contacts: Array<{
    __typename: "Contact";
    id: string;
    ctype: ContactType;
    parentId: string | null;
    displayName: string;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    isCompany: boolean;
    attrs: Record<string, unknown>;
    statusId: string | null;
    lockerId: string | null;
    insertedAt: string;
    updatedAt: string;
    parent: {
      __typename: "Contact";
      ownerId: string;
      id: string;
      parentId: string | null;
      ctype: ContactType;
      displayName: string;
      isCompany: boolean;
      salutation: string | null;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      position: string | null;
      birthdate: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      statusId: string | null;
      lockedAt: string | null;
      lockRefreshedAt: string | null;
      lockerId: string | null;
      placeOfBirth: string | null;
      civilStatus: CivilStatus | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
      locker: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      children: Array<{
        __typename: "Contact";
        id: string;
        parentId: string | null;
        ctype: ContactType;
        displayName: string;
        isCompany: boolean;
        salutation: string | null;
        firstname: string | null;
        lastname: string | null;
        companyName: string | null;
        position: string | null;
        birthdate: string | null;
        attrs: Record<string, unknown>;
        insertedAt: string;
        updatedAt: string;
        statusId: string | null;
        lockedAt: string | null;
        lockRefreshedAt: string | null;
        lockerId: string | null;
        placeOfBirth: string | null;
        civilStatus: CivilStatus | null;
        infos: Array<{
          __typename: "ContactInfo";
          id: string;
          description: string | null;
          itype: ContactInfoType;
          normalizedValue: string | null;
          value: string | null;
          confirmedAt: string | null;
          confirmationSentAt: string | null;
          insertedAt: string;
          updatedAt: string;
        }>;
        addresses: Array<{
          __typename: "ContactAddress";
          id: string;
          address: string | null;
          atype: ContactAddressType;
          city: string | null;
          cityPart: string | null;
          country: string | null;
          description: string | null;
          zip: string | null;
        }>;
      }>;
      status: { __typename: "ContactStatus"; id: string; name: string } | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        description: string | null;
        itype: ContactInfoType;
        normalizedValue: string | null;
        value: string | null;
        confirmedAt: string | null;
        confirmationSentAt: string | null;
        insertedAt: string;
        updatedAt: string;
      }>;
      addresses: Array<{
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      }>;
      primaryAddress: {
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      } | null;
      events: Array<{
        __typename: "Event";
        id: string;
        subject: string;
        allDay: boolean;
        startTime: string;
        endTime: string;
        details: string | null;
        attrs: Record<string, unknown>;
        canceled: boolean;
        cleared: boolean;
        sent: boolean;
        sentAt: string | null;
        shifted: boolean;
        contactId: string | null;
        typeId: string;
        insertedAt: string;
        updatedAt: string;
        ownerId: string;
        creatorId: string;
        type: {
          __typename: "EventType";
          id: string;
          name: string;
          type: EventTypeType;
        } | null;
        replacementForEvent: {
          __typename: "Event";
          id: string;
          subject: string;
          startTime: string;
        } | null;
        owner: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
        feedbacks: Array<{
          __typename: "EventFeedback";
          id: string;
          tookPlace: boolean | null;
          insertedAt: string;
          attrs: Record<string, unknown>;
          creator: {
            __typename: "User";
            id: string;
            username: string;
            email: string | null;
            active: boolean;
            retired: boolean;
            role: UserRole;
            homeoffice: boolean;
            bio: string | null;
            customerId: string;
            attrs: Record<string, unknown>;
            lastSeenAt: string | null;
            passwordReset: string | null;
            otp: boolean;
            billableCustomerId: string | null;
            defaultProjectId: string | null;
            avatar: {
              __typename: "UserAvatar";
              thumb: string;
              medium: string;
              original: string;
            };
            contact: {
              __typename: "Contact";
              id: string;
              firstname: string | null;
              lastname: string | null;
              displayName: string;
              companyName: string | null;
              birthdate: string | null;
            } | null;
          } | null;
        }>;
      }>;
    } | null;
    lastContact: {
      __typename: "History";
      id: string;
      insertedAt: string;
    } | null;
    nextFollowup: {
      __typename: "Event";
      id: string;
      allDay: boolean;
      startTime: string;
    } | null;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      zip: string | null;
      city: string | null;
    } | null;
    status: { __typename: "ContactStatus"; id: string; name: string } | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type CountContactsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactsListFilters | null | undefined;
}>;

export type CountContactsQuery = {
  __typename: "QueryRoot";
  countContacts: string;
};

export type ContactsWithInfosQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactsListFilters | null | undefined;
}>;

export type ContactsWithInfosQuery = {
  __typename: "QueryRoot";
  contacts: Array<{
    __typename: "Contact";
    id: string;
    parentId: string | null;
    displayName: string;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    isCompany: boolean;
    position: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
  }>;
};

export type ContactsWithInfosAndAddressesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactsListFilters | null | undefined;
}>;

export type ContactsWithInfosAndAddressesQuery = {
  __typename: "QueryRoot";
  contacts: Array<{
    __typename: "Contact";
    id: string;
    parentId: string | null;
    displayName: string;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    isCompany: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    }>;
    events: Array<{
      __typename: "Event";
      id: string;
      subject: string;
      allDay: boolean;
      startTime: string;
      endTime: string;
      details: string | null;
      attrs: Record<string, unknown>;
      canceled: boolean;
      cleared: boolean;
      sent: boolean;
      sentAt: string | null;
      shifted: boolean;
      contactId: string | null;
      typeId: string;
      insertedAt: string;
      updatedAt: string;
      ownerId: string;
      creatorId: string;
      type: {
        __typename: "EventType";
        id: string;
        name: string;
        type: EventTypeType;
      } | null;
      replacementForEvent: {
        __typename: "Event";
        id: string;
        subject: string;
        startTime: string;
      } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      feedbacks: Array<{
        __typename: "EventFeedback";
        id: string;
        tookPlace: boolean | null;
        insertedAt: string;
        attrs: Record<string, unknown>;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
      }>;
    }>;
    children: Array<{
      __typename: "Contact";
      id: string;
      displayName: string;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        description: string | null;
        itype: ContactInfoType;
        normalizedValue: string | null;
        value: string | null;
        confirmedAt: string | null;
        confirmationSentAt: string | null;
        insertedAt: string;
        updatedAt: string;
      }>;
      addresses: Array<{
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      }>;
    }>;
  }>;
};

export type CreateContactsBatchActionMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  action: ContactBatchAction;
  filters: ContactsListFilters;
  values?: ContactBatchInput | null | undefined;
}>;

export type CreateContactsBatchActionMutation = {
  __typename: "MutationRoot";
  createContactsBatchAction: {
    __typename: "JobResult";
    id: string;
    module: string;
    done: boolean;
    seen: boolean;
    hasAttachment: boolean;
    filename: string | null;
    userId: string;
    report: Record<string, unknown> | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type ImportContactsMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  config: ContactImportConfig;
  file: File;
}>;

export type ImportContactsMutation = {
  __typename: "MutationRoot";
  importContacts: {
    __typename: "JobResult";
    id: string;
    module: string;
    done: boolean;
    seen: boolean;
    hasAttachment: boolean;
    filename: string | null;
    userId: string;
    report: Record<string, unknown> | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type ExportContactsMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  filters: ContactsListFilters;
  fields: Array<ContactsExportJobField> | ContactsExportJobField;
}>;

export type ExportContactsMutation = {
  __typename: "MutationRoot";
  exportContacts: {
    __typename: "JobResult";
    id: string;
    module: string;
    done: boolean;
    seen: boolean;
    hasAttachment: boolean;
    filename: string | null;
    userId: string;
    report: Record<string, unknown> | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type MutateContactInfoMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  id?: string | null | undefined;
  info: ContactInfoInput;
}>;

export type MutateContactInfoMutation = {
  __typename: "MutationRoot";
  mutateContactInfo: {
    __typename: "ContactInfo";
    id: string;
    description: string | null;
    itype: ContactInfoType;
    normalizedValue: string | null;
    value: string | null;
    confirmedAt: string | null;
    confirmationSentAt: string | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type SendVerifyMailForInfoMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  id: string;
}>;

export type SendVerifyMailForInfoMutation = {
  __typename: "MutationRoot";
  sendVerifyMailForInfo: {
    __typename: "ContactInfo";
    id: string;
    description: string | null;
    itype: ContactInfoType;
    normalizedValue: string | null;
    value: string | null;
    confirmedAt: string | null;
    confirmationSentAt: string | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type ContactAttachmentsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  filters?: ContactsAttachmentsListFilters | null | undefined;
}>;

export type ContactAttachmentsQuery = {
  __typename: "QueryRoot";
  contactAttachments: Array<{
    __typename: "ContactAttachment";
    id: string;
    file: string;
    mimeType: string;
    description: string;
    contactId: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountContactAttachmentsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
}>;

export type CountContactAttachmentsQuery = {
  __typename: "QueryRoot";
  countContactAttachments: string;
};

export type MutateContactAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  id?: string | null | undefined;
  values: ContactAttachmentInput;
}>;

export type MutateContactAttachmentMutation = {
  __typename: "MutationRoot";
  mutateContactAttachment: {
    __typename: "ContactAttachment";
    id: string;
    file: string;
    mimeType: string;
    description: string;
    contactId: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteContactAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  id: string;
}>;

export type DeleteContactAttachmentMutation = {
  __typename: "MutationRoot";
  deleteContactAttachment: { __typename: "ContactAttachment"; id: string };
};

export type ContactQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ContactQuery = {
  __typename: "QueryRoot";
  contact: {
    __typename: "Contact";
    editorId: string;
    ownerId: string;
    id: string;
    parentId: string | null;
    ctype: ContactType;
    displayName: string;
    isCompany: boolean;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    position: string | null;
    birthdate: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    statusId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
    lockerId: string | null;
    placeOfBirth: string | null;
    civilStatus: CivilStatus | null;
    parent: { __typename: "Contact"; id: string; displayName: string } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    children: Array<{
      __typename: "Contact";
      id: string;
      parentId: string | null;
      ctype: ContactType;
      displayName: string;
      isCompany: boolean;
      salutation: string | null;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      position: string | null;
      birthdate: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      statusId: string | null;
      lockedAt: string | null;
      lockRefreshedAt: string | null;
      lockerId: string | null;
      placeOfBirth: string | null;
      civilStatus: CivilStatus | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        description: string | null;
        itype: ContactInfoType;
        normalizedValue: string | null;
        value: string | null;
        confirmedAt: string | null;
        confirmationSentAt: string | null;
        insertedAt: string;
        updatedAt: string;
      }>;
      addresses: Array<{
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      }>;
    }>;
    status: { __typename: "ContactStatus"; id: string; name: string } | null;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    }>;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    } | null;
    events: Array<{
      __typename: "Event";
      id: string;
      subject: string;
      allDay: boolean;
      startTime: string;
      endTime: string;
      details: string | null;
      attrs: Record<string, unknown>;
      canceled: boolean;
      cleared: boolean;
      sent: boolean;
      sentAt: string | null;
      shifted: boolean;
      contactId: string | null;
      typeId: string;
      insertedAt: string;
      updatedAt: string;
      ownerId: string;
      creatorId: string;
      type: {
        __typename: "EventType";
        id: string;
        name: string;
        type: EventTypeType;
      } | null;
      replacementForEvent: {
        __typename: "Event";
        id: string;
        subject: string;
        startTime: string;
      } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      feedbacks: Array<{
        __typename: "EventFeedback";
        id: string;
        tookPlace: boolean | null;
        insertedAt: string;
        attrs: Record<string, unknown>;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
      }>;
    }>;
  } | null;
};

export type MutateContactMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  contact: ContactInput;
}>;

export type MutateContactMutation = {
  __typename: "MutationRoot";
  mutateContact: {
    __typename: "Contact";
    editorId: string;
    ownerId: string;
    id: string;
    parentId: string | null;
    ctype: ContactType;
    displayName: string;
    isCompany: boolean;
    salutation: string | null;
    firstname: string | null;
    lastname: string | null;
    companyName: string | null;
    position: string | null;
    birthdate: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    statusId: string | null;
    lockedAt: string | null;
    lockRefreshedAt: string | null;
    lockerId: string | null;
    placeOfBirth: string | null;
    civilStatus: CivilStatus | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    children: Array<{
      __typename: "Contact";
      id: string;
      parentId: string | null;
      ctype: ContactType;
      displayName: string;
      isCompany: boolean;
      salutation: string | null;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      position: string | null;
      birthdate: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      statusId: string | null;
      lockedAt: string | null;
      lockRefreshedAt: string | null;
      lockerId: string | null;
      placeOfBirth: string | null;
      civilStatus: CivilStatus | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        description: string | null;
        itype: ContactInfoType;
        normalizedValue: string | null;
        value: string | null;
        confirmedAt: string | null;
        confirmationSentAt: string | null;
        insertedAt: string;
        updatedAt: string;
      }>;
      addresses: Array<{
        __typename: "ContactAddress";
        id: string;
        address: string | null;
        atype: ContactAddressType;
        city: string | null;
        cityPart: string | null;
        country: string | null;
        description: string | null;
        zip: string | null;
      }>;
    }>;
    status: { __typename: "ContactStatus"; id: string; name: string } | null;
    infos: Array<{
      __typename: "ContactInfo";
      id: string;
      description: string | null;
      itype: ContactInfoType;
      normalizedValue: string | null;
      value: string | null;
      confirmedAt: string | null;
      confirmationSentAt: string | null;
      insertedAt: string;
      updatedAt: string;
    }>;
    addresses: Array<{
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    }>;
    primaryAddress: {
      __typename: "ContactAddress";
      id: string;
      address: string | null;
      atype: ContactAddressType;
      city: string | null;
      cityPart: string | null;
      country: string | null;
      description: string | null;
      zip: string | null;
    } | null;
    events: Array<{
      __typename: "Event";
      id: string;
      subject: string;
      allDay: boolean;
      startTime: string;
      endTime: string;
      details: string | null;
      attrs: Record<string, unknown>;
      canceled: boolean;
      cleared: boolean;
      sent: boolean;
      sentAt: string | null;
      shifted: boolean;
      contactId: string | null;
      typeId: string;
      insertedAt: string;
      updatedAt: string;
      ownerId: string;
      creatorId: string;
      type: {
        __typename: "EventType";
        id: string;
        name: string;
        type: EventTypeType;
      } | null;
      replacementForEvent: {
        __typename: "Event";
        id: string;
        subject: string;
        startTime: string;
      } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      feedbacks: Array<{
        __typename: "EventFeedback";
        id: string;
        tookPlace: boolean | null;
        insertedAt: string;
        attrs: Record<string, unknown>;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
      }>;
    }>;
  };
};

export type ContractFragment = {
  __typename: "Contract";
  id: string;
  starts: string;
  ends: string | null;
  holidays: number;
  hours: number;
  hourlyWage: number | null;
  monthlyWage: number | null;
  taxBracket: number;
  insertedAt: string;
  updatedAt: string;
  userId: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type ContractsQueryVariables = Exact<{
  customerId: string;
  filters?: ContractListOptions | null | undefined;
}>;

export type ContractsQuery = {
  __typename: "QueryRoot";
  contracts: Array<{
    __typename: "Contract";
    id: string;
    starts: string;
    ends: string | null;
    holidays: number;
    hours: number;
    hourlyWage: number | null;
    monthlyWage: number | null;
    taxBracket: number;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type ContractQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ContractQuery = {
  __typename: "QueryRoot";
  contract: {
    __typename: "Contract";
    id: string;
    starts: string;
    ends: string | null;
    holidays: number;
    hours: number;
    hourlyWage: number | null;
    monthlyWage: number | null;
    taxBracket: number;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type ContractForUserAndDateQueryVariables = Exact<{
  customerId: string;
  userId: string;
  date: string;
}>;

export type ContractForUserAndDateQuery = {
  __typename: "QueryRoot";
  contractForUserAndDate: {
    __typename: "Contract";
    id: string;
    starts: string;
    ends: string | null;
    holidays: number;
    hours: number;
    hourlyWage: number | null;
    monthlyWage: number | null;
    taxBracket: number;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateContractMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: ContractInput;
}>;

export type MutateContractMutation = {
  __typename: "MutationRoot";
  mutateContract: {
    __typename: "Contract";
    id: string;
    starts: string;
    ends: string | null;
    holidays: number;
    hours: number;
    hourlyWage: number | null;
    monthlyWage: number | null;
    taxBracket: number;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteContractMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteContractMutation = {
  __typename: "MutationRoot";
  deleteContract: { __typename: "Contract"; id: string };
};

export type GenerateContractMutationVariables = Exact<{
  customerId: string;
  id: string;
  values: GenContractInput;
}>;

export type GenerateContractMutation = {
  __typename: "MutationRoot";
  generateContract: { __typename: "JobResult"; id: string };
};

export type CreateContractAdaptionMutationVariables = Exact<{
  customerId: string;
  id: string;
  values: ContractAdaptionInput;
}>;

export type CreateContractAdaptionMutation = {
  __typename: "MutationRoot";
  createContractAdaption: { __typename: "JobResult"; id: string };
};

export type EmployeeControllingDayOverviewQueryVariables = Exact<{
  customerId: string;
  date: string;
}>;

export type EmployeeControllingDayOverviewQuery = {
  __typename: "QueryRoot";
  employeeControllingDayOverview: Array<{
    __typename: "EmployeeControllingDayOverviewRow";
    userId: string;
    startHour: string;
    started: string | null;
    eta: string | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type EmployeeCouponsQueryVariables = Exact<{
  customerId: string;
  filters?: EmployeeCouponsListOptions | null | undefined;
}>;

export type EmployeeCouponsQuery = {
  __typename: "QueryRoot";
  employeeCoupons: Array<{
    __typename: "EmployeeCoupon";
    id: string;
    customerId: string;
    userId: string;
    month: string;
    amount: number;
    claimed: boolean;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountEmployeeCouponsQueryVariables = Exact<{
  customerId: string;
  filters?: EmployeeCouponsCountOptions | null | undefined;
}>;

export type CountEmployeeCouponsQuery = {
  __typename: "QueryRoot";
  countEmployeeCoupons: string;
};

export type EmployeeCouponQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type EmployeeCouponQuery = {
  __typename: "QueryRoot";
  employeeCoupon: {
    __typename: "EmployeeCoupon";
    id: string;
    customerId: string;
    userId: string;
    month: string;
    amount: number;
    claimed: boolean;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type CurrentEmployeeCouponQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentEmployeeCouponQuery = {
  __typename: "QueryRoot";
  currentEmployeeCoupon: {
    __typename: "EmployeeCoupon";
    id: string;
    month: string;
    amount: number;
  } | null;
};

export type MutateEmployeeCouponMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: EmployeeCouponInput;
}>;

export type MutateEmployeeCouponMutation = {
  __typename: "MutationRoot";
  mutateEmployeeCoupon: {
    __typename: "EmployeeCoupon";
    id: string;
    customerId: string;
    userId: string;
    month: string;
    amount: number;
    claimed: boolean;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteEmployeeCouponMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteEmployeeCouponMutation = {
  __typename: "MutationRoot";
  deleteEmployeeCoupon: {
    __typename: "EmployeeCoupon";
    id: string;
    customerId: string;
    userId: string;
    month: string;
    amount: number;
    claimed: boolean;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type CustomerFeedbacksQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CustomerFeedbackListFilters | null | undefined;
}>;

export type CustomerFeedbacksQuery = {
  __typename: "QueryRoot";
  customerFeedbacks: Array<{
    __typename: "CustomerFeedback";
    id: string;
    identifier: string;
    attrs: Record<string, unknown>;
    description: string | null;
    state: CustomerFeedbackState;
    selfAssessmentState: CustomerFeedbackState;
    allDone: boolean;
    userId: string;
    topicId: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    topic: { __typename: "CustomerFeedbackTopic"; name: string } | null;
  }>;
};

export type CountCustomerFeedbacksQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CustomerFeedbackListFilters | null | undefined;
}>;

export type CountCustomerFeedbacksQuery = {
  __typename: "QueryRoot";
  countCustomerFeedbacks: string;
};

export type CustomerFeedbackQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type CustomerFeedbackQuery = {
  __typename: "QueryRoot";
  customerFeedback: {
    __typename: "CustomerFeedback";
    id: string;
    identifier: string;
    attrs: Record<string, unknown>;
    description: string | null;
    state: CustomerFeedbackState;
    selfAssessmentState: CustomerFeedbackState;
    allDone: boolean;
    userId: string;
    topicId: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    topic: { __typename: "CustomerFeedbackTopic"; name: string } | null;
  } | null;
};

export type MarkCustomerFeedbackDoneMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type MarkCustomerFeedbackDoneMutation = {
  __typename: "MutationRoot";
  markCustomerFeedbackDone: {
    __typename: "CustomerFeedback";
    id: string;
    identifier: string;
    attrs: Record<string, unknown>;
    description: string | null;
    state: CustomerFeedbackState;
    selfAssessmentState: CustomerFeedbackState;
    allDone: boolean;
    userId: string;
    topicId: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    topic: { __typename: "CustomerFeedbackTopic"; name: string } | null;
  };
};

export type ClassifyCustomerFeedbackMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  values: CustomerFeedbackClassifyInput;
}>;

export type ClassifyCustomerFeedbackMutation = {
  __typename: "MutationRoot";
  classifyCustomerFeedback: {
    __typename: "CustomerFeedback";
    id: string;
    identifier: string;
    attrs: Record<string, unknown>;
    description: string | null;
    state: CustomerFeedbackState;
    selfAssessmentState: CustomerFeedbackState;
    allDone: boolean;
    userId: string;
    topicId: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    topic: { __typename: "CustomerFeedbackTopic"; name: string } | null;
  };
};

export type SelfClassifyCustomerFeedbackMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  values: CustomerFeedbackSelfClassifyInput;
}>;

export type SelfClassifyCustomerFeedbackMutation = {
  __typename: "MutationRoot";
  selfClassifyCustomerFeedback: {
    __typename: "CustomerFeedback";
    id: string;
    identifier: string;
    attrs: Record<string, unknown>;
    description: string | null;
    state: CustomerFeedbackState;
    selfAssessmentState: CustomerFeedbackState;
    allDone: boolean;
    userId: string;
    topicId: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    topic: { __typename: "CustomerFeedbackTopic"; name: string } | null;
  };
};

export type DeleteCustomerFeedbackMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteCustomerFeedbackMutation = {
  __typename: "MutationRoot";
  deleteCustomerFeedback: { __typename: "CustomerFeedback"; id: string };
};

export type CustomerFeedbackAnnotationsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  feedbackId: string;
}>;

export type CustomerFeedbackAnnotationsQuery = {
  __typename: "QueryRoot";
  customerFeedbackAnnotations: Array<{
    __typename: "CustomerFeedbackAnnotation";
    id: string;
    done: boolean;
    details: string;
    customerFeedbackId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MutateCustomerFeedbackAnnotationMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  feedbackId: string;
  values: CustomerFeedbackAnnotationInput;
}>;

export type MutateCustomerFeedbackAnnotationMutation = {
  __typename: "MutationRoot";
  mutateCustomerFeedbackAnnotation: {
    __typename: "CustomerFeedbackAnnotation";
    id: string;
    done: boolean;
    details: string;
    customerFeedbackId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MarkCustomerFeedbackAnnotationDoneMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  feedbackId: string;
  id: string;
}>;

export type MarkCustomerFeedbackAnnotationDoneMutation = {
  __typename: "MutationRoot";
  markCustomerFeedbackAnnotationDone: {
    __typename: "CustomerFeedbackAnnotation";
    id: string;
    done: boolean;
    details: string;
    customerFeedbackId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type CustomerFeedbackTopicsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CustomerFeedbackTopicsListFilters | null | undefined;
}>;

export type CustomerFeedbackTopicsQuery = {
  __typename: "QueryRoot";
  customerFeedbackTopics: Array<{
    __typename: "CustomerFeedbackTopic";
    id: string;
    name: string;
    active: boolean;
    color: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountCustomerFeedbackTopicsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CustomerFeedbackTopicsListFilters | null | undefined;
}>;

export type CountCustomerFeedbackTopicsQuery = {
  __typename: "QueryRoot";
  countCustomerFeedbackTopics: string;
};

export type CustomerFeedbackTopicQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type CustomerFeedbackTopicQuery = {
  __typename: "QueryRoot";
  customerFeedbackTopic: {
    __typename: "CustomerFeedbackTopic";
    id: string;
    name: string;
    active: boolean;
    color: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type MutateCustomerFeedbackTopicMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: CustomerFeedbackTopicInput;
}>;

export type MutateCustomerFeedbackTopicMutation = {
  __typename: "MutationRoot";
  mutateCustomerFeedbackTopic: {
    __typename: "CustomerFeedbackTopic";
    id: string;
    name: string;
    active: boolean;
    color: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type ImportCustomerFeedbackMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  file: File;
  importSince?: string | null | undefined;
  config?: Record<string, unknown> | null | undefined;
}>;

export type ImportCustomerFeedbackMutation = {
  __typename: "MutationRoot";
  importCustomerFeedback: { __typename: "JobResult"; id: string };
};

export type ExportCustomerFeedbackMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CustomerFeedbackListFilters | null | undefined;
}>;

export type ExportCustomerFeedbackMutation = {
  __typename: "MutationRoot";
  exportCustomerFeedback: { __typename: "JobResult"; id: string };
};

export type UnclassifiedCustomerFeedbacksCountForUserQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type UnclassifiedCustomerFeedbacksCountForUserQuery = {
  __typename: "QueryRoot";
  unclassifiedCustomerFeedbacksCountForUser: string;
};

export type ShiftCustomerFeedbackMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  userId: string;
}>;

export type ShiftCustomerFeedbackMutation = {
  __typename: "MutationRoot";
  shiftCustomerFeedback: {
    __typename: "CustomerFeedback";
    id: string;
    identifier: string;
    attrs: Record<string, unknown>;
    description: string | null;
    state: CustomerFeedbackState;
    selfAssessmentState: CustomerFeedbackState;
    allDone: boolean;
    userId: string;
    topicId: string | null;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    topic: { __typename: "CustomerFeedbackTopic"; name: string } | null;
  };
};

export type DeleteCustomerMutationVariables = Exact<{
  id: string;
}>;

export type DeleteCustomerMutation = {
  __typename: "MutationRoot";
  deleteCustomer: { __typename: "Customer"; id: string };
};

export type SwitcherCustomersQueryVariables = Exact<{
  filters?: CustomersListFilter | null | undefined;
}>;

export type SwitcherCustomersQuery = {
  __typename: "QueryRoot";
  customers: Array<{
    __typename: "Customer";
    id: string;
    name: string;
    identifier: string;
    defaultProjectId: string | null;
    attrs: Record<string, unknown>;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
    projects: Array<{
      __typename: "Project";
      id: string;
      customerId: string;
      name: string;
      identifier: string;
      active: boolean;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
    }>;
    customerAdministrators: Array<{
      __typename: "User";
      id: string;
      username: string;
    }>;
  }>;
};

export type CustomersQueryVariables = Exact<{
  filters?: CustomersListFilter | null | undefined;
}>;

export type CustomersQuery = {
  __typename: "QueryRoot";
  customers: Array<{
    __typename: "Customer";
    id: string;
    name: string;
    identifier: string;
    active: boolean;
    inDeletion: boolean;
    attrs: Record<string, unknown>;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  }>;
};

export type CustomerQueryVariables = Exact<{
  customerId: string;
}>;

export type CustomerQuery = {
  __typename: "QueryRoot";
  customer: {
    __typename: "Customer";
    id: string;
    name: string;
    active: boolean;
    inDeletion: boolean;
    identifier: string;
    defaultProjectId: string | null;
    attrs: Record<string, unknown>;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
    projects: Array<{
      __typename: "Project";
      id: string;
      name: string;
      identifier: string;
      active: boolean;
    }>;
    customerUsers: Array<{
      __typename: "User";
      id: string;
      username: string;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
    }>;
    customerAdministrators: Array<{
      __typename: "User";
      id: string;
      username: string;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
    }>;
  } | null;
};

export type CustomersWithCustomerAdministratorsAndProjectsQueryVariables =
  Exact<{
    filters?: CustomersListFilter | null | undefined;
  }>;

export type CustomersWithCustomerAdministratorsAndProjectsQuery = {
  __typename: "QueryRoot";
  customers: Array<{
    __typename: "Customer";
    id: string;
    name: string;
    identifier: string;
    active: boolean;
    inDeletion: boolean;
    attrs: Record<string, unknown>;
    customerAdministrators: Array<{
      __typename: "User";
      id: string;
      username: string;
    }>;
    projects: Array<{
      __typename: "Project";
      id: string;
      name: string;
      identifier: string;
      active: boolean;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
    }>;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
  }>;
};

export type MutateCustomerMutationVariables = Exact<{
  id?: string | null | undefined;
  values: CustomerInput;
}>;

export type MutateCustomerMutation = {
  __typename: "MutationRoot";
  mutateCustomer: {
    __typename: "Customer";
    id: string;
    name: string;
    active: boolean;
    inDeletion: boolean;
    identifier: string;
    defaultProjectId: string | null;
    attrs: Record<string, unknown>;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
    projects: Array<{
      __typename: "Project";
      id: string;
      name: string;
      identifier: string;
      active: boolean;
    }>;
    customerUsers: Array<{
      __typename: "User";
      id: string;
      username: string;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
    }>;
    customerAdministrators: Array<{
      __typename: "User";
      id: string;
      username: string;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
    }>;
  };
};

export type ContactStatesStatsRowFragment = {
  __typename: "ContactStatesStatsRow";
  statusId: string | null;
  count: number;
};

export type ContactStatesStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ContactStatesStats | null | undefined;
}>;

export type ContactStatesStatsQuery = {
  __typename: "QueryRoot";
  contactStatesStats: Array<{
    __typename: "ContactStatesStatsRow";
    statusId: string | null;
    count: number;
  }>;
};

export type ContactsAddfieldStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  addfields: Record<string, unknown>;
  filters?: ContactsAddfieldFilters | null | undefined;
}>;

export type ContactsAddfieldStatsQuery = {
  __typename: "QueryRoot";
  contactsAddfieldStats: Record<string, unknown>;
};

export type DashboardStatsNewQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters: DashboardStatsFilters;
}>;

export type DashboardStatsNewQuery = {
  __typename: "QueryRoot";
  dashboardStatsNew: Record<string, unknown>;
};

export type ProductiveHourGoalDashboardStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  starts: string;
  stops: string;
}>;

export type ProductiveHourGoalDashboardStatsQuery = {
  __typename: "QueryRoot";
  productiveHourGoalDashboardStats: Array<{
    __typename: "ProductiveHourGoalDashboardStats";
    customerId: string;
    wantedHours: number;
    productiveHours: number;
  }>;
};

export type DigitalSignatureEnvelopesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: DigitalSignatureEnvelopeListFilters | null | undefined;
}>;

export type DigitalSignatureEnvelopesQuery = {
  __typename: "QueryRoot";
  digitalSignatureEnvelopes: Array<{
    __typename: "DigitalSignatureEnvelope";
    id: string;
    name: string;
    status: EnvelopeStatus;
    customerId: string;
    projectId: string;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountDigitalSignatureEnvelopesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: DigitalSignatureEnvelopeListFilters | null | undefined;
}>;

export type CountDigitalSignatureEnvelopesQuery = {
  __typename: "QueryRoot";
  countDigitalSignatureEnvelopes: string;
};

export type DigitalSignatureEnvelopeQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DigitalSignatureEnvelopeQuery = {
  __typename: "QueryRoot";
  digitalSignatureEnvelope: {
    __typename: "DigitalSignatureEnvelope";
    id: string;
    name: string;
    status: EnvelopeStatus;
    customerId: string;
    projectId: string;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    files: Array<{
      __typename: "DigitalSignatureFile";
      id: string;
      digitalSignatureId: string;
      filename: string;
      status: EnvelopeStatus;
      insertedAt: string;
      updatedAt: string;
    }>;
    fields: Array<{
      __typename: "DigitalSignatureField";
      id: string;
      email: string;
      digitalSignatureFileId: string;
      pageNo: number;
      x: number;
      y: number;
      width: number;
      height: number;
    }>;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateDigitalSignatureEnvelopeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: DigitalSignatureEnvelopeInput;
}>;

export type MutateDigitalSignatureEnvelopeMutation = {
  __typename: "MutationRoot";
  mutateDigitalSignatureEnvelope: {
    __typename: "DigitalSignatureEnvelope";
    id: string;
    name: string;
    status: EnvelopeStatus;
    customerId: string;
    projectId: string;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteDigitalSignatureEnvelopeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteDigitalSignatureEnvelopeMutation = {
  __typename: "MutationRoot";
  deleteDigitalSignatureEnvelope: {
    __typename: "DigitalSignatureEnvelope";
    id: string;
  };
};

export type MutateDigitalSignatureFileMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  envelopeId: string;
  values: DigitalSignatureFileInput;
}>;

export type MutateDigitalSignatureFileMutation = {
  __typename: "MutationRoot";
  mutateDigitalSignatureFile: {
    __typename: "DigitalSignatureFile";
    id: string;
    digitalSignatureId: string;
    filename: string;
    status: EnvelopeStatus;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteDigitalSignatureFileMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  envelopeId: string;
  id: string;
}>;

export type DeleteDigitalSignatureFileMutation = {
  __typename: "MutationRoot";
  deleteDigitalSignatureFile: {
    __typename: "DigitalSignatureFile";
    id: string;
  };
};

export type MutateDigitalSignatureFieldMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  envelopeId: string;
  id?: string | null | undefined;
  values: DigitalSignatureFieldInput;
}>;

export type MutateDigitalSignatureFieldMutation = {
  __typename: "MutationRoot";
  mutateDigitalSignatureField: {
    __typename: "DigitalSignatureField";
    id: string;
    email: string;
    digitalSignatureFileId: string;
    pageNo: number;
    x: number;
    y: number;
    width: number;
    height: number;
  };
};

export type DeleteDigitalSignatureFieldMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  envelopeId: string;
  id: string;
}>;

export type DeleteDigitalSignatureFieldMutation = {
  __typename: "MutationRoot";
  deleteDigitalSignatureField: {
    __typename: "DigitalSignatureField";
    id: string;
  };
};

export type SendDigitalSignatureEnvelopeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type SendDigitalSignatureEnvelopeMutation = {
  __typename: "MutationRoot";
  sendDigitalSignatureEnvelope: {
    __typename: "DigitalSignatureEnvelope";
    id: string;
    name: string;
    status: EnvelopeStatus;
    customerId: string;
    projectId: string;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    files: Array<{
      __typename: "DigitalSignatureFile";
      id: string;
      digitalSignatureId: string;
      filename: string;
      status: EnvelopeStatus;
      insertedAt: string;
      updatedAt: string;
    }>;
    fields: Array<{
      __typename: "DigitalSignatureField";
      id: string;
      email: string;
      digitalSignatureFileId: string;
      pageNo: number;
      x: number;
      y: number;
      width: number;
      height: number;
    }>;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DocumentsQueryVariables = Exact<{
  filters?: ListDocumentsFilters | null | undefined;
}>;

export type DocumentsQuery = {
  __typename: "QueryRoot";
  documents: Array<{
    __typename: "Document";
    customerId: string;
    projectId: string;
    id: string;
    subject: string;
    type: DocumentType;
    keywords: Array<string>;
    visible: boolean;
    signatureType: SignatureType;
    validFrom: string | null;
    validUntil: string | null;
    relevantProjectId: string | null;
    signatureDue: number | null;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
      name: string;
    };
    project: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
      attrs: Record<string, unknown>;
    };
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
      attrs: Record<string, unknown>;
      customer: {
        __typename: "MinimalCustomer";
        id: string;
        identifier: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountDocumentsQueryVariables = Exact<{
  filters?: ListDocumentsFilters | null | undefined;
}>;

export type CountDocumentsQuery = {
  __typename: "QueryRoot";
  countDocuments: string;
};

export type DocumentQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DocumentQuery = {
  __typename: "QueryRoot";
  document: {
    __typename: "Document";
    document: Record<string, unknown>;
    mdContent: string | null;
    customerId: string;
    projectId: string;
    id: string;
    subject: string;
    type: DocumentType;
    keywords: Array<string>;
    visible: boolean;
    signatureType: SignatureType;
    validFrom: string | null;
    validUntil: string | null;
    relevantProjectId: string | null;
    signatureDue: number | null;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    attachments: Array<{
      __typename: "DocumentAttachment";
      id: string;
      documentId: string;
      file: string;
    }>;
    missingSignatures: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    signatures: Array<{
      __typename: "DocumentSignature";
      id: string;
      type: DocumentSignatureSignatureType;
      userId: string;
      documentId: string;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
      name: string;
    };
    project: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
      attrs: Record<string, unknown>;
    };
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
      attrs: Record<string, unknown>;
      customer: {
        __typename: "MinimalCustomer";
        id: string;
        identifier: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateDocumentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: DocumentInput;
}>;

export type MutateDocumentMutation = {
  __typename: "MutationRoot";
  mutateDocument: {
    __typename: "Document";
    document: Record<string, unknown>;
    id: string;
    subject: string;
    type: DocumentType;
    keywords: Array<string>;
    visible: boolean;
    signatureType: SignatureType;
    validFrom: string | null;
    validUntil: string | null;
    relevantProjectId: string | null;
    signatureDue: number | null;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteDocumentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteDocumentMutation = {
  __typename: "MutationRoot";
  deleteDocument: { __typename: "Document"; id: string };
};

export type ConfirmDocumentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ConfirmDocumentMutation = {
  __typename: "MutationRoot";
  confirmDocument: {
    __typename: "DocumentSignature";
    id: string;
    type: DocumentSignatureSignatureType;
    userId: string;
    documentId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MissingDocumentSignaturesForUsersQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type MissingDocumentSignaturesForUsersQuery = {
  __typename: "QueryRoot";
  missingDocumentSignaturesForUsers: Array<{
    __typename: "MissingSignaturesForUser";
    userId: string;
    missing: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MissingDocumentSignaturesForUserQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  userId: string;
}>;

export type MissingDocumentSignaturesForUserQuery = {
  __typename: "QueryRoot";
  missingDocumentSignaturesForUser: Array<{
    __typename: "Document";
    customerId: string;
    projectId: string;
    id: string;
    subject: string;
    type: DocumentType;
    keywords: Array<string>;
    visible: boolean;
    signatureType: SignatureType;
    validFrom: string | null;
    validUntil: string | null;
    relevantProjectId: string | null;
    signatureDue: number | null;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
      name: string;
    };
    project: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
      attrs: Record<string, unknown>;
    };
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
      attrs: Record<string, unknown>;
      customer: {
        __typename: "MinimalCustomer";
        id: string;
        identifier: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MutateDocumentAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  documentId: string;
  id?: string | null | undefined;
  values: DocumentAttachmentInput;
}>;

export type MutateDocumentAttachmentMutation = {
  __typename: "MutationRoot";
  mutateDocumentAttachment: {
    __typename: "DocumentAttachment";
    id: string;
    documentId: string;
    file: string;
  };
};

export type OverdueDocumentsQueryVariables = Exact<{ [key: string]: never }>;

export type OverdueDocumentsQuery = {
  __typename: "QueryRoot";
  overdueDocuments: Array<{
    __typename: "Document";
    customerId: string;
    projectId: string;
    id: string;
    subject: string;
    type: DocumentType;
    keywords: Array<string>;
    visible: boolean;
    signatureType: SignatureType;
    validFrom: string | null;
    validUntil: string | null;
    relevantProjectId: string | null;
    signatureDue: number | null;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
      name: string;
    };
    project: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
      attrs: Record<string, unknown>;
    };
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
      attrs: Record<string, unknown>;
      customer: {
        __typename: "MinimalCustomer";
        id: string;
        identifier: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type EmployeePerformanceQueryVariables = Exact<{
  customerId: string;
  userId: string;
  filters: EmployeePerformanceShowFilters;
}>;

export type EmployeePerformanceQuery = {
  __typename: "QueryRoot";
  employeePerformance: Record<string, unknown>;
};

export type EmployeePerformancesQueryVariables = Exact<{
  customerId: string;
  filters: EmployeePerformanceListFilters;
}>;

export type EmployeePerformancesQuery = {
  __typename: "QueryRoot";
  employeePerformances: {
    __typename: "EmployeesPerformanceResult";
    count: string;
    stats: Record<string, unknown>;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  };
};

export type EmployeesQueryVariables = Exact<{
  customerId: string;
  filters?: EmployeesListFilters | null | undefined;
}>;

export type EmployeesQuery = {
  __typename: "QueryRoot";
  employees: Array<{
    __typename: "Employee";
    id: string;
    employeeName: string | null;
    entering: string;
    leaving: string | null;
    probationEnding: string | null;
    active: boolean;
    headset: string | null;
    deleted: boolean;
    position: string | null;
    levels: Array<Level>;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountEmployeesQueryVariables = Exact<{
  customerId: string;
  filters?: EmployeesListFilters | null | undefined;
}>;

export type CountEmployeesQuery = {
  __typename: "QueryRoot";
  countEmployees: string;
};

export type EmployeeQueryVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  userId?: string | null | undefined;
}>;

export type EmployeeQuery = {
  __typename: "QueryRoot";
  employee: {
    __typename: "Employee";
    id: string;
    entering: string;
    leaving: string | null;
    active: boolean;
    datevEmployeeNo: string | null;
    deleted: boolean;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    standardBonus: number | null;
    dataProtectionTrainingCompletedAt: string | null;
    cpsNumber: string | null;
    headset: string | null;
    healthInsurance: string | null;
    notes: string | null;
    probationEnding: string | null;
    employeeName: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    additionalJobs: string | null;
    denomination: string | null;
    languagesFluent: Array<string>;
    languagesNative: Array<string>;
    position: string | null;
    levels: Array<Level>;
    sickDaysLimit: number | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    children: Array<{
      __typename: "EmployeeChild";
      id: string;
      name: string;
      birthdate: string;
    }>;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      contact: {
        __typename: "Contact";
        id: string;
        customerId: string;
        projectId: string;
        salutation: string | null;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
        infos: Array<{
          __typename: "ContactInfo";
          id: string;
          description: string | null;
          itype: ContactInfoType;
          normalizedValue: string | null;
          value: string | null;
          confirmedAt: string | null;
          confirmationSentAt: string | null;
          insertedAt: string;
          updatedAt: string;
        }>;
        addresses: Array<{
          __typename: "ContactAddress";
          id: string;
          address: string | null;
          atype: ContactAddressType;
          city: string | null;
          cityPart: string | null;
          country: string | null;
          description: string | null;
          zip: string | null;
        }>;
      } | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  } | null;
};

export type MutateEmployeeMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: EmployeeInput;
}>;

export type MutateEmployeeMutation = {
  __typename: "MutationRoot";
  mutateEmployee: {
    __typename: "Employee";
    id: string;
    entering: string;
    leaving: string | null;
    active: boolean;
    datevEmployeeNo: string | null;
    deleted: boolean;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    standardBonus: number | null;
    dataProtectionTrainingCompletedAt: string | null;
    cpsNumber: string | null;
    headset: string | null;
    healthInsurance: string | null;
    notes: string | null;
    probationEnding: string | null;
    employeeName: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    additionalJobs: string | null;
    denomination: string | null;
    languagesFluent: Array<string>;
    languagesNative: Array<string>;
    position: string | null;
    levels: Array<Level>;
    sickDaysLimit: number | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    children: Array<{
      __typename: "EmployeeChild";
      id: string;
      name: string;
      birthdate: string;
    }>;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      contact: {
        __typename: "Contact";
        id: string;
        customerId: string;
        projectId: string;
        salutation: string | null;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
        infos: Array<{
          __typename: "ContactInfo";
          id: string;
          description: string | null;
          itype: ContactInfoType;
          normalizedValue: string | null;
          value: string | null;
          confirmedAt: string | null;
          confirmationSentAt: string | null;
          insertedAt: string;
          updatedAt: string;
        }>;
        addresses: Array<{
          __typename: "ContactAddress";
          id: string;
          address: string | null;
          atype: ContactAddressType;
          city: string | null;
          cityPart: string | null;
          country: string | null;
          description: string | null;
          zip: string | null;
        }>;
      } | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  };
};

export type ArchiveEmployeeMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ArchiveEmployeeMutation = {
  __typename: "MutationRoot";
  archiveEmployee: { __typename: "Employee"; id: string };
};

export type TerminateEmployeeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  values: TerminateEmployeeInput;
}>;

export type TerminateEmployeeMutation = {
  __typename: "MutationRoot";
  terminateEmployee: {
    __typename: "Employee";
    id: string;
    entering: string;
    leaving: string | null;
    active: boolean;
    datevEmployeeNo: string | null;
    deleted: boolean;
    iban: string | null;
    bic: string | null;
    taxId: string | null;
    socialSecurityNumber: string | null;
    standardBonus: number | null;
    dataProtectionTrainingCompletedAt: string | null;
    cpsNumber: string | null;
    headset: string | null;
    healthInsurance: string | null;
    notes: string | null;
    probationEnding: string | null;
    employeeName: string | null;
    gender: EmployeeGender | null;
    nationality: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    civilStatus: EmployeeCivilStatus | null;
    disability: boolean;
    disabilityLevel: number | null;
    taxLevel: number | null;
    childTaxAllowance: number | null;
    additionalJobs: string | null;
    denomination: string | null;
    languagesFluent: Array<string>;
    languagesNative: Array<string>;
    position: string | null;
    levels: Array<Level>;
    sickDaysLimit: number | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    children: Array<{
      __typename: "EmployeeChild";
      id: string;
      name: string;
      birthdate: string;
    }>;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      contact: {
        __typename: "Contact";
        id: string;
        customerId: string;
        projectId: string;
        salutation: string | null;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
        infos: Array<{
          __typename: "ContactInfo";
          id: string;
          description: string | null;
          itype: ContactInfoType;
          normalizedValue: string | null;
          value: string | null;
          confirmedAt: string | null;
          confirmationSentAt: string | null;
          insertedAt: string;
          updatedAt: string;
        }>;
        addresses: Array<{
          __typename: "ContactAddress";
          id: string;
          address: string | null;
          atype: ContactAddressType;
          city: string | null;
          cityPart: string | null;
          country: string | null;
          description: string | null;
          zip: string | null;
        }>;
      } | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  };
};

export type MutateEmployeeInfoMutationVariables = Exact<{
  customerId: string;
  id: string;
  infoId?: string | null | undefined;
  values: ContactInfoInput;
}>;

export type MutateEmployeeInfoMutation = {
  __typename: "MutationRoot";
  mutateEmployeeInfo: { __typename: "ContactInfo"; id: string };
};

export type DeleteEmployeeInfoMutationVariables = Exact<{
  customerId: string;
  id: string;
  infoId: string;
}>;

export type DeleteEmployeeInfoMutation = {
  __typename: "MutationRoot";
  deleteEmployeeInfo: { __typename: "ContactInfo"; id: string };
};

export type MutateEmployeeAddressMutationVariables = Exact<{
  customerId: string;
  id: string;
  addressId?: string | null | undefined;
  values: ContactAddressInput;
}>;

export type MutateEmployeeAddressMutation = {
  __typename: "MutationRoot";
  mutateEmployeeAddress: { __typename: "ContactAddress"; id: string };
};

export type EventTypesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: EventTypesListFilters | null | undefined;
}>;

export type EventTypesQuery = {
  __typename: "QueryRoot";
  eventTypes: Array<{
    __typename: "EventType";
    id: string;
    name: string;
    type: EventTypeType;
    mayForeign: boolean;
  }>;
};

export type EventTypeQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type EventTypeQuery = {
  __typename: "QueryRoot";
  eventType: {
    __typename: "EventType";
    id: string;
    name: string;
    type: EventTypeType;
    mayForeign: boolean;
  } | null;
};

export type CountEventTypesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type CountEventTypesQuery = {
  __typename: "QueryRoot";
  countEventTypes: string;
};

export type MutateEventTypeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  eventType: EventTypeInput;
}>;

export type MutateEventTypeMutation = {
  __typename: "MutationRoot";
  mutateEventType: {
    __typename: "EventType";
    id: string;
    name: string;
    type: EventTypeType;
    mayForeign: boolean;
  };
};

export type DeleteEventTypeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteEventTypeMutation = {
  __typename: "MutationRoot";
  deleteEventType: { __typename: "EventType"; id: string };
};

export type CountEventsQueryVariables = Exact<{
  customerId?: string | null | undefined;
  projectId?: string | null | undefined;
  filters?: EventsListFilters | null | undefined;
}>;

export type CountEventsQuery = { __typename: "QueryRoot"; countEvents: string };

export type EventTimeValidQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  ownerId: string;
  startTime: string;
  endTime?: string | null | undefined;
}>;

export type EventTimeValidQuery = {
  __typename: "QueryRoot";
  eventTimeValid: boolean;
};

export type DeleteEventMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteEventMutation = {
  __typename: "MutationRoot";
  deleteEvent: { __typename: "Event"; id: string };
};

export type EventsCalendarQueryVariables = Exact<{
  customerId?: string | null | undefined;
  projectId?: string | null | undefined;
  filters?: EventsListFilters | null | undefined;
}>;

export type EventsCalendarQuery = {
  __typename: "QueryRoot";
  events: Array<{
    __typename: "Event";
    id: string;
    subject: string;
    details: string | null;
    startTime: string;
    endTime: string;
    allDay: boolean;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    shifted: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    customerId: string;
    projectId: string;
    contactId: string | null;
    ownerId: string;
    typeId: string;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
    } | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
  }>;
};

export type EventsWithOwnerAndAttendeeQueryVariables = Exact<{
  customerId?: string | null | undefined;
  projectId?: string | null | undefined;
  filters?: EventsListFilters | null | undefined;
}>;

export type EventsWithOwnerAndAttendeeQuery = {
  __typename: "QueryRoot";
  events: Array<{
    __typename: "Event";
    id: string;
    subject: string;
    details: string | null;
    startTime: string;
    endTime: string;
    allDay: boolean;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    shifted: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    customerId: string;
    projectId: string;
    contactId: string | null;
    ownerId: string;
    typeId: string;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
    } | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
  }>;
};

export type EventsWithOwnerAndCreatorQueryVariables = Exact<{
  customerId?: string | null | undefined;
  projectId?: string | null | undefined;
  filters?: EventsListFilters | null | undefined;
}>;

export type EventsWithOwnerAndCreatorQuery = {
  __typename: "QueryRoot";
  events: Array<{
    __typename: "Event";
    id: string;
    subject: string;
    details: string | null;
    startTime: string;
    endTime: string;
    allDay: boolean;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    shifted: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    customerId: string;
    projectId: string;
    contactId: string | null;
    ownerId: string;
    typeId: string;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
    } | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    } | null;
  }>;
};

export type ExportEventsMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: EventsListFilters | null | undefined;
}>;

export type ExportEventsMutation = {
  __typename: "MutationRoot";
  exportEvents: { __typename: "JobResult"; id: string };
};

export type EventQueryVariables = Exact<{
  customerId?: string | null | undefined;
  projectId?: string | null | undefined;
  id: string;
}>;

export type EventQuery = {
  __typename: "QueryRoot";
  event: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
      name: string;
    } | null;
    project: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
    } | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type EventAllDetailsQueryVariables = Exact<{
  customerId?: string | null | undefined;
  projectId?: string | null | undefined;
  id: string;
}>;

export type EventAllDetailsQuery = {
  __typename: "QueryRoot";
  event: {
    __typename: "Event";
    editorId: string;
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type MutateEventMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  event: EventInput;
}>;

export type MutateEventMutation = {
  __typename: "MutationRoot";
  mutateEvent: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type CancelEventMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type CancelEventMutation = {
  __typename: "MutationRoot";
  cancelEvent: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type UncancelEventMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type UncancelEventMutation = {
  __typename: "MutationRoot";
  uncancelEvent: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type ClearEventMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ClearEventMutation = {
  __typename: "MutationRoot";
  clearEvent: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type UnclearEventMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type UnclearEventMutation = {
  __typename: "MutationRoot";
  unclearEvent: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type SendEventMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type SendEventMutation = {
  __typename: "MutationRoot";
  sendEvent: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type ShiftEventMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  values: ShiftEventInput;
}>;

export type ShiftEventMutation = {
  __typename: "MutationRoot";
  shiftEvent: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type ConfirmEventWithTokenMutationVariables = Exact<{
  token: string;
}>;

export type ConfirmEventWithTokenMutation = {
  __typename: "MutationRoot";
  confirmEventWithToken: {
    __typename: "Event";
    contactId: string | null;
    id: string;
    subject: string;
    allDay: boolean;
    startTime: string;
    endTime: string;
    details: string | null;
    attrs: Record<string, unknown>;
    canceled: boolean;
    cleared: boolean;
    sent: boolean;
    sentAt: string | null;
    shifted: boolean;
    typeId: string;
    insertedAt: string;
    updatedAt: string;
    ownerId: string;
    creatorId: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
    replacementForEvent: {
      __typename: "Event";
      id: string;
      subject: string;
      startTime: string;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    feedbacks: Array<{
      __typename: "EventFeedback";
      id: string;
      tookPlace: boolean | null;
      insertedAt: string;
      attrs: Record<string, unknown>;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type TransferEventOwnershipMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  filters: EventsListFilters;
  newOwnerId: string;
}>;

export type TransferEventOwnershipMutation = {
  __typename: "MutationRoot";
  transferEventOwnership: Array<{
    __typename: "Event";
    id: string;
    subject: string;
    details: string | null;
    startTime: string;
    endTime: string;
    shifted: boolean;
    canceled: boolean;
    cleared: boolean;
    allDay: boolean;
    sent: boolean;
    customerId: string;
    projectId: string;
    contactId: string | null;
    ownerId: string;
    type: {
      __typename: "EventType";
      id: string;
      name: string;
      type: EventTypeType;
    } | null;
  }>;
};

export type FeastdayFragment = {
  __typename: "Feastday";
  id: string;
  name: string;
  day: string;
  insertedAt: string;
  updatedAt: string;
};

export type FeastdaysQueryVariables = Exact<{
  customerId: string;
  filters?: ListFeastdaysFilters | null | undefined;
}>;

export type FeastdaysQuery = {
  __typename: "QueryRoot";
  feastdays: Array<{
    __typename: "Feastday";
    id: string;
    name: string;
    day: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountFeastdaysQueryVariables = Exact<{
  customerId: string;
  filters?: CountFeastdaysFilters | null | undefined;
}>;

export type CountFeastdaysQuery = {
  __typename: "QueryRoot";
  countFeastdays: string;
};

export type FeastdayQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type FeastdayQuery = {
  __typename: "QueryRoot";
  feastday: {
    __typename: "Feastday";
    id: string;
    name: string;
    day: string;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteFeastdayMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteFeastdayMutation = {
  __typename: "MutationRoot";
  deleteFeastday: { __typename: "Feastday"; id: string };
};

export type MutateFeastdayMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  feastday: FeastdayInput;
}>;

export type MutateFeastdayMutation = {
  __typename: "MutationRoot";
  mutateFeastday: {
    __typename: "Feastday";
    id: string;
    name: string;
    day: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type EventFeedbacksQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  eventId?: string | null | undefined;
  filters?: EventFeedbackListFilters | null | undefined;
}>;

export type EventFeedbacksQuery = {
  __typename: "QueryRoot";
  eventFeedbacks: Array<{
    __typename: "EventFeedback";
    id: string;
    type: FeedbackType;
    details: string | null;
    tookPlace: boolean | null;
    done: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    eventId: string;
    ownerId: string;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    event: {
      __typename: "Event";
      id: string;
      subject: string;
      details: string | null;
      startTime: string;
      endTime: string;
      canceled: boolean;
      cleared: boolean;
      allDay: boolean;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
      type: { __typename: "EventType"; id: string; name: string } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    } | null;
  }>;
};

export type EventFeedbacksForEventQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  eventId?: string | null | undefined;
  filters?: EventFeedbackListFilters | null | undefined;
}>;

export type EventFeedbacksForEventQuery = {
  __typename: "QueryRoot";
  eventFeedbacks: Array<{
    __typename: "EventFeedback";
    id: string;
    type: FeedbackType;
    details: string | null;
    tookPlace: boolean | null;
    done: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    eventId: string;
    ownerId: string;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    event: {
      __typename: "Event";
      id: string;
      subject: string;
      details: string | null;
      startTime: string;
      endTime: string;
      canceled: boolean;
      cleared: boolean;
      allDay: boolean;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
      type: { __typename: "EventType"; id: string; name: string } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    } | null;
  }>;
};

export type CountEventFeedbacksQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  eventId?: string | null | undefined;
  filters?: EventFeedbackListFilters | null | undefined;
}>;

export type CountEventFeedbacksQuery = {
  __typename: "QueryRoot";
  countEventFeedbacks: string;
};

export type EventFeedbackQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type EventFeedbackQuery = {
  __typename: "QueryRoot";
  eventFeedback: {
    __typename: "EventFeedback";
    id: string;
    type: FeedbackType;
    details: string | null;
    tookPlace: boolean | null;
    done: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    eventId: string;
    ownerId: string;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    event: {
      __typename: "Event";
      id: string;
      subject: string;
      details: string | null;
      startTime: string;
      endTime: string;
      canceled: boolean;
      cleared: boolean;
      allDay: boolean;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
      type: { __typename: "EventType"; id: string; name: string } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type MutateEventFeedbackMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  eventId?: string | null | undefined;
  id?: string | null | undefined;
  values: EventFeedbackInput;
}>;

export type MutateEventFeedbackMutation = {
  __typename: "MutationRoot";
  mutateEventFeedback: {
    __typename: "EventFeedback";
    id: string;
    type: FeedbackType;
    details: string | null;
    tookPlace: boolean | null;
    done: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    eventId: string;
    ownerId: string;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    event: {
      __typename: "Event";
      id: string;
      subject: string;
      details: string | null;
      startTime: string;
      endTime: string;
      canceled: boolean;
      cleared: boolean;
      allDay: boolean;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
      type: { __typename: "EventType"; id: string; name: string } | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    } | null;
  };
};

export type DeleteEventFeedbackMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteEventFeedbackMutation = {
  __typename: "MutationRoot";
  deleteEventFeedback: { __typename: "EventFeedback"; id: string };
};

export type FileExchangeEntriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: FileExchangeListFilters | null | undefined;
}>;

export type FileExchangeEntriesQuery = {
  __typename: "QueryRoot";
  fileExchangeEntries: Array<{
    __typename: "FileExchangeEntry";
    id: string;
    filename: string;
    comment: string | null;
    status: FileExchangeStatus;
    customerId: string;
    projectId: string;
    ownerId: string;
    creatorId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountFileExchangeEntriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: FileExchangeListFilters | null | undefined;
}>;

export type CountFileExchangeEntriesQuery = {
  __typename: "QueryRoot";
  countFileExchangeEntries: string;
};

export type FileExchangeEntryQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type FileExchangeEntryQuery = {
  __typename: "QueryRoot";
  fileExchangeEntry: {
    __typename: "FileExchangeEntry";
    id: string;
    filename: string;
    comment: string | null;
    status: FileExchangeStatus;
    customerId: string;
    projectId: string;
    ownerId: string;
    creatorId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type FileExchangeUsersQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  search?: string | null | undefined;
}>;

export type FileExchangeUsersQuery = {
  __typename: "QueryRoot";
  fileExchangeUsers: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
};

export type MutateFileExchangeEntryMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: FileExchangeEntryInput;
}>;

export type MutateFileExchangeEntryMutation = {
  __typename: "MutationRoot";
  mutateFileExchangeEntry: {
    __typename: "FileExchangeEntry";
    id: string;
    filename: string;
    comment: string | null;
    status: FileExchangeStatus;
    customerId: string;
    projectId: string;
    ownerId: string;
    creatorId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MarkFileExchangeEntryDoneMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type MarkFileExchangeEntryDoneMutation = {
  __typename: "MutationRoot";
  markFileExchangeEntryDone: {
    __typename: "FileExchangeEntry";
    id: string;
    filename: string;
    comment: string | null;
    status: FileExchangeStatus;
    customerId: string;
    projectId: string;
    ownerId: string;
    creatorId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteFileExchangeEntryMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteFileExchangeEntryMutation = {
  __typename: "MutationRoot";
  deleteFileExchangeEntry: { __typename: "FileExchangeEntry"; id: string };
};

export type CreateFileExchangeEntryFromEmployeeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  recipientId: string;
  comment?: string | null | undefined;
}>;

export type CreateFileExchangeEntryFromEmployeeMutation = {
  __typename: "MutationRoot";
  createFileExchangeEntryFromEmployee: boolean;
};

export type CreateFileExchangeEntryFromPersonalFileMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  recipientId: string;
  comment?: string | null | undefined;
}>;

export type CreateFileExchangeEntryFromPersonalFileMutation = {
  __typename: "MutationRoot";
  createFileExchangeEntryFromPersonalFile: boolean;
};

export type FinanceReportQueryVariables = Exact<{
  filters?: FinanceReportListFilters | null | undefined;
}>;

export type FinanceReportQuery = {
  __typename: "QueryRoot";
  financeReport: Array<{
    __typename: "FinanceReport";
    userId: string;
    displayName: string;
    customerId: string | null;
    customerName: string;
    hours: number;
    earnings: string;
    expenses: string;
    source: FinanceReportEntrySource;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type RegenerateFinanceReportsMutationVariables = Exact<{
  start: string;
  stop: string;
  userId?: string | null | undefined;
}>;

export type RegenerateFinanceReportsMutation = {
  __typename: "MutationRoot";
  regenerateFinanceReports: boolean;
};

export type FinanceReportCorrectionsQueryVariables = Exact<{
  filters?: FinanceReportCorrectionListFilters | null | undefined;
}>;

export type FinanceReportCorrectionsQuery = {
  __typename: "QueryRoot";
  financeReportCorrections: Array<{
    __typename: "FinanceReportCorrection";
    id: string;
    userId: string;
    day: string;
    hours: number | null;
    earnings: string | null;
    expenses: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountFinanceReportCorrectionsQueryVariables = Exact<{
  filters?: FinanceReportCorrectionListFilters | null | undefined;
}>;

export type CountFinanceReportCorrectionsQuery = {
  __typename: "QueryRoot";
  countFinanceReportCorrections: string;
};

export type FinanceReportCorrectionQueryVariables = Exact<{
  id: string;
}>;

export type FinanceReportCorrectionQuery = {
  __typename: "QueryRoot";
  financeReportCorrection: {
    __typename: "FinanceReportCorrection";
    id: string;
    userId: string;
    day: string;
    hours: number | null;
    earnings: string | null;
    expenses: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateFinanceReportCorrectionMutationVariables = Exact<{
  id?: string | null | undefined;
  values: FinanceReportCorrectionInput;
}>;

export type MutateFinanceReportCorrectionMutation = {
  __typename: "MutationRoot";
  mutateFinanceReportCorrection: Array<{
    __typename: "FinanceReportCorrection";
    id: string;
    userId: string;
    day: string;
    hours: number | null;
    earnings: string | null;
    expenses: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type DeleteFinanceReportCorrectionMutationVariables = Exact<{
  id: string;
}>;

export type DeleteFinanceReportCorrectionMutation = {
  __typename: "MutationRoot";
  deleteFinanceReportCorrection: {
    __typename: "FinanceReportCorrection";
    id: string;
    userId: string;
    day: string;
    hours: number | null;
    earnings: string | null;
    expenses: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type HistoryAuditLogEntriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters: HistoryAuditLogFilters;
}>;

export type HistoryAuditLogEntriesQuery = {
  __typename: "QueryRoot";
  historyAuditLogEntries: Array<{
    __typename: "HistoryAuditLogEntry";
    id: string;
    contactId: string | null;
    action: HistoryAuditLogAction;
    meta: Record<string, unknown>;
    original: Record<string, unknown>;
    changes: Record<string, unknown>;
    insertedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountHistoryAuditLogEntriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters: HistoryAuditLogFilters;
}>;

export type CountHistoryAuditLogEntriesQuery = {
  __typename: "QueryRoot";
  countHistoryAuditLogEntries: string;
};

export type HistoriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: HistoriesListFilters | null | undefined;
}>;

export type HistoriesQuery = {
  __typename: "QueryRoot";
  histories: Array<{
    __typename: "History";
    id: string;
    htype: HistoryType;
    subject: string;
    details: string | null;
    meta: Record<string, unknown>;
    contactId: string | null;
    pinned: boolean;
    insertedAt: string;
    fileAttachments: Array<{
      __typename: "HistoryAttachment";
      id: string;
      file: string;
      title: string;
      deleted: boolean;
      deletionReason: string | null;
      deletedBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    callResult: { __typename: "CallResult"; id: string; name: string } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountHistoriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: HistoriesListFilters | null | undefined;
}>;

export type CountHistoriesQuery = {
  __typename: "QueryRoot";
  countHistories: string;
};

export type CallHistoriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CallHistoriesListFilters | null | undefined;
}>;

export type CallHistoriesQuery = {
  __typename: "QueryRoot";
  callHistories: Array<{
    __typename: "History";
    allDone: boolean | null;
    id: string;
    htype: HistoryType;
    subject: string;
    details: string | null;
    meta: Record<string, unknown>;
    contactId: string | null;
    pinned: boolean;
    insertedAt: string;
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountCallHistoriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CallHistoriesListFilters | null | undefined;
}>;

export type CountCallHistoriesQuery = {
  __typename: "QueryRoot";
  countCallHistories: string;
};

export type MutateHistoryMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId?: string | null | undefined;
  eventId?: string | null | undefined;
  history: HistoryInput;
}>;

export type MutateHistoryMutation = {
  __typename: "MutationRoot";
  mutateHistory: {
    __typename: "History";
    id: string;
    htype: HistoryType;
    subject: string;
    details: string | null;
    meta: Record<string, unknown>;
    contactId: string | null;
    pinned: boolean;
    insertedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type ExportCallHistoriesMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CallHistoriesListFilters | null | undefined;
}>;

export type ExportCallHistoriesMutation = {
  __typename: "MutationRoot";
  exportCallHistories: { __typename: "JobResult"; id: string };
};

export type MarkHistoryDoneMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type MarkHistoryDoneMutation = {
  __typename: "MutationRoot";
  markHistoryDone: {
    __typename: "History";
    allDone: boolean | null;
    id: string;
    htype: HistoryType;
    subject: string;
    details: string | null;
    meta: Record<string, unknown>;
    contactId: string | null;
    pinned: boolean;
    insertedAt: string;
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type HistoryQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type HistoryQuery = {
  __typename: "QueryRoot";
  history: {
    __typename: "History";
    id: string;
    htype: HistoryType;
    subject: string;
    details: string | null;
    meta: Record<string, unknown>;
    contactId: string | null;
    pinned: boolean;
    insertedAt: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    annotations: Array<{
      __typename: "HistoryAnnotation";
      id: string;
      historyId: string;
      details: string;
      insertedAt: string;
      done: boolean;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type PinHistoryMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  pinned: boolean;
}>;

export type PinHistoryMutation = {
  __typename: "MutationRoot";
  pinHistory: {
    __typename: "History";
    id: string;
    htype: HistoryType;
    subject: string;
    details: string | null;
    meta: Record<string, unknown>;
    contactId: string | null;
    pinned: boolean;
    insertedAt: string;
    fileAttachments: Array<{
      __typename: "HistoryAttachment";
      id: string;
      file: string;
      title: string;
      deleted: boolean;
      deletionReason: string | null;
      deletedBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    callResult: { __typename: "CallResult"; id: string; name: string } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MutateContactHistoryAnnotationMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  historyId: string;
  annotation: HistoryAnnotationInput;
}>;

export type MutateContactHistoryAnnotationMutation = {
  __typename: "MutationRoot";
  mutateContactHistoryAnnotation: {
    __typename: "HistoryAnnotation";
    id: string;
    historyId: string;
    details: string;
    insertedAt: string;
    done: boolean;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MarkContactHistoryAnnotationDoneMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  historyId: string;
  id: string;
}>;

export type MarkContactHistoryAnnotationDoneMutation = {
  __typename: "MutationRoot";
  markContactHistoryAnnotationDone: {
    __typename: "HistoryAnnotation";
    id: string;
    historyId: string;
    details: string;
    insertedAt: string;
    done: boolean;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type HistoriesCallResultsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type HistoriesCallResultsQuery = {
  __typename: "QueryRoot";
  historiesCallResults: Array<{
    __typename: "CallResult";
    id: string;
    name: string;
  }>;
};

export type CountHistoriesCallResultsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type CountHistoriesCallResultsQuery = {
  __typename: "QueryRoot";
  countHistoriesCallResults: string;
};

export type HistoriesCallResultQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type HistoriesCallResultQuery = {
  __typename: "QueryRoot";
  historiesCallResult: {
    __typename: "CallResult";
    id: string;
    name: string;
  } | null;
};

export type MutateHistoriesCallResultMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  callResult: CallResultInput;
}>;

export type MutateHistoriesCallResultMutation = {
  __typename: "MutationRoot";
  mutateHistoriesCallResult: {
    __typename: "CallResult";
    id: string;
    name: string;
  };
};

export type DeleteHistoriesCallResultMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteHistoriesCallResultMutation = {
  __typename: "MutationRoot";
  deleteHistoriesCallResult: {
    __typename: "CallResult";
    id: string;
    name: string;
  };
};

export type DeleteHistoryAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  deletionReason: string;
}>;

export type DeleteHistoryAttachmentMutation = {
  __typename: "MutationRoot";
  deleteHistoryAttachment: {
    __typename: "HistoryAttachment";
    id: string;
    file: string;
    title: string;
    deleted: boolean;
    deletionReason: string | null;
    deletedBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type MutateHotseatRequestMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  values: HotseatRequestInput;
}>;

export type MutateHotseatRequestMutation = {
  __typename: "MutationRoot";
  mutateHotseatRequest: {
    __typename: "HotseatRequest";
    id: string;
    url: string | null;
    category: string;
    attrs: Record<string, unknown>;
    customerId: string | null;
    projectId: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
  };
};

export type HotseatRequestsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: HotseatRequestFilters | null | undefined;
}>;

export type HotseatRequestsQuery = {
  __typename: "QueryRoot";
  hotseatRequests: Array<{
    __typename: "HotseatRequest";
    id: string;
    url: string | null;
    category: string;
    attrs: Record<string, unknown>;
    customerId: string | null;
    projectId: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
  }>;
};

export type CountHotseatRequestsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CountHotseatRequestsFilters | null | undefined;
}>;

export type CountHotseatRequestsQuery = {
  __typename: "QueryRoot";
  countHotseatRequests: string;
};

export type DeleteHotseatRequestMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteHotseatRequestMutation = {
  __typename: "MutationRoot";
  deleteHotseatRequest: { __typename: "HotseatRequest"; id: string };
};

export type ExportHotseatRequestsMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: HotseatRequestFilters | null | undefined;
}>;

export type ExportHotseatRequestsMutation = {
  __typename: "MutationRoot";
  exportHotseatRequests: { __typename: "JobResult"; id: string };
};

export type HourOrdersQueryVariables = Exact<{
  customerId: string;
  filters?: HourOrderListFilters | null | undefined;
}>;

export type HourOrdersQuery = {
  __typename: "QueryRoot";
  hourOrders: Array<{
    __typename: "HourOrder";
    id: string;
    customerId: string;
    month: string;
    productiveHours: number;
    adminHours: number;
    overCapacityHours: number;
    predictableHolidayHours: number;
    comment: string | null;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type MutateHourOrderMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: HourOrderInput;
}>;

export type MutateHourOrderMutation = {
  __typename: "MutationRoot";
  mutateHourOrder: {
    __typename: "HourOrder";
    id: string;
    customerId: string;
    month: string;
    productiveHours: number;
    adminHours: number;
    overCapacityHours: number;
    predictableHolidayHours: number;
    comment: string | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteHourOrderMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteHourOrderMutation = {
  __typename: "MutationRoot";
  deleteHourOrder: { __typename: "HourOrder"; id: string };
};

export type IndeedStatsQueryVariables = Exact<{
  customerId: string;
  filters?: IndeedStatsListOptions | null | undefined;
}>;

export type IndeedStatsQuery = {
  __typename: "QueryRoot";
  indeedStats: Array<{
    __typename: "IndeedStatsEntry";
    id: string;
    time: string;
    spend: number;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type DeleteIndeedStatsEntryMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteIndeedStatsEntryMutation = {
  __typename: "MutationRoot";
  deleteIndeedStatsEntry: {
    __typename: "IndeedStatsEntry";
    id: string;
    time: string;
    spend: number;
    insertedAt: string;
    updatedAt: string;
  };
};

export type MutateIndeedStatsMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: IndeedStatsEntryInput;
}>;

export type MutateIndeedStatsMutation = {
  __typename: "MutationRoot";
  mutateIndeedStats: {
    __typename: "IndeedStatsEntry";
    id: string;
    time: string;
    spend: number;
    insertedAt: string;
    updatedAt: string;
  };
};

export type MutateIndeedStatsForMonthMutationVariables = Exact<{
  customerId: string;
  values: IndeedStatsEntryInput;
}>;

export type MutateIndeedStatsForMonthMutation = {
  __typename: "MutationRoot";
  mutateIndeedStatsForMonth: Array<{
    __typename: "IndeedStatsEntry";
    id: string;
    time: string;
    spend: number;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type IndeedStatsEntryQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type IndeedStatsEntryQuery = {
  __typename: "QueryRoot";
  indeedStatsEntry: {
    __typename: "IndeedStatsEntry";
    id: string;
    time: string;
    spend: number;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type IndeedStatsEntryValidQueryVariables = Exact<{
  customerId: string;
  day: string;
}>;

export type IndeedStatsEntryValidQuery = {
  __typename: "QueryRoot";
  indeedStatsEntryValid: boolean;
};

export type InventoryItemTypesQueryVariables = Exact<{
  customerId: string;
  filters?: InventoryItemTypeFilters | null | undefined;
}>;

export type InventoryItemTypesQuery = {
  __typename: "QueryRoot";
  inventoryItemTypes: Array<{
    __typename: "InventoryItemType";
    id: string;
    customerId: string;
    name: string;
    type: InventoryItemTypeType;
    itemsWanted: number;
    needsCheck: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountInventoryItemTypesQueryVariables = Exact<{
  customerId: string;
  filters?: InventoryItemTypeFilters | null | undefined;
}>;

export type CountInventoryItemTypesQuery = {
  __typename: "QueryRoot";
  countInventoryItemTypes: string;
};

export type InventoryItemTypeQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type InventoryItemTypeQuery = {
  __typename: "QueryRoot";
  inventoryItemType: {
    __typename: "InventoryItemType";
    id: string;
    customerId: string;
    name: string;
    type: InventoryItemTypeType;
    itemsWanted: number;
    needsCheck: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type MutateInventoryItemTypeMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: InventoryItemTypeInput;
}>;

export type MutateInventoryItemTypeMutation = {
  __typename: "MutationRoot";
  mutateInventoryItemType: {
    __typename: "InventoryItemType";
    id: string;
    customerId: string;
    name: string;
    type: InventoryItemTypeType;
    itemsWanted: number;
    needsCheck: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteInventoryItemTypeMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteInventoryItemTypeMutation = {
  __typename: "MutationRoot";
  deleteInventoryItemType: { __typename: "InventoryItemType"; id: string };
};

export type InventoryItemTypeMetaInfoQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type InventoryItemTypeMetaInfoQuery = {
  __typename: "QueryRoot";
  inventoryItemTypeMetaInfo: {
    __typename: "InventoryItemTypeCountMeta";
    count: string;
    reserved: string;
    inStock: string;
    homeoffice: string;
    office: string;
    ready: string;
    broken: string;
    lost: string;
    disabled: string;
  };
};

export type InventoryItemsQueryVariables = Exact<{
  customerId: string;
  filters?: InventoryItemFilters | null | undefined;
}>;

export type InventoryItemsQuery = {
  __typename: "QueryRoot";
  inventoryItems: Array<{
    __typename: "InventoryItem";
    id: string;
    customerId: string;
    itemTypeId: string;
    lastBeaconId: string | null;
    lastDguvCheckId: string | null;
    name: string;
    serial: string | null;
    location: string | null;
    userId: string | null;
    deploymentInfo: InventoryItemDeploymentInfo;
    status: InventoryItemStatus;
    notes: string | null;
    attrs: Record<string, unknown>;
    needsCheck: boolean | null;
    checkInterval: number;
    insertedAt: string;
    updatedAt: string;
    itemType: {
      __typename: "InventoryItemType";
      id: string;
      type: InventoryItemTypeType;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    lastBeacon: {
      __typename: "InventoryItemBeacon";
      id: string;
      ip: string;
      mouse: boolean;
      keyboard: boolean;
      adapter: boolean;
      webcam: boolean;
      osName: string | null;
      osVersion: string | null;
      lastUser: string | null;
      insertedAt: string;
    } | null;
    lastDguvCheck: {
      __typename: "InventoryTimelineEntry";
      id: string;
      inventoryItemId: string;
      creatorId: string;
      userId: string | null;
      type: InventoryTimelineType;
      comment: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
  }>;
};

export type InventoryItemsWithItemTypeQueryVariables = Exact<{
  customerId: string;
  filters?: InventoryItemFilters | null | undefined;
}>;

export type InventoryItemsWithItemTypeQuery = {
  __typename: "QueryRoot";
  inventoryItems: Array<{
    __typename: "InventoryItem";
    id: string;
    customerId: string;
    itemTypeId: string;
    lastBeaconId: string | null;
    lastDguvCheckId: string | null;
    name: string;
    serial: string | null;
    location: string | null;
    userId: string | null;
    deploymentInfo: InventoryItemDeploymentInfo;
    status: InventoryItemStatus;
    notes: string | null;
    attrs: Record<string, unknown>;
    needsCheck: boolean | null;
    checkInterval: number;
    insertedAt: string;
    updatedAt: string;
    itemType: {
      __typename: "InventoryItemType";
      id: string;
      type: InventoryItemTypeType;
      name: string;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    lastBeacon: {
      __typename: "InventoryItemBeacon";
      id: string;
      ip: string;
      mouse: boolean;
      keyboard: boolean;
      adapter: boolean;
      webcam: boolean;
      osName: string | null;
      osVersion: string | null;
      lastUser: string | null;
      insertedAt: string;
    } | null;
    lastDguvCheck: {
      __typename: "InventoryTimelineEntry";
      id: string;
      inventoryItemId: string;
      creatorId: string;
      userId: string | null;
      type: InventoryTimelineType;
      comment: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
  }>;
};

export type CountInventoryItemsQueryVariables = Exact<{
  customerId: string;
  filters?: InventoryItemFilters | null | undefined;
}>;

export type CountInventoryItemsQuery = {
  __typename: "QueryRoot";
  countInventoryItems: string;
};

export type InventoryItemsInNeedForDguvCheckQueryVariables = Exact<{
  customerId: string;
  filters?: InventoryItemCheckFilters | null | undefined;
}>;

export type InventoryItemsInNeedForDguvCheckQuery = {
  __typename: "QueryRoot";
  inventoryItemsInNeedForDguvCheck: Array<{
    __typename: "InventoryItem";
    id: string;
    customerId: string;
    itemTypeId: string;
    lastBeaconId: string | null;
    lastDguvCheckId: string | null;
    name: string;
    serial: string | null;
    location: string | null;
    userId: string | null;
    deploymentInfo: InventoryItemDeploymentInfo;
    status: InventoryItemStatus;
    notes: string | null;
    attrs: Record<string, unknown>;
    needsCheck: boolean | null;
    checkInterval: number;
    insertedAt: string;
    updatedAt: string;
    itemType: {
      __typename: "InventoryItemType";
      id: string;
      type: InventoryItemTypeType;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    lastBeacon: {
      __typename: "InventoryItemBeacon";
      id: string;
      ip: string;
      mouse: boolean;
      keyboard: boolean;
      adapter: boolean;
      webcam: boolean;
      osName: string | null;
      osVersion: string | null;
      lastUser: string | null;
      insertedAt: string;
    } | null;
    lastDguvCheck: {
      __typename: "InventoryTimelineEntry";
      id: string;
      inventoryItemId: string;
      creatorId: string;
      userId: string | null;
      type: InventoryTimelineType;
      comment: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
  }>;
};

export type CountInventoryItemsInNeedForDguvCheckQueryVariables = Exact<{
  customerId: string;
  filters?: InventoryItemCheckFilters | null | undefined;
}>;

export type CountInventoryItemsInNeedForDguvCheckQuery = {
  __typename: "QueryRoot";
  countInventoryItemsInNeedForDguvCheck: string;
};

export type InventoryItemQueryVariables = Exact<{
  customerId: string;
  itemTypeId?: string | null | undefined;
  id: string;
}>;

export type InventoryItemQuery = {
  __typename: "QueryRoot";
  inventoryItem: {
    __typename: "InventoryItem";
    subscribed: boolean | null;
    id: string;
    customerId: string;
    itemTypeId: string;
    lastBeaconId: string | null;
    lastDguvCheckId: string | null;
    name: string;
    serial: string | null;
    location: string | null;
    userId: string | null;
    deploymentInfo: InventoryItemDeploymentInfo;
    status: InventoryItemStatus;
    notes: string | null;
    attrs: Record<string, unknown>;
    needsCheck: boolean | null;
    checkInterval: number;
    insertedAt: string;
    updatedAt: string;
    itemType: {
      __typename: "InventoryItemType";
      id: string;
      type: InventoryItemTypeType;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    lastBeacon: {
      __typename: "InventoryItemBeacon";
      id: string;
      ip: string;
      mouse: boolean;
      keyboard: boolean;
      adapter: boolean;
      webcam: boolean;
      osName: string | null;
      osVersion: string | null;
      lastUser: string | null;
      insertedAt: string;
    } | null;
    lastDguvCheck: {
      __typename: "InventoryTimelineEntry";
      id: string;
      inventoryItemId: string;
      creatorId: string;
      userId: string | null;
      type: InventoryTimelineType;
      comment: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
  } | null;
};

export type MutateInventoryItemMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: InventoryItemInput;
}>;

export type MutateInventoryItemMutation = {
  __typename: "MutationRoot";
  mutateInventoryItem: {
    __typename: "InventoryItem";
    id: string;
    customerId: string;
    itemTypeId: string;
    lastBeaconId: string | null;
    lastDguvCheckId: string | null;
    name: string;
    serial: string | null;
    location: string | null;
    userId: string | null;
    deploymentInfo: InventoryItemDeploymentInfo;
    status: InventoryItemStatus;
    notes: string | null;
    attrs: Record<string, unknown>;
    needsCheck: boolean | null;
    checkInterval: number;
    insertedAt: string;
    updatedAt: string;
    itemType: {
      __typename: "InventoryItemType";
      id: string;
      type: InventoryItemTypeType;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    lastBeacon: {
      __typename: "InventoryItemBeacon";
      id: string;
      ip: string;
      mouse: boolean;
      keyboard: boolean;
      adapter: boolean;
      webcam: boolean;
      osName: string | null;
      osVersion: string | null;
      lastUser: string | null;
      insertedAt: string;
    } | null;
    lastDguvCheck: {
      __typename: "InventoryTimelineEntry";
      id: string;
      inventoryItemId: string;
      creatorId: string;
      userId: string | null;
      type: InventoryTimelineType;
      comment: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
  };
};

export type DeleteInventoryItemMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteInventoryItemMutation = {
  __typename: "MutationRoot";
  deleteInventoryItem: { __typename: "InventoryItem"; id: string };
};

export type InventoryHandoverItemsMutationVariables = Exact<{
  customerId: string;
  values: InventoryHandover;
}>;

export type InventoryHandoverItemsMutation = {
  __typename: "MutationRoot";
  inventoryHandoverItems: Array<{
    __typename: "InventoryItem";
    id: string;
    customerId: string;
    itemTypeId: string;
    lastBeaconId: string | null;
    lastDguvCheckId: string | null;
    name: string;
    serial: string | null;
    location: string | null;
    userId: string | null;
    deploymentInfo: InventoryItemDeploymentInfo;
    status: InventoryItemStatus;
    notes: string | null;
    attrs: Record<string, unknown>;
    needsCheck: boolean | null;
    checkInterval: number;
    insertedAt: string;
    updatedAt: string;
    itemType: {
      __typename: "InventoryItemType";
      id: string;
      type: InventoryItemTypeType;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    lastBeacon: {
      __typename: "InventoryItemBeacon";
      id: string;
      ip: string;
      mouse: boolean;
      keyboard: boolean;
      adapter: boolean;
      webcam: boolean;
      osName: string | null;
      osVersion: string | null;
      lastUser: string | null;
      insertedAt: string;
    } | null;
    lastDguvCheck: {
      __typename: "InventoryTimelineEntry";
      id: string;
      inventoryItemId: string;
      creatorId: string;
      userId: string | null;
      type: InventoryTimelineType;
      comment: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
  }>;
};

export type InventoryHandbackItemsMutationVariables = Exact<{
  customerId: string;
  values: InventoryHandback;
}>;

export type InventoryHandbackItemsMutation = {
  __typename: "MutationRoot";
  inventoryHandbackItems: Array<{
    __typename: "InventoryItem";
    id: string;
    customerId: string;
    itemTypeId: string;
    lastBeaconId: string | null;
    lastDguvCheckId: string | null;
    name: string;
    serial: string | null;
    location: string | null;
    userId: string | null;
    deploymentInfo: InventoryItemDeploymentInfo;
    status: InventoryItemStatus;
    notes: string | null;
    attrs: Record<string, unknown>;
    needsCheck: boolean | null;
    checkInterval: number;
    insertedAt: string;
    updatedAt: string;
    itemType: {
      __typename: "InventoryItemType";
      id: string;
      type: InventoryItemTypeType;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    lastBeacon: {
      __typename: "InventoryItemBeacon";
      id: string;
      ip: string;
      mouse: boolean;
      keyboard: boolean;
      adapter: boolean;
      webcam: boolean;
      osName: string | null;
      osVersion: string | null;
      lastUser: string | null;
      insertedAt: string;
    } | null;
    lastDguvCheck: {
      __typename: "InventoryTimelineEntry";
      id: string;
      inventoryItemId: string;
      creatorId: string;
      userId: string | null;
      type: InventoryTimelineType;
      comment: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
  }>;
};

export type InventoryItemAttachmentsQueryVariables = Exact<{
  customerId: string;
  inventoryItemId: string;
}>;

export type InventoryItemAttachmentsQuery = {
  __typename: "QueryRoot";
  inventoryItemAttachments: Array<{
    __typename: "InventoryItemAttachment";
    id: string;
    file: string;
    inventoryItemId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CreateInventoryItemAttachmentMutationVariables = Exact<{
  customerId: string;
  inventoryItemId: string;
  attachment: File;
}>;

export type CreateInventoryItemAttachmentMutation = {
  __typename: "MutationRoot";
  createInventoryItemAttachment: {
    __typename: "InventoryItemAttachment";
    id: string;
    file: string;
    inventoryItemId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteInventoryItemAttachmentMutationVariables = Exact<{
  customerId: string;
  inventoryItemId: string;
  id: string;
}>;

export type DeleteInventoryItemAttachmentMutation = {
  __typename: "MutationRoot";
  deleteInventoryItemAttachment: {
    __typename: "InventoryItemAttachment";
    id: string;
  };
};

export type SubscribeInventoryItemMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type SubscribeInventoryItemMutation = {
  __typename: "MutationRoot";
  subscribeInventoryItem: {
    __typename: "InventoryItemWatcher";
    userId: string;
    inventoryItemId: string;
  };
};

export type InventorySetsQueryVariables = Exact<{
  customerId: string;
  filters?: InventorySetFilters | null | undefined;
}>;

export type InventorySetsQuery = {
  __typename: "QueryRoot";
  inventorySets: Array<{
    __typename: "InventorySet";
    id: string;
    customerId: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountInventorySetsQueryVariables = Exact<{
  customerId: string;
  filters?: InventorySetFilters | null | undefined;
}>;

export type CountInventorySetsQuery = {
  __typename: "QueryRoot";
  countInventorySets: string;
};

export type InventorySetQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type InventorySetQuery = {
  __typename: "QueryRoot";
  inventorySet: {
    __typename: "InventorySet";
    id: string;
    customerId: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
    items: Array<{
      __typename: "InventorySetItem";
      inventorySetId: string;
      inventoryItemTypeId: string;
      quantity: number;
      inventoryItemType: {
        __typename: "InventoryItemType";
        id: string;
        name: string;
      };
    }>;
  } | null;
};

export type MutateInventorySetMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: InventorySetInput;
}>;

export type MutateInventorySetMutation = {
  __typename: "MutationRoot";
  mutateInventorySet: {
    __typename: "InventorySet";
    id: string;
    customerId: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteInventorySetMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteInventorySetMutation = {
  __typename: "MutationRoot";
  deleteInventorySet: { __typename: "InventorySet"; id: string };
};

export type InventoryItemTimelineQueryVariables = Exact<{
  customerId: string;
  inventoryItemId: string;
  filters?: InventoryTimelineFilters | null | undefined;
}>;

export type InventoryItemTimelineQuery = {
  __typename: "QueryRoot";
  inventoryItemTimeline: Array<{
    __typename: "InventoryTimelineEntry";
    id: string;
    inventoryItemId: string;
    creatorId: string;
    userId: string | null;
    type: InventoryTimelineType;
    comment: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountInventoryItemTimelineQueryVariables = Exact<{
  customerId: string;
  inventoryItemId: string;
  filters?: InventoryTimelineFilters | null | undefined;
}>;

export type CountInventoryItemTimelineQuery = {
  __typename: "QueryRoot";
  countInventoryItemTimeline: string;
};

export type MutateInventoryItemTimelineEntryMutationVariables = Exact<{
  customerId: string;
  inventoryItemId: string;
  values: InventoryItemTimelineEntryInput;
}>;

export type MutateInventoryItemTimelineEntryMutation = {
  __typename: "MutationRoot";
  mutateInventoryItemTimelineEntry: {
    __typename: "InventoryTimelineEntry";
    id: string;
    inventoryItemId: string;
    creatorId: string;
    userId: string | null;
    type: InventoryTimelineType;
    comment: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteInventoryItemTimelineEntryMutationVariables = Exact<{
  customerId: string;
  inventoryItemId: string;
  id: string;
}>;

export type DeleteInventoryItemTimelineEntryMutation = {
  __typename: "MutationRoot";
  deleteInventoryItemTimelineEntry: {
    __typename: "InventoryTimelineEntry";
    id: string;
  };
};

export type ImportInventoryItemTimelineEntriesMutationVariables = Exact<{
  customerId: string;
  values:
    Array<InventoryItemTimelineImportInput> | InventoryItemTimelineImportInput;
}>;

export type ImportInventoryItemTimelineEntriesMutation = {
  __typename: "MutationRoot";
  importInventoryItemTimelineEntries: Array<{
    __typename: "InventoryTimelineEntry";
    id: string;
  }>;
};

export type InventoryReservationsQueryVariables = Exact<{
  customerId: string;
  filters?: InventoryReservationFilters | null | undefined;
}>;

export type InventoryReservationsQuery = {
  __typename: "QueryRoot";
  inventoryReservations: Array<{
    __typename: "InventoryReservation";
    id: string;
    customerId: string;
    inventorySetId: string;
    quantity: number;
    done: number;
    insertedAt: string;
    updatedAt: string;
    reservedFor: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    set: { __typename: "InventorySet"; id: string; name: string };
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountInventoryReservationsQueryVariables = Exact<{
  customerId: string;
}>;

export type CountInventoryReservationsQuery = {
  __typename: "QueryRoot";
  countInventoryReservations: string;
};

export type InventoryReservationQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type InventoryReservationQuery = {
  __typename: "QueryRoot";
  inventoryReservation: {
    __typename: "InventoryReservation";
    id: string;
    customerId: string;
    inventorySetId: string;
    quantity: number;
    done: number;
    insertedAt: string;
    updatedAt: string;
    reservedFor: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    set: { __typename: "InventorySet"; id: string; name: string };
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type InventoryReservationWithDetailsQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type InventoryReservationWithDetailsQuery = {
  __typename: "QueryRoot";
  inventoryReservation: {
    __typename: "InventoryReservation";
    id: string;
    customerId: string;
    inventorySetId: string;
    quantity: number;
    insertedAt: string;
    updatedAt: string;
    reservedFor: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    set: {
      __typename: "InventorySet";
      id: string;
      name: string;
      items: Array<{
        __typename: "InventorySetItem";
        inventorySetId: string;
        inventoryItemTypeId: string;
        quantity: number;
        inventoryItemType: {
          __typename: "InventoryItemType";
          id: string;
          name: string;
        };
      }>;
    };
  } | null;
};

export type MutateInventoryReservationMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: InventoryReservationInput;
}>;

export type MutateInventoryReservationMutation = {
  __typename: "MutationRoot";
  mutateInventoryReservation: {
    __typename: "InventoryReservation";
    id: string;
    customerId: string;
    inventorySetId: string;
    quantity: number;
    done: number;
    insertedAt: string;
    updatedAt: string;
    reservedFor: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    set: { __typename: "InventorySet"; id: string; name: string };
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteInventoryReservationMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteInventoryReservationMutation = {
  __typename: "MutationRoot";
  deleteInventoryReservation: {
    __typename: "InventoryReservation";
    id: string;
  };
};

export type InventoryReservationHandoverMutationVariables = Exact<{
  customerId: string;
  id: string;
  values: InventoryHandover;
}>;

export type InventoryReservationHandoverMutation = {
  __typename: "MutationRoot";
  inventoryReservationHandover: {
    __typename: "InventoryReservation";
    id: string;
    customerId: string;
    inventorySetId: string;
    quantity: number;
    done: number;
    insertedAt: string;
    updatedAt: string;
    reservedFor: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    set: { __typename: "InventorySet"; id: string; name: string };
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type InvoicesQueryVariables = Exact<{
  customerId: string;
  filters?: InvoiceListFilters | null | undefined;
}>;

export type InvoicesQuery = {
  __typename: "QueryRoot";
  invoices: Array<{
    __typename: "Invoice";
    id: string;
    periodStart: string;
    periodEnd: string;
    preview: boolean;
    details: Record<string, unknown>;
    locked: boolean;
    lockedById: string | null;
    projectId: string | null;
    insertedAt: string;
    updatedAt: string;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    positions: Array<{
      __typename: "InvoicePosition";
      id: string;
      pos: number;
      details: Record<string, unknown>;
    }>;
    attachments: Array<{
      __typename: "InvoiceAttachment";
      id: string;
      file: string;
    }>;
  }>;
};

export type InvoiceQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type InvoiceQuery = {
  __typename: "QueryRoot";
  invoice: {
    __typename: "Invoice";
    id: string;
    periodStart: string;
    periodEnd: string;
    preview: boolean;
    details: Record<string, unknown>;
    locked: boolean;
    lockedById: string | null;
    projectId: string | null;
    insertedAt: string;
    updatedAt: string;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    positions: Array<{
      __typename: "InvoicePosition";
      id: string;
      pos: number;
      details: Record<string, unknown>;
    }>;
    attachments: Array<{
      __typename: "InvoiceAttachment";
      id: string;
      file: string;
    }>;
  } | null;
};

export type CountInvoicesQueryVariables = Exact<{
  customerId: string;
  filters?: InvoiceListFilters | null | undefined;
}>;

export type CountInvoicesQuery = {
  __typename: "QueryRoot";
  countInvoices: string;
};

export type DeleteInvoiceMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteInvoiceMutation = {
  __typename: "MutationRoot";
  deleteInvoice: {
    __typename: "Invoice";
    id: string;
    periodStart: string;
    periodEnd: string;
    preview: boolean;
    details: Record<string, unknown>;
    locked: boolean;
    lockedById: string | null;
    projectId: string | null;
    insertedAt: string;
    updatedAt: string;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    positions: Array<{
      __typename: "InvoicePosition";
      id: string;
      pos: number;
      details: Record<string, unknown>;
    }>;
    attachments: Array<{
      __typename: "InvoiceAttachment";
      id: string;
      file: string;
    }>;
  };
};

export type MutateInvoiceMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: InvoiceInput;
}>;

export type MutateInvoiceMutation = {
  __typename: "MutationRoot";
  mutateInvoice: {
    __typename: "Invoice";
    id: string;
    periodStart: string;
    periodEnd: string;
    preview: boolean;
    details: Record<string, unknown>;
    locked: boolean;
    lockedById: string | null;
    projectId: string | null;
    insertedAt: string;
    updatedAt: string;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    positions: Array<{
      __typename: "InvoicePosition";
      id: string;
      pos: number;
      details: Record<string, unknown>;
    }>;
    attachments: Array<{
      __typename: "InvoiceAttachment";
      id: string;
      file: string;
    }>;
  };
};

export type ConfirmInvoiceMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ConfirmInvoiceMutation = {
  __typename: "MutationRoot";
  confirmInvoice: {
    __typename: "Invoice";
    id: string;
    periodStart: string;
    periodEnd: string;
    preview: boolean;
    details: Record<string, unknown>;
    locked: boolean;
    lockedById: string | null;
    projectId: string | null;
    insertedAt: string;
    updatedAt: string;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    positions: Array<{
      __typename: "InvoicePosition";
      id: string;
      pos: number;
      details: Record<string, unknown>;
    }>;
    attachments: Array<{
      __typename: "InvoiceAttachment";
      id: string;
      file: string;
    }>;
  };
};

export type SubscribeInvoicesSubscriptionVariables = Exact<{
  customerId: string;
}>;

export type SubscribeInvoicesSubscription = {
  __typename: "SubscriptionRoot";
  invoices: {
    __typename: "Invoice";
    id: string;
    periodStart: string;
    periodEnd: string;
    preview: boolean;
    details: Record<string, unknown>;
    locked: boolean;
    lockedById: string | null;
    projectId: string | null;
    insertedAt: string;
    updatedAt: string;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    positions: Array<{
      __typename: "InvoicePosition";
      id: string;
      pos: number;
      details: Record<string, unknown>;
    }>;
    attachments: Array<{
      __typename: "InvoiceAttachment";
      id: string;
      file: string;
    }>;
  };
};

export type InvoiceDateValidQueryVariables = Exact<{
  customerId: string;
  projectId?: string | null | undefined;
  id?: string | null | undefined;
  month: string;
}>;

export type InvoiceDateValidQuery = {
  __typename: "QueryRoot";
  invoiceDateValid: boolean;
};

export type JobResultsQueryVariables = Exact<{
  filters?: ListJobResultsFilters | null | undefined;
}>;

export type JobResultsQuery = {
  __typename: "QueryRoot";
  jobResults: Array<{
    __typename: "JobResult";
    id: string;
    module: string;
    done: boolean;
    seen: boolean;
    hasAttachment: boolean;
    filename: string | null;
    userId: string;
    report: Record<string, unknown> | null;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountJobResultsQueryVariables = Exact<{ [key: string]: never }>;

export type CountJobResultsQuery = {
  __typename: "QueryRoot";
  countJobResults: {
    __typename: "JobResultsCountResult";
    seen: string;
    unseen: string;
  };
};

export type SubscribeCountJobResultsSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SubscribeCountJobResultsSubscription = {
  __typename: "SubscriptionRoot";
  countJobResults: {
    __typename: "JobResultsCountResult";
    seen: string;
    unseen: string;
  };
};

export type JobResultQueryVariables = Exact<{
  id: string;
}>;

export type JobResultQuery = {
  __typename: "QueryRoot";
  jobResult: {
    __typename: "JobResult";
    id: string;
    module: string;
    done: boolean;
    seen: boolean;
    hasAttachment: boolean;
    filename: string | null;
    userId: string;
    report: Record<string, unknown> | null;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type MarkJobResultSeenMutationVariables = Exact<{
  id: string;
}>;

export type MarkJobResultSeenMutation = {
  __typename: "MutationRoot";
  markJobResultSeen: {
    __typename: "JobResult";
    id: string;
    module: string;
    done: boolean;
    seen: boolean;
    hasAttachment: boolean;
    filename: string | null;
    userId: string;
    report: Record<string, unknown> | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteJobResultMutationVariables = Exact<{
  id: string;
}>;

export type DeleteJobResultMutation = {
  __typename: "MutationRoot";
  deleteJobResult: { __typename: "JobResult"; id: string };
};

export type WorkerJobsQueryVariables = Exact<{
  filters?: WorkerJobsFilters | null | undefined;
}>;

export type WorkerJobsQuery = {
  __typename: "QueryRoot";
  workerJobs: Array<{
    __typename: "WorkerJob";
    id: string;
    status: JobStatus;
    kind: string;
    queue: string;
    payload: Record<string, unknown>;
    attempts: number;
    maxAttempts: number;
    runAt: string;
    startedAt: string | null;
    lockedAt: string | null;
    lockedBy: string | null;
    errors: Array<string>;
    finishedAt: string | null;
    dedupKey: string | null;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountWorkerJobsQueryVariables = Exact<{
  filters?: CountWorkerJobsFilters | null | undefined;
}>;

export type CountWorkerJobsQuery = {
  __typename: "QueryRoot";
  countWorkerJobs: string;
};

export type RequeueWorkerJobMutationVariables = Exact<{
  id: string;
}>;

export type RequeueWorkerJobMutation = {
  __typename: "MutationRoot";
  requeueWorkerJob: {
    __typename: "WorkerJob";
    id: string;
    status: JobStatus;
    kind: string;
    queue: string;
    payload: Record<string, unknown>;
    attempts: number;
    maxAttempts: number;
    runAt: string;
    startedAt: string | null;
    lockedAt: string | null;
    lockedBy: string | null;
    errors: Array<string>;
    finishedAt: string | null;
    dedupKey: string | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type SendRecruitmentPlannedNotificationMutationVariables = Exact<{
  contactId: string;
  teamId: string;
}>;

export type SendRecruitmentPlannedNotificationMutation = {
  __typename: "MutationRoot";
  sendRecruitmentPlannedNotification: boolean;
};

export type SendAllianzBuergerLeadMutationVariables = Exact<{
  customerId: string;
  contactId: string;
  wantsInfos: boolean;
  wantsAppointment: boolean;
}>;

export type SendAllianzBuergerLeadMutation = {
  __typename: "MutationRoot";
  sendAllianzBuergerLead: boolean;
};

export type KnowledgebaseQuestionsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListKnowledgebaseQuestionsFilters | null | undefined;
}>;

export type KnowledgebaseQuestionsQuery = {
  __typename: "QueryRoot";
  knowledgebaseQuestions: Array<{
    __typename: "KnowledgebaseQuestion";
    id: string;
    document: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountKnowledgebaseQuestionsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CountKnowledgebaseQuestionsFilters | null | undefined;
}>;

export type CountKnowledgebaseQuestionsQuery = {
  __typename: "QueryRoot";
  countKnowledgebaseQuestions: string;
};

export type KnowledgebaseQuestionQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type KnowledgebaseQuestionQuery = {
  __typename: "QueryRoot";
  knowledgebaseQuestion: {
    __typename: "KnowledgebaseQuestion";
    id: string;
    document: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    attachments: Array<{
      __typename: "KnowledgebaseAttachment";
      id: string;
      file: string;
      insertedAt: string;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type DeleteKnowledgebaseQuestionMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteKnowledgebaseQuestionMutation = {
  __typename: "MutationRoot";
  deleteKnowledgebaseQuestion: {
    __typename: "KnowledgebaseQuestion";
    id: string;
  };
};

export type MutateKnowledgebaseQuestionMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: KnowledgebaseQuestionInput;
}>;

export type MutateKnowledgebaseQuestionMutation = {
  __typename: "MutationRoot";
  mutateKnowledgebaseQuestion: {
    __typename: "KnowledgebaseQuestion";
    id: string;
    document: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type RegenKnowledgebaseSearchIndexMutationVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type RegenKnowledgebaseSearchIndexMutation = {
  __typename: "MutationRoot";
  regenKnowledgebaseSearchIndex: Array<{
    __typename: "KnowledgebaseQuestion";
    id: string;
    document: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MutateKnowledgebaseAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  questionId: string;
  values: KnowledgebaseAttachmentInput;
}>;

export type MutateKnowledgebaseAttachmentMutation = {
  __typename: "MutationRoot";
  mutateKnowledgebaseAttachment: {
    __typename: "KnowledgebaseAttachment";
    id: string;
  };
};

export type DeleteKnowledgebaseAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  questionId: string;
  id: string;
}>;

export type DeleteKnowledgebaseAttachmentMutation = {
  __typename: "MutationRoot";
  deleteKnowledgebaseAttachment: {
    __typename: "KnowledgebaseAttachment";
    id: string;
  };
};

export type KnowledgebaseNgArticlesQueryVariables = Exact<{
  filters?: KnowledgebaseNgArticleFilters | null | undefined;
}>;

export type KnowledgebaseNgArticlesQuery = {
  __typename: "QueryRoot";
  knowledgebaseNgArticles: Array<{
    __typename: "KnowledgebaseNgArticle";
    id: string;
    title: string;
    content: string;
    articleType: KnowledgebaseNgArticleType;
    status: KnowledgebaseNgArticleStatus;
    validFrom: string;
    validUntil: string | null;
    nextReview: string;
    timeless: boolean;
    visibleForExternals: boolean;
    tags: Array<string>;
    teamId: string | null;
    ownerId: string;
    creatorId: string;
    editorId: string;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    categories: Array<{
      __typename: "KnowledgebaseNgCategory";
      id: string;
      name: string;
    }>;
  }>;
};

export type CountKnowledgebaseNgArticlesQueryVariables = Exact<{
  filters?: KnowledgebaseNgArticleFilters | null | undefined;
}>;

export type CountKnowledgebaseNgArticlesQuery = {
  __typename: "QueryRoot";
  countKnowledgebaseNgArticles: string;
};

export type KnowledgebaseNgArticleQueryVariables = Exact<{
  id: string;
}>;

export type KnowledgebaseNgArticleQuery = {
  __typename: "QueryRoot";
  knowledgebaseNgArticle: {
    __typename: "KnowledgebaseNgArticle";
    id: string;
    title: string;
    content: string;
    articleType: KnowledgebaseNgArticleType;
    status: KnowledgebaseNgArticleStatus;
    validFrom: string;
    validUntil: string | null;
    nextReview: string;
    timeless: boolean;
    visibleForExternals: boolean;
    igorSync: boolean;
    tags: Array<string>;
    teamId: string | null;
    ownerId: string;
    creatorId: string;
    editorId: string;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    categories: Array<{
      __typename: "KnowledgebaseNgCategory";
      id: string;
      name: string;
    }>;
    categoryPaths: Array<
      Array<{ __typename: "KnowledgebaseNgCategory"; id: string; name: string }>
    >;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    team: { __typename: "Team"; id: string; name: string } | null;
    linkedArticles: Array<{
      __typename: "KnowledgebaseNgArticle";
      id: string;
      title: string;
    }>;
  } | null;
};

export type MutateKnowledgebaseNgArticleMutationVariables = Exact<{
  id?: string | null | undefined;
  values: KnowledgebaseNgArticleInput;
}>;

export type MutateKnowledgebaseNgArticleMutation = {
  __typename: "MutationRoot";
  mutateKnowledgebaseNgArticle: {
    __typename: "KnowledgebaseNgArticle";
    id: string;
    title: string;
    content: string;
    articleType: KnowledgebaseNgArticleType;
    status: KnowledgebaseNgArticleStatus;
    validFrom: string;
    validUntil: string | null;
    nextReview: string;
    timeless: boolean;
    visibleForExternals: boolean;
    igorSync: boolean;
    tags: Array<string>;
    teamId: string | null;
    ownerId: string;
    creatorId: string;
    editorId: string;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    categories: Array<{
      __typename: "KnowledgebaseNgCategory";
      id: string;
      name: string;
    }>;
    categoryPaths: Array<
      Array<{ __typename: "KnowledgebaseNgCategory"; id: string; name: string }>
    >;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    team: { __typename: "Team"; id: string; name: string } | null;
    linkedArticles: Array<{
      __typename: "KnowledgebaseNgArticle";
      id: string;
      title: string;
    }>;
  };
};

export type DeleteKnowledgebaseNgArticleMutationVariables = Exact<{
  id: string;
}>;

export type DeleteKnowledgebaseNgArticleMutation = {
  __typename: "MutationRoot";
  deleteKnowledgebaseNgArticle: {
    __typename: "KnowledgebaseNgArticle";
    id: string;
    title: string;
    content: string;
    articleType: KnowledgebaseNgArticleType;
    status: KnowledgebaseNgArticleStatus;
    validFrom: string;
    validUntil: string | null;
    nextReview: string;
    timeless: boolean;
    visibleForExternals: boolean;
    igorSync: boolean;
    tags: Array<string>;
    teamId: string | null;
    ownerId: string;
    creatorId: string;
    editorId: string;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    categories: Array<{
      __typename: "KnowledgebaseNgCategory";
      id: string;
      name: string;
    }>;
    categoryPaths: Array<
      Array<{ __typename: "KnowledgebaseNgCategory"; id: string; name: string }>
    >;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
    project: { __typename: "MinimalProject"; id: string; name: string } | null;
    team: { __typename: "Team"; id: string; name: string } | null;
    linkedArticles: Array<{
      __typename: "KnowledgebaseNgArticle";
      id: string;
      title: string;
    }>;
  };
};

export type KnowledgebaseNgCategoriesQueryVariables = Exact<{
  customerId: string;
  filters?: KnowledgebaseNgCategoryFilters | null | undefined;
}>;

export type KnowledgebaseNgCategoriesQuery = {
  __typename: "QueryRoot";
  knowledgebaseNgCategories: Array<{
    __typename: "KnowledgebaseNgCategory";
    id: string;
    name: string;
    parentId: string | null;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    path: Array<{
      __typename: "KnowledgebaseNgCategory";
      id: string;
      name: string;
    }>;
  }>;
};

export type CountKnowledgebaseNgCategoriesQueryVariables = Exact<{
  customerId: string;
  filters?: KnowledgebaseNgCategoryFilters | null | undefined;
}>;

export type CountKnowledgebaseNgCategoriesQuery = {
  __typename: "QueryRoot";
  countKnowledgebaseNgCategories: string;
};

export type KnowledgebaseNgCategoryQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type KnowledgebaseNgCategoryQuery = {
  __typename: "QueryRoot";
  knowledgebaseNgCategory: {
    __typename: "KnowledgebaseNgCategory";
    id: string;
    name: string;
    parentId: string | null;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    path: Array<{
      __typename: "KnowledgebaseNgCategory";
      id: string;
      name: string;
    }>;
  } | null;
};

export type MutateKnowledgebaseNgCategoryMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: KnowledgebaseNgCategoryInput;
}>;

export type MutateKnowledgebaseNgCategoryMutation = {
  __typename: "MutationRoot";
  mutateKnowledgebaseNgCategory: {
    __typename: "KnowledgebaseNgCategory";
    id: string;
    name: string;
    parentId: string | null;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    path: Array<{
      __typename: "KnowledgebaseNgCategory";
      id: string;
      name: string;
    }>;
  };
};

export type DeleteKnowledgebaseNgCategoryMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteKnowledgebaseNgCategoryMutation = {
  __typename: "MutationRoot";
  deleteKnowledgebaseNgCategory: {
    __typename: "KnowledgebaseNgCategory";
    id: string;
    name: string;
    parentId: string | null;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    path: Array<{
      __typename: "KnowledgebaseNgCategory";
      id: string;
      name: string;
    }>;
  };
};

export type MutateKnowledgebaseNgAttachmentMutationVariables = Exact<{
  articleId: string;
  id?: string | null | undefined;
  file: File;
}>;

export type MutateKnowledgebaseNgAttachmentMutation = {
  __typename: "MutationRoot";
  mutateKnowledgebaseNgAttachment: {
    __typename: "KnowledgebaseNgAttachment";
    id: string;
    fileName: string;
    fileType: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type KnowledgebaseNgReviewsQueryVariables = Exact<{
  articleId: string;
}>;

export type KnowledgebaseNgReviewsQuery = {
  __typename: "QueryRoot";
  knowledgebaseNgReviews: Array<{
    __typename: "KnowledgebaseNgReview";
    id: string;
    articleId: string;
    reviewerId: string;
    result: KnowledgebaseNgReviewResult;
    comment: string | null;
    reviewedAt: string | null;
    insertedAt: string;
    updatedAt: string;
    reviewer: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MutateKnowledgebaseNgReviewMutationVariables = Exact<{
  id?: string | null | undefined;
  values: KnowledgebaseNgReviewInput;
}>;

export type MutateKnowledgebaseNgReviewMutation = {
  __typename: "MutationRoot";
  mutateKnowledgebaseNgReview: {
    __typename: "KnowledgebaseNgReview";
    id: string;
    articleId: string;
    reviewerId: string;
    result: KnowledgebaseNgReviewResult;
    comment: string | null;
    reviewedAt: string | null;
    insertedAt: string;
    updatedAt: string;
    reviewer: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type KnowledgebaseNgVersionsQueryVariables = Exact<{
  articleId: string;
}>;

export type KnowledgebaseNgVersionsQuery = {
  __typename: "QueryRoot";
  knowledgebaseNgVersions: Array<{
    __typename: "KnowledgebaseNgVersion";
    id: string;
    articleId: string;
    versionNumber: number;
    title: string;
    content: string;
    articleType: KnowledgebaseNgArticleType;
    status: KnowledgebaseNgArticleStatus;
    validFrom: string;
    validUntil: string | null;
    timeless: boolean;
    visibleForExternals: boolean;
    tags: Array<string>;
    categories: Array<string>;
    ownerId: string;
    customerId: string;
    projectId: string;
    insertedAt: string;
    changelog: string | null;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type LateNoteFragment = {
  __typename: "LateNote";
  id: string;
  customerId: string;
  userId: string;
  eta: string | null;
  estimatedMinutesLate: number | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type LateNotesQueryVariables = Exact<{
  customerId: string;
  filters?: LateNoteListFilters | null | undefined;
}>;

export type LateNotesQuery = {
  __typename: "QueryRoot";
  lateNotes: Array<{
    __typename: "LateNote";
    id: string;
    customerId: string;
    userId: string;
    eta: string | null;
    estimatedMinutesLate: number | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountLateNotesQueryVariables = Exact<{
  customerId: string;
  filters?: LateNoteListFilters | null | undefined;
}>;

export type CountLateNotesQuery = {
  __typename: "QueryRoot";
  countLateNotes: string;
};

export type LateNoteQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type LateNoteQuery = {
  __typename: "QueryRoot";
  lateNote: {
    __typename: "LateNote";
    id: string;
    customerId: string;
    userId: string;
    eta: string | null;
    estimatedMinutesLate: number | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateLateNoteMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: LateNoteInput;
}>;

export type MutateLateNoteMutation = {
  __typename: "MutationRoot";
  mutateLateNote: {
    __typename: "LateNote";
    id: string;
    customerId: string;
    userId: string;
    eta: string | null;
    estimatedMinutesLate: number | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteLateNoteMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteLateNoteMutation = {
  __typename: "MutationRoot";
  deleteLateNote: { __typename: "LateNote"; id: string };
};

export type MailTemplatesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: MailTemplateListFilters | null | undefined;
}>;

export type MailTemplatesQuery = {
  __typename: "QueryRoot";
  mailTemplates: Array<{
    __typename: "MailTemplate";
    id: string;
    name: string;
    from: string | null;
    to: string | null;
    cc: string | null;
    bcc: string | null;
    subject: string;
    content: string | null;
    slateContent: Record<string, unknown>;
    mdContent: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountMailTemplatesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: MailTemplateListFilters | null | undefined;
}>;

export type CountMailTemplatesQuery = {
  __typename: "QueryRoot";
  countMailTemplates: string;
};

export type MailTemplateQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type MailTemplateQuery = {
  __typename: "QueryRoot";
  mailTemplate: {
    __typename: "MailTemplate";
    id: string;
    name: string;
    from: string | null;
    to: string | null;
    cc: string | null;
    bcc: string | null;
    subject: string;
    content: string | null;
    slateContent: Record<string, unknown>;
    mdContent: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateMailTemplateMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: MailTemplateInput;
}>;

export type MutateMailTemplateMutation = {
  __typename: "MutationRoot";
  mutateMailTemplate: {
    __typename: "MailTemplate";
    id: string;
    name: string;
    from: string | null;
    to: string | null;
    cc: string | null;
    bcc: string | null;
    subject: string;
    content: string | null;
    slateContent: Record<string, unknown>;
    mdContent: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteMailTemplateMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteMailTemplateMutation = {
  __typename: "MutationRoot";
  deleteMailTemplate: {
    __typename: "MailTemplate";
    id: string;
    name: string;
    from: string | null;
    to: string | null;
    cc: string | null;
    bcc: string | null;
    subject: string;
    content: string | null;
    slateContent: Record<string, unknown>;
    mdContent: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MailTemplateAttachmentsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: MailTemplateAttachmentListFilters | null | undefined;
}>;

export type MailTemplateAttachmentsQuery = {
  __typename: "QueryRoot";
  mailTemplateAttachments: Array<{
    __typename: "MailTemplateAttachment";
    id: string;
    name: string;
    attachByDefault: boolean;
    file: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountMailTemplateAttachmentsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type CountMailTemplateAttachmentsQuery = {
  __typename: "QueryRoot";
  countMailTemplateAttachments: string;
};

export type MailTemplateAttachmentQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type MailTemplateAttachmentQuery = {
  __typename: "QueryRoot";
  mailTemplateAttachment: {
    __typename: "MailTemplateAttachment";
    id: string;
    name: string;
    attachByDefault: boolean;
    file: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateMailTemplateAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: MailTemplateAttachmentInput;
}>;

export type MutateMailTemplateAttachmentMutation = {
  __typename: "MutationRoot";
  mutateMailTemplateAttachment: {
    __typename: "MailTemplateAttachment";
    id: string;
    name: string;
    attachByDefault: boolean;
    file: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteMailTemplateAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteMailTemplateAttachmentMutation = {
  __typename: "MutationRoot";
  deleteMailTemplateAttachment: {
    __typename: "MailTemplateAttachment";
    id: string;
    name: string;
    attachByDefault: boolean;
    file: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MailThreadsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: MailThreadListFilters | null | undefined;
}>;

export type MailThreadsQuery = {
  __typename: "QueryRoot";
  mailThreads: Array<{
    __typename: "MailThread";
    id: string;
    contactId: string | null;
    lockedAt: string | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    firstMail: {
      __typename: "Mail";
      id: string;
      threadId: string;
      from: string;
      to: string;
      cc: string | null;
      bcc: string | null;
      isSpam: boolean;
      direction: MailDirection;
      sent: boolean;
      sentAt: string | null;
      status: MailStatus;
      doneAt: string | null;
      receivedAt: string | null;
      attrs: Record<string, unknown>;
      subject: string;
      content: string | null;
      htmlContent: string | null;
      labels: Array<string>;
      folder: string | null;
      account: string | null;
      insertedAt: string;
      updatedAt: string;
      ownerId: string | null;
      editorId: string | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      sender: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    } | null;
    lastMail: {
      __typename: "Mail";
      id: string;
      threadId: string;
      from: string;
      to: string;
      cc: string | null;
      bcc: string | null;
      isSpam: boolean;
      direction: MailDirection;
      sent: boolean;
      sentAt: string | null;
      status: MailStatus;
      doneAt: string | null;
      receivedAt: string | null;
      attrs: Record<string, unknown>;
      subject: string;
      content: string | null;
      htmlContent: string | null;
      labels: Array<string>;
      folder: string | null;
      account: string | null;
      insertedAt: string;
      updatedAt: string;
      ownerId: string | null;
      editorId: string | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      sender: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    } | null;
  }>;
};

export type CountMailThreadsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: MailThreadListFilters | null | undefined;
}>;

export type CountMailThreadsQuery = {
  __typename: "QueryRoot";
  countMailThreads: string;
};

export type MailsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: MailListFilters | null | undefined;
}>;

export type MailsQuery = {
  __typename: "QueryRoot";
  mails: Array<{
    __typename: "Mail";
    id: string;
    from: string;
    to: string;
    direction: MailDirection;
    sent: boolean;
    isSpam: boolean;
    subject: string;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    thread: {
      __typename: "MailThread";
      id: string;
      contactId: string | null;
      lockedAt: string | null;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
      locker: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    };
  }>;
};

export type MailsMergeQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: MailListFilters | null | undefined;
}>;

export type MailsMergeQuery = {
  __typename: "QueryRoot";
  mails: Array<{
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type CountMailsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: MailListFilters | null | undefined;
}>;

export type CountMailsQuery = { __typename: "QueryRoot"; countMails: string };

export type MailQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type MailQuery = {
  __typename: "QueryRoot";
  mail: {
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    thread: { __typename: "MailThread"; id: string; contactId: string | null };
    attachments: Array<{
      __typename: "MailAttachment";
      id: string;
      mailId: string;
      file: string;
    }>;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  } | null;
};

export type MailThreadQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  isSpam?: boolean | null | undefined;
}>;

export type MailThreadQuery = {
  __typename: "QueryRoot";
  mailThread: {
    __typename: "MailThread";
    id: string;
    identifier: string;
    contactId: string | null;
    lockedAt: string | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    mails: Array<{
      __typename: "Mail";
      id: string;
      threadId: string;
      from: string;
      to: string;
      cc: string | null;
      bcc: string | null;
      isSpam: boolean;
      direction: MailDirection;
      sent: boolean;
      sentAt: string | null;
      status: MailStatus;
      doneAt: string | null;
      receivedAt: string | null;
      attrs: Record<string, unknown>;
      subject: string;
      content: string | null;
      htmlContent: string | null;
      labels: Array<string>;
      folder: string | null;
      account: string | null;
      insertedAt: string;
      updatedAt: string;
      ownerId: string | null;
      editorId: string | null;
      attachments: Array<{
        __typename: "MailAttachment";
        id: string;
        mailId: string;
        file: string;
      }>;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      sender: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type MailEventSubscriptionVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type MailEventSubscription = {
  __typename: "SubscriptionRoot";
  mailEvents: {
    __typename: "MailsEvent";
    mail: {
      __typename: "Mail";
      id: string;
      threadId: string;
      from: string;
      to: string;
      cc: string | null;
      bcc: string | null;
      isSpam: boolean;
      direction: MailDirection;
      sent: boolean;
      sentAt: string | null;
      status: MailStatus;
      doneAt: string | null;
      receivedAt: string | null;
      attrs: Record<string, unknown>;
      subject: string;
      content: string | null;
      htmlContent: string | null;
      labels: Array<string>;
      folder: string | null;
      account: string | null;
      insertedAt: string;
      updatedAt: string;
      ownerId: string | null;
      editorId: string | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      sender: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    } | null;
    thread: {
      __typename: "MailThread";
      id: string;
      identifier: string;
      lockedAt: string | null;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
      locker: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      mails: Array<{
        __typename: "Mail";
        id: string;
        threadId: string;
        from: string;
        to: string;
        cc: string | null;
        bcc: string | null;
        isSpam: boolean;
        direction: MailDirection;
        sent: boolean;
        sentAt: string | null;
        status: MailStatus;
        doneAt: string | null;
        receivedAt: string | null;
        attrs: Record<string, unknown>;
        subject: string;
        content: string | null;
        htmlContent: string | null;
        labels: Array<string>;
        folder: string | null;
        account: string | null;
        insertedAt: string;
        updatedAt: string;
        ownerId: string | null;
        editorId: string | null;
        attachments: Array<{
          __typename: "MailAttachment";
          id: string;
          mailId: string;
          file: string;
        }>;
        owner: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
        editor: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
        sender: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
      }>;
    } | null;
  };
};

export type AssignMailThreadMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  contactId: string;
}>;

export type AssignMailThreadMutation = {
  __typename: "MutationRoot";
  assignMailThread: { __typename: "MailThread"; id: string };
};

export type DeleteMailThreadMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteMailThreadMutation = {
  __typename: "MutationRoot";
  deleteMailThread: { __typename: "MailThread"; id: string };
};

export type DeleteMailMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteMailMutation = {
  __typename: "MutationRoot";
  deleteMail: {
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type MutateMailMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: MailInput;
}>;

export type MutateMailMutation = {
  __typename: "MutationRoot";
  mutateMail: {
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type SendMailMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type SendMailMutation = {
  __typename: "MutationRoot";
  sendMail: {
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type OwnMailMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type OwnMailMutation = {
  __typename: "MutationRoot";
  ownMail: {
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type MutateMailStatusMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  status: MailStatus;
  updateAllOpen?: boolean | null | undefined;
}>;

export type MutateMailStatusMutation = {
  __typename: "MutationRoot";
  mutateMailStatus: {
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  } | null;
};

export type MarkMailSpamMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  isSpam: boolean;
}>;

export type MarkMailSpamMutation = {
  __typename: "MutationRoot";
  markMailSpam: {
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type LockMailThreadMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type LockMailThreadMutation = {
  __typename: "MutationRoot";
  lockMailThread: {
    __typename: "MailThread";
    id: string;
    identifier: string;
    lockedAt: string | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    mails: Array<{
      __typename: "Mail";
      id: string;
      threadId: string;
      from: string;
      to: string;
      cc: string | null;
      bcc: string | null;
      isSpam: boolean;
      direction: MailDirection;
      sent: boolean;
      sentAt: string | null;
      status: MailStatus;
      doneAt: string | null;
      receivedAt: string | null;
      attrs: Record<string, unknown>;
      subject: string;
      content: string | null;
      htmlContent: string | null;
      labels: Array<string>;
      folder: string | null;
      account: string | null;
      insertedAt: string;
      updatedAt: string;
      ownerId: string | null;
      editorId: string | null;
      attachments: Array<{
        __typename: "MailAttachment";
        id: string;
        file: string;
      }>;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      sender: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type UnlockMailThreadMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type UnlockMailThreadMutation = {
  __typename: "MutationRoot";
  unlockMailThread: {
    __typename: "MailThread";
    id: string;
    identifier: string;
    lockedAt: string | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    mails: Array<{
      __typename: "Mail";
      id: string;
      threadId: string;
      from: string;
      to: string;
      cc: string | null;
      bcc: string | null;
      isSpam: boolean;
      direction: MailDirection;
      sent: boolean;
      sentAt: string | null;
      status: MailStatus;
      doneAt: string | null;
      receivedAt: string | null;
      attrs: Record<string, unknown>;
      subject: string;
      content: string | null;
      htmlContent: string | null;
      labels: Array<string>;
      folder: string | null;
      account: string | null;
      insertedAt: string;
      updatedAt: string;
      ownerId: string | null;
      editorId: string | null;
      attachments: Array<{
        __typename: "MailAttachment";
        id: string;
        file: string;
      }>;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      sender: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type MergeMailThreadsMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  threadId: string;
  secondThreadId: string;
}>;

export type MergeMailThreadsMutation = {
  __typename: "MutationRoot";
  mergeMailThreads: {
    __typename: "MailThread";
    id: string;
    identifier: string;
    lockedAt: string | null;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
    locker: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    mails: Array<{
      __typename: "Mail";
      id: string;
      threadId: string;
      from: string;
      to: string;
      cc: string | null;
      bcc: string | null;
      isSpam: boolean;
      direction: MailDirection;
      sent: boolean;
      sentAt: string | null;
      status: MailStatus;
      doneAt: string | null;
      receivedAt: string | null;
      attrs: Record<string, unknown>;
      subject: string;
      content: string | null;
      htmlContent: string | null;
      labels: Array<string>;
      folder: string | null;
      account: string | null;
      insertedAt: string;
      updatedAt: string;
      ownerId: string | null;
      editorId: string | null;
      attachments: Array<{
        __typename: "MailAttachment";
        id: string;
        file: string;
      }>;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      sender: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type AssignMailMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  userId: string;
}>;

export type AssignMailMutation = {
  __typename: "MutationRoot";
  assignMail: {
    __typename: "Mail";
    id: string;
    threadId: string;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    isSpam: boolean;
    direction: MailDirection;
    sent: boolean;
    sentAt: string | null;
    status: MailStatus;
    doneAt: string | null;
    receivedAt: string | null;
    attrs: Record<string, unknown>;
    subject: string;
    content: string | null;
    htmlContent: string | null;
    labels: Array<string>;
    folder: string | null;
    account: string | null;
    insertedAt: string;
    updatedAt: string;
    ownerId: string | null;
    editorId: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type MessagesQueryVariables = Exact<{
  filters?: ListMessagesFilters | null | undefined;
}>;

export type MessagesQuery = {
  __typename: "QueryRoot";
  messages: Array<{
    __typename: "Message";
    id: string;
    subject: string | null;
    subjectI18nId: string | null;
    subjectParams: Record<string, unknown> | null;
    seen: boolean;
    format: MessageFormat;
    userId: string;
    insertedAt: string;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountMessagesQueryVariables = Exact<{
  filters?: CountMessagesFilters | null | undefined;
}>;

export type CountMessagesQuery = {
  __typename: "QueryRoot";
  countMessages: {
    __typename: "MessageCountResult";
    unread: string;
    read: string;
  };
};

export type MessageQueryVariables = Exact<{
  id: string;
}>;

export type MessageQuery = {
  __typename: "QueryRoot";
  message: {
    __typename: "Message";
    content: string | null;
    contentI18nId: string | null;
    contentParams: Record<string, unknown> | null;
    id: string;
    subject: string | null;
    subjectI18nId: string | null;
    subjectParams: Record<string, unknown> | null;
    seen: boolean;
    format: MessageFormat;
    userId: string;
    insertedAt: string;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateMessageMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  message: MessageInput;
}>;

export type MutateMessageMutation = {
  __typename: "MutationRoot";
  mutateMessage: {
    __typename: "Message";
    content: string | null;
    contentI18nId: string | null;
    contentParams: Record<string, unknown> | null;
    id: string;
    subject: string | null;
    subjectI18nId: string | null;
    subjectParams: Record<string, unknown> | null;
    seen: boolean;
    format: MessageFormat;
    userId: string;
    insertedAt: string;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteMessageMutationVariables = Exact<{
  id: string;
}>;

export type DeleteMessageMutation = {
  __typename: "MutationRoot";
  deleteMessage: { __typename: "Message"; id: string } | null;
};

export type MarkMessageReadMutationVariables = Exact<{
  id: string;
}>;

export type MarkMessageReadMutation = {
  __typename: "MutationRoot";
  markMessageRead: {
    __typename: "Message";
    content: string | null;
    contentI18nId: string | null;
    contentParams: Record<string, unknown> | null;
    id: string;
    subject: string | null;
    subjectI18nId: string | null;
    subjectParams: Record<string, unknown> | null;
    seen: boolean;
    format: MessageFormat;
    userId: string;
    insertedAt: string;
    sender: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type OauthTokensQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type OauthTokensQuery = {
  __typename: "QueryRoot";
  oauthTokens: Array<{
    __typename: "OauthToken";
    name: string;
    description: string | null;
    id: string;
    appId: string | null;
    clientId: string | null;
    clientSecret: string | null;
    scopes: string | null;
    grantType: string | null;
    url: string;
    tokenQuery: string;
    accessToken: string | null;
    expires: string | null;
    useBasicAuth: boolean;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type OauthTokenQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type OauthTokenQuery = {
  __typename: "QueryRoot";
  oauthToken: {
    __typename: "OauthToken";
    name: string;
    description: string | null;
    id: string;
    appId: string | null;
    clientId: string | null;
    clientSecret: string | null;
    scopes: string | null;
    grantType: string | null;
    url: string;
    tokenQuery: string;
    accessToken: string | null;
    expires: string | null;
    useBasicAuth: boolean;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type MutateOauthTokenMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: OauthTokenInput;
}>;

export type MutateOauthTokenMutation = {
  __typename: "MutationRoot";
  mutateOauthToken: {
    __typename: "OauthToken";
    name: string;
    description: string | null;
    id: string;
    appId: string | null;
    clientId: string | null;
    clientSecret: string | null;
    scopes: string | null;
    grantType: string | null;
    url: string;
    tokenQuery: string;
    accessToken: string | null;
    expires: string | null;
    useBasicAuth: boolean;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteOauthTokenMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteOauthTokenMutation = {
  __typename: "MutationRoot";
  deleteOauthToken: {
    __typename: "OauthToken";
    name: string;
    description: string | null;
    id: string;
    appId: string | null;
    clientId: string | null;
    clientSecret: string | null;
    scopes: string | null;
    grantType: string | null;
    url: string;
    tokenQuery: string;
    accessToken: string | null;
    expires: string | null;
    useBasicAuth: boolean;
    insertedAt: string;
    updatedAt: string;
  };
};

export type StaffPaymentInfosQueryVariables = Exact<{
  customerId: string;
  filters: StaffPaymentInfoListFilters;
}>;

export type StaffPaymentInfosQuery = {
  __typename: "QueryRoot";
  staffPaymentInfos: Array<{
    __typename: "StaffPaymentInfo";
    id: string;
    customerId: string;
    payrollImportJobId: string;
    employeeId: string;
    month: string;
    gross: number;
    net: number;
    paid: number;
    cost: number;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
  }>;
};

export type CountStaffPaymentInfosQueryVariables = Exact<{
  customerId: string;
  filters: StaffPaymentInfoListFilters;
}>;

export type CountStaffPaymentInfosQuery = {
  __typename: "QueryRoot";
  countStaffPaymentInfos: string;
};

export type StaffPaymentInfoQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type StaffPaymentInfoQuery = {
  __typename: "QueryRoot";
  staffPaymentInfo: {
    __typename: "StaffPaymentInfo";
    id: string;
    customerId: string;
    payrollImportJobId: string;
    employeeId: string;
    month: string;
    gross: number;
    net: number;
    paid: number;
    cost: number;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
    positions: Array<{
      __typename: "StaffPaymentInfoPosition";
      id: string;
      paymentInfoId: string;
      positionType: string;
      name: string;
      unit: string | null;
      amount: number | null;
      factor: number | null;
      percent: number | null;
      sum: number;
    }>;
  } | null;
};

export type MutateStaffPaymentInfoMutationVariables = Exact<{
  customerId: string;
  payrollPdfImportId?: string | null | undefined;
  id?: string | null | undefined;
  values: StaffPaymentInfoInput;
}>;

export type MutateStaffPaymentInfoMutation = {
  __typename: "MutationRoot";
  mutateStaffPaymentInfo: {
    __typename: "StaffPaymentInfo";
    id: string;
    customerId: string;
    payrollImportJobId: string;
    employeeId: string;
    month: string;
    gross: number;
    net: number;
    paid: number;
    cost: number;
    insertedAt: string;
    updatedAt: string;
    employee: {
      __typename: "Employee";
      id: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    } | null;
    positions: Array<{
      __typename: "StaffPaymentInfoPosition";
      id: string;
      paymentInfoId: string;
      positionType: string;
      name: string;
      unit: string | null;
      amount: number | null;
      factor: number | null;
      percent: number | null;
      sum: number;
    }>;
  };
};

export type DeleteStaffPaymentInfoMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteStaffPaymentInfoMutation = {
  __typename: "MutationRoot";
  deleteStaffPaymentInfo: { __typename: "StaffPaymentInfo"; id: string };
};

export type PayrollPdfImportsQueryVariables = Exact<{
  customerId: string;
  filters?: PayrollPdfImportListFilters | null | undefined;
}>;

export type PayrollPdfImportsQuery = {
  __typename: "QueryRoot";
  payrollPdfImports: Array<{
    __typename: "PayrollPdfImport";
    id: string;
    month: string;
    status: PayrollPdfImportStatus;
    importType: PayrollPdfImportType;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountPayrollPdfImportsQueryVariables = Exact<{
  customerId: string;
  filters?: PayrollPdfImportListFilters | null | undefined;
}>;

export type CountPayrollPdfImportsQuery = {
  __typename: "QueryRoot";
  countPayrollPdfImports: string;
};

export type PayrollPdfImportQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type PayrollPdfImportQuery = {
  __typename: "QueryRoot";
  payrollPdfImport: {
    __typename: "PayrollPdfImport";
    id: string;
    month: string;
    status: PayrollPdfImportStatus;
    importType: PayrollPdfImportType;
    insertedAt: string;
    updatedAt: string;
    errors: Array<{
      __typename: "PayrollPdfImportError";
      id: string;
      payrollImportJobId: string;
      message: string | null;
      status: PayrollPdfImportErrorStatus;
    }>;
  } | null;
};

export type MutatePayrollPdfImportMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: PayrollPdfImportInput;
}>;

export type MutatePayrollPdfImportMutation = {
  __typename: "MutationRoot";
  mutatePayrollPdfImport: {
    __typename: "PayrollPdfImport";
    id: string;
    month: string;
    status: PayrollPdfImportStatus;
    importType: PayrollPdfImportType;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeletePayrollPdfImportMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeletePayrollPdfImportMutation = {
  __typename: "MutationRoot";
  deletePayrollPdfImport: { __typename: "PayrollPdfImport"; id: string };
};

export type CreatePayrollPdfImportFromFileExchangeMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  month: string;
  importType: PayrollPdfImportType;
}>;

export type CreatePayrollPdfImportFromFileExchangeMutation = {
  __typename: "MutationRoot";
  createPayrollPdfImportFromFileExchange: {
    __typename: "PayrollPdfImport";
    id: string;
    month: string;
    status: PayrollPdfImportStatus;
    importType: PayrollPdfImportType;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DiscardPayrollPdfImportErrorMutationVariables = Exact<{
  customerId: string;
  payrollPdfImportId: string;
  id: string;
}>;

export type DiscardPayrollPdfImportErrorMutation = {
  __typename: "MutationRoot";
  discardPayrollPdfImportError: {
    __typename: "PayrollPdfImportError";
    id: string;
  };
};

export type AssignPayrollPdfImportErrorMutationVariables = Exact<{
  customerId: string;
  payrollPdfImportId: string;
  id: string;
  values: PayrollPdfImportAssignErrorValues;
}>;

export type AssignPayrollPdfImportErrorMutation = {
  __typename: "MutationRoot";
  assignPayrollPdfImportError: {
    __typename: "PayrollPdfImportError";
    id: string;
  };
};

export type PayrollAccountingFinalizeMonthMutationVariables = Exact<{
  customerId: string;
}>;

export type PayrollAccountingFinalizeMonthMutation = {
  __typename: "MutationRoot";
  payrollAccountingFinalizeMonth: boolean;
};

export type StaffPayrollDeviationsQueryVariables = Exact<{
  customerId: string;
  month: string;
}>;

export type StaffPayrollDeviationsQuery = {
  __typename: "QueryRoot";
  staffPayrollDeviations: Array<{
    __typename: "PayrollDeviation";
    accountant: number;
    calculated: number;
    userId: string;
    message: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type PersonalFilesQueryVariables = Exact<{
  customerId: string;
  filters?: PersonalFileListFilters | null | undefined;
}>;

export type PersonalFilesQuery = {
  __typename: "QueryRoot";
  personalFiles: Array<{
    __typename: "PersonalFile";
    id: string;
    file: string;
    mimeType: string;
    description: string | null;
    userId: string;
    read: boolean;
    personalFileTypeId: string | null;
    pubDate: string;
    insertedAt: string;
    updatedAt: string;
    fileType: {
      __typename: "PersonalFileType";
      id: string;
      name: string;
      required: boolean;
      category: string;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MutatePersonalFileMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: PersonalFileInput;
}>;

export type MutatePersonalFileMutation = {
  __typename: "MutationRoot";
  mutatePersonalFile: {
    __typename: "PersonalFile";
    id: string;
    file: string;
    mimeType: string;
    description: string | null;
    userId: string;
    read: boolean;
    personalFileTypeId: string | null;
    pubDate: string;
    insertedAt: string;
    updatedAt: string;
    fileType: {
      __typename: "PersonalFileType";
      id: string;
      name: string;
      required: boolean;
      category: string;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MarkPersonalFileReadMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type MarkPersonalFileReadMutation = {
  __typename: "MutationRoot";
  markPersonalFileRead: {
    __typename: "PersonalFile";
    id: string;
    file: string;
    mimeType: string;
    description: string | null;
    userId: string;
    read: boolean;
    personalFileTypeId: string | null;
    pubDate: string;
    insertedAt: string;
    updatedAt: string;
    fileType: {
      __typename: "PersonalFileType";
      id: string;
      name: string;
      required: boolean;
      category: string;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeletePersonalFileMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeletePersonalFileMutation = {
  __typename: "MutationRoot";
  deletePersonalFile: { __typename: "PersonalFile"; id: string };
};

export type SendPersonalFileChallengeMutationVariables = Exact<{
  id: string;
}>;

export type SendPersonalFileChallengeMutation = {
  __typename: "MutationRoot";
  sendPersonalFileChallenge: boolean;
};

export type VerifyPersonalFileChallengeMutationVariables = Exact<{
  id: string;
  response: string;
}>;

export type VerifyPersonalFileChallengeMutation = {
  __typename: "MutationRoot";
  verifyPersonalFileChallenge: string;
};

export type SendPersonalFileMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type SendPersonalFileMutation = {
  __typename: "MutationRoot";
  sendPersonalFile: boolean;
};

export type PersonalFileTypesQueryVariables = Exact<{
  customerId: string;
  filters?: PersonalFileTypeListFilters | null | undefined;
}>;

export type PersonalFileTypesQuery = {
  __typename: "QueryRoot";
  personalFileTypes: Array<{
    __typename: "PersonalFileType";
    id: string;
    name: string;
    required: boolean;
    category: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountPersonalFileTypesQueryVariables = Exact<{
  customerId: string;
  filters?: PersonalFileTypeListFilters | null | undefined;
}>;

export type CountPersonalFileTypesQuery = {
  __typename: "QueryRoot";
  countPersonalFileTypes: string;
};

export type PersonalFileTypeQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type PersonalFileTypeQuery = {
  __typename: "QueryRoot";
  personalFileType: {
    __typename: "PersonalFileType";
    id: string;
    name: string;
    required: boolean;
    category: string;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type MutatePersonalFileTypeMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: PersonalFileTypeInput;
}>;

export type MutatePersonalFileTypeMutation = {
  __typename: "MutationRoot";
  mutatePersonalFileType: {
    __typename: "PersonalFileType";
    id: string;
    name: string;
    required: boolean;
    category: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeletePersonalFileTypeMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeletePersonalFileTypeMutation = {
  __typename: "MutationRoot";
  deletePersonalFileType: { __typename: "PersonalFileType"; id: string };
};

export type MissingPersonalFileTypesQueryVariables = Exact<{
  customerId: string;
  filters?: MissingPersonalFileTypesFilters | null | undefined;
}>;

export type MissingPersonalFileTypesQuery = {
  __typename: "QueryRoot";
  missingPersonalFileTypes: Array<{
    __typename: "MissingPersonalFileType";
    employee: {
      __typename: "Employee";
      id: string;
      entering: string;
      leaving: string | null;
      active: boolean;
      datevEmployeeNo: string | null;
      deleted: boolean;
      iban: string | null;
      bic: string | null;
      taxId: string | null;
      socialSecurityNumber: string | null;
      standardBonus: number | null;
      dataProtectionTrainingCompletedAt: string | null;
      cpsNumber: string | null;
      headset: string | null;
      healthInsurance: string | null;
      notes: string | null;
      probationEnding: string | null;
      employeeName: string | null;
      gender: EmployeeGender | null;
      nationality: string | null;
      placeOfBirth: string | null;
      countryOfBirth: string | null;
      civilStatus: EmployeeCivilStatus | null;
      disability: boolean;
      disabilityLevel: number | null;
      taxLevel: number | null;
      childTaxAllowance: number | null;
      additionalJobs: string | null;
      denomination: string | null;
      languagesFluent: Array<string>;
      languagesNative: Array<string>;
      position: string | null;
      levels: Array<Level>;
      sickDaysLimit: number | null;
      userId: string;
      insertedAt: string;
      updatedAt: string;
      children: Array<{
        __typename: "EmployeeChild";
        id: string;
        name: string;
        birthdate: string;
      }>;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        contact: {
          __typename: "Contact";
          id: string;
          customerId: string;
          projectId: string;
          salutation: string | null;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
          infos: Array<{
            __typename: "ContactInfo";
            id: string;
            description: string | null;
            itype: ContactInfoType;
            normalizedValue: string | null;
            value: string | null;
            confirmedAt: string | null;
            confirmationSentAt: string | null;
            insertedAt: string;
            updatedAt: string;
          }>;
          addresses: Array<{
            __typename: "ContactAddress";
            id: string;
            address: string | null;
            atype: ContactAddressType;
            city: string | null;
            cityPart: string | null;
            country: string | null;
            description: string | null;
            zip: string | null;
          }>;
        } | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    };
    fileTypes: Array<{
      __typename: "PersonalFileType";
      id: string;
      name: string;
    }>;
  }>;
};

export type CountMissingPersonalFileTypesQueryVariables = Exact<{
  customerId: string;
  filters?: MissingPersonalFileTypesFilters | null | undefined;
}>;

export type CountMissingPersonalFileTypesQuery = {
  __typename: "QueryRoot";
  countMissingPersonalFileTypes: string;
};

export type ProfileRefFragment = {
  __typename: "Profile";
  id: string;
  name: string;
};

export type ProfileListItemFragment = {
  __typename: "Profile";
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  id: string;
  name: string;
};

export type ProfileDetailFragment = {
  __typename: "Profile";
  attrs: Record<string, unknown>;
  insertedAt: string;
  updatedAt: string;
  id: string;
  name: string;
  users: Array<{
    __typename: "User";
    id: string;
    username: string;
    contact: { __typename: "Contact"; id: string; displayName: string } | null;
  }>;
};

export type ProfilesQueryVariables = Exact<{
  customerId: string;
  limit?: string | null | undefined;
  offset?: string | null | undefined;
}>;

export type ProfilesQuery = {
  __typename: "QueryRoot";
  profiles: Array<{
    __typename: "Profile";
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    id: string;
    name: string;
  }>;
};

export type CountProfilesQueryVariables = Exact<{
  customerId: string;
}>;

export type CountProfilesQuery = {
  __typename: "QueryRoot";
  countProfiles: string;
};

export type ProfileQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ProfileQuery = {
  __typename: "QueryRoot";
  profile: {
    __typename: "Profile";
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    id: string;
    name: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
      } | null;
    }>;
  } | null;
};

export type DeleteProfileMutationVariables = Exact<{
  id: string;
  customerId: string;
}>;

export type DeleteProfileMutation = {
  __typename: "MutationRoot";
  deleteProfile: { __typename: "Profile"; id: string };
};

export type MutateProfileMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  profile: ProfileInput;
}>;

export type MutateProfileMutation = {
  __typename: "MutationRoot";
  mutateProfile: {
    __typename: "Profile";
    id: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type ProjectNewsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListProjectNewsFilters | null | undefined;
}>;

export type ProjectNewsQuery = {
  __typename: "QueryRoot";
  projectNews: Array<{
    __typename: "ProjectNews";
    id: string;
    subject: string;
    content: string;
    active: boolean;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountProjectNewsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListProjectNewsFilters | null | undefined;
}>;

export type CountProjectNewsQuery = {
  __typename: "QueryRoot";
  countProjectNews: string;
};

export type ProjectNewsPostQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ProjectNewsPostQuery = {
  __typename: "QueryRoot";
  projectNewsPost: {
    __typename: "ProjectNews";
    id: string;
    subject: string;
    content: string;
    active: boolean;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteProjectNewsMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteProjectNewsMutation = {
  __typename: "MutationRoot";
  deleteProjectNews: {
    __typename: "ProjectNews";
    id: string;
    subject: string;
    content: string;
    active: boolean;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type MutateProjectNewsMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: ProjectNewsInput;
}>;

export type MutateProjectNewsMutation = {
  __typename: "MutationRoot";
  mutateProjectNews: {
    __typename: "ProjectNews";
    id: string;
    subject: string;
    content: string;
    active: boolean;
    customerId: string;
    projectId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type MutateProjectNewsAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  newsId: string;
  values: ProjectNewsAttachmentInput;
}>;

export type MutateProjectNewsAttachmentMutation = {
  __typename: "MutationRoot";
  mutateProjectNewsAttachment: {
    __typename: "ProjectNewsAttachment";
    id: string;
    file: string;
  };
};

export type HideProjectNewsMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type HideProjectNewsMutation = {
  __typename: "MutationRoot";
  hideProjectNews: {
    __typename: "ProjectNewsHidelistEntry";
    id: string;
    newsId: string;
    userId: string;
    insertedAt: string;
  };
};

export type ProjectReportsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ProjectReportListFilters | null | undefined;
}>;

export type ProjectReportsQuery = {
  __typename: "QueryRoot";
  projectReports: Array<{
    __typename: "ProjectReport";
    id: string;
    subject: string | null;
    month: string | null;
    reportType: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountProjectReportsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ProjectReportListFilters | null | undefined;
}>;

export type CountProjectReportsQuery = {
  __typename: "QueryRoot";
  countProjectReports: string;
};

export type ProjectReportQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ProjectReportQuery = {
  __typename: "QueryRoot";
  projectReport: {
    __typename: "ProjectReport";
    reportData: Record<string, unknown>;
    id: string;
    subject: string | null;
    month: string | null;
    reportType: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateProjectReportMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: ProjectReportInput;
}>;

export type MutateProjectReportMutation = {
  __typename: "MutationRoot";
  mutateProjectReport: {
    __typename: "ProjectReport";
    reportData: Record<string, unknown>;
    id: string;
    subject: string | null;
    month: string | null;
    reportType: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteProjectReportMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteProjectReportMutation = {
  __typename: "MutationRoot";
  deleteProjectReport: { __typename: "ProjectReport"; id: string };
};

export type ProjectReportSuggestionForMonthQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  month: string;
}>;

export type ProjectReportSuggestionForMonthQuery = {
  __typename: "QueryRoot";
  projectReportSuggestionForMonth: Record<string, unknown>;
};

export type SwitcherProjectsQueryVariables = Exact<{
  customerId: string;
  filters?: ListProjectsFilters | null | undefined;
}>;

export type SwitcherProjectsQuery = {
  __typename: "QueryRoot";
  projects: Array<{
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    identifier: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type ProjectsQueryVariables = Exact<{
  customerId: string;
  filters?: ListProjectsFilters | null | undefined;
}>;

export type ProjectsQuery = {
  __typename: "QueryRoot";
  projects: Array<{
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    identifier: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type GlobalProjectsQueryVariables = Exact<{
  customerId?: string | null | undefined;
  filters?: ListProjectsFilters | null | undefined;
}>;

export type GlobalProjectsQuery = {
  __typename: "QueryRoot";
  projects: Array<{
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
  }>;
};

export type CountProjectsQueryVariables = Exact<{
  customerId: string;
  filters?: CountProjectsFilters | null | undefined;
}>;

export type CountProjectsQuery = {
  __typename: "QueryRoot";
  countProjects: string;
};

export type ProjectQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type ProjectQuery = {
  __typename: "QueryRoot";
  project: {
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    identifier: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  } | null;
};

export type MutateProjectMutationVariables = Exact<{
  customerId: string;
  projectId?: string | null | undefined;
  project: ProjectInput;
}>;

export type MutateProjectMutation = {
  __typename: "MutationRoot";
  mutateProject: {
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    identifier: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  };
};

export type ToggleFeatureMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  feature: string;
}>;

export type ToggleFeatureMutation = {
  __typename: "MutationRoot";
  toggleFeature: {
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    identifier: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  };
};

export type DeleteProjectMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteProjectMutation = {
  __typename: "MutationRoot";
  deleteProject: { __typename: "JobResult"; id: string };
};

export type CopyProjectMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  name: string;
  identifier: string;
  targetCustomer?: string | null | undefined;
}>;

export type CopyProjectMutation = {
  __typename: "MutationRoot";
  copyProject: {
    __typename: "Project";
    id: string;
    customerId: string;
    name: string;
    identifier: string;
    active: boolean;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  };
};

export type ProjectAttachmentsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListProjectAttachmentsFilters | null | undefined;
}>;

export type ProjectAttachmentsQuery = {
  __typename: "QueryRoot";
  projectAttachments: Array<{
    __typename: "ProjectAttachment";
    id: string;
    file: string;
    identifier: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountProjectAttachmentsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type CountProjectAttachmentsQuery = {
  __typename: "QueryRoot";
  countProjectAttachments: string;
};

export type ProjectAttachmentQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type ProjectAttachmentQuery = {
  __typename: "QueryRoot";
  projectAttachment: {
    __typename: "ProjectAttachment";
    id: string;
    file: string;
    identifier: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type DeleteProjectAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteProjectAttachmentMutation = {
  __typename: "MutationRoot";
  deleteProjectAttachment: { __typename: "ProjectAttachment"; id: string };
};

export type MutateProjectAttachmentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  attachment: ProjectAttachmentInput;
}>;

export type MutateProjectAttachmentMutation = {
  __typename: "MutationRoot";
  mutateProjectAttachment: {
    __typename: "ProjectAttachment";
    id: string;
    file: string;
    identifier: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type PunchlistEntriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListPunchlistEntriesFilters | null | undefined;
}>;

export type PunchlistEntriesQuery = {
  __typename: "QueryRoot";
  punchlistEntries: Array<{
    __typename: "PunchlistEntry";
    id: string;
    subject: string;
    category: string | null;
    url: string | null;
    description: string;
    status: PunchlistEntryStatus;
    errorDate: string;
    historyId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type SugPunchlistEntriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListPunchlistEntriesFilters | null | undefined;
}>;

export type SugPunchlistEntriesQuery = {
  __typename: "QueryRoot";
  punchlistEntries: Array<{
    __typename: "PunchlistEntry";
    id: string;
    subject: string;
    category: string | null;
    url: string | null;
    description: string;
    status: PunchlistEntryStatus;
    errorDate: string;
    historyId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    project: {
      __typename: "Project";
      id: string;
      identifier: string;
      name: string;
    };
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountPunchlistEntriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: CountPunchlistEntriesFilters | null | undefined;
}>;

export type CountPunchlistEntriesQuery = {
  __typename: "QueryRoot";
  countPunchlistEntries: string;
};

export type PunchlistEntryQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type PunchlistEntryQuery = {
  __typename: "QueryRoot";
  punchlistEntry: {
    __typename: "PunchlistEntry";
    id: string;
    subject: string;
    category: string | null;
    url: string | null;
    description: string;
    status: PunchlistEntryStatus;
    errorDate: string;
    historyId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type PunchlistEntryForHistoryQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  historyId: string;
}>;

export type PunchlistEntryForHistoryQuery = {
  __typename: "QueryRoot";
  punchlistEntryForHistory: {
    __typename: "PunchlistEntry";
    id: string;
    subject: string;
    category: string | null;
    url: string | null;
    description: string;
    status: PunchlistEntryStatus;
    errorDate: string;
    historyId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    comments: Array<{
      __typename: "PunchlistEntryComment";
      id: string;
      comment: string;
      userId: string;
      insertedAt: string;
      updatedAt: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type PunchlistEntryForHistoriesQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  historyIds: Array<string> | string;
}>;

export type PunchlistEntryForHistoriesQuery = {
  __typename: "QueryRoot";
  punchlistEntryForHistories: Array<{
    __typename: "PunchlistEntry";
    id: string;
    subject: string;
    category: string | null;
    url: string | null;
    description: string;
    status: PunchlistEntryStatus;
    errorDate: string;
    historyId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type PunchlistEntryCommentsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  entryId: string;
}>;

export type PunchlistEntryCommentsQuery = {
  __typename: "QueryRoot";
  punchlistEntryComments: Array<{
    __typename: "PunchlistEntryComment";
    id: string;
    comment: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type DeletePunchlistEntryMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeletePunchlistEntryMutation = {
  __typename: "MutationRoot";
  deletePunchlistEntry: { __typename: "PunchlistEntry"; id: string };
};

export type MutatePunchlistEntryMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  entry: PunchlistEntryInput;
}>;

export type MutatePunchlistEntryMutation = {
  __typename: "MutationRoot";
  mutatePunchlistEntry: {
    __typename: "PunchlistEntry";
    id: string;
    subject: string;
    category: string | null;
    url: string | null;
    description: string;
    status: PunchlistEntryStatus;
    errorDate: string;
    historyId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type ClosePunchlistEntryMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  comment: string;
}>;

export type ClosePunchlistEntryMutation = {
  __typename: "MutationRoot";
  closePunchlistEntry: {
    __typename: "PunchlistEntry";
    id: string;
    subject: string;
    category: string | null;
    url: string | null;
    description: string;
    status: PunchlistEntryStatus;
    errorDate: string;
    historyId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MutatePunchlistEntryCommentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  entryId: string;
  comment: PunchlistEntryCommentInput;
}>;

export type MutatePunchlistEntryCommentMutation = {
  __typename: "MutationRoot";
  mutatePunchlistEntryComment: {
    __typename: "PunchlistEntryComment";
    id: string;
    comment: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type RemindersQueryVariables = Exact<{
  customerId: string;
  filters?: ReminderFilters | null | undefined;
}>;

export type RemindersQuery = {
  __typename: "QueryRoot";
  reminders: Array<{
    __typename: "Reminder";
    id: string;
    name: string;
    identifier: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    recipients: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  }>;
};

export type CountRemindersQueryVariables = Exact<{
  customerId: string;
}>;

export type CountRemindersQuery = {
  __typename: "QueryRoot";
  countReminders: string;
};

export type ReminderQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ReminderQuery = {
  __typename: "QueryRoot";
  reminder: {
    __typename: "Reminder";
    id: string;
    name: string;
    identifier: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    recipients: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  } | null;
};

export type MutateReminderMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: ReminderInput;
}>;

export type MutateReminderMutation = {
  __typename: "MutationRoot";
  mutateReminder: {
    __typename: "Reminder";
    id: string;
    name: string;
    identifier: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    recipients: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  };
};

export type DeleteReminderMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteReminderMutation = {
  __typename: "MutationRoot";
  deleteReminder: {
    __typename: "Reminder";
    id: string;
    name: string;
    identifier: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    recipients: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  };
};

export type ReminderNotificationsQueryVariables = Exact<{
  customerId: string;
  filters?: ReminderNotificationFilters | null | undefined;
}>;

export type ReminderNotificationsQuery = {
  __typename: "QueryRoot";
  reminderNotifications: Array<{
    __typename: "ReminderNotification";
    id: string;
    content: string;
    done: boolean;
    doneAt: string | null;
    dueAt: string | null;
    doneById: string | null;
    reminderId: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    reminder: {
      __typename: "Reminder";
      id: string;
      name: string;
      identifier: string;
      customerId: string;
      insertedAt: string;
      updatedAt: string;
      recipients: Array<{
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type CountReminderNotificationsQueryVariables = Exact<{
  customerId: string;
  filters?: ReminderNotificationFilters | null | undefined;
}>;

export type CountReminderNotificationsQuery = {
  __typename: "QueryRoot";
  countReminderNotifications: string;
};

export type MarkReminderNotificationDoneMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type MarkReminderNotificationDoneMutation = {
  __typename: "MutationRoot";
  markReminderNotificationDone: {
    __typename: "ReminderNotification";
    id: string;
    content: string;
    done: boolean;
    doneAt: string | null;
    dueAt: string | null;
    doneById: string | null;
    reminderId: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    reminder: {
      __typename: "Reminder";
      id: string;
      name: string;
      identifier: string;
      customerId: string;
      insertedAt: string;
      updatedAt: string;
      recipients: Array<{
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      }>;
    } | null;
  };
};

export type DeleteReminderNotificationMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteReminderNotificationMutation = {
  __typename: "MutationRoot";
  deleteReminderNotification: {
    __typename: "ReminderNotification";
    id: string;
    content: string;
    done: boolean;
    doneAt: string | null;
    dueAt: string | null;
    doneById: string | null;
    reminderId: string;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    reminder: {
      __typename: "Reminder";
      id: string;
      name: string;
      identifier: string;
      customerId: string;
      insertedAt: string;
      updatedAt: string;
      recipients: Array<{
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      }>;
    } | null;
  };
};

export type ResidualLeavesQueryVariables = Exact<{
  customerId: string;
  filters?: ResidualLeaveListOptions | null | undefined;
}>;

export type ResidualLeavesQuery = {
  __typename: "QueryRoot";
  residualLeaves: Array<{
    __typename: "ResidualLeave";
    id: string;
    year: number;
    daysLeft: number;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type ResidualLeaveQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ResidualLeaveQuery = {
  __typename: "QueryRoot";
  residualLeave: {
    __typename: "ResidualLeave";
    id: string;
    year: number;
    daysLeft: number;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type MutateResidualLeaveMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: ResidualLeaveInput;
}>;

export type MutateResidualLeaveMutation = {
  __typename: "MutationRoot";
  mutateResidualLeave: {
    __typename: "ResidualLeave";
    id: string;
    year: number;
    daysLeft: number;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteResidualLeaveMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteResidualLeaveMutation = {
  __typename: "MutationRoot";
  deleteResidualLeave: { __typename: "ResidualLeave"; id: string };
};

export type RosterAttendanceTypesQueryVariables = Exact<{
  customerId: string;
  filters?: RosterAttendanceTypeFilters | null | undefined;
}>;

export type RosterAttendanceTypesQuery = {
  __typename: "QueryRoot";
  rosterAttendanceTypes: Array<{
    __typename: "RosterAttendanceType";
    id: string;
    name: string;
    type: RosterAttendanceTypeType;
    char: string;
    color: string;
    location: RosterLocationType;
    isStandard: boolean;
    ignoreForSickNotes: boolean;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CountRosterAttendanceTypesQueryVariables = Exact<{
  customerId: string;
  filters?: RosterAttendanceTypeFilters | null | undefined;
}>;

export type CountRosterAttendanceTypesQuery = {
  __typename: "QueryRoot";
  countRosterAttendanceTypes: string;
};

export type RosterAttendanceTypeQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type RosterAttendanceTypeQuery = {
  __typename: "QueryRoot";
  rosterAttendanceType: {
    __typename: "RosterAttendanceType";
    id: string;
    name: string;
    type: RosterAttendanceTypeType;
    char: string;
    color: string;
    location: RosterLocationType;
    isStandard: boolean;
    ignoreForSickNotes: boolean;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type RosterStandardAttendanceTypeValidQueryVariables = Exact<{
  customerId: string;
}>;

export type RosterStandardAttendanceTypeValidQuery = {
  __typename: "QueryRoot";
  rosterStandardAttendanceTypeValid: boolean;
};

export type MutateRosterAttendanceTypeMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: RosterAttendanceTypeInput;
}>;

export type MutateRosterAttendanceTypeMutation = {
  __typename: "MutationRoot";
  mutateRosterAttendanceType: {
    __typename: "RosterAttendanceType";
    id: string;
    name: string;
    type: RosterAttendanceTypeType;
    char: string;
    color: string;
    location: RosterLocationType;
    isStandard: boolean;
    ignoreForSickNotes: boolean;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteRosterAttendanceTypeMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteRosterAttendanceTypeMutation = {
  __typename: "MutationRoot";
  deleteRosterAttendanceType: {
    __typename: "RosterAttendanceType";
    id: string;
    name: string;
    type: RosterAttendanceTypeType;
    char: string;
    color: string;
    location: RosterLocationType;
    isStandard: boolean;
    ignoreForSickNotes: boolean;
    insertedAt: string;
    updatedAt: string;
  };
};

export type ArchiveRosterAttendanceTypeMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ArchiveRosterAttendanceTypeMutation = {
  __typename: "MutationRoot";
  archiveRosterAttendanceType: {
    __typename: "RosterAttendanceType";
    id: string;
    name: string;
    type: RosterAttendanceTypeType;
    char: string;
    color: string;
    location: RosterLocationType;
    isStandard: boolean;
    ignoreForSickNotes: boolean;
    insertedAt: string;
    updatedAt: string;
  };
};

export type RosterTasksQueryVariables = Exact<{
  customerId: string;
  filters?: RosterTaskFilters | null | undefined;
}>;

export type RosterTasksQuery = {
  __typename: "QueryRoot";
  rosterTasks: Array<{
    __typename: "RosterTask";
    id: string;
    name: string;
    type: RosterTaskType;
    char: string;
    color: string;
    notifyUser: boolean;
    notifyMinutes: number | null;
    insertedAt: string;
    updatedAt: string;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  }>;
};

export type CountRosterTasksQueryVariables = Exact<{
  customerId: string;
  filters?: RosterTaskFilters | null | undefined;
}>;

export type CountRosterTasksQuery = {
  __typename: "QueryRoot";
  countRosterTasks: string;
};

export type RosterTaskQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type RosterTaskQuery = {
  __typename: "QueryRoot";
  rosterTask: {
    __typename: "RosterTask";
    id: string;
    name: string;
    type: RosterTaskType;
    char: string;
    color: string;
    notifyUser: boolean;
    notifyMinutes: number | null;
    insertedAt: string;
    updatedAt: string;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  } | null;
};

export type MutateRosterTaskMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: RosterTaskInput;
}>;

export type MutateRosterTaskMutation = {
  __typename: "MutationRoot";
  mutateRosterTask: {
    __typename: "RosterTask";
    id: string;
    name: string;
    type: RosterTaskType;
    char: string;
    color: string;
    notifyUser: boolean;
    notifyMinutes: number | null;
    insertedAt: string;
    updatedAt: string;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  };
};

export type DeleteRosterTaskMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteRosterTaskMutation = {
  __typename: "MutationRoot";
  deleteRosterTask: {
    __typename: "RosterTask";
    id: string;
    name: string;
    type: RosterTaskType;
    char: string;
    color: string;
    notifyUser: boolean;
    notifyMinutes: number | null;
    insertedAt: string;
    updatedAt: string;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  };
};

export type ArchiveRosterTaskMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ArchiveRosterTaskMutation = {
  __typename: "MutationRoot";
  archiveRosterTask: {
    __typename: "RosterTask";
    id: string;
    name: string;
    type: RosterTaskType;
    char: string;
    color: string;
    notifyUser: boolean;
    notifyMinutes: number | null;
    insertedAt: string;
    updatedAt: string;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  };
};

export type RosterGroupsQueryVariables = Exact<{
  customerId: string;
  filters?: RosterGroupFilters | null | undefined;
}>;

export type RosterGroupsQuery = {
  __typename: "QueryRoot";
  rosterGroups: Array<{
    __typename: "RosterGroup";
    id: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  }>;
};

export type RosterGroupsForFormQueryVariables = Exact<{
  customerId: string;
  filters?: RosterGroupFilters | null | undefined;
}>;

export type RosterGroupsForFormQuery = {
  __typename: "QueryRoot";
  rosterGroups: Array<{
    __typename: "RosterGroup";
    id: string;
    name: string;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  }>;
};

export type RosterGroupQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type RosterGroupQuery = {
  __typename: "QueryRoot";
  rosterGroup: {
    __typename: "RosterGroup";
    id: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  } | null;
};

export type MutateRosterGroupMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: RosterGroupInput;
}>;

export type MutateRosterGroupMutation = {
  __typename: "MutationRoot";
  mutateRosterGroup: {
    __typename: "RosterGroup";
    id: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  };
};

export type DeleteRosterGroupMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteRosterGroupMutation = {
  __typename: "MutationRoot";
  deleteRosterGroup: {
    __typename: "RosterGroup";
    id: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
  };
};

export type MutateRosterGroupsForUserMutationVariables = Exact<{
  customerId: string;
  userId: string;
  groupIds: Array<string> | string;
}>;

export type MutateRosterGroupsForUserMutation = {
  __typename: "MutationRoot";
  mutateRosterGroupsForUser: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type RosterStandardAttendancesQueryVariables = Exact<{
  customerId: string;
  filters?: RosterStandardAttendanceFilters | null | undefined;
}>;

export type RosterStandardAttendancesQuery = {
  __typename: "QueryRoot";
  rosterStandardAttendances: Array<{
    __typename: "RosterStandardAttendance";
    id: string;
    weekDay: number;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    type: {
      __typename: "RosterAttendanceType";
      id: string;
      name: string;
      type: RosterAttendanceTypeType;
      char: string;
      color: string;
      location: RosterLocationType;
      isStandard: boolean;
      ignoreForSickNotes: boolean;
      insertedAt: string;
      updatedAt: string;
    };
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MutateRosterStandardAttendanceMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: RosterStandardAttendanceInput;
}>;

export type MutateRosterStandardAttendanceMutation = {
  __typename: "MutationRoot";
  mutateRosterStandardAttendance: {
    __typename: "RosterStandardAttendance";
    id: string;
    weekDay: number;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    type: {
      __typename: "RosterAttendanceType";
      id: string;
      name: string;
      type: RosterAttendanceTypeType;
      char: string;
      color: string;
      location: RosterLocationType;
      isStandard: boolean;
      ignoreForSickNotes: boolean;
      insertedAt: string;
      updatedAt: string;
    };
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteRosterStandardAttendanceMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteRosterStandardAttendanceMutation = {
  __typename: "MutationRoot";
  deleteRosterStandardAttendance: {
    __typename: "RosterStandardAttendance";
    id: string;
    weekDay: number;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    type: {
      __typename: "RosterAttendanceType";
      id: string;
      name: string;
      type: RosterAttendanceTypeType;
      char: string;
      color: string;
      location: RosterLocationType;
      isStandard: boolean;
      ignoreForSickNotes: boolean;
      insertedAt: string;
      updatedAt: string;
    };
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type RosterStandardDaysQueryVariables = Exact<{
  customerId: string;
  filters?: RosterStandardDayFilters | null | undefined;
}>;

export type RosterStandardDaysQuery = {
  __typename: "QueryRoot";
  rosterStandardDays: Array<{
    __typename: "RosterStandardDay";
    id: string;
    weekDay: number;
    attendanceTypeId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    type: {
      __typename: "RosterAttendanceType";
      id: string;
      name: string;
      type: RosterAttendanceTypeType;
      char: string;
      color: string;
      location: RosterLocationType;
      isStandard: boolean;
      ignoreForSickNotes: boolean;
      insertedAt: string;
      updatedAt: string;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    hours: Array<{
      __typename: "RosterStandardHour";
      id: string;
      hour: string;
      taskId: string;
      task: {
        __typename: "RosterTask";
        id: string;
        name: string;
        type: RosterTaskType;
        char: string;
        color: string;
        notifyUser: boolean;
        notifyMinutes: number | null;
        insertedAt: string;
        updatedAt: string;
        customer: { __typename: "MinimalCustomer"; id: string; name: string };
      };
    }>;
  }>;
};

export type MutateRosterStandardDayMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: RosterStandardDayInput;
}>;

export type MutateRosterStandardDayMutation = {
  __typename: "MutationRoot";
  mutateRosterStandardDay: {
    __typename: "RosterStandardDay";
    id: string;
    weekDay: number;
    attendanceTypeId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    type: {
      __typename: "RosterAttendanceType";
      id: string;
      name: string;
      type: RosterAttendanceTypeType;
      char: string;
      color: string;
      location: RosterLocationType;
      isStandard: boolean;
      ignoreForSickNotes: boolean;
      insertedAt: string;
      updatedAt: string;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    hours: Array<{
      __typename: "RosterStandardHour";
      id: string;
      hour: string;
      taskId: string;
      task: {
        __typename: "RosterTask";
        id: string;
        name: string;
        type: RosterTaskType;
        char: string;
        color: string;
        notifyUser: boolean;
        notifyMinutes: number | null;
        insertedAt: string;
        updatedAt: string;
        customer: { __typename: "MinimalCustomer"; id: string; name: string };
      };
    }>;
  };
};

export type ShiftRosterStandardDayHoursMutationVariables = Exact<{
  customerId: string;
  standardDayId: string;
  minutes: number;
}>;

export type ShiftRosterStandardDayHoursMutation = {
  __typename: "MutationRoot";
  shiftRosterStandardDayHours: Array<{
    __typename: "RosterStandardHour";
    id: string;
    hour: string;
    taskId: string;
    task: {
      __typename: "RosterTask";
      id: string;
      name: string;
      type: RosterTaskType;
      char: string;
      color: string;
      notifyUser: boolean;
      notifyMinutes: number | null;
      insertedAt: string;
      updatedAt: string;
      customer: { __typename: "MinimalCustomer"; id: string; name: string };
    };
  }>;
};

export type CopyRosterStandardDayMutationVariables = Exact<{
  customerId: string;
  id: string;
  values: RosterStandardDayInput;
}>;

export type CopyRosterStandardDayMutation = {
  __typename: "MutationRoot";
  copyRosterStandardDay: {
    __typename: "RosterStandardDay";
    id: string;
    weekDay: number;
    attendanceTypeId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    type: {
      __typename: "RosterAttendanceType";
      id: string;
      name: string;
      type: RosterAttendanceTypeType;
      char: string;
      color: string;
      location: RosterLocationType;
      isStandard: boolean;
      ignoreForSickNotes: boolean;
      insertedAt: string;
      updatedAt: string;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    hours: Array<{
      __typename: "RosterStandardHour";
      id: string;
      hour: string;
      taskId: string;
      task: {
        __typename: "RosterTask";
        id: string;
        name: string;
        type: RosterTaskType;
        char: string;
        color: string;
        notifyUser: boolean;
        notifyMinutes: number | null;
        insertedAt: string;
        updatedAt: string;
        customer: { __typename: "MinimalCustomer"; id: string; name: string };
      };
    }>;
  };
};

export type DeleteRosterStandardDayMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteRosterStandardDayMutation = {
  __typename: "MutationRoot";
  deleteRosterStandardDay: {
    __typename: "RosterStandardDay";
    id: string;
    weekDay: number;
    attendanceTypeId: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    type: {
      __typename: "RosterAttendanceType";
      id: string;
      name: string;
      type: RosterAttendanceTypeType;
      char: string;
      color: string;
      location: RosterLocationType;
      isStandard: boolean;
      ignoreForSickNotes: boolean;
      insertedAt: string;
      updatedAt: string;
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    hours: Array<{
      __typename: "RosterStandardHour";
      id: string;
      hour: string;
      taskId: string;
      task: {
        __typename: "RosterTask";
        id: string;
        name: string;
        type: RosterTaskType;
        char: string;
        color: string;
        notifyUser: boolean;
        notifyMinutes: number | null;
        insertedAt: string;
        updatedAt: string;
        customer: { __typename: "MinimalCustomer"; id: string; name: string };
      };
    }>;
  };
};

export type RosterAttendancesQueryVariables = Exact<{
  customerId: string;
  filters?: RosterAttendanceFilters | null | undefined;
}>;

export type RosterAttendancesQuery = {
  __typename: "QueryRoot";
  rosterAttendances: Array<{
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type RosterAttendancesWithTypeQueryVariables = Exact<{
  customerId: string;
  filters?: RosterAttendanceFilters | null | undefined;
}>;

export type RosterAttendancesWithTypeQuery = {
  __typename: "QueryRoot";
  rosterAttendances: Array<{
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    attendanceType: {
      __typename: "RosterAttendanceType";
      id: string;
      name: string;
      type: RosterAttendanceTypeType;
    };
  }>;
};

export type RosterAttendancesWithUserQueryVariables = Exact<{
  customerId: string;
  filters?: RosterAttendanceFilters | null | undefined;
}>;

export type RosterAttendancesWithUserQuery = {
  __typename: "QueryRoot";
  rosterAttendances: Array<{
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type RosterAttendanceQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type RosterAttendanceQuery = {
  __typename: "QueryRoot";
  rosterAttendance: {
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  } | null;
};

export type MutateRosterAttendanceMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: RosterAttendanceInput;
}>;

export type MutateRosterAttendanceMutation = {
  __typename: "MutationRoot";
  mutateRosterAttendance: {
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type PlanStandardRosterAttendanceMutationVariables = Exact<{
  customerId: string;
  userId: string;
  month: string;
}>;

export type PlanStandardRosterAttendanceMutation = {
  __typename: "MutationRoot";
  planStandardRosterAttendance: Array<{
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type DeleteRosterAttendanceMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteRosterAttendanceMutation = {
  __typename: "MutationRoot";
  deleteRosterAttendance: {
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type BatchDeleteRosterAttendancesMutationVariables = Exact<{
  customerId: string;
  userId: string;
  month: string;
}>;

export type BatchDeleteRosterAttendancesMutation = {
  __typename: "MutationRoot";
  batchDeleteRosterAttendances: Array<{
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type ConfirmRosterAttendancesMutationVariables = Exact<{
  customerId: string;
  userIds: Array<string> | string;
  month: string;
}>;

export type ConfirmRosterAttendancesMutation = {
  __typename: "MutationRoot";
  confirmRosterAttendances: Array<{
    __typename: "RosterAttendance";
    id: string;
    day: string;
    visible: boolean;
    toBeDeleted: boolean;
    attendanceTypeId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type RosterHoursQueryVariables = Exact<{
  customerId: string;
  filters?: RosterHourFilters | null | undefined;
}>;

export type RosterHoursQuery = {
  __typename: "QueryRoot";
  rosterHours: Array<{
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type MutateRosterHourMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: RosterHourInput;
}>;

export type MutateRosterHourMutation = {
  __typename: "MutationRoot";
  mutateRosterHour: {
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type ShiftRosterHoursMutationVariables = Exact<{
  customerId: string;
  userId: string;
  day: string;
  minutes: number;
}>;

export type ShiftRosterHoursMutation = {
  __typename: "MutationRoot";
  shiftRosterHours: Array<{
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type ConfirmRosterHoursMutationVariables = Exact<{
  customerId: string;
  userIds: Array<string> | string;
  day: string;
}>;

export type ConfirmRosterHoursMutation = {
  __typename: "MutationRoot";
  confirmRosterHours: Array<{
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type PlanStandardRosterHoursMutationVariables = Exact<{
  customerId: string;
  userId: string;
  day: string;
}>;

export type PlanStandardRosterHoursMutation = {
  __typename: "MutationRoot";
  planStandardRosterHours: Array<{
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type DeleteRosterHourMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteRosterHourMutation = {
  __typename: "MutationRoot";
  deleteRosterHour: {
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type BatchDeleteRosterHoursMutationVariables = Exact<{
  customerId: string;
  userId: string;
  day: string;
}>;

export type BatchDeleteRosterHoursMutation = {
  __typename: "MutationRoot";
  batchDeleteRosterHours: Array<{
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type CopyRosterHoursMutationVariables = Exact<{
  customerId: string;
  userId: string;
  sourceDay: string;
  targetDay: string;
}>;

export type CopyRosterHoursMutation = {
  __typename: "MutationRoot";
  copyRosterHours: Array<{
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type RosterMonthQueryVariables = Exact<{
  customerId: string;
  month: string;
  filters?: RosterMonthFilters | null | undefined;
}>;

export type RosterMonthQuery = {
  __typename: "QueryRoot";
  rosterMonth: Array<{
    __typename: "RosterMonthUser";
    userId: string;
    sum: number;
    days: Array<{
      __typename: "RosterMonthDay";
      date: string;
      startTime: string | null;
      stopTime: string | null;
      pauseTime: string | null;
      mostUsedTaskId: string | null;
      attendanceType: {
        __typename: "RosterAttendanceType";
        id: string;
        name: string;
        type: RosterAttendanceTypeType;
        char: string;
        color: string;
        location: RosterLocationType;
        isStandard: boolean;
        ignoreForSickNotes: boolean;
        insertedAt: string;
        updatedAt: string;
      };
    }>;
  }>;
};

export type RosterHoursMonthSumsQueryVariables = Exact<{
  customerId: string;
  month: string;
  groupIds?: Array<string> | string | null | undefined;
}>;

export type RosterHoursMonthSumsQuery = {
  __typename: "QueryRoot";
  rosterHoursMonthSums: Array<{
    __typename: "RosterHourSum";
    userId: string;
    sum: number;
  }>;
};

export type RosterNotificationsQueryVariables = Exact<{
  customerId: string;
  filters?: RosterNotificationFilters | null | undefined;
}>;

export type RosterNotificationsQuery = {
  __typename: "QueryRoot";
  rosterNotifications: Array<{
    __typename: "RosterNotification";
    id: string;
    content: string;
    done: boolean;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
  }>;
};

export type MarkRosterNotificationDoneMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type MarkRosterNotificationDoneMutation = {
  __typename: "MutationRoot";
  markRosterNotificationDone: {
    __typename: "RosterNotification";
    id: string;
    content: string;
    done: boolean;
    customerId: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type NotifyRosterHourSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type NotifyRosterHourSubscription = {
  __typename: "SubscriptionRoot";
  notifyRosterHour: {
    __typename: "RosterHour";
    id: string;
    hour: string;
    visible: boolean;
    toBeDeleted: boolean;
    taskId: string;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    task: { __typename: "RosterTask"; id: string; name: string };
  };
};

export type SecretsQueryVariables = Exact<{
  filters?: ListSecretsFilters | null | undefined;
}>;

export type SecretsQuery = {
  __typename: "QueryRoot";
  secrets: Array<{
    __typename: "Secret";
    id: string;
    customerId: string;
    name: string;
    description: string | null;
    validUntil: string | null;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "Customer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  }>;
};

export type CountSecretsQueryVariables = Exact<{
  filters?: ListSecretsFilters | null | undefined;
}>;

export type CountSecretsQuery = {
  __typename: "QueryRoot";
  countSecrets: string;
};

export type MutateSecretMutationVariables = Exact<{
  id?: string | null | undefined;
  values: SecretInput;
}>;

export type MutateSecretMutation = {
  __typename: "MutationRoot";
  mutateSecret: {
    __typename: "Secret";
    id: string;
    customerId: string;
    name: string;
    description: string | null;
    validUntil: string | null;
    insertedAt: string;
    updatedAt: string;
    customer: {
      __typename: "Customer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  };
};

export type DeleteSecretMutationVariables = Exact<{
  id: string;
}>;

export type DeleteSecretMutation = {
  __typename: "MutationRoot";
  deleteSecret: { __typename: "Secret"; id: string };
};

export type VersionsSubscriptionVariables = Exact<{ [key: string]: never }>;

export type VersionsSubscription = {
  __typename: "SubscriptionRoot";
  versions: { __typename: "VersionsEvent"; frontend: string; backend: string };
};

export type LoginMutationVariables = Exact<{
  username: string;
  password: string;
  otp?: string | null | undefined;
}>;

export type LoginMutation = { __typename: "MutationRoot"; login: string };

export type TokenForUserMutationVariables = Exact<{
  userId: string;
}>;

export type TokenForUserMutation = {
  __typename: "MutationRoot";
  tokenForUser: string;
};

export type RequestChallengeMutationVariables = Exact<{
  number: string;
}>;

export type RequestChallengeMutation = {
  __typename: "MutationRoot";
  requestChallenge: boolean;
};

export type VerifyChallengeMutationVariables = Exact<{
  number: string;
  response: string;
}>;

export type VerifyChallengeMutation = {
  __typename: "MutationRoot";
  verifyChallenge: boolean;
};

export type RefreshUserProtocolBeaconMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RefreshUserProtocolBeaconMutation = {
  __typename: "MutationRoot";
  refreshUserProtocolBeacon: { __typename: "UserProtocolEntry"; id: string };
};

export type SessionDataQueryVariables = Exact<{
  customerIdentifier?: string | null | undefined;
}>;

export type SessionDataQuery = {
  __typename: "QueryRoot";
  sessionData: {
    __typename: "SessionData";
    user: {
      __typename: "User";
      id: string;
      customerId: string;
      username: string;
      email: string | null;
      role: UserRole;
      flags: Array<string>;
      teamLeader: boolean;
      isJumper: boolean;
      billableCustomerId: string | null;
      billableCustomerIds: Array<string>;
      currentBillingCustomerId: string | null;
      defaultProjectId: string | null;
      attrs: Record<string, unknown>;
      passwordReset: string | null;
      otp: boolean;
      currentBillingCustomer: {
        __typename: "MinimalCustomer";
        id: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      } | null;
      billableCustomers: Array<{
        __typename: "MinimalCustomer";
        id: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      }>;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
        birthdate: string | null;
      } | null;
      projects: Array<{
        __typename: "Project";
        id: string;
        customerId: string;
        name: string;
        identifier: string;
        active: boolean;
        attrs: Record<string, unknown>;
        insertedAt: string;
        updatedAt: string;
      }>;
      customer: {
        __typename: "Customer";
        id: string;
        identifier: string;
        attrs: Record<string, unknown>;
        defaultProject: {
          __typename: "Project";
          id: string;
          identifier: string;
          attrs: Record<string, unknown>;
        } | null;
      } | null;
    };
    customer: {
      __typename: "Customer";
      id: string;
      name: string;
      identifier: string;
      defaultProjectId: string | null;
      attrs: Record<string, unknown>;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
      projects: Array<{
        __typename: "Project";
        id: string;
        customerId: string;
        name: string;
        identifier: string;
        active: boolean;
        attrs: Record<string, unknown>;
        insertedAt: string;
        updatedAt: string;
      }>;
      customerAdministrators: Array<{
        __typename: "User";
        id: string;
        username: string;
      }>;
    };
  };
};

export type RefreshMutationVariables = Exact<{
  customerIdentifier?: string | null | undefined;
}>;

export type RefreshMutation = {
  __typename: "MutationRoot";
  refresh: {
    __typename: "RefreshResponse";
    token: string;
    user: {
      __typename: "User";
      id: string;
      customerId: string;
      username: string;
      email: string | null;
      role: UserRole;
      flags: Array<string>;
      teamLeader: boolean;
      isJumper: boolean;
      billableCustomerId: string | null;
      billableCustomerIds: Array<string>;
      currentBillingCustomerId: string | null;
      defaultProjectId: string | null;
      attrs: Record<string, unknown>;
      passwordReset: string | null;
      otp: boolean;
      currentBillingCustomer: {
        __typename: "MinimalCustomer";
        id: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      } | null;
      billableCustomers: Array<{
        __typename: "MinimalCustomer";
        id: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      }>;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        displayName: string;
        birthdate: string | null;
      } | null;
      projects: Array<{
        __typename: "Project";
        id: string;
        customerId: string;
        name: string;
        identifier: string;
        active: boolean;
        attrs: Record<string, unknown>;
        insertedAt: string;
        updatedAt: string;
      }>;
      customer: {
        __typename: "Customer";
        id: string;
        identifier: string;
        attrs: Record<string, unknown>;
        defaultProject: {
          __typename: "Project";
          id: string;
          identifier: string;
          attrs: Record<string, unknown>;
        } | null;
      } | null;
    };
    customer: {
      __typename: "Customer";
      id: string;
      name: string;
      identifier: string;
      defaultProjectId: string | null;
      attrs: Record<string, unknown>;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
      projects: Array<{
        __typename: "Project";
        id: string;
        customerId: string;
        name: string;
        identifier: string;
        active: boolean;
        attrs: Record<string, unknown>;
        insertedAt: string;
        updatedAt: string;
      }>;
      customerAdministrators: Array<{
        __typename: "User";
        id: string;
        username: string;
      }>;
    };
  };
};

export type SessionCustomerQueryVariables = Exact<{
  customerId?: string | null | undefined;
  identifier?: string | null | undefined;
}>;

export type SessionCustomerQuery = {
  __typename: "QueryRoot";
  customer: {
    __typename: "Customer";
    id: string;
    name: string;
    identifier: string;
    defaultProjectId: string | null;
    attrs: Record<string, unknown>;
    logo: {
      __typename: "CustomerLogo";
      thumb: string;
      medium: string;
      original: string;
    };
    projects: Array<{
      __typename: "Project";
      id: string;
      customerId: string;
      name: string;
      identifier: string;
      active: boolean;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
    }>;
    customerAdministrators: Array<{
      __typename: "User";
      id: string;
      username: string;
    }>;
  } | null;
};

export type UsersSetCurrentBillingCustomerMutationVariables = Exact<{
  customerId: string;
}>;

export type UsersSetCurrentBillingCustomerMutation = {
  __typename: "MutationRoot";
  usersSetCurrentBillingCustomer: {
    __typename: "User";
    id: string;
    customerId: string;
    username: string;
    email: string | null;
    role: UserRole;
    flags: Array<string>;
    teamLeader: boolean;
    isJumper: boolean;
    billableCustomerId: string | null;
    billableCustomerIds: Array<string>;
    currentBillingCustomerId: string | null;
    defaultProjectId: string | null;
    attrs: Record<string, unknown>;
    passwordReset: string | null;
    otp: boolean;
    currentBillingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    billableCustomers: Array<{
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    }>;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      birthdate: string | null;
    } | null;
    projects: Array<{
      __typename: "Project";
      id: string;
      customerId: string;
      name: string;
      identifier: string;
      active: boolean;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
    }>;
    customer: {
      __typename: "Customer";
      id: string;
      identifier: string;
      attrs: Record<string, unknown>;
      defaultProject: {
        __typename: "Project";
        id: string;
        identifier: string;
        attrs: Record<string, unknown>;
      } | null;
    } | null;
  };
};

export type PresettlementsQueryVariables = Exact<{
  customerId: string;
  filters?: PresettlementListFilters | null | undefined;
}>;

export type PresettlementsQuery = {
  __typename: "QueryRoot";
  presettlements: Array<{
    __typename: "Presettlement";
    id: string;
    month: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    entries: Array<{
      __typename: "PresettlementEntry";
      id: string;
      partialWage: number;
    }>;
    wageModifications: Array<{
      __typename: "PresettlementWageModification";
      id: string;
      modification: number;
    }>;
  }>;
};

export type CountPresettlementsQueryVariables = Exact<{
  customerId: string;
}>;

export type CountPresettlementsQuery = {
  __typename: "QueryRoot";
  countPresettlements: string;
};

export type PresettlementValidationQueryVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  month: string;
}>;

export type PresettlementValidationQuery = {
  __typename: "QueryRoot";
  presettlementValidation: boolean;
};

export type PresettlementQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type PresettlementQuery = {
  __typename: "QueryRoot";
  presettlement: {
    __typename: "Presettlement";
    id: string;
    month: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    entries: Array<{
      __typename: "PresettlementEntry";
      id: string;
      hourlyWage: number;
      wage: number;
      partialWage: number;
      regularHours: number;
      illnessHours: number;
      vacationHours: number;
      sundayHours: number;
      feastDayHours: number;
      userId: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
    wageModifications: Array<{
      __typename: "PresettlementWageModification";
      id: string;
      modification: number;
      userId: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  } | null;
};

export type PresettlementSuggestionQueryVariables = Exact<{
  customerId: string;
  month: string;
}>;

export type PresettlementSuggestionQuery = {
  __typename: "QueryRoot";
  presettlementSuggestion: Array<{
    __typename: "PresettlementSuggestion";
    hourlyWage: number;
    wage: number;
    partialWage: number;
    regularHours: number;
    illnessHours: number;
    vacationHours: number;
    sundayHours: number;
    feastDayHours: number;
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MutatePresettlementMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: PresettlementInput;
}>;

export type MutatePresettlementMutation = {
  __typename: "MutationRoot";
  mutatePresettlement: {
    __typename: "Presettlement";
    id: string;
    month: string;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    entries: Array<{
      __typename: "PresettlementEntry";
      id: string;
      hourlyWage: number;
      wage: number;
      partialWage: number;
      regularHours: number;
      illnessHours: number;
      vacationHours: number;
      sundayHours: number;
      feastDayHours: number;
      userId: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
    wageModifications: Array<{
      __typename: "PresettlementWageModification";
      id: string;
      modification: number;
      userId: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  };
};

export type DeletePresettlementMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeletePresettlementMutation = {
  __typename: "MutationRoot";
  deletePresettlement: { __typename: "Presettlement"; id: string };
};

export type SettlementQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type SettlementQuery = {
  __typename: "QueryRoot";
  settlement: {
    __typename: "Settlement";
    id: string;
    month: string;
    isVisible: boolean;
    read: boolean;
    comment: string | null;
    inflationBonus: number | null;
    couponBonus: number | null;
    ticketBonus: number | null;
    travelCosts: number | null;
    userId: string;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    visibleAt: string | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    positions: Array<{
      __typename: "SettlementPosition";
      id: string;
      name: string;
      value: number;
      comment: string | null;
      posType: SettlementPositionType;
    }>;
    corrections: Array<{
      __typename: "SettlementCorrection";
      id: string;
      taskId: string;
      hours: number;
      month: string;
      contractId: string;
      description: string | null;
    }>;
  } | null;
};

export type SettlementsQueryVariables = Exact<{
  customerId: string;
  filters?: SettlementsListOptions | null | undefined;
}>;

export type SettlementsQuery = {
  __typename: "QueryRoot";
  settlements: Array<{
    __typename: "Settlement";
    id: string;
    month: string;
    isVisible: boolean;
    insertedAt: string;
    updatedAt: string;
    visibleAt: string | null;
    read: boolean;
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountSettlementsQueryVariables = Exact<{
  customerId: string;
  filters?: SettlementsListOptions | null | undefined;
}>;

export type CountSettlementsQuery = {
  __typename: "QueryRoot";
  countSettlements: string;
};

export type MutateSettlementMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: SettlementInput;
}>;

export type MutateSettlementMutation = {
  __typename: "MutationRoot";
  mutateSettlement: {
    __typename: "Settlement";
    id: string;
    month: string;
    isVisible: boolean;
    read: boolean;
    comment: string | null;
    inflationBonus: number | null;
    couponBonus: number | null;
    ticketBonus: number | null;
    travelCosts: number | null;
    userId: string;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    visibleAt: string | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    positions: Array<{
      __typename: "SettlementPosition";
      id: string;
      name: string;
      value: number;
      comment: string | null;
      posType: SettlementPositionType;
    }>;
    corrections: Array<{
      __typename: "SettlementCorrection";
      id: string;
      taskId: string;
      hours: number;
      month: string;
      contractId: string;
      description: string | null;
    }>;
  };
};

export type MarkSettlementReadMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type MarkSettlementReadMutation = {
  __typename: "MutationRoot";
  markSettlementRead: {
    __typename: "Settlement";
    id: string;
    month: string;
    isVisible: boolean;
    read: boolean;
    comment: string | null;
    inflationBonus: number | null;
    couponBonus: number | null;
    ticketBonus: number | null;
    travelCosts: number | null;
    userId: string;
    creatorId: string;
    editorId: string;
    insertedAt: string;
    updatedAt: string;
    visibleAt: string | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    positions: Array<{
      __typename: "SettlementPosition";
      id: string;
      name: string;
      value: number;
      comment: string | null;
      posType: SettlementPositionType;
    }>;
    corrections: Array<{
      __typename: "SettlementCorrection";
      id: string;
      taskId: string;
      hours: number;
      month: string;
      contractId: string;
      description: string | null;
    }>;
  };
};

export type DeleteSettlementMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteSettlementMutation = {
  __typename: "MutationRoot";
  deleteSettlement: { __typename: "Settlement"; id: string };
};

export type SettlementDayHoursQueryVariables = Exact<{
  customerId: string;
  userId: string;
  month: string;
}>;

export type SettlementDayHoursQuery = {
  __typename: "QueryRoot";
  settlementDayHours: {
    __typename: "SettlementDayHourResult";
    expectedHours: number;
    dayHours: Array<{
      __typename: "SettlementDayHours";
      day: string;
      paid: number;
      work: number;
      pause: number;
      illness: number;
      childSick: number;
      sickNoPayment: number;
      notAvailable: number;
      holidays: number;
      holidaysUnpaid: number;
      compensation: number;
      feastday: number;
      feastdayOff: number;
      sum: number;
      deviation: boolean;
    }>;
    sums: {
      __typename: "SettlementDayHours";
      paid: number;
      work: number;
      pause: number;
      illness: number;
      childSick: number;
      sickNoPayment: number;
      notAvailable: number;
      holidays: number;
      holidaysUnpaid: number;
      compensation: number;
      feastday: number;
      feastdayOff: number;
      sum: number;
    };
  };
};

export type SettlementsGenerateAccountantOverviewMutationVariables = Exact<{
  customerId: string;
  month: string;
}>;

export type SettlementsGenerateAccountantOverviewMutation = {
  __typename: "MutationRoot";
  settlementsGenerateAccountantOverview: {
    __typename: "JobResult";
    id: string;
    module: string;
    done: boolean;
    seen: boolean;
    hasAttachment: boolean;
    filename: string | null;
    userId: string;
    report: Record<string, unknown> | null;
    insertedAt: string;
    updatedAt: string;
  };
};

export type StaffShareLinkByShareIdQueryVariables = Exact<{
  shareId: string;
  code: string;
}>;

export type StaffShareLinkByShareIdQuery = {
  __typename: "QueryRoot";
  staffShareLinkByShareId: {
    __typename: "StaffShareLink";
    id: string;
    customerId: string;
    shareId: string;
    validForDays: number;
    note: string | null;
    insertedAt: string;
    updatedAt: string;
    files: Array<{
      __typename: "StaffShareLinkFile";
      id: string;
      personalFile: {
        __typename: "PersonalFile";
        id: string;
        file: string;
        mimeType: string;
        description: string | null;
        userId: string;
        read: boolean;
        personalFileTypeId: string | null;
        pubDate: string;
        insertedAt: string;
        updatedAt: string;
        fileType: {
          __typename: "PersonalFileType";
          id: string;
          name: string;
          required: boolean;
          category: string;
        } | null;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        };
        editor: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        };
      };
    }>;
  } | null;
};

export type MutateStaffShareLinkMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: StaffShareLinkInput;
}>;

export type MutateStaffShareLinkMutation = {
  __typename: "MutationRoot";
  mutateStaffShareLink: {
    __typename: "StaffShareLink";
    id: string;
    customerId: string;
    shareId: string;
    validForDays: number;
    note: string | null;
    insertedAt: string;
    updatedAt: string;
    files: Array<{
      __typename: "StaffShareLinkFile";
      id: string;
      personalFile: {
        __typename: "PersonalFile";
        id: string;
        file: string;
        mimeType: string;
        description: string | null;
        userId: string;
        read: boolean;
        personalFileTypeId: string | null;
        pubDate: string;
        insertedAt: string;
        updatedAt: string;
        fileType: {
          __typename: "PersonalFileType";
          id: string;
          name: string;
          required: boolean;
          category: string;
        } | null;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        };
        editor: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        };
      };
    }>;
  };
};

export type SendStaffShareLinkMutationVariables = Exact<{
  customerId: string;
  id: string;
  recipient: StaffShareLinkSendInput;
}>;

export type SendStaffShareLinkMutation = {
  __typename: "MutationRoot";
  sendStaffShareLink: {
    __typename: "StaffShareLink";
    id: string;
    customerId: string;
    shareId: string;
    validForDays: number;
    note: string | null;
    insertedAt: string;
    updatedAt: string;
    files: Array<{
      __typename: "StaffShareLinkFile";
      id: string;
      personalFile: {
        __typename: "PersonalFile";
        id: string;
        file: string;
        mimeType: string;
        description: string | null;
        userId: string;
        read: boolean;
        personalFileTypeId: string | null;
        pubDate: string;
        insertedAt: string;
        updatedAt: string;
        fileType: {
          __typename: "PersonalFileType";
          id: string;
          name: string;
          required: boolean;
          category: string;
        } | null;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        };
        editor: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        };
      };
    }>;
  };
};

export type SickNoteFragment = {
  __typename: "SickNote";
  id: string;
  customerId: string;
  userId: string;
  status: SickNoteStatus;
  starts: string;
  ends: string;
  hasSickCertificate: boolean;
  childSick: boolean;
  payment: boolean;
  sickCertificateType: SickNoteCertificateType | null;
  voucherType: SickNoteVoucherType | null;
  filename: string | null;
  insertedAt: string;
  updatedAt: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type SickNotesQueryVariables = Exact<{
  customerId: string;
  filters?: SickNoteListFilters | null | undefined;
}>;

export type SickNotesQuery = {
  __typename: "QueryRoot";
  sickNotes: Array<{
    __typename: "SickNote";
    id: string;
    customerId: string;
    userId: string;
    status: SickNoteStatus;
    starts: string;
    ends: string;
    hasSickCertificate: boolean;
    childSick: boolean;
    payment: boolean;
    sickCertificateType: SickNoteCertificateType | null;
    voucherType: SickNoteVoucherType | null;
    filename: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountSickNotesQueryVariables = Exact<{
  customerId: string;
  filters?: SickNoteListFilters | null | undefined;
}>;

export type CountSickNotesQuery = {
  __typename: "QueryRoot";
  countSickNotes: string;
};

export type SickNoteQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type SickNoteQuery = {
  __typename: "QueryRoot";
  sickNote: {
    __typename: "SickNote";
    id: string;
    customerId: string;
    userId: string;
    status: SickNoteStatus;
    starts: string;
    ends: string;
    hasSickCertificate: boolean;
    childSick: boolean;
    payment: boolean;
    sickCertificateType: SickNoteCertificateType | null;
    voucherType: SickNoteVoucherType | null;
    filename: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type SickNoteNeedsCertificateQueryVariables = Exact<{
  customerId: string;
  userId: string;
  starts: string;
  childSick: boolean;
}>;

export type SickNoteNeedsCertificateQuery = {
  __typename: "QueryRoot";
  sickNoteNeedsCertificate: boolean;
};

export type SickNoteNoPaymentCandidateQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type SickNoteNoPaymentCandidateQuery = {
  __typename: "QueryRoot";
  sickNoteNoPaymentCandidate: boolean;
};

export type MutateSickNoteMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: SickNoteInput;
}>;

export type MutateSickNoteMutation = {
  __typename: "MutationRoot";
  mutateSickNote: {
    __typename: "SickNote";
    id: string;
    customerId: string;
    userId: string;
    status: SickNoteStatus;
    starts: string;
    ends: string;
    hasSickCertificate: boolean;
    childSick: boolean;
    payment: boolean;
    sickCertificateType: SickNoteCertificateType | null;
    voucherType: SickNoteVoucherType | null;
    filename: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteSickNoteMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteSickNoteMutation = {
  __typename: "MutationRoot";
  deleteSickNote: { __typename: "SickNote"; id: string };
};

export type ConfirmSickNoteMutationVariables = Exact<{
  customerId: string;
  id: string;
  payment: boolean;
}>;

export type ConfirmSickNoteMutation = {
  __typename: "MutationRoot";
  confirmSickNote: {
    __typename: "SickNote";
    id: string;
    customerId: string;
    userId: string;
    status: SickNoteStatus;
    starts: string;
    ends: string;
    hasSickCertificate: boolean;
    childSick: boolean;
    payment: boolean;
    sickCertificateType: SickNoteCertificateType | null;
    voucherType: SickNoteVoucherType | null;
    filename: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeclineSickNoteMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeclineSickNoteMutation = {
  __typename: "MutationRoot";
  declineSickNote: {
    __typename: "SickNote";
    id: string;
    customerId: string;
    userId: string;
    status: SickNoteStatus;
    starts: string;
    ends: string;
    hasSickCertificate: boolean;
    childSick: boolean;
    payment: boolean;
    sickCertificateType: SickNoteCertificateType | null;
    voucherType: SickNoteVoucherType | null;
    filename: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type WorktimesSupervisorQueryVariables = Exact<{
  customerId: string;
  filters: SupervisorFilters;
}>;

export type WorktimesSupervisorQuery = {
  __typename: "QueryRoot";
  worktimesSupervisor: Array<{
    __typename: "WorktimesSuperviseRow";
    userId: string;
    taskId: string;
    starts: string;
    dayStart: string | null;
    stops: string | null;
    worktime: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    task: {
      __typename: "WorktimesTask";
      id: string;
      name: string;
      type: WorktimesTaskType;
    };
  }>;
};

export type StaffAbsenceOverviewQueryVariables = Exact<{
  customerId: string;
  year: number;
  filters?: StaffAbsenceOverviewFilters | null | undefined;
}>;

export type StaffAbsenceOverviewQuery = {
  __typename: "QueryRoot";
  staffAbsenceOverview: Array<{
    __typename: "StaffAbsenceOverview";
    userId: string;
    yearSickTotal: number;
    yearAbsentWoPermission: number;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    months: Array<{
      __typename: "StaffAbsenceMonth";
      month: number;
      sickTotal: number;
      absentWoPermission: number;
    }>;
  }>;
};

export type ProductiveHourGoalFragment = {
  __typename: "ProductiveHourGoal";
  id: string;
  customerId: string;
  projectId: string | null;
  wantedHours: number;
  period: ProductiveHourGoalPeriod;
  startDate: string;
  endDate: string | null;
};

export type ProductiveHourGoalsQueryVariables = Exact<{
  customerId: string;
  filters?: ProductiveHourGoalListOptions | null | undefined;
}>;

export type ProductiveHourGoalsQuery = {
  __typename: "QueryRoot";
  productiveHourGoals: Array<{
    __typename: "ProductiveHourGoal";
    id: string;
    customerId: string;
    projectId: string | null;
    wantedHours: number;
    period: ProductiveHourGoalPeriod;
    startDate: string;
    endDate: string | null;
  }>;
};

export type CountProductiveHourGoalsQueryVariables = Exact<{
  customerId: string;
  filters?: ProductiveHourGoalListOptions | null | undefined;
}>;

export type CountProductiveHourGoalsQuery = {
  __typename: "QueryRoot";
  countProductiveHourGoals: string;
};

export type ProductiveHourGoalQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ProductiveHourGoalQuery = {
  __typename: "QueryRoot";
  productiveHourGoal: {
    __typename: "ProductiveHourGoal";
    id: string;
    customerId: string;
    projectId: string | null;
    wantedHours: number;
    period: ProductiveHourGoalPeriod;
    startDate: string;
    endDate: string | null;
  } | null;
};

export type ProductiveHourGoalPeriodValidQueryVariables = Exact<{
  customerId: string;
  values: ProductiveHourGoalValidationInput;
}>;

export type ProductiveHourGoalPeriodValidQuery = {
  __typename: "QueryRoot";
  productiveHourGoalPeriodValid: {
    __typename: "ProductiveHourGoalValidation";
    valid: boolean;
    goals: Array<{
      __typename: "ProductiveHourGoal";
      id: string;
      customerId: string;
      projectId: string | null;
      wantedHours: number;
      period: ProductiveHourGoalPeriod;
      startDate: string;
      endDate: string | null;
    }>;
  };
};

export type MutateProductiveHourGoalMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: ProductiveHourGoalInput;
}>;

export type MutateProductiveHourGoalMutation = {
  __typename: "MutationRoot";
  mutateProductiveHourGoal: {
    __typename: "ProductiveHourGoal";
    id: string;
    customerId: string;
    projectId: string | null;
    wantedHours: number;
    period: ProductiveHourGoalPeriod;
    startDate: string;
    endDate: string | null;
  };
};

export type MutateFteGoalMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  values: FteGoalInput;
}>;

export type MutateFteGoalMutation = {
  __typename: "MutationRoot";
  mutateFteGoal: {
    __typename: "FteGoal";
    id: string;
    teamId: string;
    wantedFte: number;
    date: string;
  };
};

export type MutateStaffHistoryMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: StaffHistoryInput;
}>;

export type MutateStaffHistoryMutation = {
  __typename: "MutationRoot";
  mutateStaffHistory: {
    __typename: "StaffHistory";
    id: string;
    htype: StaffHistoryType;
    text: string;
    date: string;
    nextTalk: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteStaffHistoryMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteStaffHistoryMutation = {
  __typename: "MutationRoot";
  deleteStaffHistory: {
    __typename: "StaffHistory";
    id: string;
    htype: StaffHistoryType;
    text: string;
    date: string;
    nextTalk: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type StaffHistoriesQueryVariables = Exact<{
  customerId: string;
  filters?: StaffHistoriesListOptions | null | undefined;
}>;

export type StaffHistoriesQuery = {
  __typename: "QueryRoot";
  staffHistories: Array<{
    __typename: "StaffHistory";
    id: string;
    htype: StaffHistoryType;
    text: string;
    date: string;
    nextTalk: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountStaffHistoriesQueryVariables = Exact<{
  customerId: string;
  filters?: StaffHistoriesListOptions | null | undefined;
}>;

export type CountStaffHistoriesQuery = {
  __typename: "QueryRoot";
  countStaffHistories: string;
};

export type StaffHistoryQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type StaffHistoryQuery = {
  __typename: "QueryRoot";
  staffHistory: {
    __typename: "StaffHistory";
    id: string;
    htype: StaffHistoryType;
    text: string;
    date: string;
    nextTalk: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type ProjectStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  type: string;
  args?: Record<string, unknown> | null | undefined;
  filters?: ProjectStatsFilters | null | undefined;
}>;

export type ProjectStatsQuery = {
  __typename: "QueryRoot";
  projectStats: Record<string, unknown>;
};

export type WorkerStatsQueryVariables = Exact<{
  customerId: string;
  projectId?: string | null | undefined;
  filters: WorkerStatsFilters;
}>;

export type WorkerStatsQuery = {
  __typename: "QueryRoot";
  workerStats: Record<string, unknown>;
};

export type DataPoolStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: DataPoolStatsFilters | null | undefined;
}>;

export type DataPoolStatsQuery = {
  __typename: "QueryRoot";
  dataPoolStats: Array<{
    __typename: "ContactDataPoolStatsRow";
    groupName: string | null;
    statusName: string | null;
    cnt: number;
  }>;
};

export type DataPoolByProjectStatsQueryVariables = Exact<{
  customerId: string;
}>;

export type DataPoolByProjectStatsQuery = {
  __typename: "QueryRoot";
  dataPoolByProjectStats: Array<{
    __typename: "ContactDataPoolByProjectStatsRow";
    count: number;
    status: {
      __typename: "ContactStatus";
      id: string;
      name: string;
      position: number;
    } | null;
    project: { __typename: "MinimalProject"; id: string; name: string };
  }>;
};

export type TicketStatsQueryVariables = Exact<{
  start: string;
  stop: string;
}>;

export type TicketStatsQuery = {
  __typename: "QueryRoot";
  ticketStats: {
    __typename: "TicketStats";
    byCustomer: Array<{
      __typename: "TicketStatsByCustomer";
      effort: number;
      cnt: number;
      customer: {
        __typename: "MinimalCustomer";
        id: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      };
    }>;
    byOwner: Array<{
      __typename: "TicketStatsByUser";
      effort: number;
      cnt: number;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
    byReporter: Array<{
      __typename: "TicketStatsByUser";
      effort: number;
      cnt: number;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
    byCategory: Array<{
      __typename: "TicketStatsByCategory";
      effort: number;
      cnt: number;
      category: string;
    }>;
    bySolution: Array<{
      __typename: "TicketStatsBySolution";
      effort: number;
      cnt: number;
      solution: string;
    }>;
  };
};

export type HotseatStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters: HotseatStatsFilters;
}>;

export type HotseatStatsQuery = {
  __typename: "QueryRoot";
  hotseatStats: {
    __typename: "HotseatStatsResult";
    catsByUser: Record<string, unknown>;
    subCatsByCat: Record<string, unknown>;
    cats: Array<{ __typename: "CategoryRow"; category: string; cnt: number }>;
  };
};

export type RecruitingContactsCreatedQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters: DashboardStatsFilters;
}>;

export type RecruitingContactsCreatedQuery = {
  __typename: "QueryRoot";
  recruitingContactsCreated: Record<string, unknown>;
};

export type AppointmentStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters: AppointmentStatsFilters;
}>;

export type AppointmentStatsQuery = {
  __typename: "QueryRoot";
  appointmentStats: {
    __typename: "AppointmentStatsResult";
    created: Array<{
      __typename: "CreatedRow";
      userId: string;
      created: number;
      cleared: number;
      storno: number;
      shifted: number;
      notTookPlace: number;
    }>;
    feedbacks: Array<{
      __typename: "FeedbackRow";
      userId: string;
      new: number;
      shifted: number;
      missing: number;
    }>;
  };
};

export type ProductiveHourOverviewStatsQueryVariables = Exact<{
  customerId: string;
  starts: string;
  stops: string;
}>;

export type ProductiveHourOverviewStatsQuery = {
  __typename: "QueryRoot";
  productiveHourOverviewStats: {
    __typename: "ProductiveHourStatsOverview";
    wantedHours: number;
    paidHours: number;
    forecastedProductiveHours: number;
    forecastedPaidHours: number;
    productiveHours: number;
    adminHours: number;
    holidayHoursApproved: number;
    holidayHoursPending: number;
    sickHours: number;
  };
};

export type ProductiveHourStatsQueryVariables = Exact<{
  customerId: string;
  starts: string;
  stops: string;
}>;

export type ProductiveHourStatsQuery = {
  __typename: "QueryRoot";
  productiveHourStats: Array<{
    __typename: "ProductiveHourStatsUserRow";
    userId: string;
    wantedHours: number;
    paidHours: number;
    forecastedPaidHours: number;
    productiveHours: number;
    adminHours: number;
    holidayHoursApproved: number;
    holidayHoursPending: number;
    sickHours: number;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type SickDaysStatsQueryVariables = Exact<{
  starts: string;
  stops: string;
}>;

export type SickDaysStatsQuery = {
  __typename: "QueryRoot";
  sickDaysStats: {
    __typename: "SickDaysStats";
    total: {
      __typename: "SickDaysReportRow";
      activeUsers: number;
      sickUsers: number;
      sickDays: number;
    };
    perCustomer: Array<{
      __typename: "SickDaysReportRow";
      customerId: number | null;
      activeUsers: number;
      sickUsers: number;
      sickDays: number;
      customer: {
        __typename: "MinimalCustomer";
        id: string;
        name: string;
        logo: {
          __typename: "CustomerLogo";
          thumb: string;
          medium: string;
          original: string;
        };
      } | null;
    }>;
  };
};

export type TaskQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type TaskQuery = {
  __typename: "QueryRoot";
  task: {
    __typename: "Task";
    id: string;
    contactType: string;
    type: TaskType;
    questionnaireType: string | null;
    attrs: Record<string, unknown>;
    reactionNeeded: boolean;
    description: string | null;
    sent: boolean;
    insertedAt: string;
    updatedAt: string;
    contactId: string | null;
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      isCompany: boolean;
      statusId: string | null;
      attrs: Record<string, unknown>;
      primaryAddress: {
        __typename: "ContactAddress";
        id: string;
        atype: ContactAddressType;
        description: string | null;
        address: string | null;
        zip: string | null;
        city: string | null;
        cityPart: string | null;
        country: string | null;
      } | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        itype: ContactInfoType;
        value: string | null;
        confirmedAt: string | null;
      }>;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type QuestionnaireTaskQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  questionnaireType: string;
}>;

export type QuestionnaireTaskQuery = {
  __typename: "QueryRoot";
  questionnaireTask: {
    __typename: "Task";
    id: string;
    contactType: string;
    type: TaskType;
    questionnaireType: string | null;
    attrs: Record<string, unknown>;
    reactionNeeded: boolean;
    description: string | null;
    sent: boolean;
    insertedAt: string;
    updatedAt: string;
    contactId: string | null;
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      isCompany: boolean;
      statusId: string | null;
      attrs: Record<string, unknown>;
      primaryAddress: {
        __typename: "ContactAddress";
        id: string;
        atype: ContactAddressType;
        description: string | null;
        address: string | null;
        zip: string | null;
        city: string | null;
        cityPart: string | null;
        country: string | null;
      } | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        itype: ContactInfoType;
        value: string | null;
        confirmedAt: string | null;
      }>;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateTaskMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: TaskInput;
}>;

export type MutateTaskMutation = {
  __typename: "MutationRoot";
  mutateTask: {
    __typename: "Task";
    id: string;
    contactType: string;
    type: TaskType;
    questionnaireType: string | null;
    attrs: Record<string, unknown>;
    reactionNeeded: boolean;
    description: string | null;
    sent: boolean;
    insertedAt: string;
    updatedAt: string;
    contactId: string | null;
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      isCompany: boolean;
      statusId: string | null;
      attrs: Record<string, unknown>;
      primaryAddress: {
        __typename: "ContactAddress";
        id: string;
        atype: ContactAddressType;
        description: string | null;
        address: string | null;
        zip: string | null;
        city: string | null;
        cityPart: string | null;
        country: string | null;
      } | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        itype: ContactInfoType;
        value: string | null;
        confirmedAt: string | null;
      }>;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type TasksQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TaskListFilters | null | undefined;
}>;

export type TasksQuery = {
  __typename: "QueryRoot";
  tasks: Array<{
    __typename: "Task";
    id: string;
    contactType: string;
    type: TaskType;
    questionnaireType: string | null;
    attrs: Record<string, unknown>;
    reactionNeeded: boolean;
    description: string | null;
    sent: boolean;
    accepted: boolean | null;
    reason: string | null;
    points: number;
    wantedPoints: number;
    insertedAt: string;
    updatedAt: string;
    contactId: string | null;
    creatorId: string;
    editorId: string;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountTasksQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TaskListFilters | null | undefined;
}>;

export type CountTasksQuery = { __typename: "QueryRoot"; countTasks: string };

export type DeleteTaskMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteTaskMutation = {
  __typename: "MutationRoot";
  deleteTask: { __typename: "Task"; id: string };
};

export type SendTaskMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type SendTaskMutation = {
  __typename: "MutationRoot";
  sendTask: {
    __typename: "Task";
    id: string;
    contactType: string;
    type: TaskType;
    questionnaireType: string | null;
    attrs: Record<string, unknown>;
    reactionNeeded: boolean;
    description: string | null;
    sent: boolean;
    accepted: boolean | null;
    reason: string | null;
    points: number;
    wantedPoints: number;
    insertedAt: string;
    updatedAt: string;
    contactId: string | null;
    creatorId: string;
    editorId: string;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      companyName: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type TaskOffersQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TaskOfferListFilters | null | undefined;
}>;

export type TaskOffersQuery = {
  __typename: "QueryRoot";
  taskOffers: Array<{
    __typename: "TaskOffer";
    id: string;
    name: string;
    start: string;
    ends: string | null;
    products: Array<{
      __typename: "TaskProduct";
      id: string;
      name: string;
      price: number;
    }>;
  }>;
};

export type CountTaskOffersQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TaskOfferListFilters | null | undefined;
}>;

export type CountTaskOffersQuery = {
  __typename: "QueryRoot";
  countTaskOffers: string;
};

export type TaskOfferQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type TaskOfferQuery = {
  __typename: "QueryRoot";
  taskOffer: {
    __typename: "TaskOffer";
    id: string;
    name: string;
    start: string;
    ends: string | null;
    products: Array<{
      __typename: "TaskProduct";
      id: string;
      name: string;
      price: number;
    }>;
  } | null;
};

export type MutateTaskOfferMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: TaskOfferInput;
}>;

export type MutateTaskOfferMutation = {
  __typename: "MutationRoot";
  mutateTaskOffer: {
    __typename: "TaskOffer";
    id: string;
    name: string;
    start: string;
    ends: string | null;
  };
};

export type DeleteTaskOfferMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteTaskOfferMutation = {
  __typename: "MutationRoot";
  deleteTaskOffer: { __typename: "TaskOffer"; id: string };
};

export type TaskProductsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TaskProductListFilters | null | undefined;
}>;

export type TaskProductsQuery = {
  __typename: "QueryRoot";
  taskProducts: Array<{
    __typename: "TaskProduct";
    id: string;
    name: string;
    price: number;
  }>;
};

export type TaskProductQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type TaskProductQuery = {
  __typename: "QueryRoot";
  taskProduct: {
    __typename: "TaskProduct";
    id: string;
    name: string;
    price: number;
    offer: {
      __typename: "TaskOffer";
      id: string;
      name: string;
      start: string;
      ends: string | null;
    };
  } | null;
};

export type MutateTaskProductMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  offerId: string;
  id?: string | null | undefined;
  values: TaskProductInput;
}>;

export type MutateTaskProductMutation = {
  __typename: "MutationRoot";
  mutateTaskProduct: {
    __typename: "TaskProduct";
    id: string;
    name: string;
    price: number;
  };
};

export type DeleteTaskProductMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteTaskProductMutation = {
  __typename: "MutationRoot";
  deleteTaskProduct: { __typename: "TaskProduct"; id: string };
};

export type ExportTasksMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TaskListFilters | null | undefined;
  fields: Array<string> | string;
  fieldNames: Array<string> | string;
}>;

export type ExportTasksMutation = {
  __typename: "MutationRoot";
  exportTasks: { __typename: "JobResult"; id: string };
};

export type RecalculateTaskPointsMutationVariables = Exact<{
  starts: string;
  stops: string;
}>;

export type RecalculateTaskPointsMutation = {
  __typename: "MutationRoot";
  recalculateTaskPoints: { __typename: "JobResult"; id: string };
};

export type TasksByHourStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  field: TaskStatsField;
  filters: TaskStatsFilters;
}>;

export type TasksByHourStatsQuery = {
  __typename: "QueryRoot";
  tasksByHourStats: Array<{
    __typename: "TaskStatsRow";
    hour: string;
    val: string | null;
    cnt: number;
  }>;
};

export type TasksAttrStatsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  attr: string;
  filters: TaskAttrStatsFilters;
}>;

export type TasksAttrStatsQuery = {
  __typename: "QueryRoot";
  tasksAttrStats: Record<string, unknown>;
};

export type TeamsQueryVariables = Exact<{
  customerId: string;
  projectId?: string | null | undefined;
  filters?: TeamsListFilters | null | undefined;
}>;

export type TeamsQuery = {
  __typename: "QueryRoot";
  teams: Array<{
    __typename: "Team";
    id: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    };
  }>;
};

export type CountTeamsQueryVariables = Exact<{
  customerId: string;
  projectId?: string | null | undefined;
}>;

export type CountTeamsQuery = { __typename: "QueryRoot"; countTeams: string };

export type TeamsWithUsersQueryVariables = Exact<{
  customerId: string;
  projectId?: string | null | undefined;
}>;

export type TeamsWithUsersQuery = {
  __typename: "QueryRoot";
  teams: Array<{
    __typename: "Team";
    id: string;
    name: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  }>;
};

export type TeamsWithUsersAndForeignUsersQueryVariables = Exact<{
  customerId: string;
  projectId?: string | null | undefined;
}>;

export type TeamsWithUsersAndForeignUsersQuery = {
  __typename: "QueryRoot";
  teams: Array<{
    __typename: "Team";
    id: string;
    name: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    foreignUsers: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  }>;
};

export type CopyTeamMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  teamId: string;
  name: string;
}>;

export type CopyTeamMutation = {
  __typename: "MutationRoot";
  copyTeam: {
    __typename: "Team";
    id: string;
    name: string;
    insertedAt: string;
    updatedAt: string;
    project: {
      __typename: "MinimalProject";
      id: string;
      name: string;
      identifier: string;
    };
  };
};

export type DeleteTeamMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteTeamMutation = {
  __typename: "MutationRoot";
  deleteTeam: { __typename: "Team"; id: string };
};

export type IsTeamLeaderQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  userId?: string | null | undefined;
  userIds?: Array<string> | string | null | undefined;
}>;

export type IsTeamLeaderQuery = {
  __typename: "QueryRoot";
  isTeamLeader: boolean;
};

export type RecruitingTeamOverviewQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  date: string;
}>;

export type RecruitingTeamOverviewQuery = {
  __typename: "QueryRoot";
  recruitingTeamOverview: Array<{
    __typename: "RecruitingSummary";
    name: string;
    teamId: string;
    wanted: number;
    planned: number;
    employed: number;
  }>;
};

export type TeamQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type TeamQuery = {
  __typename: "QueryRoot";
  team: {
    __typename: "Team";
    id: string;
    name: string;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    leaders: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    foreignUsers: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    foreignLeaders: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  } | null;
};

export type MutateTeamMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  team: TeamInput;
}>;

export type MutateTeamMutation = {
  __typename: "MutationRoot";
  mutateTeam: {
    __typename: "Team";
    id: string;
    name: string;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    users: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    leaders: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    foreignUsers: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
    foreignLeaders: Array<{
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    }>;
  };
};

export type TeamsForCustomersQueryVariables = Exact<{
  customerIds: Array<string> | string;
}>;

export type TeamsForCustomersQuery = {
  __typename: "QueryRoot";
  teamsForCustomers: Array<{
    __typename: "Team";
    id: string;
    name: string;
    customer: { __typename: "MinimalCustomer"; id: string; name: string };
    project: { __typename: "MinimalProject"; id: string; name: string };
  }>;
};

export type TermitelContractsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
}>;

export type TermitelContractsQuery = {
  __typename: "QueryRoot";
  termitelContracts: Array<{
    __typename: "TermitelContract";
    id: string;
    contactId: string;
    starts: string;
    ends: string | null;
    contract: TermitelContractFileStatus;
    orderDataProcessing: TermitelContractFileStatus;
    letterOfIndemnity: TermitelContractFileStatus;
    runtime: number | null;
    runtimeType: TermitelContractRuntimeType;
    noticePeriod: number | null;
    noticePeriodType: TermitelContractNoticePeriodType;
    paymentGoal: number | null;
    paymentGoalType: TermitelContractPaymentGoalType;
    deletionPeriod: number | null;
    deletionPeriodType: TermitelContractDeletionPeriodType;
    insertedAt: string;
    updatedAt: string;
    nextPossibleTermination: string | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    documents: Array<{
      __typename: "TermitelContractAttachment";
      id: string;
      contractId: string;
      documentType: TermitelContractDocumentType;
      filename: string;
      insertedAt: string;
      updatedAt: string;
    }>;
    contact: { __typename: "Contact"; id: string; displayName: string };
  }>;
};

export type TermitelContractOverviewQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type TermitelContractOverviewQuery = {
  __typename: "QueryRoot";
  termitelContractOverview: Array<{
    __typename: "TermitelContract";
    id: string;
    contactId: string;
    starts: string;
    ends: string | null;
    contract: TermitelContractFileStatus;
    orderDataProcessing: TermitelContractFileStatus;
    letterOfIndemnity: TermitelContractFileStatus;
    runtime: number | null;
    runtimeType: TermitelContractRuntimeType;
    noticePeriod: number | null;
    noticePeriodType: TermitelContractNoticePeriodType;
    paymentGoal: number | null;
    paymentGoalType: TermitelContractPaymentGoalType;
    deletionPeriod: number | null;
    deletionPeriodType: TermitelContractDeletionPeriodType;
    insertedAt: string;
    updatedAt: string;
    nextPossibleTermination: string | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    documents: Array<{
      __typename: "TermitelContractAttachment";
      id: string;
      contractId: string;
      documentType: TermitelContractDocumentType;
      filename: string;
      insertedAt: string;
      updatedAt: string;
    }>;
    contact: { __typename: "Contact"; id: string; displayName: string };
  }>;
};

export type MutateTermitelContractMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  id?: string | null | undefined;
  values: TermitelContractInput;
}>;

export type MutateTermitelContractMutation = {
  __typename: "MutationRoot";
  mutateTermitelContract: {
    __typename: "TermitelContract";
    id: string;
    contactId: string;
    starts: string;
    ends: string | null;
    contract: TermitelContractFileStatus;
    orderDataProcessing: TermitelContractFileStatus;
    letterOfIndemnity: TermitelContractFileStatus;
    runtime: number | null;
    runtimeType: TermitelContractRuntimeType;
    noticePeriod: number | null;
    noticePeriodType: TermitelContractNoticePeriodType;
    paymentGoal: number | null;
    paymentGoalType: TermitelContractPaymentGoalType;
    deletionPeriod: number | null;
    deletionPeriodType: TermitelContractDeletionPeriodType;
    insertedAt: string;
    updatedAt: string;
    nextPossibleTermination: string | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    documents: Array<{
      __typename: "TermitelContractAttachment";
      id: string;
      contractId: string;
      documentType: TermitelContractDocumentType;
      filename: string;
      insertedAt: string;
      updatedAt: string;
    }>;
    contact: { __typename: "Contact"; id: string; displayName: string };
  };
};

export type DeleteTermitelContractMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  id: string;
}>;

export type DeleteTermitelContractMutation = {
  __typename: "MutationRoot";
  deleteTermitelContract: {
    __typename: "TermitelContract";
    id: string;
    contactId: string;
    starts: string;
    ends: string | null;
    contract: TermitelContractFileStatus;
    orderDataProcessing: TermitelContractFileStatus;
    letterOfIndemnity: TermitelContractFileStatus;
    runtime: number | null;
    runtimeType: TermitelContractRuntimeType;
    noticePeriod: number | null;
    noticePeriodType: TermitelContractNoticePeriodType;
    paymentGoal: number | null;
    paymentGoalType: TermitelContractPaymentGoalType;
    deletionPeriod: number | null;
    deletionPeriodType: TermitelContractDeletionPeriodType;
    insertedAt: string;
    updatedAt: string;
    nextPossibleTermination: string | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    documents: Array<{
      __typename: "TermitelContractAttachment";
      id: string;
      contractId: string;
      documentType: TermitelContractDocumentType;
      filename: string;
      insertedAt: string;
      updatedAt: string;
    }>;
    contact: { __typename: "Contact"; id: string; displayName: string };
  };
};

export type AttachTermitelContractDocumentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  id: string;
  values: TermitelContractAttachmentInput;
}>;

export type AttachTermitelContractDocumentMutation = {
  __typename: "MutationRoot";
  attachTermitelContractDocument: {
    __typename: "TermitelContractAttachment";
    id: string;
    contractId: string;
    documentType: TermitelContractDocumentType;
    filename: string;
    insertedAt: string;
    updatedAt: string;
  };
};

export type DeleteTermitelContractDocumentMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  contactId: string;
  contractId: string;
  id: string;
}>;

export type DeleteTermitelContractDocumentMutation = {
  __typename: "MutationRoot";
  deleteTermitelContractDocument: {
    __typename: "TermitelContractAttachment";
    id: string;
  };
};

export type TicketsQueryVariables = Exact<{
  filters?: TicketListFilters | null | undefined;
}>;

export type TicketsQuery = {
  __typename: "QueryRoot";
  tickets: Array<{
    __typename: "Ticket";
    id: string;
    priority: number | null;
    subject: string;
    description: string | null;
    status: TicketState;
    url: string | null;
    category: TicketCategory | null;
    forecastedEffort: number | null;
    realEffort: number;
    solution: TicketSolution | null;
    attrs: Record<string, unknown>;
    document: Record<string, unknown>;
    mdContent: string;
    visible: boolean | null;
    doneAt: string | null;
    dueDate: string | null;
    insertedAt: string;
    updatedAt: string;
    reporterId: string | null;
    ownerId: string | null;
    orderedById: string | null;
    nextStepById: string | null;
    relevantCustomerId: string | null;
    relevantProjectId: string | null;
    reporter: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    orderedBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    nextStepBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    relevantCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
    } | null;
  }>;
};

export type CountTicketsQueryVariables = Exact<{
  filters?: TicketCountFilters | null | undefined;
}>;

export type CountTicketsQuery = {
  __typename: "QueryRoot";
  countTickets: string;
};

export type TicketQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type TicketQuery = {
  __typename: "QueryRoot";
  ticket: {
    __typename: "Ticket";
    subscribed: boolean;
    id: string;
    priority: number | null;
    subject: string;
    description: string | null;
    status: TicketState;
    url: string | null;
    category: TicketCategory | null;
    forecastedEffort: number | null;
    realEffort: number;
    solution: TicketSolution | null;
    attrs: Record<string, unknown>;
    document: Record<string, unknown>;
    mdContent: string;
    visible: boolean | null;
    doneAt: string | null;
    dueDate: string | null;
    insertedAt: string;
    updatedAt: string;
    reporterId: string | null;
    ownerId: string | null;
    orderedById: string | null;
    nextStepById: string | null;
    relevantCustomerId: string | null;
    relevantProjectId: string | null;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      identifier: string;
      name: string;
    } | null;
    reporter: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    orderedBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    nextStepBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    relevantCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
    } | null;
  } | null;
};

export type DeleteTicketMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteTicketMutation = {
  __typename: "MutationRoot";
  deleteTicket: { __typename: "Ticket"; id: string };
};

export type MutateTicketMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: TicketInput;
}>;

export type MutateTicketMutation = {
  __typename: "MutationRoot";
  mutateTicket: {
    __typename: "Ticket";
    id: string;
    priority: number | null;
    subject: string;
    description: string | null;
    status: TicketState;
    url: string | null;
    category: TicketCategory | null;
    forecastedEffort: number | null;
    realEffort: number;
    solution: TicketSolution | null;
    attrs: Record<string, unknown>;
    document: Record<string, unknown>;
    mdContent: string;
    visible: boolean | null;
    doneAt: string | null;
    dueDate: string | null;
    insertedAt: string;
    updatedAt: string;
    reporterId: string | null;
    ownerId: string | null;
    orderedById: string | null;
    nextStepById: string | null;
    relevantCustomerId: string | null;
    relevantProjectId: string | null;
    reporter: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    orderedBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    nextStepBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    relevantCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
    } | null;
  };
};

export type OrderTicketMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type OrderTicketMutation = {
  __typename: "MutationRoot";
  orderTicket: {
    __typename: "Ticket";
    id: string;
    priority: number | null;
    subject: string;
    description: string | null;
    status: TicketState;
    url: string | null;
    category: TicketCategory | null;
    forecastedEffort: number | null;
    realEffort: number;
    solution: TicketSolution | null;
    attrs: Record<string, unknown>;
    document: Record<string, unknown>;
    mdContent: string;
    visible: boolean | null;
    doneAt: string | null;
    dueDate: string | null;
    insertedAt: string;
    updatedAt: string;
    reporterId: string | null;
    ownerId: string | null;
    orderedById: string | null;
    nextStepById: string | null;
    relevantCustomerId: string | null;
    relevantProjectId: string | null;
    reporter: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    orderedBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    nextStepBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    relevantCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      identifier: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    relevantProject: {
      __typename: "MinimalProject";
      id: string;
      identifier: string;
      name: string;
    } | null;
  };
};

export type SubscribeTicketMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type SubscribeTicketMutation = {
  __typename: "MutationRoot";
  subscribeTicket: { __typename: "TicketWatcher"; ticketId: string };
};

export type UnsubscribeTicketMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type UnsubscribeTicketMutation = {
  __typename: "MutationRoot";
  unsubscribeTicket: { __typename: "TicketWatcher"; ticketId: string };
};

export type TicketTimelineQueryVariables = Exact<{
  customerId: string;
  ticketId: string;
}>;

export type TicketTimelineQuery = {
  __typename: "QueryRoot";
  ticketTimeline: Array<{
    __typename: "TicketTimelineEntry";
    id: string;
    type: TimelineEntryType;
    effort: number | null;
    content: string | null;
    file: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type MutateTicketTimelineEntryMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  ticketId: string;
  values: TicketTimelineEntryInput;
}>;

export type MutateTicketTimelineEntryMutation = {
  __typename: "MutationRoot";
  mutateTicketTimelineEntry: {
    __typename: "TicketTimelineEntry";
    id: string;
    type: TimelineEntryType;
    effort: number | null;
    content: string | null;
    file: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteTicketTimelineEntryMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteTicketTimelineEntryMutation = {
  __typename: "MutationRoot";
  deleteTicketTimelineEntry: {
    __typename: "TicketTimelineEntry";
    id: string;
    type: TimelineEntryType;
    effort: number | null;
    content: string | null;
    file: string | null;
    userId: string;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type TimesheetOverviewQueryVariables = Exact<{
  customerId: string;
  userId: string;
  start: string;
  stop: string;
}>;

export type TimesheetOverviewQuery = {
  __typename: "QueryRoot";
  timesheetOverview: {
    __typename: "TimesheetOverview";
    worktime: number;
    productive: number;
    sunday: number;
    feastday: number;
    feastdayOff: number;
    paidTime: number;
    homeoffice: number;
    unplannedHomeoffice: number;
    office: number;
    byType: Array<{
      __typename: "TimesheetOverviewByType";
      seconds: number;
      task: {
        __typename: "WorktimesTask";
        id: string;
        name: string;
        type: WorktimesTaskType;
        position: number;
      };
    }>;
  };
};

export type TimesheetPresencesQueryVariables = Exact<{
  customerId: string;
  userId: string;
  start: string;
  stop: string;
}>;

export type TimesheetPresencesQuery = {
  __typename: "QueryRoot";
  timesheetPresences: {
    __typename: "TimesheetPresences";
    vacationTaken: number;
    vacationEntitled: number;
    vacationPlanned: number;
    vacationInSpan: number;
    sickYear: number;
    childSickYear: number;
    sickInSpan: number;
    childSickInSpan: number;
    hoursWorked: number;
    absentWoPermission: number;
    expected: number;
    workedInSpan: number;
  };
};

export type TimesheetYearOverviewQueryVariables = Exact<{
  customerId: string;
  userId: string;
  year: number;
}>;

export type TimesheetYearOverviewQuery = {
  __typename: "QueryRoot";
  timesheetYearOverview: {
    __typename: "TimesheetYearOverview";
    homeoffice: number;
    unplannedHomeoffice: number;
    office: number;
    days: Array<{
      __typename: "TimesheetYearOverviewDay";
      date: string;
      type: string;
    }>;
  };
};

export type TodosQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TodoListFilters | null | undefined;
}>;

export type TodosQuery = {
  __typename: "QueryRoot";
  todos: Array<{
    __typename: "Todo";
    id: string;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    sent: boolean;
    status: Status | null;
    ownerId: string | null;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    creatorId: string;
    allDone: boolean;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    todos: Array<{
      __typename: "Todo";
      id: string;
      attrs: Record<string, unknown>;
      description: string;
      file: string | null;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
  }>;
};

export type TodosForContactsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TodoListFilters | null | undefined;
}>;

export type TodosForContactsQuery = {
  __typename: "QueryRoot";
  todos: Array<{
    __typename: "Todo";
    id: string;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    status: Status | null;
    statusAttrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type CountTodosQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TodoListFilters | null | undefined;
}>;

export type CountTodosQuery = { __typename: "QueryRoot"; countTodos: string };

export type TodoQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type TodoQuery = {
  __typename: "QueryRoot";
  todo: {
    __typename: "Todo";
    id: string;
    parentId: string | null;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    allDone: boolean;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    sent: boolean;
    status: Status | null;
    statusAssignedAt: string | null;
    statusAttrs: Record<string, unknown>;
    ownerId: string | null;
    contactId: string | null;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    todos: Array<{
      __typename: "Todo";
      id: string;
      parentId: string | null;
      attrs: Record<string, unknown>;
      description: string;
      file: string | null;
      done: boolean;
      doneAt: string | null;
      doneText: string | null;
      insertedAt: string;
      updatedAt: string;
      doneBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    notes: Array<{
      __typename: "TodoNote";
      id: string;
      text: string | null;
      file: string | null;
      insertedAt: string;
      todoId: string;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  } | null;
};

export type MutateTodoMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: TodoInput;
}>;

export type MutateTodoMutation = {
  __typename: "MutationRoot";
  mutateTodo: {
    __typename: "Todo";
    id: string;
    parentId: string | null;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    allDone: boolean;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    sent: boolean;
    status: Status | null;
    statusAssignedAt: string | null;
    statusAttrs: Record<string, unknown>;
    ownerId: string | null;
    contactId: string | null;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    todos: Array<{
      __typename: "Todo";
      id: string;
      parentId: string | null;
      attrs: Record<string, unknown>;
      description: string;
      file: string | null;
      done: boolean;
      doneAt: string | null;
      doneText: string | null;
      insertedAt: string;
      updatedAt: string;
      doneBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    notes: Array<{
      __typename: "TodoNote";
      id: string;
      text: string | null;
      file: string | null;
      insertedAt: string;
      todoId: string;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  };
};

export type SendTodoMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type SendTodoMutation = {
  __typename: "MutationRoot";
  sendTodo: {
    __typename: "Todo";
    id: string;
    parentId: string | null;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    allDone: boolean;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    sent: boolean;
    status: Status | null;
    statusAssignedAt: string | null;
    statusAttrs: Record<string, unknown>;
    ownerId: string | null;
    contactId: string | null;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    todos: Array<{
      __typename: "Todo";
      id: string;
      parentId: string | null;
      attrs: Record<string, unknown>;
      description: string;
      file: string | null;
      done: boolean;
      doneAt: string | null;
      doneText: string | null;
      insertedAt: string;
      updatedAt: string;
      doneBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    notes: Array<{
      __typename: "TodoNote";
      id: string;
      text: string | null;
      file: string | null;
      insertedAt: string;
      todoId: string;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  };
};

export type OwnTodoMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type OwnTodoMutation = {
  __typename: "MutationRoot";
  ownTodo: {
    __typename: "Todo";
    id: string;
    parentId: string | null;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    allDone: boolean;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    sent: boolean;
    status: Status | null;
    statusAssignedAt: string | null;
    statusAttrs: Record<string, unknown>;
    ownerId: string | null;
    contactId: string | null;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    todos: Array<{
      __typename: "Todo";
      id: string;
      parentId: string | null;
      attrs: Record<string, unknown>;
      description: string;
      file: string | null;
      done: boolean;
      doneAt: string | null;
      doneText: string | null;
      insertedAt: string;
      updatedAt: string;
      doneBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    notes: Array<{
      __typename: "TodoNote";
      id: string;
      text: string | null;
      file: string | null;
      insertedAt: string;
      todoId: string;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  };
};

export type DeleteTodoMutationVariables = Exact<{
  id: string;
  customerId: string;
  projectId: string;
}>;

export type DeleteTodoMutation = {
  __typename: "MutationRoot";
  deleteTodo: { __typename: "Todo"; id: string };
};

export type ArchiveTodoMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  values: ArchiveTodoInput;
}>;

export type ArchiveTodoMutation = {
  __typename: "MutationRoot";
  archiveTodo: {
    __typename: "Todo";
    id: string;
    parentId: string | null;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    allDone: boolean;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    sent: boolean;
    status: Status | null;
    statusAssignedAt: string | null;
    statusAttrs: Record<string, unknown>;
    ownerId: string | null;
    contactId: string | null;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    todos: Array<{
      __typename: "Todo";
      id: string;
      parentId: string | null;
      attrs: Record<string, unknown>;
      description: string;
      file: string | null;
      done: boolean;
      doneAt: string | null;
      doneText: string | null;
      insertedAt: string;
      updatedAt: string;
      doneBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    notes: Array<{
      __typename: "TodoNote";
      id: string;
      text: string | null;
      file: string | null;
      insertedAt: string;
      todoId: string;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  };
};

export type CreateTodoNoteMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  todoId: string;
  values: TodoNoteInput;
}>;

export type CreateTodoNoteMutation = {
  __typename: "MutationRoot";
  createTodoNote: {
    __typename: "TodoNote";
    id: string;
    todoId: string;
    text: string | null;
    file: string | null;
    insertedAt: string;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type AssignTodoMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  userId: string;
}>;

export type AssignTodoMutation = {
  __typename: "MutationRoot";
  assignTodo: {
    __typename: "Todo";
    id: string;
    parentId: string | null;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    allDone: boolean;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    sent: boolean;
    status: Status | null;
    statusAssignedAt: string | null;
    statusAttrs: Record<string, unknown>;
    ownerId: string | null;
    contactId: string | null;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    todos: Array<{
      __typename: "Todo";
      id: string;
      parentId: string | null;
      attrs: Record<string, unknown>;
      description: string;
      file: string | null;
      done: boolean;
      doneAt: string | null;
      doneText: string | null;
      insertedAt: string;
      updatedAt: string;
      doneBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    notes: Array<{
      __typename: "TodoNote";
      id: string;
      text: string | null;
      file: string | null;
      insertedAt: string;
      todoId: string;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  };
};

export type TodoEventsSubscriptionVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type TodoEventsSubscription = {
  __typename: "SubscriptionRoot";
  todoEvents: {
    __typename: "TodoEvent";
    todoId: string;
    todo: {
      __typename: "Todo";
      id: string;
      parentId: string | null;
      description: string;
      file: string | null;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
      allDone: boolean;
      done: boolean;
      doneAt: string | null;
      doneText: string | null;
      sent: boolean;
      status: Status | null;
      statusAssignedAt: string | null;
      statusAttrs: Record<string, unknown>;
      ownerId: string | null;
      contactId: string | null;
      creatorId: string;
      owner: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        attrs: Record<string, unknown>;
      } | null;
      doneBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
      editor: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
      todos: Array<{
        __typename: "Todo";
        id: string;
        parentId: string | null;
        attrs: Record<string, unknown>;
        description: string;
        file: string | null;
        done: boolean;
        doneAt: string | null;
        doneText: string | null;
        insertedAt: string;
        updatedAt: string;
        doneBy: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        } | null;
      }>;
      notes: Array<{
        __typename: "TodoNote";
        id: string;
        text: string | null;
        file: string | null;
        insertedAt: string;
        todoId: string;
        creator: {
          __typename: "User";
          id: string;
          username: string;
          email: string | null;
          active: boolean;
          retired: boolean;
          role: UserRole;
          homeoffice: boolean;
          bio: string | null;
          customerId: string;
          attrs: Record<string, unknown>;
          lastSeenAt: string | null;
          passwordReset: string | null;
          otp: boolean;
          billableCustomerId: string | null;
          defaultProjectId: string | null;
          avatar: {
            __typename: "UserAvatar";
            thumb: string;
            medium: string;
            original: string;
          };
          contact: {
            __typename: "Contact";
            id: string;
            firstname: string | null;
            lastname: string | null;
            displayName: string;
            companyName: string | null;
            birthdate: string | null;
          } | null;
        };
      }>;
    } | null;
  };
};

export type ExportTodosMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: TodoListFilters | null | undefined;
}>;

export type ExportTodosMutation = {
  __typename: "MutationRoot";
  exportTodos: { __typename: "JobResult"; id: string };
};

export type ConfirmTodoWithTokenMutationVariables = Exact<{
  token: string;
}>;

export type ConfirmTodoWithTokenMutation = {
  __typename: "MutationRoot";
  confirmTodoWithToken: {
    __typename: "Todo";
    id: string;
    parentId: string | null;
    description: string;
    file: string | null;
    attrs: Record<string, unknown>;
    insertedAt: string;
    updatedAt: string;
    allDone: boolean;
    done: boolean;
    doneAt: string | null;
    doneText: string | null;
    sent: boolean;
    status: Status | null;
    statusAssignedAt: string | null;
    statusAttrs: Record<string, unknown>;
    ownerId: string | null;
    contactId: string | null;
    creatorId: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      attrs: Record<string, unknown>;
    } | null;
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    todos: Array<{
      __typename: "Todo";
      id: string;
      parentId: string | null;
      attrs: Record<string, unknown>;
      description: string;
      file: string | null;
      done: boolean;
      doneAt: string | null;
      doneText: string | null;
      insertedAt: string;
      updatedAt: string;
      doneBy: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      } | null;
    }>;
    notes: Array<{
      __typename: "TodoNote";
      id: string;
      text: string | null;
      file: string | null;
      insertedAt: string;
      todoId: string;
      creator: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
    }>;
  };
};

export type TtDashboardContractsQueryVariables = Exact<{
  customerId: string;
}>;

export type TtDashboardContractsQuery = {
  __typename: "QueryRoot";
  ttDashboardContracts: Array<{
    __typename: "Contract";
    id: string;
    starts: string;
    ends: string | null;
    employee: { __typename: "Employee"; id: string } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type TtDashboardBirthdaysQueryVariables = Exact<{
  customerId: string;
}>;

export type TtDashboardBirthdaysQuery = {
  __typename: "QueryRoot";
  ttDashboardBirthdays: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
};

export type TtDashboardWorktimesQueryVariables = Exact<{
  customerId: string;
}>;

export type TtDashboardWorktimesQuery = {
  __typename: "QueryRoot";
  ttDashboardWorktimes: {
    __typename: "WorktimeInfos";
    worktime: number;
    sickDays: number;
    sunday: number;
    feastday: number;
    vacation: number;
    expected: number;
    expectedUntilYesterday: number;
  };
};

export type TtDashboardRosterQueryVariables = Exact<{
  customerId: string;
}>;

export type TtDashboardRosterQuery = {
  __typename: "QueryRoot";
  ttDashboardRoster: Array<{
    __typename: "DashboardRoster";
    start: string;
    stop: string;
    pause: string | null;
  }>;
};

export type TtDashboardProbationsQueryVariables = Exact<{
  customerId: string;
}>;

export type TtDashboardProbationsQuery = {
  __typename: "QueryRoot";
  ttDashboardProbations: Array<{
    __typename: "Employee";
    id: string;
    probationEnding: string | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type TtDashboardFileExchangeQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type TtDashboardFileExchangeQuery = {
  __typename: "QueryRoot";
  ttDashboardFileExchange: Array<{
    __typename: "FileExchangeEntry";
    id: string;
    filename: string;
    comment: string | null;
    status: FileExchangeStatus;
    customerId: string;
    projectId: string;
    ownerId: string;
    creatorId: string;
    insertedAt: string;
    updatedAt: string;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type UploadsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  filters?: ListProjectUploadsFilters | null | undefined;
}>;

export type UploadsQuery = {
  __typename: "QueryRoot";
  uploads: Array<{
    __typename: "ProjectUpload";
    id: string;
    file: string;
    comment: string | null;
    status: UploadStatus;
    message: string | null;
    imported: number | null;
    insertedAt: string;
    updatedAt: string;
    doneAt: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  }>;
};

export type CountUploadsQueryVariables = Exact<{
  customerId: string;
  projectId: string;
}>;

export type CountUploadsQuery = {
  __typename: "QueryRoot";
  countUploads: string;
};

export type UploadQueryVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type UploadQuery = {
  __typename: "QueryRoot";
  upload: {
    __typename: "ProjectUpload";
    id: string;
    file: string;
    comment: string | null;
    status: UploadStatus;
    message: string | null;
    imported: number | null;
    insertedAt: string;
    updatedAt: string;
    doneAt: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  } | null;
};

export type MutateUploadMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id?: string | null | undefined;
  values: ProjectUploadInput;
}>;

export type MutateUploadMutation = {
  __typename: "MutationRoot";
  mutateUpload: {
    __typename: "ProjectUpload";
    id: string;
    file: string;
    comment: string | null;
    status: UploadStatus;
    message: string | null;
    imported: number | null;
    insertedAt: string;
    updatedAt: string;
    doneAt: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type DeleteUploadMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
}>;

export type DeleteUploadMutation = {
  __typename: "MutationRoot";
  deleteUpload: {
    __typename: "ProjectUpload";
    id: string;
    file: string;
    comment: string | null;
    status: UploadStatus;
    message: string | null;
    imported: number | null;
    insertedAt: string;
    updatedAt: string;
    doneAt: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type MarkUploadDoneMutationVariables = Exact<{
  customerId: string;
  projectId: string;
  id: string;
  values: MarkUploadDoneInput;
}>;

export type MarkUploadDoneMutation = {
  __typename: "MutationRoot";
  markUploadDone: {
    __typename: "ProjectUpload";
    id: string;
    file: string;
    comment: string | null;
    status: UploadStatus;
    message: string | null;
    imported: number | null;
    insertedAt: string;
    updatedAt: string;
    doneAt: string | null;
    owner: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    doneBy: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    } | null;
  };
};

export type MutateSessionUserPasswordMutationVariables = Exact<{
  password: string;
}>;

export type MutateSessionUserPasswordMutation = {
  __typename: "MutationRoot";
  mutateUserPassword: {
    __typename: "User";
    id: string;
    customerId: string;
    username: string;
    email: string | null;
    role: UserRole;
    flags: Array<string>;
    teamLeader: boolean;
    isJumper: boolean;
    billableCustomerId: string | null;
    billableCustomerIds: Array<string>;
    currentBillingCustomerId: string | null;
    defaultProjectId: string | null;
    attrs: Record<string, unknown>;
    passwordReset: string | null;
    otp: boolean;
    currentBillingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    billableCustomers: Array<{
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    }>;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      birthdate: string | null;
    } | null;
    projects: Array<{
      __typename: "Project";
      id: string;
      customerId: string;
      name: string;
      identifier: string;
      active: boolean;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
    }>;
    customer: {
      __typename: "Customer";
      id: string;
      identifier: string;
      attrs: Record<string, unknown>;
      defaultProject: {
        __typename: "Project";
        id: string;
        identifier: string;
        attrs: Record<string, unknown>;
      } | null;
    } | null;
  };
};

export type MutateUserMutationVariables = Exact<{
  customerId: string;
  userId?: string | null | undefined;
  user: UserInput;
  options?: UserMutationOptions | null | undefined;
}>;

export type MutateUserMutation = {
  __typename: "MutationRoot";
  mutateUser: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type MutateUserProfileMutationVariables = Exact<{
  bio: string;
}>;

export type MutateUserProfileMutation = {
  __typename: "MutationRoot";
  mutateUserProfile: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type EnableOtpMutationVariables = Exact<{ [key: string]: never }>;

export type EnableOtpMutation = {
  __typename: "MutationRoot";
  enableOtp: string;
};

export type DeleteUserMutationVariables = Exact<{
  userId: string;
  inheritorId: string;
  customerId: string;
}>;

export type DeleteUserMutation = {
  __typename: "MutationRoot";
  deleteUser: { __typename: "User"; id: string };
};

export type MutateUserPasswordMutationVariables = Exact<{
  password: string;
}>;

export type MutateUserPasswordMutation = {
  __typename: "MutationRoot";
  mutateUserPassword: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type MutateUserAvatarMutationVariables = Exact<{
  avatar: File;
}>;

export type MutateUserAvatarMutation = {
  __typename: "MutationRoot";
  mutateUserAvatar: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type DisableOtpMutationVariables = Exact<{
  otp: string;
}>;

export type DisableOtpMutation = {
  __typename: "MutationRoot";
  disableOtp: {
    __typename: "User";
    id: string;
    customerId: string;
    username: string;
    email: string | null;
    role: UserRole;
    flags: Array<string>;
    teamLeader: boolean;
    isJumper: boolean;
    billableCustomerId: string | null;
    billableCustomerIds: Array<string>;
    currentBillingCustomerId: string | null;
    defaultProjectId: string | null;
    attrs: Record<string, unknown>;
    passwordReset: string | null;
    otp: boolean;
    currentBillingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    billableCustomers: Array<{
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    }>;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      displayName: string;
      birthdate: string | null;
    } | null;
    projects: Array<{
      __typename: "Project";
      id: string;
      customerId: string;
      name: string;
      identifier: string;
      active: boolean;
      attrs: Record<string, unknown>;
      insertedAt: string;
      updatedAt: string;
    }>;
    customer: {
      __typename: "Customer";
      id: string;
      identifier: string;
      attrs: Record<string, unknown>;
      defaultProject: {
        __typename: "Project";
        id: string;
        identifier: string;
        attrs: Record<string, unknown>;
      } | null;
    } | null;
  };
};

export type DisableOtpForUserMutationVariables = Exact<{
  customerId: string;
  userId: string;
}>;

export type DisableOtpForUserMutation = {
  __typename: "MutationRoot";
  disableOtpForUser: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type UserQueryVariables = Exact<{
  customerId: string;
  userId: string;
}>;

export type UserQuery = {
  __typename: "QueryRoot";
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type UserWithBillingQueryVariables = Exact<{
  customerId: string;
  userId: string;
}>;

export type UserWithBillingQuery = {
  __typename: "QueryRoot";
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    billableCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
    billableCustomers: Array<{
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    }>;
    currentBillingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  } | null;
};

export type UserWithDetailsQueryVariables = Exact<{
  customerId: string;
  userId: string;
}>;

export type UserWithDetailsQuery = {
  __typename: "QueryRoot";
  user: {
    __typename: "User";
    isJumper: boolean;
    billableCustomerIds: Array<string>;
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    contact: {
      __typename: "Contact";
      isCompany: boolean;
      salutation: string | null;
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
      infos: Array<{
        __typename: "ContactInfo";
        id: string;
        itype: ContactInfoType;
        value: string | null;
        normalizedValue: string | null;
      }>;
    } | null;
    profiles: Array<{
      __typename: "Profile";
      id: string;
      name: string;
      attrs: Record<string, unknown>;
    }>;
    projects: Array<{
      __typename: "Project";
      id: string;
      name: string;
      customerId: string;
      customer: {
        __typename: "MinimalCustomer";
        id: string;
        name: string;
      } | null;
    }>;
    userCustomers: Array<{ __typename: "Customer"; id: string; name: string }>;
    adminCustomers: Array<{ __typename: "Customer"; id: string; name: string }>;
    userTeams: Array<{ __typename: "Team"; id: string }>;
    leaderTeams: Array<{ __typename: "Team"; id: string }>;
    foreignUserTeams: Array<{ __typename: "Team"; id: string }>;
    foreignLeaderTeams: Array<{ __typename: "Team"; id: string }>;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
  } | null;
};

export type UsersQueryVariables = Exact<{
  filters?: UsersListFilter | null | undefined;
}>;

export type UsersQuery = {
  __typename: "QueryRoot";
  users: Array<{
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  }>;
};

export type CountUsersQueryVariables = Exact<{
  filters?: UsersCountFilter | null | undefined;
}>;

export type CountUsersQuery = { __typename: "QueryRoot"; countUsers: string };

export type UsernameUniqueQueryVariables = Exact<{
  username: string;
  userId?: string | null | undefined;
}>;

export type UsernameUniqueQuery = {
  __typename: "QueryRoot";
  usernameUnique: boolean;
};

export type ResetUserPasswordMutationVariables = Exact<{
  customerId: string;
  userId: string;
  emailLang: string;
  sendAs: UserPasswortSendAs;
  template: UserPasswordMailType;
}>;

export type ResetUserPasswordMutation = {
  __typename: "MutationRoot";
  resetUserPassword: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type ApiTokenForUserMutationVariables = Exact<{
  customerId: string;
  userId: string;
}>;

export type ApiTokenForUserMutation = {
  __typename: "MutationRoot";
  apiTokenForUser: string;
};

export type SetUserDefaultProjectMutationVariables = Exact<{
  customerId: string;
  defaultProjectId: string;
}>;

export type SetUserDefaultProjectMutation = {
  __typename: "MutationRoot";
  setUserDefaultProject: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type VacationRequestFragment = {
  __typename: "VacationRequest";
  id: string;
  from: string;
  to: string;
  type: VacationRequestType;
  status: VacationRequestStatus;
  comment: string | null;
  adminComment: string | null;
  halfDay: boolean;
  startTime: string | null;
  endTime: string | null;
  insertedAt: string;
  updatedAt: string;
  userId: string;
  creatorId: string;
  editorId: string;
  user: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  creator: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
  editor: {
    __typename: "User";
    id: string;
    username: string;
    email: string | null;
    active: boolean;
    retired: boolean;
    role: UserRole;
    homeoffice: boolean;
    bio: string | null;
    customerId: string;
    attrs: Record<string, unknown>;
    lastSeenAt: string | null;
    passwordReset: string | null;
    otp: boolean;
    billableCustomerId: string | null;
    defaultProjectId: string | null;
    avatar: {
      __typename: "UserAvatar";
      thumb: string;
      medium: string;
      original: string;
    };
    contact: {
      __typename: "Contact";
      id: string;
      firstname: string | null;
      lastname: string | null;
      displayName: string;
      companyName: string | null;
      birthdate: string | null;
    } | null;
  };
};

export type VacationPlanQueryVariables = Exact<{
  customerId: string;
  month: string;
  filters?: VacationPlanFilters | null | undefined;
}>;

export type VacationPlanQuery = {
  __typename: "QueryRoot";
  vacationPlan: Array<{
    __typename: "VacationPlan";
    userId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    vacation: Array<{
      __typename: "VacationPlanEntry";
      date: string;
      status: VacationRequestStatus;
    }>;
  }>;
};

export type VacationRequestsQueryVariables = Exact<{
  customerId: string;
  filters?: VacationRequestListOptions | null | undefined;
}>;

export type VacationRequestsQuery = {
  __typename: "QueryRoot";
  vacationRequests: Array<{
    __typename: "VacationRequest";
    id: string;
    from: string;
    to: string;
    type: VacationRequestType;
    status: VacationRequestStatus;
    comment: string | null;
    adminComment: string | null;
    halfDay: boolean;
    startTime: string | null;
    endTime: string | null;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    creatorId: string;
    editorId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountVacationRequestsQueryVariables = Exact<{
  customerId: string;
  filters?: VacationRequestListOptions | null | undefined;
}>;

export type CountVacationRequestsQuery = {
  __typename: "QueryRoot";
  countVacationRequests: string;
};

export type VacationRequestQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type VacationRequestQuery = {
  __typename: "QueryRoot";
  vacationRequest: {
    __typename: "VacationRequest";
    id: string;
    from: string;
    to: string;
    type: VacationRequestType;
    status: VacationRequestStatus;
    comment: string | null;
    adminComment: string | null;
    halfDay: boolean;
    startTime: string | null;
    endTime: string | null;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    creatorId: string;
    editorId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type DeleteVacationRequestMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteVacationRequestMutation = {
  __typename: "MutationRoot";
  deleteVacationRequest: { __typename: "VacationRequest"; id: string };
};

export type MutateVacationRequestMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: VacationRequestInput;
}>;

export type MutateVacationRequestMutation = {
  __typename: "MutationRoot";
  mutateVacationRequest: {
    __typename: "VacationRequest";
    id: string;
    from: string;
    to: string;
    type: VacationRequestType;
    status: VacationRequestStatus;
    comment: string | null;
    adminComment: string | null;
    halfDay: boolean;
    startTime: string | null;
    endTime: string | null;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    creatorId: string;
    editorId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type MutateVacationRequestCommentMutationVariables = Exact<{
  customerId: string;
  id: string;
  comment: string;
}>;

export type MutateVacationRequestCommentMutation = {
  __typename: "MutationRoot";
  mutateVacationRequestComment: {
    __typename: "VacationRequest";
    id: string;
    from: string;
    to: string;
    type: VacationRequestType;
    status: VacationRequestStatus;
    comment: string | null;
    adminComment: string | null;
    halfDay: boolean;
    startTime: string | null;
    endTime: string | null;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    creatorId: string;
    editorId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type FinalizeVacationRequestMutationVariables = Exact<{
  customerId: string;
  id: string;
  values: VacationRequestStatusInput;
}>;

export type FinalizeVacationRequestMutation = {
  __typename: "MutationRoot";
  finalizeVacationRequest: {
    __typename: "VacationRequest";
    id: string;
    from: string;
    to: string;
    type: VacationRequestType;
    status: VacationRequestStatus;
    comment: string | null;
    adminComment: string | null;
    halfDay: boolean;
    startTime: string | null;
    endTime: string | null;
    insertedAt: string;
    updatedAt: string;
    userId: string;
    creatorId: string;
    editorId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    creator: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    editor: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type VacationOverviewQueryVariables = Exact<{
  customerId: string;
  year: number;
  filters?: VacationOverviewFilters | null | undefined;
}>;

export type VacationOverviewQuery = {
  __typename: "QueryRoot";
  vacationOverview: Array<{
    __typename: "VacationYearlyOverview";
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    byContract: number;
    entitled: number;
    planned: number;
    taken: number;
    left: number;
    residual: number;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type VacationAvailableQueryVariables = Exact<{
  customerId: string;
  userId: string;
  id?: string | null | undefined;
  values: VacationAvailableInput;
}>;

export type VacationAvailableQuery = {
  __typename: "QueryRoot";
  vacationAvailable: boolean;
};

export type AvailableVacationDaysQueryVariables = Exact<{
  customerId: string;
  userId: string;
  year: number;
}>;

export type AvailableVacationDaysQuery = {
  __typename: "QueryRoot";
  availableVacationDays: number;
};

export type WorktimesTasksQueryVariables = Exact<{
  customerId: string;
}>;

export type WorktimesTasksQuery = {
  __typename: "QueryRoot";
  worktimesTasks: Array<{
    __typename: "WorktimesTask";
    id: string;
    name: string;
    type: WorktimesTaskType;
    paid: boolean;
    productive: boolean;
    sidebar: boolean;
    allowInCorrections: boolean;
    position: number;
    acdId: string | null;
  }>;
};

export type WorktimesTaskQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type WorktimesTaskQuery = {
  __typename: "QueryRoot";
  worktimesTask: {
    __typename: "WorktimesTask";
    id: string;
    name: string;
    type: WorktimesTaskType;
    paid: boolean;
    productive: boolean;
    sidebar: boolean;
    allowInCorrections: boolean;
    position: number;
    acdId: string | null;
  } | null;
};

export type MutateWorktimesTaskMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: WorktimesTaskInput;
}>;

export type MutateWorktimesTaskMutation = {
  __typename: "MutationRoot";
  mutateWorktimesTask: {
    __typename: "WorktimesTask";
    id: string;
    name: string;
    type: WorktimesTaskType;
    paid: boolean;
    productive: boolean;
    sidebar: boolean;
    allowInCorrections: boolean;
    position: number;
    acdId: string | null;
  };
};

export type DeleteWorktimesTaskMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteWorktimesTaskMutation = {
  __typename: "MutationRoot";
  deleteWorktimesTask: {
    __typename: "WorktimesTask";
    id: string;
    name: string;
    type: WorktimesTaskType;
    paid: boolean;
    productive: boolean;
    sidebar: boolean;
    allowInCorrections: boolean;
    position: number;
    acdId: string | null;
  };
};

export type WorktimesQueryVariables = Exact<{
  customerId: string;
  filters?: WorktimesListFilters | null | undefined;
}>;

export type WorktimesQuery = {
  __typename: "QueryRoot";
  worktimes: Array<{
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    acdId: string | null;
    customerId: string;
    billingCustomerId: string | null;
    customerReviewDone: boolean;
    userId: string;
    taskId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    task: {
      __typename: "WorktimesTask";
      id: string;
      type: WorktimesTaskType;
      name: string;
      paid: boolean;
    };
  }>;
};

export type WorktimesWithBillingCustomerQueryVariables = Exact<{
  customerId: string;
  filters?: WorktimesListFilters | null | undefined;
}>;

export type WorktimesWithBillingCustomerQuery = {
  __typename: "QueryRoot";
  worktimes: Array<{
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    acdId: string | null;
    customerId: string;
    billingCustomerId: string | null;
    customerReviewDone: boolean;
    userId: string;
    taskId: string;
    billingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    task: {
      __typename: "WorktimesTask";
      id: string;
      type: WorktimesTaskType;
      name: string;
      paid: boolean;
    };
  }>;
};

export type CountWorktimesQueryVariables = Exact<{
  customerId: string;
  filters?: WorktimesListFilters | null | undefined;
}>;

export type CountWorktimesQuery = {
  __typename: "QueryRoot";
  countWorktimes: string;
};

export type WorktimesWithoutUserQueryVariables = Exact<{
  customerId: string;
  filters?: WorktimesListFilters | null | undefined;
}>;

export type WorktimesWithoutUserQuery = {
  __typename: "QueryRoot";
  worktimes: Array<{
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    userId: string;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    billingCustomerId: string | null;
    customerId: string;
    task: {
      __typename: "WorktimesTask";
      id: string;
      name: string;
      type: WorktimesTaskType;
      paid: boolean;
    };
    billingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
  }>;
};

export type SubscribeWorktimeDayStatusSubscriptionVariables = Exact<{
  customerId: string;
}>;

export type SubscribeWorktimeDayStatusSubscription = {
  __typename: "SubscriptionRoot";
  worktimeDayStatus: {
    __typename: "WorktimesDaySummary";
    worktime: string;
    runningTask: {
      __typename: "Worktime";
      id: string;
      starts: string;
      stops: string | null;
      userId: string;
      comment: string | null;
      declined: boolean;
      declineReason: string | null;
      billingCustomerId: string | null;
      customerId: string;
      task: {
        __typename: "WorktimesTask";
        id: string;
        name: string;
        type: WorktimesTaskType;
        paid: boolean;
      };
      billingCustomer: {
        __typename: "MinimalCustomer";
        id: string;
        name: string;
      } | null;
    } | null;
  };
};

export type WorktimeQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type WorktimeQuery = {
  __typename: "QueryRoot";
  worktime: {
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    acdId: string | null;
    customerId: string;
    billingCustomerId: string | null;
    customerReviewDone: boolean;
    userId: string;
    taskId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    task: {
      __typename: "WorktimesTask";
      id: string;
      type: WorktimesTaskType;
      name: string;
      paid: boolean;
    };
  };
};

export type WorktimeWithBillingCustomerQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type WorktimeWithBillingCustomerQuery = {
  __typename: "QueryRoot";
  worktime: {
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    acdId: string | null;
    customerId: string;
    billingCustomerId: string | null;
    customerReviewDone: boolean;
    userId: string;
    taskId: string;
    billingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    task: {
      __typename: "WorktimesTask";
      id: string;
      type: WorktimesTaskType;
      name: string;
      paid: boolean;
    };
  };
};

export type WorktimeStartEndValidQueryVariables = Exact<{
  customerId: string;
  filters: WorktimeValidationInput;
}>;

export type WorktimeStartEndValidQuery = {
  __typename: "QueryRoot";
  worktimeStartEndValid: {
    __typename: "WorktimeValidation";
    valid: boolean;
    worktimes: Array<{
      __typename: "Worktime";
      id: string;
      starts: string;
      stops: string | null;
      comment: string | null;
      declined: boolean;
      declineReason: string | null;
      acdId: string | null;
      customerId: string;
      billingCustomerId: string | null;
      customerReviewDone: boolean;
      userId: string;
      taskId: string;
      user: {
        __typename: "User";
        id: string;
        username: string;
        email: string | null;
        active: boolean;
        retired: boolean;
        role: UserRole;
        homeoffice: boolean;
        bio: string | null;
        customerId: string;
        attrs: Record<string, unknown>;
        lastSeenAt: string | null;
        passwordReset: string | null;
        otp: boolean;
        billableCustomerId: string | null;
        defaultProjectId: string | null;
        avatar: {
          __typename: "UserAvatar";
          thumb: string;
          medium: string;
          original: string;
        };
        contact: {
          __typename: "Contact";
          id: string;
          firstname: string | null;
          lastname: string | null;
          displayName: string;
          companyName: string | null;
          birthdate: string | null;
        } | null;
      };
      task: {
        __typename: "WorktimesTask";
        id: string;
        type: WorktimesTaskType;
        name: string;
        paid: boolean;
      };
    }>;
  };
};

export type WorktimeMutationMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  worktime: WorktimeInput;
  byContract?: boolean | null | undefined;
  days?: number | null | undefined;
}>;

export type WorktimeMutationMutation = {
  __typename: "MutationRoot";
  mutateWorktime: Array<{
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    acdId: string | null;
    customerId: string;
    billingCustomerId: string | null;
    customerReviewDone: boolean;
    userId: string;
    taskId: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    task: {
      __typename: "WorktimesTask";
      id: string;
      type: WorktimesTaskType;
      name: string;
      paid: boolean;
    };
  }>;
};

export type DeleteWorktimeMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteWorktimeMutation = {
  __typename: "MutationRoot";
  deleteWorktime: { __typename: "Worktime"; id: string };
};

export type StartWorktimeMutationVariables = Exact<{
  customerId: string;
  taskId: string;
}>;

export type StartWorktimeMutation = {
  __typename: "MutationRoot";
  startWorktime: Array<{
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    userId: string;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    billingCustomerId: string | null;
    customerId: string;
    task: {
      __typename: "WorktimesTask";
      id: string;
      name: string;
      type: WorktimesTaskType;
      paid: boolean;
    };
    billingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
  }>;
};

export type StopCurrentWorktimeMutationVariables = Exact<{
  customerId: string;
}>;

export type StopCurrentWorktimeMutation = {
  __typename: "MutationRoot";
  stopCurrentWorktime: Array<{
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    userId: string;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    billingCustomerId: string | null;
    customerId: string;
    task: {
      __typename: "WorktimesTask";
      id: string;
      name: string;
      type: WorktimesTaskType;
      paid: boolean;
    };
    billingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
    } | null;
  }>;
};

export type ConfirmDayWorktimesMutationVariables = Exact<{
  customerId: string;
  date: string;
}>;

export type ConfirmDayWorktimesMutation = {
  __typename: "MutationRoot";
  confirmDayWorktimes: Array<{ __typename: "Worktime"; id: string }>;
};

export type DeclineDayWorktimesMutationVariables = Exact<{
  customerId: string;
  date: string;
  reason: string;
}>;

export type DeclineDayWorktimesMutation = {
  __typename: "MutationRoot";
  declineDayWorktimes: Array<{ __typename: "Worktime"; id: string }>;
};

export type WorktimesWithCustomerDataQueryVariables = Exact<{
  customerId: string;
  filters?: WorktimesListFilters | null | undefined;
}>;

export type WorktimesWithCustomerDataQuery = {
  __typename: "QueryRoot";
  worktimes: Array<{
    __typename: "Worktime";
    id: string;
    starts: string;
    stops: string | null;
    comment: string | null;
    declined: boolean;
    declineReason: string | null;
    acdId: string | null;
    customerId: string;
    billingCustomerId: string | null;
    customerReviewDone: boolean;
    userId: string;
    taskId: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    };
    billingCustomer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    } | null;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
    task: {
      __typename: "WorktimesTask";
      id: string;
      type: WorktimesTaskType;
      name: string;
      paid: boolean;
    };
  }>;
};

export type WorktimesByCustomerSummaryQueryVariables = Exact<{
  customerId: string;
  filters: WorktimesByCustomerFilters;
}>;

export type WorktimesByCustomerSummaryQuery = {
  __typename: "QueryRoot";
  worktimesByCustomerSummary: Array<{
    __typename: "WorktimesByCustomerRow";
    customerId: string;
    seconds: string;
    productiveSeconds: string;
    worktimesCount: string;
    customer: {
      __typename: "MinimalCustomer";
      id: string;
      name: string;
      logo: {
        __typename: "CustomerLogo";
        thumb: string;
        medium: string;
        original: string;
      };
    };
  }>;
};

export type WorktimesByCustomerPerUserQueryVariables = Exact<{
  customerId: string;
  targetCustomerId: string;
  filters: WorktimesByCustomerFilters;
}>;

export type WorktimesByCustomerPerUserQuery = {
  __typename: "QueryRoot";
  worktimesByCustomerPerUser: Array<{
    __typename: "WorktimesByCustomerUserRow";
    userId: string;
    seconds: string;
    productiveSeconds: string;
    worktimesCount: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type WorktimesConfirmCustomerMutationVariables = Exact<{
  customerId: string;
  worktimeIds: Array<string> | string;
}>;

export type WorktimesConfirmCustomerMutation = {
  __typename: "MutationRoot";
  worktimesConfirmCustomer: Array<{ __typename: "Worktime"; id: string }>;
};

export type WorktimesMutateCustomerMutationVariables = Exact<{
  customerId: string;
  userId: string;
  values: Array<WorktimesCustomerInput> | WorktimesCustomerInput;
}>;

export type WorktimesMutateCustomerMutation = {
  __typename: "MutationRoot";
  worktimesMutateCustomer: Array<{ __typename: "Worktime"; id: string }>;
};

export type WorktimeDayStatusQueryVariables = Exact<{
  customerId: string;
}>;

export type WorktimeDayStatusQuery = {
  __typename: "QueryRoot";
  worktimeDayStatus: {
    __typename: "WorktimesDaySummary";
    worktime: string;
    runningTask: {
      __typename: "Worktime";
      id: string;
      starts: string;
      stops: string | null;
      userId: string;
      comment: string | null;
      declined: boolean;
      declineReason: string | null;
      billingCustomerId: string | null;
      customerId: string;
      task: {
        __typename: "WorktimesTask";
        id: string;
        name: string;
        type: WorktimesTaskType;
        paid: boolean;
      };
      billingCustomer: {
        __typename: "MinimalCustomer";
        id: string;
        name: string;
      } | null;
    } | null;
  };
};

export type WorktimesChangeRequestsQueryVariables = Exact<{
  customerId: string;
  filters?: WorktimesChangeRequestListFilters | null | undefined;
}>;

export type WorktimesChangeRequestsQuery = {
  __typename: "QueryRoot";
  worktimesChangeRequests: Array<{
    __typename: "WorktimesChangeRequest";
    id: string;
    userId: string;
    status: WorktimesChangeRequestStatus;
    comment: string | null;
    adminComment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  }>;
};

export type CountWorktimesChangeRequestsQueryVariables = Exact<{
  customerId: string;
  filters?: WorktimesChangeRequestListFilters | null | undefined;
}>;

export type CountWorktimesChangeRequestsQuery = {
  __typename: "QueryRoot";
  countWorktimesChangeRequests: string;
};

export type WorktimesChangeRequestQueryVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type WorktimesChangeRequestQuery = {
  __typename: "QueryRoot";
  worktimesChangeRequest: {
    __typename: "WorktimesChangeRequest";
    id: string;
    userId: string;
    status: WorktimesChangeRequestStatus;
    comment: string | null;
    adminComment: string | null;
    insertedAt: string;
    updatedAt: string;
    entries: Array<{
      __typename: "WorktimesChangeRequestEntry";
      id: string;
      starts: string;
      stops: string;
      billingCustomerId: string | null;
      task: {
        __typename: "WorktimesTask";
        id: string;
        name: string;
        paid: boolean;
        productive: boolean;
        sidebar: boolean;
        allowInCorrections: boolean;
        position: number;
        type: WorktimesTaskType;
        acdId: string | null;
      };
      billingCustomer: {
        __typename: "MinimalCustomer";
        id: string;
        name: string;
      } | null;
    }>;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  } | null;
};

export type MutateWorktimesChangeRequestMutationVariables = Exact<{
  customerId: string;
  id?: string | null | undefined;
  values: WorktimesChangeRequestInput;
}>;

export type MutateWorktimesChangeRequestMutation = {
  __typename: "MutationRoot";
  mutateWorktimesChangeRequest: {
    __typename: "WorktimesChangeRequest";
    id: string;
    userId: string;
    status: WorktimesChangeRequestStatus;
    comment: string | null;
    adminComment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type DeleteWorktimesChangeRequestMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type DeleteWorktimesChangeRequestMutation = {
  __typename: "MutationRoot";
  deleteWorktimesChangeRequest: {
    __typename: "WorktimesChangeRequest";
    id: string;
  };
};

export type InquireWorktimesChangeRequestMutationVariables = Exact<{
  customerId: string;
  id: string;
  comment: string;
}>;

export type InquireWorktimesChangeRequestMutation = {
  __typename: "MutationRoot";
  inquireWorktimesChangeRequest: {
    __typename: "WorktimesChangeRequest";
    id: string;
    userId: string;
    status: WorktimesChangeRequestStatus;
    comment: string | null;
    adminComment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type RejectWorktimesChangeRequestMutationVariables = Exact<{
  customerId: string;
  id: string;
  comment: string;
}>;

export type RejectWorktimesChangeRequestMutation = {
  __typename: "MutationRoot";
  rejectWorktimesChangeRequest: {
    __typename: "WorktimesChangeRequest";
    id: string;
    userId: string;
    status: WorktimesChangeRequestStatus;
    comment: string | null;
    adminComment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export type ApproveWorktimesChangeRequestMutationVariables = Exact<{
  customerId: string;
  id: string;
}>;

export type ApproveWorktimesChangeRequestMutation = {
  __typename: "MutationRoot";
  approveWorktimesChangeRequest: {
    __typename: "WorktimesChangeRequest";
    id: string;
    userId: string;
    status: WorktimesChangeRequestStatus;
    comment: string | null;
    adminComment: string | null;
    insertedAt: string;
    updatedAt: string;
    user: {
      __typename: "User";
      id: string;
      username: string;
      email: string | null;
      active: boolean;
      retired: boolean;
      role: UserRole;
      homeoffice: boolean;
      bio: string | null;
      customerId: string;
      attrs: Record<string, unknown>;
      lastSeenAt: string | null;
      passwordReset: string | null;
      otp: boolean;
      billableCustomerId: string | null;
      defaultProjectId: string | null;
      avatar: {
        __typename: "UserAvatar";
        thumb: string;
        medium: string;
        original: string;
      };
      contact: {
        __typename: "Contact";
        id: string;
        firstname: string | null;
        lastname: string | null;
        displayName: string;
        companyName: string | null;
        birthdate: string | null;
      } | null;
    };
  };
};

export const AcdCallListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCall" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
          { kind: "Field", name: { kind: "Name", value: "noCalls" } },
          { kind: "Field", name: { kind: "Name", value: "firstCall" } },
          { kind: "Field", name: { kind: "Name", value: "lastCall" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcdCallListItemFragment, unknown>;
export const AcdCallTimeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallTime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCallTime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "callTime" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcdCallTimeFragment, unknown>;
export const AcdCallFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCall" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCall" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AcdCallListItem" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "callTimes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AcdCallTime" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCall" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
          { kind: "Field", name: { kind: "Name", value: "noCalls" } },
          { kind: "Field", name: { kind: "Name", value: "firstCall" } },
          { kind: "Field", name: { kind: "Name", value: "lastCall" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallTime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCallTime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "callTime" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcdCallFragment, unknown>;
export const UserAvatarFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserAvatarFragment, unknown>;
export const UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFragment, unknown>;
export const ApiKeyFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApiKey" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ApiKey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApiKeyFragment, unknown>;
export const LogEntryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LogEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LogEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "relid" } },
          { kind: "Field", name: { kind: "Name", value: "relation" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "previousContents" } },
          { kind: "Field", name: { kind: "Name", value: "contents" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogEntryFragment, unknown>;
export const ContactInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactInfoFragment, unknown>;
export const ContactAddressFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactAddressFragment, unknown>;
export const EmployeeFullFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeFullFragment, unknown>;
export const ChangeRequestFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "landline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactName" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactPhone" },
          },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailConfirmationToken" },
          },
          { kind: "Field", name: { kind: "Name", value: "emailConfirmed" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "requestComment" } },
          { kind: "Field", name: { kind: "Name", value: "returnComment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeRequestFragment, unknown>;
export const CommunicationListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommunicationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommunicationList" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "addresses" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommunicationListFragment, unknown>;
export const CommunicationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Communication" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Communication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "lists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommunicationFragment, unknown>;
export const CompanyNewsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyNewsFragment, unknown>;
export const ContactOfferFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactOffer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "views" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "offerId" } },
                { kind: "Field", name: { kind: "Name", value: "userAgent" } },
                { kind: "Field", name: { kind: "Name", value: "viewedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactOfferFragment, unknown>;
export const StatusUpdateFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatusUpdate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatusUpdate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fromId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "from" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "toId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "to" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "afterDays" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusUpdateFragment, unknown>;
export const ContactStatusFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactStatus" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allowedAfterCall" } },
          { kind: "Field", name: { kind: "Name", value: "enforceFollowup" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "followupEventTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupSubject" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactStatusFragment, unknown>;
export const ContactGroupDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactGroupDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "gtype" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactGroupDetailFragment, unknown>;
export const ContactAddfieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddfield" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddfield" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "automatic" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactAddfieldFragment, unknown>;
export const ContactAttachmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactAttachmentFragment, unknown>;
export const ContactDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactDetailFragment, unknown>;
export const EventDetailWoContactFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventDetailWoContactFragment, unknown>;
export const ContactFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ContactDetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactFragmentFragment, unknown>;
export const ContactListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "parent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastContact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextFollowup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "allDay" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "zip" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ContactDetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactListItemFragment, unknown>;
export const ContactWithInfosListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactWithInfosListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactWithInfosListItemFragment, unknown>;
export const ContactWithInfosAndAddressesListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactWithInfosAndAddressesListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactWithInfosAndAddressesListItemFragment,
  unknown
>;
export const EmployeeCouponFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeCoupon" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EmployeeCoupon" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "claimed" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeCouponFragment, unknown>;
export const CustomerFeedbackFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedback" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selfAssessmentState" },
          },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "topicId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerFeedbackFragment, unknown>;
export const CustomerFeedbackAnnotationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedbackId" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerFeedbackAnnotationFragment, unknown>;
export const CustomerFeedbackTopicFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedbackTopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedbackTopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerFeedbackTopicFragment, unknown>;
export const CustomerLogoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerLogoFragment, unknown>;
export const CustomerListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "inDeletion" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerLogo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerListItemFragment, unknown>;
export const CustomerFullFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "inDeletion" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerLogo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "active" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerAdministrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerFullFragment, unknown>;
export const DigitalSignatureEnvelopeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DigitalSignatureEnvelopeFragment, unknown>;
export const DigitalSignatureFileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureId" },
          },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DigitalSignatureFileFragment, unknown>;
export const DigitalSignatureFieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureField" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureFileId" },
          },
          { kind: "Field", name: { kind: "Name", value: "pageNo" } },
          { kind: "Field", name: { kind: "Name", value: "x" } },
          { kind: "Field", name: { kind: "Name", value: "y" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DigitalSignatureFieldFragment, unknown>;
export const DocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "signatureType" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "signatureDue" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentFragment, unknown>;
export const DocumentListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Document" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "signatureType" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "signatureDue" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentListItemFragment, unknown>;
export const DocumentAttachmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DocumentAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentAttachmentFragment, unknown>;
export const DocumentSignatureFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentSignature" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DocumentSignature" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentSignatureFragment, unknown>;
export const DetailDocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DetailDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "DocumentListItem" },
          },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentAttachment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "missingSignatures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "signatureType" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "signatureDue" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Document" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DocumentAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentSignature" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DocumentSignature" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DetailDocumentFragment, unknown>;
export const EmployeeListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeListItemFragment, unknown>;
export const EventTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "mayForeign" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventTypeFragment, unknown>;
export const EventDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventDetailFragment, unknown>;
export const EventListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventListItemFragment, unknown>;
export const EventFeedbackEventFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventFeedbackEventFragment, unknown>;
export const EventFeedbackDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "eventId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackEvent" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventFeedbackDetailFragment, unknown>;
export const FileExchangeEntryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileExchangeEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FileExchangeEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileExchangeEntryFragment, unknown>;
export const FinanceReportCorrectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinanceReportCorrection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FinanceReportCorrection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "earnings" } },
          { kind: "Field", name: { kind: "Name", value: "expenses" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinanceReportCorrectionFragment, unknown>;
export const HistoryAuditLogEntryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryAuditLogEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAuditLogEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
          { kind: "Field", name: { kind: "Name", value: "changes" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HistoryAuditLogEntryFragment, unknown>;
export const HistoryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "History" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "History" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "pinned" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HistoryFragment, unknown>;
export const HistoryCallResultFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryCallResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CallResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HistoryCallResultFragment, unknown>;
export const HistoryFileAttachmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryFileAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "deletionReason" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HistoryFileAttachmentFragment, unknown>;
export const HistoryAnnotationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryAnnotation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAnnotation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HistoryAnnotationFragment, unknown>;
export const HotseatRequestFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HotseatRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HotseatRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HotseatRequestFragment, unknown>;
export const HourOrderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HourOrder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HourOrder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "productiveHours" } },
          { kind: "Field", name: { kind: "Name", value: "adminHours" } },
          { kind: "Field", name: { kind: "Name", value: "overCapacityHours" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "predictableHolidayHours" },
          },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HourOrderFragment, unknown>;
export const IndeedStatsEntryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndeedStatsEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndeedStatsEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "time" } },
          { kind: "Field", name: { kind: "Name", value: "spend" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IndeedStatsEntryFragment, unknown>;
export const InventoryItemTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItemType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItemType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "itemsWanted" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventoryItemTypeFragment, unknown>;
export const InventoryTimelineEntryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventoryTimelineEntryFragment, unknown>;
export const InventoryItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "itemTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "lastBeaconId" } },
          { kind: "Field", name: { kind: "Name", value: "lastDguvCheckId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "serial" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentInfo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "checkInterval" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "mouse" } },
                { kind: "Field", name: { kind: "Name", value: "keyboard" } },
                { kind: "Field", name: { kind: "Name", value: "adapter" } },
                { kind: "Field", name: { kind: "Name", value: "webcam" } },
                { kind: "Field", name: { kind: "Name", value: "osName" } },
                { kind: "Field", name: { kind: "Name", value: "osVersion" } },
                { kind: "Field", name: { kind: "Name", value: "lastUser" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastDguvCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventoryItemFragment, unknown>;
export const InventoryItemAttachmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItemAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItemAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventoryItemAttachmentFragment, unknown>;
export const InventorySetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventorySet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventorySet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventorySetFragment, unknown>;
export const InventoryReservationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "inventorySetId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservedFor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "set" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventoryReservationFragment, unknown>;
export const InvoiceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Invoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "periodStart" } },
          { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "preview" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "locked" } },
          { kind: "Field", name: { kind: "Name", value: "lockedById" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "pos" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceFragment, unknown>;
export const JobResultFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "JobResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "JobResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "module" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "hasAttachment" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "report" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobResultFragment, unknown>;
export const KnowledgebaseQuestionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgebaseQuestionFragment, unknown>;
export const KnowledgebaseAttachmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgebaseAttachmentFragment, unknown>;
export const KnowledgebaseNgCategoryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "path" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgebaseNgCategoryFragment, unknown>;
export const KnowledgebaseNgArticleFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgArticle" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgArticle" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "articleType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "nextReview" } },
          { kind: "Field", name: { kind: "Name", value: "timeless" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "visibleForExternals" },
          },
          { kind: "Field", name: { kind: "Name", value: "igorSync" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categoryPaths" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "team" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "linkedArticles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgebaseNgArticleFragment, unknown>;
export const KnowledgebaseNgReviewFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgReview" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgReview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "articleId" } },
          { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
          { kind: "Field", name: { kind: "Name", value: "result" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "reviewedAt" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgebaseNgReviewFragment, unknown>;
export const MailTemplateFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "slateContent" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailTemplateFragment, unknown>;
export const MailTemplateAttachmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplateAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplateAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "attachByDefault" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailTemplateAttachmentFragment, unknown>;
export const MailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailFragment, unknown>;
export const MessageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "subjectI18nId" } },
          { kind: "Field", name: { kind: "Name", value: "subjectParams" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "format" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageFragment, unknown>;
export const OauthTokenFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OauthToken" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OauthToken" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "appId" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "scopes" } },
          { kind: "Field", name: { kind: "Name", value: "grantType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "tokenQuery" } },
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "expires" } },
          { kind: "Field", name: { kind: "Name", value: "useBasicAuth" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OauthTokenFragment, unknown>;
export const StaffPaymentInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffPaymentInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffPaymentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payrollImportJobId" },
          },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "gross" } },
          { kind: "Field", name: { kind: "Name", value: "net" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "cost" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentInfoId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "positionType" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "factor" } },
                { kind: "Field", name: { kind: "Name", value: "percent" } },
                { kind: "Field", name: { kind: "Name", value: "sum" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffPaymentInfoFragment, unknown>;
export const PayrollPdfImportFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PayrollPdfImport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PayrollPdfImport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "importType" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PayrollPdfImportFragment, unknown>;
export const PayrollPdfImportErrorFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PayrollPdfImportError" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PayrollPdfImportError" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payrollImportJobId" },
          },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PayrollPdfImportErrorFragment, unknown>;
export const PersonalFileTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFileType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFileType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersonalFileTypeFragment, unknown>;
export const ProjectNewsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectNewsFragment, unknown>;
export const ProjectReportFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectReport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectReport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "reportType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectReportFragment, unknown>;
export const ProjectListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectListItemFragment, unknown>;
export const ProjectWithCustomerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectWithCustomer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectWithCustomerFragment, unknown>;
export const ProjectFullFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectFullFragment, unknown>;
export const ProjectAttachmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectAttachmentFragment, unknown>;
export const PunchlistEntryCommentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntryComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntryComment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PunchlistEntryCommentFragment, unknown>;
export const PunchlistEntryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PunchlistEntryFragment, unknown>;
export const PunchlistEntryWithProjectFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntryWithProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PunchlistEntry" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PunchlistEntryWithProjectFragment, unknown>;
export const ReminderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReminderFragment, unknown>;
export const ReminderNotificationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReminderNotification" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ReminderNotification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reminder" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Reminder" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reminderId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReminderNotificationFragment, unknown>;
export const ResidualLeaveFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResidualLeave" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResidualLeave" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "year" } },
          { kind: "Field", name: { kind: "Name", value: "daysLeft" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResidualLeaveFragment, unknown>;
export const RosterGroupFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterGroupFragment, unknown>;
export const RosterAttendanceTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterAttendanceTypeFragment, unknown>;
export const RosterStandardAttendanceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterStandardAttendanceFragment, unknown>;
export const RosterTaskFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterTaskFragment, unknown>;
export const RosterStandardHourFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterStandardHourFragment, unknown>;
export const RosterStandardDayFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardDay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardDay" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hours" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardHour" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterStandardDayFragment, unknown>;
export const RosterAttendanceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterAttendanceFragment, unknown>;
export const RosterHourFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterHourFragment, unknown>;
export const RosterNotificationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterNotification" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterNotification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterNotificationFragment, unknown>;
export const SecretFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Secret" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Secret" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SecretFragment, unknown>;
export const SessionProjectFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SessionProjectFragment, unknown>;
export const SessionUserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "flags" } },
          { kind: "Field", name: { kind: "Name", value: "teamLeader" } },
          { kind: "Field", name: { kind: "Name", value: "isJumper" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerIds" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultProject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SessionUserFragment, unknown>;
export const SessionCustomerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionCustomer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerAdministrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SessionCustomerFragment, unknown>;
export const PresettlementFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Presettlement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Presettlement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "entries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
                { kind: "Field", name: { kind: "Name", value: "wage" } },
                { kind: "Field", name: { kind: "Name", value: "partialWage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regularHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "illnessHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacationHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "sundayHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feastDayHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "wageModifications" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modification" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PresettlementFragment, unknown>;
export const SettlementFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Settlement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Settlement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "isVisible" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inflationBonus" } },
          { kind: "Field", name: { kind: "Name", value: "couponBonus" } },
          { kind: "Field", name: { kind: "Name", value: "ticketBonus" } },
          { kind: "Field", name: { kind: "Name", value: "travelCosts" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "visibleAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "posType" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "corrections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "taskId" } },
                { kind: "Field", name: { kind: "Name", value: "hours" } },
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "contractId" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettlementFragment, unknown>;
export const PersonalFileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersonalFileFragment, unknown>;
export const StaffShareLinkFileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLinkFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLinkFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffShareLinkFileFragment, unknown>;
export const StaffShareLinkFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLink" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "shareId" } },
          { kind: "Field", name: { kind: "Name", value: "validForDays" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "files" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffShareLinkFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLinkFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLinkFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFile" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffShareLinkFragment, unknown>;
export const StaffHistoryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffHistory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffHistory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "nextTalk" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffHistoryFragment, unknown>;
export const TaskListFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskListFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Task" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaireType" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "reactionNeeded" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "points" } },
          { kind: "Field", name: { kind: "Name", value: "wantedPoints" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskListFragmentFragment, unknown>;
export const TaskOfferFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskOfferFragmentFragment, unknown>;
export const TaskProductFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskProductFragmentFragment, unknown>;
export const TaskOfferWithProductsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferWithProductsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TaskOfferFragment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "products" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskProductFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskOfferWithProductsFragmentFragment, unknown>;
export const TaskProductWithOfferFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductWithOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TaskProductFragment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "offer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskOfferFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskProductWithOfferFragmentFragment, unknown>;
export const TaskFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Task" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaireType" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "reactionNeeded" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "isCompany" } },
                { kind: "Field", name: { kind: "Name", value: "statusId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "primaryAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "atype" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "zip" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cityPart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "itype" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskFragmentFragment, unknown>;
export const TeamListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamListItemFragment, unknown>;
export const RecruitingSummaryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecruitingSummary" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RecruitingSummary" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "wanted" } },
          { kind: "Field", name: { kind: "Name", value: "planned" } },
          { kind: "Field", name: { kind: "Name", value: "employed" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecruitingSummaryFragment, unknown>;
export const TeamWithUsersFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamWithUsers" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamWithUsersFragment, unknown>;
export const TeamWithUsersAndForeignUsersFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamWithUsersAndForeignUsers" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamWithUsersAndForeignUsersFragment, unknown>;
export const TeamDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignLeaders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamDetailFragment, unknown>;
export const TermitelContractAttachmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContractAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContractAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contractId" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TermitelContractAttachmentFragment, unknown>;
export const TermitelContractFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "contract" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderDataProcessing" },
          },
          { kind: "Field", name: { kind: "Name", value: "letterOfIndemnity" } },
          { kind: "Field", name: { kind: "Name", value: "runtime" } },
          { kind: "Field", name: { kind: "Name", value: "runtimeType" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriod" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriodType" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoal" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoalType" } },
          { kind: "Field", name: { kind: "Name", value: "deletionPeriod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletionPeriodType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextPossibleTermination" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContractAttachment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContractAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContractAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contractId" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TermitelContractFragment, unknown>;
export const TimelineEntryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TicketTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "effort" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimelineEntryFragment, unknown>;
export const TicketFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Ticket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Ticket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "forecastedEffort" } },
          { kind: "Field", name: { kind: "Name", value: "realEffort" } },
          { kind: "Field", name: { kind: "Name", value: "solution" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reporterId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reporter" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "orderedById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "nextStepById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextStepBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TicketFragment, unknown>;
export const TimesheetYearOverviewDayFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimesheetYearOverviewDay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimesheetYearOverviewDay" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimesheetYearOverviewDayFragment, unknown>;
export const TodoDetailFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoDetailFragmentFragment, unknown>;
export const UploadFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Upload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectUpload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "imported" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadFragment, unknown>;
export const UserWithBillingFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserWithBilling" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "User" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserWithBillingFragment, unknown>;
export const UserWithDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserWithDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "User" } },
          { kind: "Field", name: { kind: "Name", value: "isJumper" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerIds" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isCompany" } },
                { kind: "Field", name: { kind: "Name", value: "salutation" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "itype" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "normalizedValue" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "adminCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaderTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignUserTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignLeaderTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserWithDetailsFragment, unknown>;
export const WorktimeTaskFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "productive" } },
          { kind: "Field", name: { kind: "Name", value: "sidebar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowInCorrections" },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimeTaskFragment, unknown>;
export const WorktimeWoUserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeWoUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimeWoUserFragment, unknown>;
export const WorktimeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Worktime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerReviewDone" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimeFragment, unknown>;
export const WorktimesChangeRequestFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimesChangeRequestFragment, unknown>;
export const WorktimesChangeRequestTaskFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequestTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "productive" } },
          { kind: "Field", name: { kind: "Name", value: "sidebar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowInCorrections" },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimesChangeRequestTaskFragment, unknown>;
export const WorktimesChangeRequestEntryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequestEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequestEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimesChangeRequestTask" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequestTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "productive" } },
          { kind: "Field", name: { kind: "Name", value: "sidebar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowInCorrections" },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimesChangeRequestEntryFragment, unknown>;
export const CoachingFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Coaching" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Coaching" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "employeeInput" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "signed" } },
          { kind: "Field", name: { kind: "Name", value: "nextAppointment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoachingFragment, unknown>;
export const ContactsPrioListContactBaseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactsPrioListContactBase" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "nextCallWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastContact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "zip" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactsPrioListContactBaseFragment, unknown>;
export const ContractFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Contract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "holidays" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "taxBracket" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContractFragment, unknown>;
export const ContactStatesStatsRowFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactStatesStatsRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatesStatsRow" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "count" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactStatesStatsRowFragment, unknown>;
export const FeastdayFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Feastday" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Feastday" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeastdayFragment, unknown>;
export const LateNoteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LateNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LateNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "eta" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "estimatedMinutesLate" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LateNoteFragment, unknown>;
export const ProfileRefFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileRef" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileRefFragment, unknown>;
export const ProfileListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfileRef" },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileRef" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileListItemFragment, unknown>;
export const ProfileDetailFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfileListItem" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileRef" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfileRef" },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileDetailFragment, unknown>;
export const SickNoteFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SickNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SickNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasSickCertificate" },
          },
          { kind: "Field", name: { kind: "Name", value: "childSick" } },
          { kind: "Field", name: { kind: "Name", value: "payment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sickCertificateType" },
          },
          { kind: "Field", name: { kind: "Name", value: "voucherType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SickNoteFragment, unknown>;
export const ProductiveHourGoalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductiveHourGoal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProductiveHourGoal" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "wantedHours" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductiveHourGoalFragment, unknown>;
export const VacationRequestFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VacationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VacationRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "halfDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VacationRequestFragment, unknown>;
export const AcdCallsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "acdCalls" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListAcdCallsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acdCalls" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AcdCallListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCall" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
          { kind: "Field", name: { kind: "Name", value: "noCalls" } },
          { kind: "Field", name: { kind: "Name", value: "firstCall" } },
          { kind: "Field", name: { kind: "Name", value: "lastCall" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcdCallsQuery, AcdCallsQueryVariables>;
export const CountAcdCallsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countAcdCalls" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListAcdCallsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countAcdCalls" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountAcdCallsQuery, CountAcdCallsQueryVariables>;
export const AcdCallDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "acdCall" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acdCall" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AcdCall" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCall" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
          { kind: "Field", name: { kind: "Name", value: "noCalls" } },
          { kind: "Field", name: { kind: "Name", value: "firstCall" } },
          { kind: "Field", name: { kind: "Name", value: "lastCall" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallTime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCallTime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "callTime" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCall" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCall" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AcdCallListItem" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "callTimes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AcdCallTime" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcdCallQuery, AcdCallQueryVariables>;
export const AcdCallTimesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "acdCallTimes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acdCallTimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AcdCallTime" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallTime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCallTime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "callTime" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcdCallTimesQuery, AcdCallTimesQueryVariables>;
export const MutateAcdCallDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateAcdCall" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "call" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AcdCallInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateAcdCall" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "call" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "call" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AcdCall" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCall" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
          { kind: "Field", name: { kind: "Name", value: "noCalls" } },
          { kind: "Field", name: { kind: "Name", value: "firstCall" } },
          { kind: "Field", name: { kind: "Name", value: "lastCall" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCallTime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCallTime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "callTime" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "initiator" } },
          { kind: "Field", name: { kind: "Name", value: "calledNo" } },
          { kind: "Field", name: { kind: "Name", value: "peerNos" } },
          { kind: "Field", name: { kind: "Name", value: "duration" } },
          { kind: "Field", name: { kind: "Name", value: "waiting" } },
          { kind: "Field", name: { kind: "Name", value: "callResult" } },
          { kind: "Field", name: { kind: "Name", value: "connectedPeer" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AcdCall" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AcdCall" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "AcdCallListItem" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "callTimes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AcdCallTime" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateAcdCallMutation,
  MutateAcdCallMutationVariables
>;
export const ContactsRegenStatusChangesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "contactsRegenStatusChanges" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "start" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDateTime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stop" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDateTime" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsRegenStatusChanges" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "start" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "start" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stop" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stop" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsRegenStatusChangesMutation,
  ContactsRegenStatusChangesMutationVariables
>;
export const ApiKeysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "apiKeys" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListApiKeysFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apiKeys" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ApiKey" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApiKey" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ApiKey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApiKeysQuery, ApiKeysQueryVariables>;
export const CountApiKeysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countApiKeys" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListApiKeysFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countApiKeys" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountApiKeysQuery, CountApiKeysQueryVariables>;
export const CreateApiKeyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createApiKey" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ApiKeyInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createApiKey" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "apiKey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ApiKey" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "token" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApiKey" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ApiKey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateApiKeyMutation,
  CreateApiKeyMutationVariables
>;
export const RevokeApiKeyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "revokeApiKey" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revokeApiKey" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ApiKey" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ApiKey" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ApiKey" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "revokedAt" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RevokeApiKeyMutation,
  RevokeApiKeyMutationVariables
>;
export const LogEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "logEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LogFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "logEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LogEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LogEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LogEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "relid" } },
          { kind: "Field", name: { kind: "Name", value: "relation" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "previousContents" } },
          { kind: "Field", name: { kind: "Name", value: "contents" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogEntriesQuery, LogEntriesQueryVariables>;
export const CountLogEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countLogEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CountLogFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countLogEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountLogEntriesQuery,
  CountLogEntriesQueryVariables
>;
export const LogEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "logEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "logEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LogEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LogEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LogEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "relid" } },
          { kind: "Field", name: { kind: "Name", value: "relation" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "previousContents" } },
          { kind: "Field", name: { kind: "Name", value: "contents" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogEntryQuery, LogEntryQueryVariables>;
export const ChangeRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "changeRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ChangeRequestListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "employeeId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EmployeeFull" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "salutation" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeRequestsQuery, ChangeRequestsQueryVariables>;
export const CountChangeRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countChangeRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ChangeRequestListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countChangeRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountChangeRequestsQuery,
  CountChangeRequestsQueryVariables
>;
export const ChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "changeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "landline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactName" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactPhone" },
          },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailConfirmationToken" },
          },
          { kind: "Field", name: { kind: "Name", value: "emailConfirmed" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "requestComment" } },
          { kind: "Field", name: { kind: "Name", value: "returnComment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeRequestQuery, ChangeRequestQueryVariables>;
export const ChangeRequestByTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "changeRequestByToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "token" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeRequestByToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "token" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "landline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactName" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactPhone" },
          },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailConfirmationToken" },
          },
          { kind: "Field", name: { kind: "Name", value: "emailConfirmed" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "requestComment" } },
          { kind: "Field", name: { kind: "Name", value: "returnComment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeRequestByTokenQuery,
  ChangeRequestByTokenQueryVariables
>;
export const DeleteChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteChangeRequestMutation,
  DeleteChangeRequestMutationVariables
>;
export const MutateChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ChangeRequestInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "landline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactName" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactPhone" },
          },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailConfirmationToken" },
          },
          { kind: "Field", name: { kind: "Name", value: "emailConfirmed" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "requestComment" } },
          { kind: "Field", name: { kind: "Name", value: "returnComment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateChangeRequestMutation,
  MutateChangeRequestMutationVariables
>;
export const MutateChangeRequestByTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateChangeRequestByToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "token" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ChangeRequestInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateChangeRequestByToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "token" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "landline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactName" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactPhone" },
          },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailConfirmationToken" },
          },
          { kind: "Field", name: { kind: "Name", value: "emailConfirmed" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "requestComment" } },
          { kind: "Field", name: { kind: "Name", value: "returnComment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateChangeRequestByTokenMutation,
  MutateChangeRequestByTokenMutationVariables
>;
export const SendChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "date" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "landline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactName" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "emergencyContactPhone" },
          },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "emailConfirmationToken" },
          },
          { kind: "Field", name: { kind: "Name", value: "emailConfirmed" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "requestComment" } },
          { kind: "Field", name: { kind: "Name", value: "returnComment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendChangeRequestMutation,
  SendChangeRequestMutationVariables
>;
export const CoachingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "coachings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListCoachingsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coachings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Coaching" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Coaching" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Coaching" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "employeeInput" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "signed" } },
          { kind: "Field", name: { kind: "Name", value: "nextAppointment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoachingsQuery, CoachingsQueryVariables>;
export const CountCoachingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countCoachings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CountCoachingsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countCoachings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountCoachingsQuery, CountCoachingsQueryVariables>;
export const CoachingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "coaching" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coaching" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Coaching" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Coaching" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Coaching" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "employeeInput" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "signed" } },
          { kind: "Field", name: { kind: "Name", value: "nextAppointment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoachingQuery, CoachingQueryVariables>;
export const MutateCoachingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateCoaching" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coaching" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CoachingInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateCoaching" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "coaching" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "coaching" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Coaching" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Coaching" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Coaching" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "employeeInput" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "signed" } },
          { kind: "Field", name: { kind: "Name", value: "nextAppointment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateCoachingMutation,
  MutateCoachingMutationVariables
>;
export const DeleteCoachingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCoaching" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCoaching" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCoachingMutation,
  DeleteCoachingMutationVariables
>;
export const ConfirmCoachingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmCoaching" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmCoaching" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Coaching" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Coaching" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Coaching" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "employeeInput" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "signed" } },
          { kind: "Field", name: { kind: "Name", value: "nextAppointment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmCoachingMutation,
  ConfirmCoachingMutationVariables
>;
export const CommunicationListsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "communicationLists" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CommunicationListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communicationLists" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommunicationList" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommunicationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommunicationList" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "addresses" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CommunicationListsQuery,
  CommunicationListsQueryVariables
>;
export const CountCommunicationListsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countCommunicationLists" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countCommunicationLists" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountCommunicationListsQuery,
  CountCommunicationListsQueryVariables
>;
export const CommunicationListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "communicationList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communicationList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommunicationList" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommunicationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommunicationList" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "addresses" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CommunicationListQuery,
  CommunicationListQueryVariables
>;
export const MutateCommunicationListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateCommunicationList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CommunicationListInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateCommunicationList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommunicationList" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommunicationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CommunicationList" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "addresses" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateCommunicationListMutation,
  MutateCommunicationListMutationVariables
>;
export const DeleteCommunicationListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCommunicationList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCommunicationList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCommunicationListMutation,
  DeleteCommunicationListMutationVariables
>;
export const CommunicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "communications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CommunicationFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Communication" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Communication" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Communication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "lists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommunicationsQuery, CommunicationsQueryVariables>;
export const CountCommunicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countCommunications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CommunicationFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countCommunications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountCommunicationsQuery,
  CountCommunicationsQueryVariables
>;
export const CommunicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "communication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Communication" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Communication" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Communication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "lists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommunicationQuery, CommunicationQueryVariables>;
export const MutateCommunicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateCommunication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CommunicationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateCommunication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Communication" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Communication" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Communication" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "lists" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateCommunicationMutation,
  MutateCommunicationMutationVariables
>;
export const DeleteCommunicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCommunication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCommunication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCommunicationMutation,
  DeleteCommunicationMutationVariables
>;
export const LastCompanyNewsPostDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "lastCompanyNewsPost" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lastCompanyNewsPost" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CompanyNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LastCompanyNewsPostQuery,
  LastCompanyNewsPostQueryVariables
>;
export const CompanyNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "companyNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CompanyNewsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companyNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CompanyNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyNewsQuery, CompanyNewsQueryVariables>;
export const CountCompanyNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countCompanyNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countCompanyNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountCompanyNewsQuery,
  CountCompanyNewsQueryVariables
>;
export const MutateCompanyNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateCompanyNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CompanyNewsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateCompanyNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CompanyNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateCompanyNewsMutation,
  MutateCompanyNewsMutationVariables
>;
export const DeleteCompanyNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCompanyNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCompanyNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCompanyNewsMutation,
  DeleteCompanyNewsMutationVariables
>;
export const CompanyNewsPostDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "companyNewsPost" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companyNewsPost" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CompanyNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyNewsPostQuery,
  CompanyNewsPostQueryVariables
>;
export const ContactOfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactOffer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactOffer" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactOffer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "views" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "offerId" } },
                { kind: "Field", name: { kind: "Name", value: "userAgent" } },
                { kind: "Field", name: { kind: "Name", value: "viewedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactOfferQuery, ContactOfferQueryVariables>;
export const MutateContactOfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContactOffer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "token" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContactOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "token" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactOffer" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactOffer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "views" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "offerId" } },
                { kind: "Field", name: { kind: "Name", value: "userAgent" } },
                { kind: "Field", name: { kind: "Name", value: "viewedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactOfferMutation,
  MutateContactOfferMutationVariables
>;
export const DeleteContactOfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteContactOffer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteContactOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactOffer" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactOffer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "token" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "views" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "offerId" } },
                { kind: "Field", name: { kind: "Name", value: "userAgent" } },
                { kind: "Field", name: { kind: "Name", value: "viewedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteContactOfferMutation,
  DeleteContactOfferMutationVariables
>;
export const CountPipelineContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countPipelineContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactPipelineFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countPipelineContacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountPipelineContactsQuery,
  CountPipelineContactsQueryVariables
>;
export const NextContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "nextContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactPipelineFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "nextContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "project" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NextContactQuery, NextContactQueryVariables>;
export const ContactStatusUpdatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactStatusUpdates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactStatusUpdateListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactStatusUpdates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StatusUpdate" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatusUpdate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatusUpdate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fromId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "from" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "toId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "to" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "afterDays" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactStatusUpdatesQuery,
  ContactStatusUpdatesQueryVariables
>;
export const CountContactStatusUpdatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countContactStatusUpdates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countContactStatusUpdates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountContactStatusUpdatesQuery,
  CountContactStatusUpdatesQueryVariables
>;
export const ContactStatusUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactStatusUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactStatusUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StatusUpdate" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatusUpdate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatusUpdate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fromId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "from" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "toId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "to" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "afterDays" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactStatusUpdateQuery,
  ContactStatusUpdateQueryVariables
>;
export const MutateContactStatusUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContactStatusUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactStatusUpdateInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContactStatusUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StatusUpdate" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatusUpdate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatusUpdate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fromId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "from" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "toId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "to" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "afterDays" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactStatusUpdateMutation,
  MutateContactStatusUpdateMutationVariables
>;
export const DeleteContactStatusUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteContactStatusUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteContactStatusUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StatusUpdate" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StatusUpdate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatusUpdate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "fromId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "from" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "toId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "to" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "afterDays" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteContactStatusUpdateMutation,
  DeleteContactStatusUpdateMutationVariables
>;
export const ContactStatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactStates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactStatesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactStates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactStatus" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactStatus" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allowedAfterCall" } },
          { kind: "Field", name: { kind: "Name", value: "enforceFollowup" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "followupEventTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupSubject" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactStatesQuery, ContactStatesQueryVariables>;
export const CountContactStatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countContactStates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactStatesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countContactStates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountContactStatesQuery,
  CountContactStatesQueryVariables
>;
export const ContactStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactStatus" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactStatus" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allowedAfterCall" } },
          { kind: "Field", name: { kind: "Name", value: "enforceFollowup" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "followupEventTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupSubject" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactStatusQuery, ContactStatusQueryVariables>;
export const MutateContactStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContactStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactStatusInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContactStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactStatus" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactStatus" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allowedAfterCall" } },
          { kind: "Field", name: { kind: "Name", value: "enforceFollowup" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "followupEventTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupSubject" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactStatusMutation,
  MutateContactStatusMutationVariables
>;
export const MoveContactStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "moveContactStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "direction" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MoveContactStatusDirection" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "moveContactStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "direction" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "direction" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactStatus" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactStatus" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allowedAfterCall" } },
          { kind: "Field", name: { kind: "Name", value: "enforceFollowup" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "followupEventTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupSubject" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MoveContactStatusMutation,
  MoveContactStatusMutationVariables
>;
export const DeleteContactStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteContactStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteContactStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactStatus" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactStatus" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatus" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allowedAfterCall" } },
          { kind: "Field", name: { kind: "Name", value: "enforceFollowup" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "followupEventTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupSubject" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultFollowupDays" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteContactStatusMutation,
  DeleteContactStatusMutationVariables
>;
export const ContactGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactGroupDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactGroupDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "gtype" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactGroupsQuery, ContactGroupsQueryVariables>;
export const ContactGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactGroupDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactGroupDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "gtype" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactGroupQuery, ContactGroupQueryVariables>;
export const MutateContactGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContactGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "group" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactGroupInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContactGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "group" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "group" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactGroupDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactGroupDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "gtype" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactGroupMutation,
  MutateContactGroupMutationVariables
>;
export const DeleteContactGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteContactGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withContacts" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteContactGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "withContacts" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "withContacts" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteContactGroupMutation,
  DeleteContactGroupMutationVariables
>;
export const ContactAddfieldsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactAddfields" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactAddfieldListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactAddfields" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddfield" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddfield" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddfield" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "automatic" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactAddfieldsQuery,
  ContactAddfieldsQueryVariables
>;
export const CountContactAddfieldsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countContactAddfields" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countContactAddfields" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountContactAddfieldsQuery,
  CountContactAddfieldsQueryVariables
>;
export const ContactAddfieldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactAddfield" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactAddfield" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddfield" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddfield" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddfield" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "automatic" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactAddfieldQuery,
  ContactAddfieldQueryVariables
>;
export const MutateContactAddfieldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContactAddfield" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactAddfieldInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContactAddfield" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddfield" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddfield" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddfield" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "automatic" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactAddfieldMutation,
  MutateContactAddfieldMutationVariables
>;
export const DeleteContactAddfieldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteContactAddfield" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteContactAddfield" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddfield" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddfield" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddfield" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "automatic" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteContactAddfieldMutation,
  DeleteContactAddfieldMutationVariables
>;
export const CountContactsPrioListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countContactsPrioList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsPrioListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countContactsPrioList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountContactsPrioListQuery,
  CountContactsPrioListQueryVariables
>;
export const ContactTransferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "contactTransfer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ownerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "transferContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ownerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ownerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ContactDetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactTransferMutation,
  ContactTransferMutationVariables
>;
export const ContactLockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "contactLock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lockContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "contactId" } },
                { kind: "Field", name: { kind: "Name", value: "lockerId" } },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockRefreshedAt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactLockMutation, ContactLockMutationVariables>;
export const ContactUnlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "contactUnlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unlockContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "contactId" } },
                { kind: "Field", name: { kind: "Name", value: "lockerId" } },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockRefreshedAt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactUnlockMutation,
  ContactUnlockMutationVariables
>;
export const ContactsMergeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "contactsMerge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "merge" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "StringNumber" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeContacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "merge" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "merge" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsMergeMutation,
  ContactsMergeMutationVariables
>;
export const ContactsPrioListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactsPrioList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsPrioListFilters" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "followupDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NaiveDate" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "followupCleared" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "followupCanceled" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsPrioList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactsPrioListContactBase" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "followups" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "startDate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "followupDate" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "cleared" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "followupCleared" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "canceled" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "followupCanceled" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startTime" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactsPrioListContactBase" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "nextCallWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastContact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "zip" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsPrioListQuery,
  ContactsPrioListQueryVariables
>;
export const ContactsPrioListWoFollowupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactsPrioListWoFollowups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsPrioListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsPrioList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactsPrioListContactBase" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextFollowup" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startTime" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactsPrioListContactBase" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "nextCallWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastContact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "zip" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsPrioListWoFollowupsQuery,
  ContactsPrioListWoFollowupsQueryVariables
>;
export const ContactDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "contactDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactDeleteMutation,
  ContactDeleteMutationVariables
>;
export const ContactsSubscriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "contactsSubscription" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactFragment" },
                },
                { kind: "Field", name: { kind: "Name", value: "statusId" } },
                { kind: "Field", name: { kind: "Name", value: "editorId" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ContactDetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsSubscriptionSubscription,
  ContactsSubscriptionSubscriptionVariables
>;
export const ContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ContactDetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "parent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastContact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextFollowup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "allDay" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                { kind: "Field", name: { kind: "Name", value: "zip" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactsQuery, ContactsQueryVariables>;
export const CountContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countContacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountContactsQuery, CountContactsQueryVariables>;
export const ContactsWithInfosDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactsWithInfos" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactWithInfosListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactWithInfosListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsWithInfosQuery,
  ContactsWithInfosQueryVariables
>;
export const ContactsWithInfosAndAddressesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactsWithInfosAndAddresses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ContactWithInfosAndAddressesListItem",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactWithInfosAndAddressesListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsWithInfosAndAddressesQuery,
  ContactsWithInfosAndAddressesQueryVariables
>;
export const CreateContactsBatchActionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createContactsBatchAction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "action" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactBatchAction" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactsListFilters" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactBatchInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createContactsBatchAction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "action" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "action" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "JobResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "JobResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "JobResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "module" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "hasAttachment" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "report" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateContactsBatchActionMutation,
  CreateContactsBatchActionMutationVariables
>;
export const ImportContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "importContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "config" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactImportConfig" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "importContacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "config" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "file" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "file" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "JobResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "JobResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "JobResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "module" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "hasAttachment" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "report" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImportContactsMutation,
  ImportContactsMutationVariables
>;
export const ExportContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "exportContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactsListFilters" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fields" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ContactsExportJobField" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exportContacts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fields" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fields" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "JobResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "JobResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "JobResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "module" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "hasAttachment" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "report" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportContactsMutation,
  ExportContactsMutationVariables
>;
export const MutateContactInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContactInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "info" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactInfoInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContactInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "info" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "info" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactInfoMutation,
  MutateContactInfoMutationVariables
>;
export const SendVerifyMailForInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendVerifyMailForInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendVerifyMailForInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendVerifyMailForInfoMutation,
  SendVerifyMailForInfoMutationVariables
>;
export const ContactAttachmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactAttachments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsAttachmentsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactAttachments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactAttachmentsQuery,
  ContactAttachmentsQueryVariables
>;
export const CountContactAttachmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countContactAttachments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countContactAttachments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountContactAttachmentsQuery,
  CountContactAttachmentsQueryVariables
>;
export const MutateContactAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContactAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactAttachmentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContactAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactAttachmentMutation,
  MutateContactAttachmentMutationVariables
>;
export const DeleteContactAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteContactAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteContactAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteContactAttachmentMutation,
  DeleteContactAttachmentMutationVariables
>;
export const ContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactFragment" },
                },
                { kind: "Field", name: { kind: "Name", value: "editorId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ContactDetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactQuery, ContactQueryVariables>;
export const MutateContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contact" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contact" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contact" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactFragment" },
                },
                { kind: "Field", name: { kind: "Name", value: "editorId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "project" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "ctype" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "isCompany" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "firstname" } },
          { kind: "Field", name: { kind: "Name", value: "lastname" } },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "birthdate" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockRefreshedAt" } },
          { kind: "Field", name: { kind: "Name", value: "lockerId" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contact" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ContactDetail" },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactInfo" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContactAddress" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "status" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "infos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactInfo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "addresses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactAddress" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetailWoContact" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactMutation,
  MutateContactMutationVariables
>;
export const ContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContractListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contracts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Contract" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Contract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "holidays" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "taxBracket" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContractsQuery, ContractsQueryVariables>;
export const ContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contract" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contract" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Contract" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Contract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "holidays" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "taxBracket" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContractQuery, ContractQueryVariables>;
export const ContractForUserAndDateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contractForUserAndDate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contractForUserAndDate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "date" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Contract" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Contract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "holidays" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "taxBracket" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContractForUserAndDateQuery,
  ContractForUserAndDateQueryVariables
>;
export const MutateContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContract" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContractInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContract" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Contract" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Contract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Contract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "holidays" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "monthlyWage" } },
          { kind: "Field", name: { kind: "Name", value: "taxBracket" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContractMutation,
  MutateContractMutationVariables
>;
export const DeleteContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteContract" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteContract" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteContractMutation,
  DeleteContractMutationVariables
>;
export const GenerateContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "generateContract" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GenContractInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "generateContract" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateContractMutation,
  GenerateContractMutationVariables
>;
export const CreateContractAdaptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createContractAdaption" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContractAdaptionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createContractAdaption" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateContractAdaptionMutation,
  CreateContractAdaptionMutationVariables
>;
export const EmployeeControllingDayOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "employeeControllingDayOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employeeControllingDayOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "date" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "startHour" } },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "eta" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmployeeControllingDayOverviewQuery,
  EmployeeControllingDayOverviewQueryVariables
>;
export const EmployeeCouponsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "employeeCoupons" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EmployeeCouponsListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employeeCoupons" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeCoupon" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeCoupon" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EmployeeCoupon" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "claimed" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmployeeCouponsQuery,
  EmployeeCouponsQueryVariables
>;
export const CountEmployeeCouponsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countEmployeeCoupons" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EmployeeCouponsCountOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countEmployeeCoupons" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountEmployeeCouponsQuery,
  CountEmployeeCouponsQueryVariables
>;
export const EmployeeCouponDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "employeeCoupon" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employeeCoupon" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeCoupon" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeCoupon" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EmployeeCoupon" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "claimed" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeCouponQuery, EmployeeCouponQueryVariables>;
export const CurrentEmployeeCouponDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "currentEmployeeCoupon" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentEmployeeCoupon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CurrentEmployeeCouponQuery,
  CurrentEmployeeCouponQueryVariables
>;
export const MutateEmployeeCouponDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateEmployeeCoupon" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EmployeeCouponInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateEmployeeCoupon" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeCoupon" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeCoupon" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EmployeeCoupon" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "claimed" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateEmployeeCouponMutation,
  MutateEmployeeCouponMutationVariables
>;
export const DeleteEmployeeCouponDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteEmployeeCoupon" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteEmployeeCoupon" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeCoupon" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeCoupon" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EmployeeCoupon" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "claimed" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteEmployeeCouponMutation,
  DeleteEmployeeCouponMutationVariables
>;
export const CustomerFeedbacksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "customerFeedbacks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CustomerFeedbackListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedbacks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedback" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedback" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selfAssessmentState" },
          },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "topicId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerFeedbacksQuery,
  CustomerFeedbacksQueryVariables
>;
export const CountCustomerFeedbacksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countCustomerFeedbacks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CustomerFeedbackListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countCustomerFeedbacks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountCustomerFeedbacksQuery,
  CountCustomerFeedbacksQueryVariables
>;
export const CustomerFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "customerFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedback" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedback" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selfAssessmentState" },
          },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "topicId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerFeedbackQuery,
  CustomerFeedbackQueryVariables
>;
export const MarkCustomerFeedbackDoneDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markCustomerFeedbackDone" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markCustomerFeedbackDone" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedback" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedback" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selfAssessmentState" },
          },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "topicId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkCustomerFeedbackDoneMutation,
  MarkCustomerFeedbackDoneMutationVariables
>;
export const ClassifyCustomerFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "classifyCustomerFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CustomerFeedbackClassifyInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "classifyCustomerFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedback" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedback" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selfAssessmentState" },
          },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "topicId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClassifyCustomerFeedbackMutation,
  ClassifyCustomerFeedbackMutationVariables
>;
export const SelfClassifyCustomerFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "selfClassifyCustomerFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CustomerFeedbackSelfClassifyInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "selfClassifyCustomerFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedback" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedback" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selfAssessmentState" },
          },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "topicId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SelfClassifyCustomerFeedbackMutation,
  SelfClassifyCustomerFeedbackMutationVariables
>;
export const DeleteCustomerFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCustomerFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCustomerFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCustomerFeedbackMutation,
  DeleteCustomerFeedbackMutationVariables
>;
export const CustomerFeedbackAnnotationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "customerFeedbackAnnotations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "feedbackId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedbackAnnotations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "feedbackId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedbackId" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerFeedbackAnnotationsQuery,
  CustomerFeedbackAnnotationsQueryVariables
>;
export const MutateCustomerFeedbackAnnotationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateCustomerFeedbackAnnotation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "feedbackId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CustomerFeedbackAnnotationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateCustomerFeedbackAnnotation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "feedbackId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedbackId" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateCustomerFeedbackAnnotationMutation,
  MutateCustomerFeedbackAnnotationMutationVariables
>;
export const MarkCustomerFeedbackAnnotationDoneDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markCustomerFeedbackAnnotationDone" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "feedbackId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markCustomerFeedbackAnnotationDone" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feedbackId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "feedbackId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedbackAnnotation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedbackId" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkCustomerFeedbackAnnotationDoneMutation,
  MarkCustomerFeedbackAnnotationDoneMutationVariables
>;
export const CustomerFeedbackTopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "customerFeedbackTopics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CustomerFeedbackTopicsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedbackTopics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedbackTopic" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedbackTopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedbackTopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerFeedbackTopicsQuery,
  CustomerFeedbackTopicsQueryVariables
>;
export const CountCustomerFeedbackTopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countCustomerFeedbackTopics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CustomerFeedbackTopicsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countCustomerFeedbackTopics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountCustomerFeedbackTopicsQuery,
  CountCustomerFeedbackTopicsQueryVariables
>;
export const CustomerFeedbackTopicDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "customerFeedbackTopic" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerFeedbackTopic" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedbackTopic" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedbackTopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedbackTopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerFeedbackTopicQuery,
  CustomerFeedbackTopicQueryVariables
>;
export const MutateCustomerFeedbackTopicDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateCustomerFeedbackTopic" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CustomerFeedbackTopicInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateCustomerFeedbackTopic" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedbackTopic" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedbackTopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedbackTopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateCustomerFeedbackTopicMutation,
  MutateCustomerFeedbackTopicMutationVariables
>;
export const ImportCustomerFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "importCustomerFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "importSince" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NaiveDateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "config" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "importCustomerFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "file" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "file" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "importSince" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "importSince" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "config" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImportCustomerFeedbackMutation,
  ImportCustomerFeedbackMutationVariables
>;
export const ExportCustomerFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "exportCustomerFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CustomerFeedbackListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exportCustomerFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportCustomerFeedbackMutation,
  ExportCustomerFeedbackMutationVariables
>;
export const UnclassifiedCustomerFeedbacksCountForUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "unclassifiedCustomerFeedbacksCountForUser",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "unclassifiedCustomerFeedbacksCountForUser",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnclassifiedCustomerFeedbacksCountForUserQuery,
  UnclassifiedCustomerFeedbacksCountForUserQueryVariables
>;
export const ShiftCustomerFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "shiftCustomerFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftCustomerFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFeedback" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFeedback" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selfAssessmentState" },
          },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "topicId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "topic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftCustomerFeedbackMutation,
  ShiftCustomerFeedbackMutationVariables
>;
export const DeleteCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCustomerMutation,
  DeleteCustomerMutationVariables
>;
export const SwitcherCustomersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "switcherCustomers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CustomersListFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionCustomer" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionCustomer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerAdministrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SwitcherCustomersQuery,
  SwitcherCustomersQueryVariables
>;
export const CustomersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "customers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CustomersListFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "inDeletion" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerLogo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomersQuery, CustomersQueryVariables>;
export const CustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "customer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "inDeletion" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerLogo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "active" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerAdministrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerQuery, CustomerQueryVariables>;
export const CustomersWithCustomerAdministratorsAndProjectsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "customersWithCustomerAdministratorsAndProjects",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CustomersListFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerListItem" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customerAdministrators" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "username" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projects" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "active" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "insertedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "inDeletion" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerLogo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomersWithCustomerAdministratorsAndProjectsQuery,
  CustomersWithCustomerAdministratorsAndProjectsQueryVariables
>;
export const MutateCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CustomerInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "inDeletion" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CustomerLogo" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "active" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerAdministrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateCustomerMutation,
  MutateCustomerMutationVariables
>;
export const ContactStatesStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactStatesStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactStatesStats" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactStatesStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContactStatesStatsRow" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactStatesStatsRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactStatesStatsRow" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "statusId" } },
          { kind: "Field", name: { kind: "Name", value: "count" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactStatesStatsQuery,
  ContactStatesStatsQueryVariables
>;
export const ContactsAddfieldStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "contactsAddfieldStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "addfields" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ContactsAddfieldFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsAddfieldStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "addfields" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "addfields" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactsAddfieldStatsQuery,
  ContactsAddfieldStatsQueryVariables
>;
export const DashboardStatsNewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "dashboardStatsNew" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DashboardStatsFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dashboardStatsNew" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DashboardStatsNewQuery,
  DashboardStatsNewQueryVariables
>;
export const ProductiveHourGoalDashboardStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "productiveHourGoalDashboardStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "starts" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stops" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "productiveHourGoalDashboardStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "starts" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "starts" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stops" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stops" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "wantedHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "productiveHours" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductiveHourGoalDashboardStatsQuery,
  ProductiveHourGoalDashboardStatsQueryVariables
>;
export const DigitalSignatureEnvelopesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "digitalSignatureEnvelopes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "DigitalSignatureEnvelopeListFilters",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureEnvelopes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DigitalSignatureEnvelope" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DigitalSignatureEnvelopesQuery,
  DigitalSignatureEnvelopesQueryVariables
>;
export const CountDigitalSignatureEnvelopesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countDigitalSignatureEnvelopes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "DigitalSignatureEnvelopeListFilters",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countDigitalSignatureEnvelopes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountDigitalSignatureEnvelopesQuery,
  CountDigitalSignatureEnvelopesQueryVariables
>;
export const DigitalSignatureEnvelopeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "digitalSignatureEnvelope" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureEnvelope" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DigitalSignatureEnvelope" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "files" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DigitalSignatureFile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fields" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DigitalSignatureField" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureId" },
          },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureField" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureFileId" },
          },
          { kind: "Field", name: { kind: "Name", value: "pageNo" } },
          { kind: "Field", name: { kind: "Name", value: "x" } },
          { kind: "Field", name: { kind: "Name", value: "y" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DigitalSignatureEnvelopeQuery,
  DigitalSignatureEnvelopeQueryVariables
>;
export const MutateDigitalSignatureEnvelopeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateDigitalSignatureEnvelope" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DigitalSignatureEnvelopeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateDigitalSignatureEnvelope" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DigitalSignatureEnvelope" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateDigitalSignatureEnvelopeMutation,
  MutateDigitalSignatureEnvelopeMutationVariables
>;
export const DeleteDigitalSignatureEnvelopeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteDigitalSignatureEnvelope" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteDigitalSignatureEnvelope" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDigitalSignatureEnvelopeMutation,
  DeleteDigitalSignatureEnvelopeMutationVariables
>;
export const MutateDigitalSignatureFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateDigitalSignatureFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "envelopeId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DigitalSignatureFileInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateDigitalSignatureFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "envelopeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "envelopeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DigitalSignatureFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureId" },
          },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateDigitalSignatureFileMutation,
  MutateDigitalSignatureFileMutationVariables
>;
export const DeleteDigitalSignatureFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteDigitalSignatureFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "envelopeId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteDigitalSignatureFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "envelopeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "envelopeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDigitalSignatureFileMutation,
  DeleteDigitalSignatureFileMutationVariables
>;
export const MutateDigitalSignatureFieldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateDigitalSignatureField" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "envelopeId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DigitalSignatureFieldInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateDigitalSignatureField" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "envelopeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "envelopeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DigitalSignatureField" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureField" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureFileId" },
          },
          { kind: "Field", name: { kind: "Name", value: "pageNo" } },
          { kind: "Field", name: { kind: "Name", value: "x" } },
          { kind: "Field", name: { kind: "Name", value: "y" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateDigitalSignatureFieldMutation,
  MutateDigitalSignatureFieldMutationVariables
>;
export const DeleteDigitalSignatureFieldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteDigitalSignatureField" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "envelopeId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteDigitalSignatureField" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "envelopeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "envelopeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDigitalSignatureFieldMutation,
  DeleteDigitalSignatureFieldMutationVariables
>;
export const SendDigitalSignatureEnvelopeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendDigitalSignatureEnvelope" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendDigitalSignatureEnvelope" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DigitalSignatureEnvelope" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "files" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DigitalSignatureFile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fields" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DigitalSignatureField" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureEnvelope" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureId" },
          },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalSignatureField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DigitalSignatureField" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "digitalSignatureFileId" },
          },
          { kind: "Field", name: { kind: "Name", value: "pageNo" } },
          { kind: "Field", name: { kind: "Name", value: "x" } },
          { kind: "Field", name: { kind: "Name", value: "y" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendDigitalSignatureEnvelopeMutation,
  SendDigitalSignatureEnvelopeMutationVariables
>;
export const DocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "documents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListDocumentsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "signatureType" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "signatureDue" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Document" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentsQuery, DocumentsQueryVariables>;
export const CountDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListDocumentsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countDocuments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountDocumentsQuery, CountDocumentsQueryVariables>;
export const DocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "document" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "document" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DetailDocument" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "signatureType" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "signatureDue" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Document" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DocumentAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentSignature" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DocumentSignature" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DetailDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "DocumentListItem" },
          },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentAttachment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "missingSignatures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "signatures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentQuery, DocumentQueryVariables>;
export const MutateDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DocumentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Document" },
                },
                { kind: "Field", name: { kind: "Name", value: "document" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "signatureType" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "signatureDue" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateDocumentMutation,
  MutateDocumentMutationVariables
>;
export const DeleteDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;
export const ConfirmDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentSignature" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentSignature" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DocumentSignature" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmDocumentMutation,
  ConfirmDocumentMutationVariables
>;
export const MissingDocumentSignaturesForUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "missingDocumentSignaturesForUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "missingDocumentSignaturesForUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "missing" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MissingDocumentSignaturesForUsersQuery,
  MissingDocumentSignaturesForUsersQueryVariables
>;
export const MissingDocumentSignaturesForUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "missingDocumentSignaturesForUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "missingDocumentSignaturesForUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "signatureType" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "signatureDue" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Document" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MissingDocumentSignaturesForUserQuery,
  MissingDocumentSignaturesForUserQueryVariables
>;
export const MutateDocumentAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateDocumentAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "documentId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DocumentAttachmentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateDocumentAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "documentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "documentId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DocumentAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "documentId" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateDocumentAttachmentMutation,
  MutateDocumentAttachmentMutationVariables
>;
export const OverdueDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "overdueDocuments" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "overdueDocuments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DocumentListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "keywords" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "signatureType" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "signatureDue" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DocumentListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Document" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OverdueDocumentsQuery,
  OverdueDocumentsQueryVariables
>;
export const EmployeePerformanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "employeePerformance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EmployeePerformanceShowFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employeePerformance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmployeePerformanceQuery,
  EmployeePerformanceQueryVariables
>;
export const EmployeePerformancesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "employeePerformances" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EmployeePerformanceListFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employeePerformances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "stats" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmployeePerformancesQuery,
  EmployeePerformancesQueryVariables
>;
export const EmployeesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "employees" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EmployeesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employees" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeesQuery, EmployeesQueryVariables>;
export const CountEmployeesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countEmployees" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EmployeesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countEmployees" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountEmployeesQuery, CountEmployeesQueryVariables>;
export const EmployeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "employee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeQuery, EmployeeQueryVariables>;
export const MutateEmployeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EmployeeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateEmployee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateEmployeeMutation,
  MutateEmployeeMutationVariables
>;
export const ArchiveEmployeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "archiveEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "archiveEmployee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArchiveEmployeeMutation,
  ArchiveEmployeeMutationVariables
>;
export const TerminateEmployeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "terminateEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TerminateEmployeeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "terminateEmployee" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EmployeeFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TerminateEmployeeMutation,
  TerminateEmployeeMutationVariables
>;
export const MutateEmployeeInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateEmployeeInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "infoId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactInfoInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateEmployeeInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "infoId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "infoId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateEmployeeInfoMutation,
  MutateEmployeeInfoMutationVariables
>;
export const DeleteEmployeeInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteEmployeeInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "infoId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteEmployeeInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "infoId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "infoId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteEmployeeInfoMutation,
  DeleteEmployeeInfoMutationVariables
>;
export const MutateEmployeeAddressDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateEmployeeAddress" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "addressId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ContactAddressInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateEmployeeAddress" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "addressId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "addressId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateEmployeeAddressMutation,
  MutateEmployeeAddressMutationVariables
>;
export const EventTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventTypesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "mayForeign" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventTypesQuery, EventTypesQueryVariables>;
export const EventTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "mayForeign" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventTypeQuery, EventTypeQueryVariables>;
export const CountEventTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countEventTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countEventTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountEventTypesQuery,
  CountEventTypesQueryVariables
>;
export const MutateEventTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateEventType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "eventType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EventTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateEventType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "eventType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "mayForeign" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateEventTypeMutation,
  MutateEventTypeMutationVariables
>;
export const DeleteEventTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteEventType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteEventType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteEventTypeMutation,
  DeleteEventTypeMutationVariables
>;
export const CountEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountEventsQuery, CountEventsQueryVariables>;
export const EventTimeValidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventTimeValid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ownerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startTime" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDateTime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endTime" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "NaiveDateTime" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventTimeValid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ownerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ownerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startTime" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startTime" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endTime" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endTime" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventTimeValidQuery, EventTimeValidQueryVariables>;
export const DeleteEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEventMutation, DeleteEventMutationVariables>;
export const EventsCalendarDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventsCalendar" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventsCalendarQuery, EventsCalendarQueryVariables>;
export const EventsWithOwnerAndAttendeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventsWithOwnerAndAttendee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EventsWithOwnerAndAttendeeQuery,
  EventsWithOwnerAndAttendeeQueryVariables
>;
export const EventsWithOwnerAndCreatorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventsWithOwnerAndCreator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EventsWithOwnerAndCreatorQuery,
  EventsWithOwnerAndCreatorQueryVariables
>;
export const ExportEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "exportEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exportEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportEventsMutation,
  ExportEventsMutationVariables
>;
export const EventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "event" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "project" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventQuery, EventQueryVariables>;
export const EventAllDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventAllDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
                { kind: "Field", name: { kind: "Name", value: "editorId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "editor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EventAllDetailsQuery,
  EventAllDetailsQueryVariables
>;
export const MutateEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EventInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutateEventMutation, MutateEventMutationVariables>;
export const CancelEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "cancelEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelEventMutation, CancelEventMutationVariables>;
export const UncancelEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "uncancelEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uncancelEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UncancelEventMutation,
  UncancelEventMutationVariables
>;
export const ClearEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "clearEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClearEventMutation, ClearEventMutationVariables>;
export const UnclearEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "unclearEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unclearEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnclearEventMutation,
  UnclearEventMutationVariables
>;
export const SendEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendEventMutation, SendEventMutationVariables>;
export const ShiftEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "shiftEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ShiftEventInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShiftEventMutation, ShiftEventMutationVariables>;
export const ConfirmEventWithTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmEventWithToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "token" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmEventWithToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "token" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetailWoContact" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "shifted" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "typeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "replacementForEvent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbacks" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EventDetailWoContact" },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmEventWithTokenMutation,
  ConfirmEventWithTokenMutationVariables
>;
export const TransferEventOwnershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "transferEventOwnership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EventsListFilters" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "newOwnerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "transferEventOwnership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newOwnerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "newOwnerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
                { kind: "Field", name: { kind: "Name", value: "endTime" } },
                { kind: "Field", name: { kind: "Name", value: "shifted" } },
                { kind: "Field", name: { kind: "Name", value: "canceled" } },
                { kind: "Field", name: { kind: "Name", value: "cleared" } },
                { kind: "Field", name: { kind: "Name", value: "allDay" } },
                { kind: "Field", name: { kind: "Name", value: "sent" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "contactId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "type" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TransferEventOwnershipMutation,
  TransferEventOwnershipMutationVariables
>;
export const FeastdaysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "feastdays" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListFeastdaysFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "feastdays" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Feastday" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Feastday" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Feastday" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeastdaysQuery, FeastdaysQueryVariables>;
export const CountFeastdaysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countFeastdays" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CountFeastdaysFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countFeastdays" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountFeastdaysQuery, CountFeastdaysQueryVariables>;
export const FeastdayDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "feastday" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "feastday" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Feastday" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Feastday" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Feastday" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeastdayQuery, FeastdayQueryVariables>;
export const DeleteFeastdayDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteFeastday" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFeastday" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteFeastdayMutation,
  DeleteFeastdayMutationVariables
>;
export const MutateFeastdayDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateFeastday" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "feastday" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FeastdayInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateFeastday" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feastday" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "feastday" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Feastday" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Feastday" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Feastday" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateFeastdayMutation,
  MutateFeastdayMutationVariables
>;
export const EventFeedbacksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventFeedbacks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "eventId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventFeedbackListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventFeedbacks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "eventId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "eventId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackEvent" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventFeedbacksQuery, EventFeedbacksQueryVariables>;
export const EventFeedbacksForEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventFeedbacksForEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "eventId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventFeedbackListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventFeedbacks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "eventId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "eventId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackEvent" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EventFeedbacksForEventQuery,
  EventFeedbacksForEventQueryVariables
>;
export const CountEventFeedbacksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countEventFeedbacks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "eventId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EventFeedbackListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countEventFeedbacks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "eventId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountEventFeedbacksQuery,
  CountEventFeedbacksQueryVariables
>;
export const EventFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "eventFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eventFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "eventId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackEvent" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventFeedbackQuery, EventFeedbackQueryVariables>;
export const MutateEventFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateEventFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "eventId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EventFeedbackInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateEventFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "eventId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Event" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "canceled" } },
          { kind: "Field", name: { kind: "Name", value: "cleared" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EventFeedbackDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventFeedback" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "tookPlace" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "eventId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "event" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EventFeedbackEvent" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateEventFeedbackMutation,
  MutateEventFeedbackMutationVariables
>;
export const DeleteEventFeedbackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteEventFeedback" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteEventFeedback" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteEventFeedbackMutation,
  DeleteEventFeedbackMutationVariables
>;
export const FileExchangeEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fileExchangeEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FileExchangeListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fileExchangeEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FileExchangeEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileExchangeEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FileExchangeEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FileExchangeEntriesQuery,
  FileExchangeEntriesQueryVariables
>;
export const CountFileExchangeEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countFileExchangeEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FileExchangeListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countFileExchangeEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountFileExchangeEntriesQuery,
  CountFileExchangeEntriesQueryVariables
>;
export const FileExchangeEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fileExchangeEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fileExchangeEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FileExchangeEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileExchangeEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FileExchangeEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FileExchangeEntryQuery,
  FileExchangeEntryQueryVariables
>;
export const FileExchangeUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fileExchangeUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fileExchangeUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "search" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FileExchangeUsersQuery,
  FileExchangeUsersQueryVariables
>;
export const MutateFileExchangeEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateFileExchangeEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FileExchangeEntryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateFileExchangeEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FileExchangeEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileExchangeEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FileExchangeEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateFileExchangeEntryMutation,
  MutateFileExchangeEntryMutationVariables
>;
export const MarkFileExchangeEntryDoneDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markFileExchangeEntryDone" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markFileExchangeEntryDone" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FileExchangeEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FileExchangeEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FileExchangeEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkFileExchangeEntryDoneMutation,
  MarkFileExchangeEntryDoneMutationVariables
>;
export const DeleteFileExchangeEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteFileExchangeEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFileExchangeEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteFileExchangeEntryMutation,
  DeleteFileExchangeEntryMutationVariables
>;
export const CreateFileExchangeEntryFromEmployeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createFileExchangeEntryFromEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "recipientId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createFileExchangeEntryFromEmployee",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipientId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "recipientId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFileExchangeEntryFromEmployeeMutation,
  CreateFileExchangeEntryFromEmployeeMutationVariables
>;
export const CreateFileExchangeEntryFromPersonalFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createFileExchangeEntryFromPersonalFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "recipientId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createFileExchangeEntryFromPersonalFile",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipientId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "recipientId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFileExchangeEntryFromPersonalFileMutation,
  CreateFileExchangeEntryFromPersonalFileMutationVariables
>;
export const FinanceReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "financeReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FinanceReportListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financeReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customerName" },
                },
                { kind: "Field", name: { kind: "Name", value: "hours" } },
                { kind: "Field", name: { kind: "Name", value: "earnings" } },
                { kind: "Field", name: { kind: "Name", value: "expenses" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FinanceReportQuery, FinanceReportQueryVariables>;
export const RegenerateFinanceReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "regenerateFinanceReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "start" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stop" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "regenerateFinanceReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "start" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "start" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stop" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stop" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegenerateFinanceReportsMutation,
  RegenerateFinanceReportsMutationVariables
>;
export const FinanceReportCorrectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "financeReportCorrections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FinanceReportCorrectionListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financeReportCorrections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinanceReportCorrection" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinanceReportCorrection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FinanceReportCorrection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "earnings" } },
          { kind: "Field", name: { kind: "Name", value: "expenses" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FinanceReportCorrectionsQuery,
  FinanceReportCorrectionsQueryVariables
>;
export const CountFinanceReportCorrectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countFinanceReportCorrections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "FinanceReportCorrectionListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countFinanceReportCorrections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountFinanceReportCorrectionsQuery,
  CountFinanceReportCorrectionsQueryVariables
>;
export const FinanceReportCorrectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "financeReportCorrection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financeReportCorrection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinanceReportCorrection" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinanceReportCorrection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FinanceReportCorrection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "earnings" } },
          { kind: "Field", name: { kind: "Name", value: "expenses" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FinanceReportCorrectionQuery,
  FinanceReportCorrectionQueryVariables
>;
export const MutateFinanceReportCorrectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateFinanceReportCorrection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FinanceReportCorrectionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateFinanceReportCorrection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinanceReportCorrection" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinanceReportCorrection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FinanceReportCorrection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "earnings" } },
          { kind: "Field", name: { kind: "Name", value: "expenses" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateFinanceReportCorrectionMutation,
  MutateFinanceReportCorrectionMutationVariables
>;
export const DeleteFinanceReportCorrectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteFinanceReportCorrection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFinanceReportCorrection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FinanceReportCorrection" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FinanceReportCorrection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FinanceReportCorrection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "hours" } },
          { kind: "Field", name: { kind: "Name", value: "earnings" } },
          { kind: "Field", name: { kind: "Name", value: "expenses" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteFinanceReportCorrectionMutation,
  DeleteFinanceReportCorrectionMutationVariables
>;
export const HistoryAuditLogEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "historyAuditLogEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "HistoryAuditLogFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "historyAuditLogEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HistoryAuditLogEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryAuditLogEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAuditLogEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
          { kind: "Field", name: { kind: "Name", value: "changes" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HistoryAuditLogEntriesQuery,
  HistoryAuditLogEntriesQueryVariables
>;
export const CountHistoryAuditLogEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countHistoryAuditLogEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "HistoryAuditLogFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countHistoryAuditLogEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountHistoryAuditLogEntriesQuery,
  CountHistoryAuditLogEntriesQueryVariables
>;
export const HistoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "histories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "HistoriesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "histories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "History" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fileAttachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "HistoryFileAttachment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "callResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "History" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "History" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "pinned" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryFileAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "deletionReason" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HistoriesQuery, HistoriesQueryVariables>;
export const CountHistoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countHistories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "HistoriesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countHistories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountHistoriesQuery, CountHistoriesQueryVariables>;
export const CallHistoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "callHistories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CallHistoriesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "callHistories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "History" },
                },
                { kind: "Field", name: { kind: "Name", value: "allDone" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "History" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "History" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "pinned" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallHistoriesQuery, CallHistoriesQueryVariables>;
export const CountCallHistoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countCallHistories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CallHistoriesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countCallHistories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountCallHistoriesQuery,
  CountCallHistoriesQueryVariables
>;
export const MutateHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "eventId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "history" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "HistoryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "eventId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "eventId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "history" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "history" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "History" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "History" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "History" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "pinned" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateHistoryMutation,
  MutateHistoryMutationVariables
>;
export const ExportCallHistoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "exportCallHistories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CallHistoriesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exportCallHistories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportCallHistoriesMutation,
  ExportCallHistoriesMutationVariables
>;
export const MarkHistoryDoneDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markHistoryDone" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markHistoryDone" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "History" },
                },
                { kind: "Field", name: { kind: "Name", value: "allDone" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "History" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "History" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "pinned" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkHistoryDoneMutation,
  MarkHistoryDoneMutationVariables
>;
export const HistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "history" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "history" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "History" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "annotations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "HistoryAnnotation" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "History" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "History" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "pinned" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryAnnotation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAnnotation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HistoryQuery, HistoryQueryVariables>;
export const PinHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "pinHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pinned" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "pinHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pinned" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pinned" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "History" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fileAttachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "HistoryFileAttachment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "callResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "History" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "History" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "meta" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "pinned" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryFileAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "deletionReason" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PinHistoryMutation, PinHistoryMutationVariables>;
export const MutateContactHistoryAnnotationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateContactHistoryAnnotation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "historyId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "annotation" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "HistoryAnnotationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateContactHistoryAnnotation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "historyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "historyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "annotation" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "annotation" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HistoryAnnotation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryAnnotation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAnnotation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateContactHistoryAnnotationMutation,
  MutateContactHistoryAnnotationMutationVariables
>;
export const MarkContactHistoryAnnotationDoneDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markContactHistoryAnnotationDone" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "historyId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markContactHistoryAnnotationDone" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "historyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "historyId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HistoryAnnotation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryAnnotation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAnnotation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkContactHistoryAnnotationDoneMutation,
  MarkContactHistoryAnnotationDoneMutationVariables
>;
export const HistoriesCallResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "historiesCallResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "historiesCallResults" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HistoriesCallResultsQuery,
  HistoriesCallResultsQueryVariables
>;
export const CountHistoriesCallResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countHistoriesCallResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countHistoriesCallResults" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountHistoriesCallResultsQuery,
  CountHistoriesCallResultsQueryVariables
>;
export const HistoriesCallResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "historiesCallResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "historiesCallResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HistoryCallResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryCallResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CallResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HistoriesCallResultQuery,
  HistoriesCallResultQueryVariables
>;
export const MutateHistoriesCallResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateHistoriesCallResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "callResult" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CallResultInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateHistoriesCallResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "callResult" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "callResult" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HistoryCallResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryCallResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CallResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateHistoriesCallResultMutation,
  MutateHistoriesCallResultMutationVariables
>;
export const DeleteHistoriesCallResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteHistoriesCallResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteHistoriesCallResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HistoryCallResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryCallResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CallResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteHistoriesCallResultMutation,
  DeleteHistoriesCallResultMutationVariables
>;
export const DeleteHistoryAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteHistoryAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deletionReason" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteHistoryAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deletionReason" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deletionReason" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HistoryFileAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HistoryFileAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HistoryAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "deletionReason" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteHistoryAttachmentMutation,
  DeleteHistoryAttachmentMutationVariables
>;
export const MutateHotseatRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateHotseatRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "HotseatRequestInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateHotseatRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HotseatRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HotseatRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HotseatRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateHotseatRequestMutation,
  MutateHotseatRequestMutationVariables
>;
export const HotseatRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "hotseatRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "HotseatRequestFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hotseatRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HotseatRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HotseatRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HotseatRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HotseatRequestsQuery,
  HotseatRequestsQueryVariables
>;
export const CountHotseatRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countHotseatRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CountHotseatRequestsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countHotseatRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountHotseatRequestsQuery,
  CountHotseatRequestsQueryVariables
>;
export const DeleteHotseatRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteHotseatRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteHotseatRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteHotseatRequestMutation,
  DeleteHotseatRequestMutationVariables
>;
export const ExportHotseatRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "exportHotseatRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "HotseatRequestFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exportHotseatRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportHotseatRequestsMutation,
  ExportHotseatRequestsMutationVariables
>;
export const HourOrdersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "hourOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "HourOrderListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hourOrders" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HourOrder" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HourOrder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HourOrder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "productiveHours" } },
          { kind: "Field", name: { kind: "Name", value: "adminHours" } },
          { kind: "Field", name: { kind: "Name", value: "overCapacityHours" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "predictableHolidayHours" },
          },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HourOrdersQuery, HourOrdersQueryVariables>;
export const MutateHourOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateHourOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "HourOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateHourOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HourOrder" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HourOrder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HourOrder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "productiveHours" } },
          { kind: "Field", name: { kind: "Name", value: "adminHours" } },
          { kind: "Field", name: { kind: "Name", value: "overCapacityHours" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "predictableHolidayHours" },
          },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateHourOrderMutation,
  MutateHourOrderMutationVariables
>;
export const DeleteHourOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteHourOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteHourOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteHourOrderMutation,
  DeleteHourOrderMutationVariables
>;
export const IndeedStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "indeedStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "IndeedStatsListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "indeedStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "IndeedStatsEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndeedStatsEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndeedStatsEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "time" } },
          { kind: "Field", name: { kind: "Name", value: "spend" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IndeedStatsQuery, IndeedStatsQueryVariables>;
export const DeleteIndeedStatsEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteIndeedStatsEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteIndeedStatsEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "IndeedStatsEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndeedStatsEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndeedStatsEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "time" } },
          { kind: "Field", name: { kind: "Name", value: "spend" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteIndeedStatsEntryMutation,
  DeleteIndeedStatsEntryMutationVariables
>;
export const MutateIndeedStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateIndeedStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "IndeedStatsEntryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateIndeedStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "IndeedStatsEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndeedStatsEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndeedStatsEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "time" } },
          { kind: "Field", name: { kind: "Name", value: "spend" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateIndeedStatsMutation,
  MutateIndeedStatsMutationVariables
>;
export const MutateIndeedStatsForMonthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateIndeedStatsForMonth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "IndeedStatsEntryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateIndeedStatsForMonth" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "IndeedStatsEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndeedStatsEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndeedStatsEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "time" } },
          { kind: "Field", name: { kind: "Name", value: "spend" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateIndeedStatsForMonthMutation,
  MutateIndeedStatsForMonthMutationVariables
>;
export const IndeedStatsEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "indeedStatsEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "indeedStatsEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "IndeedStatsEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndeedStatsEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndeedStatsEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "time" } },
          { kind: "Field", name: { kind: "Name", value: "spend" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IndeedStatsEntryQuery,
  IndeedStatsEntryQueryVariables
>;
export const IndeedStatsEntryValidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "indeedStatsEntryValid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "day" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "indeedStatsEntryValid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "day" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "day" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IndeedStatsEntryValidQuery,
  IndeedStatsEntryValidQueryVariables
>;
export const InventoryItemTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItemTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryItemTypeFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItemTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItemType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItemType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItemType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "itemsWanted" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryItemTypesQuery,
  InventoryItemTypesQueryVariables
>;
export const CountInventoryItemTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countInventoryItemTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryItemTypeFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countInventoryItemTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountInventoryItemTypesQuery,
  CountInventoryItemTypesQueryVariables
>;
export const InventoryItemTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItemType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItemType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItemType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItemType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItemType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "itemsWanted" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryItemTypeQuery,
  InventoryItemTypeQueryVariables
>;
export const MutateInventoryItemTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateInventoryItemType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InventoryItemTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateInventoryItemType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItemType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItemType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItemType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "itemsWanted" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateInventoryItemTypeMutation,
  MutateInventoryItemTypeMutationVariables
>;
export const DeleteInventoryItemTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteInventoryItemType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInventoryItemType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInventoryItemTypeMutation,
  DeleteInventoryItemTypeMutationVariables
>;
export const InventoryItemTypeMetaInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItemTypeMetaInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItemTypeMetaInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "reserved" } },
                { kind: "Field", name: { kind: "Name", value: "inStock" } },
                { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
                { kind: "Field", name: { kind: "Name", value: "office" } },
                { kind: "Field", name: { kind: "Name", value: "ready" } },
                { kind: "Field", name: { kind: "Name", value: "broken" } },
                { kind: "Field", name: { kind: "Name", value: "lost" } },
                { kind: "Field", name: { kind: "Name", value: "disabled" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryItemTypeMetaInfoQuery,
  InventoryItemTypeMetaInfoQueryVariables
>;
export const InventoryItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryItemFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "itemTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "lastBeaconId" } },
          { kind: "Field", name: { kind: "Name", value: "lastDguvCheckId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "serial" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentInfo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "checkInterval" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "mouse" } },
                { kind: "Field", name: { kind: "Name", value: "keyboard" } },
                { kind: "Field", name: { kind: "Name", value: "adapter" } },
                { kind: "Field", name: { kind: "Name", value: "webcam" } },
                { kind: "Field", name: { kind: "Name", value: "osName" } },
                { kind: "Field", name: { kind: "Name", value: "osVersion" } },
                { kind: "Field", name: { kind: "Name", value: "lastUser" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastDguvCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventoryItemsQuery, InventoryItemsQueryVariables>;
export const InventoryItemsWithItemTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItemsWithItemType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryItemFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItem" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "itemType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "itemTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "lastBeaconId" } },
          { kind: "Field", name: { kind: "Name", value: "lastDguvCheckId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "serial" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentInfo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "checkInterval" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "mouse" } },
                { kind: "Field", name: { kind: "Name", value: "keyboard" } },
                { kind: "Field", name: { kind: "Name", value: "adapter" } },
                { kind: "Field", name: { kind: "Name", value: "webcam" } },
                { kind: "Field", name: { kind: "Name", value: "osName" } },
                { kind: "Field", name: { kind: "Name", value: "osVersion" } },
                { kind: "Field", name: { kind: "Name", value: "lastUser" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastDguvCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryItemsWithItemTypeQuery,
  InventoryItemsWithItemTypeQueryVariables
>;
export const CountInventoryItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countInventoryItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryItemFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countInventoryItems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountInventoryItemsQuery,
  CountInventoryItemsQueryVariables
>;
export const InventoryItemsInNeedForDguvCheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItemsInNeedForDguvCheck" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryItemCheckFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItemsInNeedForDguvCheck" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "itemTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "lastBeaconId" } },
          { kind: "Field", name: { kind: "Name", value: "lastDguvCheckId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "serial" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentInfo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "checkInterval" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "mouse" } },
                { kind: "Field", name: { kind: "Name", value: "keyboard" } },
                { kind: "Field", name: { kind: "Name", value: "adapter" } },
                { kind: "Field", name: { kind: "Name", value: "webcam" } },
                { kind: "Field", name: { kind: "Name", value: "osName" } },
                { kind: "Field", name: { kind: "Name", value: "osVersion" } },
                { kind: "Field", name: { kind: "Name", value: "lastUser" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastDguvCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryItemsInNeedForDguvCheckQuery,
  InventoryItemsInNeedForDguvCheckQueryVariables
>;
export const CountInventoryItemsInNeedForDguvCheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countInventoryItemsInNeedForDguvCheck" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryItemCheckFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "countInventoryItemsInNeedForDguvCheck",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountInventoryItemsInNeedForDguvCheckQuery,
  CountInventoryItemsInNeedForDguvCheckQueryVariables
>;
export const InventoryItemDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItem" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "itemTypeId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItem" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "itemTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "itemTypeId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItem" },
                },
                { kind: "Field", name: { kind: "Name", value: "subscribed" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "itemTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "lastBeaconId" } },
          { kind: "Field", name: { kind: "Name", value: "lastDguvCheckId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "serial" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentInfo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "checkInterval" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "mouse" } },
                { kind: "Field", name: { kind: "Name", value: "keyboard" } },
                { kind: "Field", name: { kind: "Name", value: "adapter" } },
                { kind: "Field", name: { kind: "Name", value: "webcam" } },
                { kind: "Field", name: { kind: "Name", value: "osName" } },
                { kind: "Field", name: { kind: "Name", value: "osVersion" } },
                { kind: "Field", name: { kind: "Name", value: "lastUser" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastDguvCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventoryItemQuery, InventoryItemQueryVariables>;
export const MutateInventoryItemDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateInventoryItem" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InventoryItemInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateInventoryItem" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "itemTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "lastBeaconId" } },
          { kind: "Field", name: { kind: "Name", value: "lastDguvCheckId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "serial" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentInfo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "checkInterval" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "mouse" } },
                { kind: "Field", name: { kind: "Name", value: "keyboard" } },
                { kind: "Field", name: { kind: "Name", value: "adapter" } },
                { kind: "Field", name: { kind: "Name", value: "webcam" } },
                { kind: "Field", name: { kind: "Name", value: "osName" } },
                { kind: "Field", name: { kind: "Name", value: "osVersion" } },
                { kind: "Field", name: { kind: "Name", value: "lastUser" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastDguvCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateInventoryItemMutation,
  MutateInventoryItemMutationVariables
>;
export const DeleteInventoryItemDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteInventoryItem" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInventoryItem" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInventoryItemMutation,
  DeleteInventoryItemMutationVariables
>;
export const InventoryHandoverItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "inventoryHandoverItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InventoryHandover" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryHandoverItems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "itemTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "lastBeaconId" } },
          { kind: "Field", name: { kind: "Name", value: "lastDguvCheckId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "serial" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentInfo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "checkInterval" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "mouse" } },
                { kind: "Field", name: { kind: "Name", value: "keyboard" } },
                { kind: "Field", name: { kind: "Name", value: "adapter" } },
                { kind: "Field", name: { kind: "Name", value: "webcam" } },
                { kind: "Field", name: { kind: "Name", value: "osName" } },
                { kind: "Field", name: { kind: "Name", value: "osVersion" } },
                { kind: "Field", name: { kind: "Name", value: "lastUser" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastDguvCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryHandoverItemsMutation,
  InventoryHandoverItemsMutationVariables
>;
export const InventoryHandbackItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "inventoryHandbackItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InventoryHandback" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryHandbackItems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "itemTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "lastBeaconId" } },
          { kind: "Field", name: { kind: "Name", value: "lastDguvCheckId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "serial" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "deploymentInfo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "needsCheck" } },
          { kind: "Field", name: { kind: "Name", value: "checkInterval" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "mouse" } },
                { kind: "Field", name: { kind: "Name", value: "keyboard" } },
                { kind: "Field", name: { kind: "Name", value: "adapter" } },
                { kind: "Field", name: { kind: "Name", value: "webcam" } },
                { kind: "Field", name: { kind: "Name", value: "osName" } },
                { kind: "Field", name: { kind: "Name", value: "osVersion" } },
                { kind: "Field", name: { kind: "Name", value: "lastUser" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lastDguvCheck" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryHandbackItemsMutation,
  InventoryHandbackItemsMutationVariables
>;
export const InventoryItemAttachmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItemAttachments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inventoryItemId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItemAttachments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inventoryItemId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inventoryItemId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItemAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItemAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItemAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryItemAttachmentsQuery,
  InventoryItemAttachmentsQueryVariables
>;
export const CreateInventoryItemAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createInventoryItemAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inventoryItemId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attachment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createInventoryItemAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inventoryItemId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inventoryItemId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attachment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attachment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryItemAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryItemAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryItemAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateInventoryItemAttachmentMutation,
  CreateInventoryItemAttachmentMutationVariables
>;
export const DeleteInventoryItemAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteInventoryItemAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inventoryItemId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInventoryItemAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inventoryItemId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inventoryItemId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInventoryItemAttachmentMutation,
  DeleteInventoryItemAttachmentMutationVariables
>;
export const SubscribeInventoryItemDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "subscribeInventoryItem" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "subscribeInventoryItem" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inventoryItemId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscribeInventoryItemMutation,
  SubscribeInventoryItemMutationVariables
>;
export const InventorySetsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventorySets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventorySetFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventorySets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventorySet" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventorySet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventorySet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventorySetsQuery, InventorySetsQueryVariables>;
export const CountInventorySetsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countInventorySets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventorySetFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countInventorySets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountInventorySetsQuery,
  CountInventorySetsQueryVariables
>;
export const InventorySetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventorySet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventorySet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventorySet" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inventorySetId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inventoryItemTypeId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quantity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inventoryItemType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventorySet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventorySet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InventorySetQuery, InventorySetQueryVariables>;
export const MutateInventorySetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateInventorySet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InventorySetInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateInventorySet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventorySet" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventorySet" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventorySet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateInventorySetMutation,
  MutateInventorySetMutationVariables
>;
export const DeleteInventorySetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteInventorySet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInventorySet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInventorySetMutation,
  DeleteInventorySetMutationVariables
>;
export const InventoryItemTimelineDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryItemTimeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inventoryItemId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryTimelineFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryItemTimeline" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inventoryItemId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inventoryItemId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryItemTimelineQuery,
  InventoryItemTimelineQueryVariables
>;
export const CountInventoryItemTimelineDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countInventoryItemTimeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inventoryItemId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryTimelineFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countInventoryItemTimeline" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inventoryItemId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inventoryItemId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountInventoryItemTimelineQuery,
  CountInventoryItemTimelineQueryVariables
>;
export const MutateInventoryItemTimelineEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateInventoryItemTimelineEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inventoryItemId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InventoryItemTimelineEntryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateInventoryItemTimelineEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inventoryItemId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inventoryItemId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryTimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryTimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "inventoryItemId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateInventoryItemTimelineEntryMutation,
  MutateInventoryItemTimelineEntryMutationVariables
>;
export const DeleteInventoryItemTimelineEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteInventoryItemTimelineEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inventoryItemId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInventoryItemTimelineEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inventoryItemId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inventoryItemId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInventoryItemTimelineEntryMutation,
  DeleteInventoryItemTimelineEntryMutationVariables
>;
export const ImportInventoryItemTimelineEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "importInventoryItemTimelineEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "InventoryItemTimelineImportInput",
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "importInventoryItemTimelineEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImportInventoryItemTimelineEntriesMutation,
  ImportInventoryItemTimelineEntriesMutationVariables
>;
export const InventoryReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InventoryReservationFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryReservations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryReservation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "inventorySetId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservedFor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "set" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryReservationsQuery,
  InventoryReservationsQueryVariables
>;
export const CountInventoryReservationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countInventoryReservations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countInventoryReservations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountInventoryReservationsQuery,
  CountInventoryReservationsQueryVariables
>;
export const InventoryReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryReservation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "inventorySetId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservedFor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "set" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryReservationQuery,
  InventoryReservationQueryVariables
>;
export const InventoryReservationWithDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inventoryReservationWithDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inventorySetId" },
                },
                { kind: "Field", name: { kind: "Name", value: "quantity" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedFor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "set" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inventorySetId" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "inventoryItemTypeId",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quantity" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "inventoryItemType",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryReservationWithDetailsQuery,
  InventoryReservationWithDetailsQueryVariables
>;
export const MutateInventoryReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateInventoryReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InventoryReservationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateInventoryReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryReservation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "inventorySetId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservedFor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "set" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateInventoryReservationMutation,
  MutateInventoryReservationMutationVariables
>;
export const DeleteInventoryReservationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteInventoryReservation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInventoryReservation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInventoryReservationMutation,
  DeleteInventoryReservationMutationVariables
>;
export const InventoryReservationHandoverDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "inventoryReservationHandover" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InventoryHandover" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inventoryReservationHandover" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InventoryReservation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InventoryReservation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InventoryReservation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "inventorySetId" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reservedFor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "set" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InventoryReservationHandoverMutation,
  InventoryReservationHandoverMutationVariables
>;
export const InvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "invoices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InvoiceListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoices" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Invoice" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Invoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "periodStart" } },
          { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "preview" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "locked" } },
          { kind: "Field", name: { kind: "Name", value: "lockedById" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "pos" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoicesQuery, InvoicesQueryVariables>;
export const InvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "invoice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Invoice" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Invoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "periodStart" } },
          { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "preview" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "locked" } },
          { kind: "Field", name: { kind: "Name", value: "lockedById" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "pos" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceQuery, InvoiceQueryVariables>;
export const CountInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countInvoices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InvoiceListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countInvoices" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountInvoicesQuery, CountInvoicesQueryVariables>;
export const DeleteInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteInvoice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInvoice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Invoice" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Invoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "periodStart" } },
          { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "preview" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "locked" } },
          { kind: "Field", name: { kind: "Name", value: "lockedById" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "pos" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInvoiceMutation,
  DeleteInvoiceMutationVariables
>;
export const MutateInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateInvoice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InvoiceInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateInvoice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Invoice" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Invoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "periodStart" } },
          { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "preview" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "locked" } },
          { kind: "Field", name: { kind: "Name", value: "lockedById" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "pos" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateInvoiceMutation,
  MutateInvoiceMutationVariables
>;
export const ConfirmInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmInvoice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmInvoice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Invoice" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Invoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "periodStart" } },
          { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "preview" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "locked" } },
          { kind: "Field", name: { kind: "Name", value: "lockedById" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "pos" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmInvoiceMutation,
  ConfirmInvoiceMutationVariables
>;
export const SubscribeInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "subscribeInvoices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoices" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Invoice" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Invoice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invoice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "periodStart" } },
          { kind: "Field", name: { kind: "Name", value: "periodEnd" } },
          { kind: "Field", name: { kind: "Name", value: "preview" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "locked" } },
          { kind: "Field", name: { kind: "Name", value: "lockedById" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "pos" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attachments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscribeInvoicesSubscription,
  SubscribeInvoicesSubscriptionVariables
>;
export const InvoiceDateValidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "invoiceDateValid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceDateValid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InvoiceDateValidQuery,
  InvoiceDateValidQueryVariables
>;
export const JobResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "jobResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListJobResultsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "jobResults" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "JobResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "JobResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "JobResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "module" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "hasAttachment" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "report" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobResultsQuery, JobResultsQueryVariables>;
export const CountJobResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countJobResults" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countJobResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "seen" } },
                { kind: "Field", name: { kind: "Name", value: "unseen" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountJobResultsQuery,
  CountJobResultsQueryVariables
>;
export const SubscribeCountJobResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "subscribeCountJobResults" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countJobResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "seen" } },
                { kind: "Field", name: { kind: "Name", value: "unseen" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscribeCountJobResultsSubscription,
  SubscribeCountJobResultsSubscriptionVariables
>;
export const JobResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "jobResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "jobResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "JobResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "JobResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "JobResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "module" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "hasAttachment" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "report" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobResultQuery, JobResultQueryVariables>;
export const MarkJobResultSeenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markJobResultSeen" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markJobResultSeen" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "JobResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "JobResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "JobResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "module" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "hasAttachment" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "report" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkJobResultSeenMutation,
  MarkJobResultSeenMutationVariables
>;
export const DeleteJobResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteJobResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteJobResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteJobResultMutation,
  DeleteJobResultMutationVariables
>;
export const WorkerJobsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "workerJobs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WorkerJobsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "workerJobs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "kind" } },
                { kind: "Field", name: { kind: "Name", value: "queue" } },
                { kind: "Field", name: { kind: "Name", value: "payload" } },
                { kind: "Field", name: { kind: "Name", value: "attempts" } },
                { kind: "Field", name: { kind: "Name", value: "maxAttempts" } },
                { kind: "Field", name: { kind: "Name", value: "runAt" } },
                { kind: "Field", name: { kind: "Name", value: "startedAt" } },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                { kind: "Field", name: { kind: "Name", value: "lockedBy" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "finishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "dedupKey" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkerJobsQuery, WorkerJobsQueryVariables>;
export const CountWorkerJobsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countWorkerJobs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CountWorkerJobsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countWorkerJobs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountWorkerJobsQuery,
  CountWorkerJobsQueryVariables
>;
export const RequeueWorkerJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "requeueWorkerJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requeueWorkerJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "kind" } },
                { kind: "Field", name: { kind: "Name", value: "queue" } },
                { kind: "Field", name: { kind: "Name", value: "payload" } },
                { kind: "Field", name: { kind: "Name", value: "attempts" } },
                { kind: "Field", name: { kind: "Name", value: "maxAttempts" } },
                { kind: "Field", name: { kind: "Name", value: "runAt" } },
                { kind: "Field", name: { kind: "Name", value: "startedAt" } },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                { kind: "Field", name: { kind: "Name", value: "lockedBy" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "finishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "dedupKey" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequeueWorkerJobMutation,
  RequeueWorkerJobMutationVariables
>;
export const SendRecruitmentPlannedNotificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendRecruitmentPlannedNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teamId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendRecruitmentPlannedNotification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teamId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendRecruitmentPlannedNotificationMutation,
  SendRecruitmentPlannedNotificationMutationVariables
>;
export const SendAllianzBuergerLeadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendAllianzBuergerLead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "wantsInfos" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "wantsAppointment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendAllianzBuergerLead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "wantsInfos" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "wantsInfos" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "wantsAppointment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "wantsAppointment" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendAllianzBuergerLeadMutation,
  SendAllianzBuergerLeadMutationVariables
>;
export const KnowledgebaseQuestionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgebaseQuestions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListKnowledgebaseQuestionsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgebaseQuestions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseQuestion" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgebaseQuestionsQuery,
  KnowledgebaseQuestionsQueryVariables
>;
export const CountKnowledgebaseQuestionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countKnowledgebaseQuestions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CountKnowledgebaseQuestionsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countKnowledgebaseQuestions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountKnowledgebaseQuestionsQuery,
  CountKnowledgebaseQuestionsQueryVariables
>;
export const KnowledgebaseQuestionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgebaseQuestion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgebaseQuestion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseQuestion" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "KnowledgebaseAttachment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgebaseQuestionQuery,
  KnowledgebaseQuestionQueryVariables
>;
export const DeleteKnowledgebaseQuestionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteKnowledgebaseQuestion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteKnowledgebaseQuestion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteKnowledgebaseQuestionMutation,
  DeleteKnowledgebaseQuestionMutationVariables
>;
export const MutateKnowledgebaseQuestionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateKnowledgebaseQuestion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "KnowledgebaseQuestionInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateKnowledgebaseQuestion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseQuestion" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateKnowledgebaseQuestionMutation,
  MutateKnowledgebaseQuestionMutationVariables
>;
export const RegenKnowledgebaseSearchIndexDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "regenKnowledgebaseSearchIndex" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "regenKnowledgebaseSearchIndex" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseQuestion" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseQuestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegenKnowledgebaseSearchIndexMutation,
  RegenKnowledgebaseSearchIndexMutationVariables
>;
export const MutateKnowledgebaseAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateKnowledgebaseAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "questionId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "KnowledgebaseAttachmentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateKnowledgebaseAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "questionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "questionId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateKnowledgebaseAttachmentMutation,
  MutateKnowledgebaseAttachmentMutationVariables
>;
export const DeleteKnowledgebaseAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteKnowledgebaseAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "questionId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteKnowledgebaseAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "questionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "questionId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteKnowledgebaseAttachmentMutation,
  DeleteKnowledgebaseAttachmentMutationVariables
>;
export const KnowledgebaseNgArticlesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgebaseNgArticles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "KnowledgebaseNgArticleFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgebaseNgArticles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "articleType" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "validFrom" } },
                { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                { kind: "Field", name: { kind: "Name", value: "nextReview" } },
                { kind: "Field", name: { kind: "Name", value: "timeless" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visibleForExternals" },
                },
                { kind: "Field", name: { kind: "Name", value: "tags" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "creatorId" } },
                { kind: "Field", name: { kind: "Name", value: "editorId" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgebaseNgArticlesQuery,
  KnowledgebaseNgArticlesQueryVariables
>;
export const CountKnowledgebaseNgArticlesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countKnowledgebaseNgArticles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "KnowledgebaseNgArticleFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countKnowledgebaseNgArticles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountKnowledgebaseNgArticlesQuery,
  CountKnowledgebaseNgArticlesQueryVariables
>;
export const KnowledgebaseNgArticleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgebaseNgArticle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgebaseNgArticle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgArticle" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgArticle" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgArticle" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "articleType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "nextReview" } },
          { kind: "Field", name: { kind: "Name", value: "timeless" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "visibleForExternals" },
          },
          { kind: "Field", name: { kind: "Name", value: "igorSync" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categoryPaths" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "team" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "linkedArticles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgebaseNgArticleQuery,
  KnowledgebaseNgArticleQueryVariables
>;
export const MutateKnowledgebaseNgArticleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateKnowledgebaseNgArticle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "KnowledgebaseNgArticleInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateKnowledgebaseNgArticle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgArticle" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgArticle" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgArticle" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "articleType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "nextReview" } },
          { kind: "Field", name: { kind: "Name", value: "timeless" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "visibleForExternals" },
          },
          { kind: "Field", name: { kind: "Name", value: "igorSync" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categoryPaths" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "team" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "linkedArticles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateKnowledgebaseNgArticleMutation,
  MutateKnowledgebaseNgArticleMutationVariables
>;
export const DeleteKnowledgebaseNgArticleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteKnowledgebaseNgArticle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteKnowledgebaseNgArticle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgArticle" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgArticle" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgArticle" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "articleType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "validFrom" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "nextReview" } },
          { kind: "Field", name: { kind: "Name", value: "timeless" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "visibleForExternals" },
          },
          { kind: "Field", name: { kind: "Name", value: "igorSync" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "categoryPaths" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "team" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "linkedArticles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteKnowledgebaseNgArticleMutation,
  DeleteKnowledgebaseNgArticleMutationVariables
>;
export const KnowledgebaseNgCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgebaseNgCategories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "KnowledgebaseNgCategoryFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgebaseNgCategories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgCategory" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "path" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgebaseNgCategoriesQuery,
  KnowledgebaseNgCategoriesQueryVariables
>;
export const CountKnowledgebaseNgCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countKnowledgebaseNgCategories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "KnowledgebaseNgCategoryFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countKnowledgebaseNgCategories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountKnowledgebaseNgCategoriesQuery,
  CountKnowledgebaseNgCategoriesQueryVariables
>;
export const KnowledgebaseNgCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgebaseNgCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgebaseNgCategory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgCategory" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "path" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgebaseNgCategoryQuery,
  KnowledgebaseNgCategoryQueryVariables
>;
export const MutateKnowledgebaseNgCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateKnowledgebaseNgCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "KnowledgebaseNgCategoryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateKnowledgebaseNgCategory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgCategory" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "path" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateKnowledgebaseNgCategoryMutation,
  MutateKnowledgebaseNgCategoryMutationVariables
>;
export const DeleteKnowledgebaseNgCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteKnowledgebaseNgCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteKnowledgebaseNgCategory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgCategory" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgCategory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "path" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteKnowledgebaseNgCategoryMutation,
  DeleteKnowledgebaseNgCategoryMutationVariables
>;
export const MutateKnowledgebaseNgAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateKnowledgebaseNgAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "articleId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "file" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateKnowledgebaseNgAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "articleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "articleId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "file" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "file" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "fileType" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateKnowledgebaseNgAttachmentMutation,
  MutateKnowledgebaseNgAttachmentMutationVariables
>;
export const KnowledgebaseNgReviewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgebaseNgReviews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "articleId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgebaseNgReviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "articleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "articleId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgReview" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgReview" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgReview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "articleId" } },
          { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
          { kind: "Field", name: { kind: "Name", value: "result" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "reviewedAt" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgebaseNgReviewsQuery,
  KnowledgebaseNgReviewsQueryVariables
>;
export const MutateKnowledgebaseNgReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateKnowledgebaseNgReview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "KnowledgebaseNgReviewInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateKnowledgebaseNgReview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "KnowledgebaseNgReview" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KnowledgebaseNgReview" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "KnowledgebaseNgReview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "articleId" } },
          { kind: "Field", name: { kind: "Name", value: "reviewerId" } },
          { kind: "Field", name: { kind: "Name", value: "result" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "reviewedAt" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateKnowledgebaseNgReviewMutation,
  MutateKnowledgebaseNgReviewMutationVariables
>;
export const KnowledgebaseNgVersionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "knowledgebaseNgVersions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "articleId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "knowledgebaseNgVersions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "articleId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "articleId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "articleId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "versionNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "articleType" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "validFrom" } },
                { kind: "Field", name: { kind: "Name", value: "validUntil" } },
                { kind: "Field", name: { kind: "Name", value: "timeless" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visibleForExternals" },
                },
                { kind: "Field", name: { kind: "Name", value: "tags" } },
                { kind: "Field", name: { kind: "Name", value: "categories" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "changelog" } },
                { kind: "Field", name: { kind: "Name", value: "creatorId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  KnowledgebaseNgVersionsQuery,
  KnowledgebaseNgVersionsQueryVariables
>;
export const LateNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "lateNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LateNoteListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lateNotes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LateNote" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LateNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LateNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "eta" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "estimatedMinutesLate" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LateNotesQuery, LateNotesQueryVariables>;
export const CountLateNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countLateNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LateNoteListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countLateNotes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountLateNotesQuery, CountLateNotesQueryVariables>;
export const LateNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "lateNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lateNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LateNote" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LateNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LateNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "eta" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "estimatedMinutesLate" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LateNoteQuery, LateNoteQueryVariables>;
export const MutateLateNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateLateNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LateNoteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateLateNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LateNote" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LateNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LateNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "eta" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "estimatedMinutesLate" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateLateNoteMutation,
  MutateLateNoteMutationVariables
>;
export const DeleteLateNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteLateNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteLateNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteLateNoteMutation,
  DeleteLateNoteMutationVariables
>;
export const MailTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mailTemplates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MailTemplateListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mailTemplates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MailTemplate" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "slateContent" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailTemplatesQuery, MailTemplatesQueryVariables>;
export const CountMailTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countMailTemplates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MailTemplateListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countMailTemplates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountMailTemplatesQuery,
  CountMailTemplatesQueryVariables
>;
export const MailTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mailTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mailTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MailTemplate" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "slateContent" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailTemplateQuery, MailTemplateQueryVariables>;
export const MutateMailTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateMailTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MailTemplateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateMailTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MailTemplate" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "slateContent" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateMailTemplateMutation,
  MutateMailTemplateMutationVariables
>;
export const DeleteMailTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMailTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMailTemplate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MailTemplate" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplate" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplate" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "slateContent" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMailTemplateMutation,
  DeleteMailTemplateMutationVariables
>;
export const MailTemplateAttachmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mailTemplateAttachments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MailTemplateAttachmentListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mailTemplateAttachments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MailTemplateAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplateAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplateAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "attachByDefault" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MailTemplateAttachmentsQuery,
  MailTemplateAttachmentsQueryVariables
>;
export const CountMailTemplateAttachmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countMailTemplateAttachments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countMailTemplateAttachments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountMailTemplateAttachmentsQuery,
  CountMailTemplateAttachmentsQueryVariables
>;
export const MailTemplateAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mailTemplateAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mailTemplateAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MailTemplateAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplateAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplateAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "attachByDefault" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MailTemplateAttachmentQuery,
  MailTemplateAttachmentQueryVariables
>;
export const MutateMailTemplateAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateMailTemplateAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MailTemplateAttachmentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateMailTemplateAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MailTemplateAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplateAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplateAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "attachByDefault" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateMailTemplateAttachmentMutation,
  MutateMailTemplateAttachmentMutationVariables
>;
export const DeleteMailTemplateAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMailTemplateAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMailTemplateAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MailTemplateAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MailTemplateAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MailTemplateAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "attachByDefault" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMailTemplateAttachmentMutation,
  DeleteMailTemplateAttachmentMutationVariables
>;
export const MailThreadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mailThreads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MailThreadListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mailThreads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "contactId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locker" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstMail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Mail" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastMail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Mail" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailThreadsQuery, MailThreadsQueryVariables>;
export const CountMailThreadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countMailThreads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MailThreadListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countMailThreads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountMailThreadsQuery,
  CountMailThreadsQueryVariables
>;
export const MailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MailListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "from" } },
                { kind: "Field", name: { kind: "Name", value: "to" } },
                { kind: "Field", name: { kind: "Name", value: "direction" } },
                { kind: "Field", name: { kind: "Name", value: "sent" } },
                { kind: "Field", name: { kind: "Name", value: "isSpam" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "labels" } },
                { kind: "Field", name: { kind: "Name", value: "folder" } },
                { kind: "Field", name: { kind: "Name", value: "account" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "editor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thread" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contact" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lockedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locker" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "User" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailsQuery, MailsQueryVariables>;
export const MailsMergeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mailsMerge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MailListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailsMergeQuery, MailsMergeQueryVariables>;
export const CountMailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countMails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MailListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countMails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountMailsQuery, CountMailsQueryVariables>;
export const MailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thread" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactId" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mailId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "file" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailQuery, MailQueryVariables>;
export const MailThreadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "mailThread" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isSpam" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mailThread" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "contactId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locker" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mails" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "isSpam" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "isSpam" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Mail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mailId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "file" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MailThreadQuery, MailThreadQueryVariables>;
export const MailEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "mailEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mailEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Mail" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "thread" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contact" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lockedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locker" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "User" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Mail" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "attachments" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mailId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "file" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MailEventSubscription,
  MailEventSubscriptionVariables
>;
export const AssignMailThreadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "assignMailThread" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignMailThread" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignMailThreadMutation,
  AssignMailThreadMutationVariables
>;
export const DeleteMailThreadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMailThread" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMailThread" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMailThreadMutation,
  DeleteMailThreadMutationVariables
>;
export const DeleteMailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMailMutation, DeleteMailMutationVariables>;
export const MutateMailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateMail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MailInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateMail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutateMailMutation, MutateMailMutationVariables>;
export const SendMailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendMail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendMail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMailMutation, SendMailMutationVariables>;
export const OwnMailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ownMail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownMail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnMailMutation, OwnMailMutationVariables>;
export const MutateMailStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateMailStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MailStatus" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updateAllOpen" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateMailStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateAllOpen" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updateAllOpen" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateMailStatusMutation,
  MutateMailStatusMutationVariables
>;
export const MarkMailSpamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markMailSpam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isSpam" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markMailSpam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isSpam" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isSpam" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkMailSpamMutation,
  MarkMailSpamMutationVariables
>;
export const LockMailThreadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "lockMailThread" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "lockMailThread" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locker" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Mail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "file" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LockMailThreadMutation,
  LockMailThreadMutationVariables
>;
export const UnlockMailThreadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "unlockMailThread" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unlockMailThread" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locker" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Mail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "file" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnlockMailThreadMutation,
  UnlockMailThreadMutationVariables
>;
export const MergeMailThreadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mergeMailThreads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "threadId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "secondThreadId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mergeMailThreads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "threadId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "threadId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "secondThreadId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "secondThreadId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "lockedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locker" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Mail" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "file" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MergeMailThreadsMutation,
  MergeMailThreadsMutationVariables
>;
export const AssignMailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "assignMail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignMail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Mail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Mail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Mail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "threadId" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "cc" } },
          { kind: "Field", name: { kind: "Name", value: "bcc" } },
          { kind: "Field", name: { kind: "Name", value: "isSpam" } },
          { kind: "Field", name: { kind: "Name", value: "direction" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "sentAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "receivedAt" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "htmlContent" } },
          { kind: "Field", name: { kind: "Name", value: "labels" } },
          { kind: "Field", name: { kind: "Name", value: "folder" } },
          { kind: "Field", name: { kind: "Name", value: "account" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignMailMutation, AssignMailMutationVariables>;
export const MessagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "messages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListMessagesFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "messages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "subjectI18nId" } },
          { kind: "Field", name: { kind: "Name", value: "subjectParams" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "format" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessagesQuery, MessagesQueryVariables>;
export const CountMessagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countMessages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CountMessagesFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countMessages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "unread" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountMessagesQuery, CountMessagesQueryVariables>;
export const MessageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "message" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentI18nId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentParams" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "subjectI18nId" } },
          { kind: "Field", name: { kind: "Name", value: "subjectParams" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "format" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageQuery, MessageQueryVariables>;
export const MutateMessageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateMessage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "message" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MessageInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateMessage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "message" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "message" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentI18nId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentParams" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "subjectI18nId" } },
          { kind: "Field", name: { kind: "Name", value: "subjectParams" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "format" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateMessageMutation,
  MutateMessageMutationVariables
>;
export const DeleteMessageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMessage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMessage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMessageMutation,
  DeleteMessageMutationVariables
>;
export const MarkMessageReadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markMessageRead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markMessageRead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
                { kind: "Field", name: { kind: "Name", value: "content" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentI18nId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentParams" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "subjectI18nId" } },
          { kind: "Field", name: { kind: "Name", value: "subjectParams" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "format" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sender" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkMessageReadMutation,
  MarkMessageReadMutationVariables
>;
export const OauthTokensDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "oauthTokens" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "oauthTokens" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OauthToken" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OauthToken" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OauthToken" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "appId" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "scopes" } },
          { kind: "Field", name: { kind: "Name", value: "grantType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "tokenQuery" } },
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "expires" } },
          { kind: "Field", name: { kind: "Name", value: "useBasicAuth" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OauthTokensQuery, OauthTokensQueryVariables>;
export const OauthTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "oauthToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "oauthToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OauthToken" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OauthToken" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OauthToken" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "appId" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "scopes" } },
          { kind: "Field", name: { kind: "Name", value: "grantType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "tokenQuery" } },
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "expires" } },
          { kind: "Field", name: { kind: "Name", value: "useBasicAuth" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OauthTokenQuery, OauthTokenQueryVariables>;
export const MutateOauthTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateOauthToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OauthTokenInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateOauthToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OauthToken" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OauthToken" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OauthToken" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "appId" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "scopes" } },
          { kind: "Field", name: { kind: "Name", value: "grantType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "tokenQuery" } },
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "expires" } },
          { kind: "Field", name: { kind: "Name", value: "useBasicAuth" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateOauthTokenMutation,
  MutateOauthTokenMutationVariables
>;
export const DeleteOauthTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteOauthToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOauthToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OauthToken" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OauthToken" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OauthToken" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "appId" } },
          { kind: "Field", name: { kind: "Name", value: "clientId" } },
          { kind: "Field", name: { kind: "Name", value: "clientSecret" } },
          { kind: "Field", name: { kind: "Name", value: "scopes" } },
          { kind: "Field", name: { kind: "Name", value: "grantType" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "tokenQuery" } },
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "expires" } },
          { kind: "Field", name: { kind: "Name", value: "useBasicAuth" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOauthTokenMutation,
  DeleteOauthTokenMutationVariables
>;
export const StaffPaymentInfosDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "staffPaymentInfos" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffPaymentInfoListFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffPaymentInfos" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payrollImportJobId" },
                },
                { kind: "Field", name: { kind: "Name", value: "employeeId" } },
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "gross" } },
                { kind: "Field", name: { kind: "Name", value: "net" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
                { kind: "Field", name: { kind: "Name", value: "cost" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "User" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffPaymentInfosQuery,
  StaffPaymentInfosQueryVariables
>;
export const CountStaffPaymentInfosDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countStaffPaymentInfos" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffPaymentInfoListFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countStaffPaymentInfos" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountStaffPaymentInfosQuery,
  CountStaffPaymentInfosQueryVariables
>;
export const StaffPaymentInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "staffPaymentInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffPaymentInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffPaymentInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffPaymentInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffPaymentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payrollImportJobId" },
          },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "gross" } },
          { kind: "Field", name: { kind: "Name", value: "net" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "cost" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentInfoId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "positionType" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "factor" } },
                { kind: "Field", name: { kind: "Name", value: "percent" } },
                { kind: "Field", name: { kind: "Name", value: "sum" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffPaymentInfoQuery,
  StaffPaymentInfoQueryVariables
>;
export const MutateStaffPaymentInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateStaffPaymentInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payrollPdfImportId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffPaymentInfoInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateStaffPaymentInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "payrollPdfImportId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payrollPdfImportId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffPaymentInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffPaymentInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffPaymentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payrollImportJobId" },
          },
          { kind: "Field", name: { kind: "Name", value: "employeeId" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "gross" } },
          { kind: "Field", name: { kind: "Name", value: "net" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "cost" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "employee" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentInfoId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "positionType" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "factor" } },
                { kind: "Field", name: { kind: "Name", value: "percent" } },
                { kind: "Field", name: { kind: "Name", value: "sum" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateStaffPaymentInfoMutation,
  MutateStaffPaymentInfoMutationVariables
>;
export const DeleteStaffPaymentInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteStaffPaymentInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteStaffPaymentInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteStaffPaymentInfoMutation,
  DeleteStaffPaymentInfoMutationVariables
>;
export const PayrollPdfImportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "payrollPdfImports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PayrollPdfImportListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payrollPdfImports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PayrollPdfImport" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PayrollPdfImport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PayrollPdfImport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "importType" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayrollPdfImportsQuery,
  PayrollPdfImportsQueryVariables
>;
export const CountPayrollPdfImportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countPayrollPdfImports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PayrollPdfImportListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countPayrollPdfImports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountPayrollPdfImportsQuery,
  CountPayrollPdfImportsQueryVariables
>;
export const PayrollPdfImportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "payrollPdfImport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payrollPdfImport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PayrollPdfImport" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PayrollPdfImportError" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PayrollPdfImport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PayrollPdfImport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "importType" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PayrollPdfImportError" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PayrollPdfImportError" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payrollImportJobId" },
          },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayrollPdfImportQuery,
  PayrollPdfImportQueryVariables
>;
export const MutatePayrollPdfImportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutatePayrollPdfImport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PayrollPdfImportInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutatePayrollPdfImport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PayrollPdfImport" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PayrollPdfImport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PayrollPdfImport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "importType" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutatePayrollPdfImportMutation,
  MutatePayrollPdfImportMutationVariables
>;
export const DeletePayrollPdfImportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deletePayrollPdfImport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePayrollPdfImport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePayrollPdfImportMutation,
  DeletePayrollPdfImportMutationVariables
>;
export const CreatePayrollPdfImportFromFileExchangeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createPayrollPdfImportFromFileExchange" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "importType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PayrollPdfImportType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createPayrollPdfImportFromFileExchange",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "importType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "importType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PayrollPdfImport" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PayrollPdfImport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PayrollPdfImport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "importType" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePayrollPdfImportFromFileExchangeMutation,
  CreatePayrollPdfImportFromFileExchangeMutationVariables
>;
export const DiscardPayrollPdfImportErrorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "discardPayrollPdfImportError" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payrollPdfImportId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "discardPayrollPdfImportError" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "payrollPdfImportId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payrollPdfImportId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiscardPayrollPdfImportErrorMutation,
  DiscardPayrollPdfImportErrorMutationVariables
>;
export const AssignPayrollPdfImportErrorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "assignPayrollPdfImportError" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payrollPdfImportId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "PayrollPdfImportAssignErrorValues",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignPayrollPdfImportError" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "payrollPdfImportId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payrollPdfImportId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignPayrollPdfImportErrorMutation,
  AssignPayrollPdfImportErrorMutationVariables
>;
export const PayrollAccountingFinalizeMonthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "payrollAccountingFinalizeMonth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payrollAccountingFinalizeMonth" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PayrollAccountingFinalizeMonthMutation,
  PayrollAccountingFinalizeMonthMutationVariables
>;
export const StaffPayrollDeviationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "staffPayrollDeviations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffPayrollDeviations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accountant" } },
                { kind: "Field", name: { kind: "Name", value: "calculated" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffPayrollDeviationsQuery,
  StaffPayrollDeviationsQueryVariables
>;
export const PersonalFilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "personalFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PersonalFileListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PersonalFilesQuery, PersonalFilesQueryVariables>;
export const MutatePersonalFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutatePersonalFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PersonalFileInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutatePersonalFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutatePersonalFileMutation,
  MutatePersonalFileMutationVariables
>;
export const MarkPersonalFileReadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markPersonalFileRead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markPersonalFileRead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkPersonalFileReadMutation,
  MarkPersonalFileReadMutationVariables
>;
export const DeletePersonalFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deletePersonalFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePersonalFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePersonalFileMutation,
  DeletePersonalFileMutationVariables
>;
export const SendPersonalFileChallengeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendPersonalFileChallenge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendPersonalFileChallenge" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendPersonalFileChallengeMutation,
  SendPersonalFileChallengeMutationVariables
>;
export const VerifyPersonalFileChallengeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "verifyPersonalFileChallenge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "response" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyPersonalFileChallenge" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "response" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "response" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyPersonalFileChallengeMutation,
  VerifyPersonalFileChallengeMutationVariables
>;
export const SendPersonalFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendPersonalFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendPersonalFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendPersonalFileMutation,
  SendPersonalFileMutationVariables
>;
export const PersonalFileTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "personalFileTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PersonalFileTypeListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFileType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFileType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFileType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PersonalFileTypesQuery,
  PersonalFileTypesQueryVariables
>;
export const CountPersonalFileTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countPersonalFileTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PersonalFileTypeListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countPersonalFileTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountPersonalFileTypesQuery,
  CountPersonalFileTypesQueryVariables
>;
export const PersonalFileTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "personalFileType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFileType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFileType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFileType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PersonalFileTypeQuery,
  PersonalFileTypeQueryVariables
>;
export const MutatePersonalFileTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutatePersonalFileType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PersonalFileTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutatePersonalFileType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFileType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFileType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFileType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "required" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutatePersonalFileTypeMutation,
  MutatePersonalFileTypeMutationVariables
>;
export const DeletePersonalFileTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deletePersonalFileType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePersonalFileType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePersonalFileTypeMutation,
  DeletePersonalFileTypeMutationVariables
>;
export const MissingPersonalFileTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "missingPersonalFileTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MissingPersonalFileTypesFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "missingPersonalFileTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EmployeeFull" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fileTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "itype" } },
          { kind: "Field", name: { kind: "Name", value: "normalizedValue" } },
          { kind: "Field", name: { kind: "Name", value: "value" } },
          { kind: "Field", name: { kind: "Name", value: "confirmedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmationSentAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContactAddress" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContactAddress" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "address" } },
          { kind: "Field", name: { kind: "Name", value: "atype" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "cityPart" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "zip" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmployeeFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "entering" } },
          { kind: "Field", name: { kind: "Name", value: "leaving" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "datevEmployeeNo" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          { kind: "Field", name: { kind: "Name", value: "bic" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialSecurityNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "standardBonus" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dataProtectionTrainingCompletedAt" },
          },
          { kind: "Field", name: { kind: "Name", value: "cpsNumber" } },
          { kind: "Field", name: { kind: "Name", value: "headset" } },
          { kind: "Field", name: { kind: "Name", value: "healthInsurance" } },
          { kind: "Field", name: { kind: "Name", value: "notes" } },
          { kind: "Field", name: { kind: "Name", value: "probationEnding" } },
          { kind: "Field", name: { kind: "Name", value: "employeeName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "nationality" } },
          { kind: "Field", name: { kind: "Name", value: "placeOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "countryOfBirth" } },
          { kind: "Field", name: { kind: "Name", value: "civilStatus" } },
          { kind: "Field", name: { kind: "Name", value: "disability" } },
          { kind: "Field", name: { kind: "Name", value: "disabilityLevel" } },
          { kind: "Field", name: { kind: "Name", value: "taxLevel" } },
          { kind: "Field", name: { kind: "Name", value: "childTaxAllowance" } },
          { kind: "Field", name: { kind: "Name", value: "additionalJobs" } },
          { kind: "Field", name: { kind: "Name", value: "denomination" } },
          { kind: "Field", name: { kind: "Name", value: "languagesFluent" } },
          { kind: "Field", name: { kind: "Name", value: "languagesNative" } },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "levels" } },
          { kind: "Field", name: { kind: "Name", value: "sickDaysLimit" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "children" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addresses" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContactAddress" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MissingPersonalFileTypesQuery,
  MissingPersonalFileTypesQueryVariables
>;
export const CountMissingPersonalFileTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countMissingPersonalFileTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MissingPersonalFileTypesFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countMissingPersonalFileTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountMissingPersonalFileTypesQuery,
  CountMissingPersonalFileTypesQueryVariables
>;
export const ProfilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "profiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfileListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileRef" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfileRef" },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilesQuery, ProfilesQueryVariables>;
export const CountProfilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countProfiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountProfilesQuery, CountProfilesQueryVariables>;
export const ProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "profile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfileDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileRef" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfileRef" },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfileDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfileListItem" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const DeleteProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteProfileMutation,
  DeleteProfileMutationVariables
>;
export const MutateProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "profile" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProfileInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "profile" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "profile" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateProfileMutation,
  MutateProfileMutationVariables
>;
export const ProjectNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projectNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListProjectNewsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectNewsQuery, ProjectNewsQueryVariables>;
export const CountProjectNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countProjectNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListProjectNewsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countProjectNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountProjectNewsQuery,
  CountProjectNewsQueryVariables
>;
export const ProjectNewsPostDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projectNewsPost" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectNewsPost" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProjectNewsPostQuery,
  ProjectNewsPostQueryVariables
>;
export const DeleteProjectNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteProjectNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProjectNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteProjectNewsMutation,
  DeleteProjectNewsMutationVariables
>;
export const MutateProjectNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateProjectNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProjectNewsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateProjectNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectNews" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateProjectNewsMutation,
  MutateProjectNewsMutationVariables
>;
export const MutateProjectNewsAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateProjectNewsAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "newsId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProjectNewsAttachmentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateProjectNewsAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newsId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "newsId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateProjectNewsAttachmentMutation,
  MutateProjectNewsAttachmentMutationVariables
>;
export const HideProjectNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "hideProjectNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hideProjectNews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "newsId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HideProjectNewsMutation,
  HideProjectNewsMutationVariables
>;
export const ProjectReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projectReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ProjectReportListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectReport" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectReport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectReport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "reportType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectReportsQuery, ProjectReportsQueryVariables>;
export const CountProjectReportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countProjectReports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ProjectReportListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countProjectReports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountProjectReportsQuery,
  CountProjectReportsQueryVariables
>;
export const ProjectReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projectReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectReport" },
                },
                { kind: "Field", name: { kind: "Name", value: "reportData" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectReport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectReport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "reportType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectReportQuery, ProjectReportQueryVariables>;
export const MutateProjectReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateProjectReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProjectReportInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateProjectReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectReport" },
                },
                { kind: "Field", name: { kind: "Name", value: "reportData" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectReport" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectReport" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "reportType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateProjectReportMutation,
  MutateProjectReportMutationVariables
>;
export const DeleteProjectReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteProjectReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProjectReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteProjectReportMutation,
  DeleteProjectReportMutationVariables
>;
export const ProjectReportSuggestionForMonthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projectReportSuggestionForMonth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectReportSuggestionForMonth" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProjectReportSuggestionForMonthQuery,
  ProjectReportSuggestionForMonthQueryVariables
>;
export const SwitcherProjectsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "switcherProjects" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListProjectsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SwitcherProjectsQuery,
  SwitcherProjectsQueryVariables
>;
export const ProjectsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projects" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListProjectsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectsQuery, ProjectsQueryVariables>;
export const GlobalProjectsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "globalProjects" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListProjectsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectWithCustomer" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectWithCustomer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GlobalProjectsQuery, GlobalProjectsQueryVariables>;
export const CountProjectsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countProjects" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CountProjectsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countProjects" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountProjectsQuery, CountProjectsQueryVariables>;
export const ProjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "project" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectQuery, ProjectQueryVariables>;
export const MutateProjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateProject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "project" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProjectInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateProject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "project" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "project" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateProjectMutation,
  MutateProjectMutationVariables
>;
export const ToggleFeatureDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "toggleFeature" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "feature" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "toggleFeature" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "feature" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "feature" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleFeatureMutation,
  ToggleFeatureMutationVariables
>;
export const DeleteProjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteProject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;
export const CopyProjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "copyProject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "identifier" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "targetCustomer" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "copyProject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "identifier" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "identifier" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetCustomer" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "targetCustomer" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CopyProjectMutation, CopyProjectMutationVariables>;
export const ProjectAttachmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projectAttachments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListProjectAttachmentsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectAttachments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProjectAttachmentsQuery,
  ProjectAttachmentsQueryVariables
>;
export const CountProjectAttachmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countProjectAttachments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countProjectAttachments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountProjectAttachmentsQuery,
  CountProjectAttachmentsQueryVariables
>;
export const ProjectAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projectAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProjectAttachmentQuery,
  ProjectAttachmentQueryVariables
>;
export const DeleteProjectAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteProjectAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteProjectAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteProjectAttachmentMutation,
  DeleteProjectAttachmentMutationVariables
>;
export const MutateProjectAttachmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateProjectAttachment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "attachment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProjectAttachmentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateProjectAttachment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attachment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attachment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProjectAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProjectAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateProjectAttachmentMutation,
  MutateProjectAttachmentMutationVariables
>;
export const PunchlistEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "punchlistEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListPunchlistEntriesFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "punchlistEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PunchlistEntriesQuery,
  PunchlistEntriesQueryVariables
>;
export const SugPunchlistEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "sugPunchlistEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListPunchlistEntriesFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "punchlistEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntryWithProject" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntryWithProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PunchlistEntry" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SugPunchlistEntriesQuery,
  SugPunchlistEntriesQueryVariables
>;
export const CountPunchlistEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countPunchlistEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "CountPunchlistEntriesFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countPunchlistEntries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountPunchlistEntriesQuery,
  CountPunchlistEntriesQueryVariables
>;
export const PunchlistEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "punchlistEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "punchlistEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PunchlistEntryQuery, PunchlistEntryQueryVariables>;
export const PunchlistEntryForHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "punchlistEntryForHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "historyId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "punchlistEntryForHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "historyId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "historyId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntry" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PunchlistEntryComment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntryComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntryComment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PunchlistEntryForHistoryQuery,
  PunchlistEntryForHistoryQueryVariables
>;
export const PunchlistEntryForHistoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "punchlistEntryForHistories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "historyIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "StringNumber" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "punchlistEntryForHistories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "historyIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "historyIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PunchlistEntryForHistoriesQuery,
  PunchlistEntryForHistoriesQueryVariables
>;
export const PunchlistEntryCommentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "punchlistEntryComments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "entryId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "punchlistEntryComments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "entryId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "entryId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntryComment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntryComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntryComment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PunchlistEntryCommentsQuery,
  PunchlistEntryCommentsQueryVariables
>;
export const DeletePunchlistEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deletePunchlistEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePunchlistEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePunchlistEntryMutation,
  DeletePunchlistEntryMutationVariables
>;
export const MutatePunchlistEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutatePunchlistEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "entry" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PunchlistEntryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutatePunchlistEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "entry" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "entry" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutatePunchlistEntryMutation,
  MutatePunchlistEntryMutationVariables
>;
export const ClosePunchlistEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "closePunchlistEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "closePunchlistEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "errorDate" } },
          { kind: "Field", name: { kind: "Name", value: "historyId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClosePunchlistEntryMutation,
  ClosePunchlistEntryMutationVariables
>;
export const MutatePunchlistEntryCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutatePunchlistEntryComment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "entryId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PunchlistEntryCommentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutatePunchlistEntryComment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "entryId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "entryId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PunchlistEntryComment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PunchlistEntryComment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PunchlistEntryComment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutatePunchlistEntryCommentMutation,
  MutatePunchlistEntryCommentMutationVariables
>;
export const RemindersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "reminders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ReminderFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reminders" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Reminder" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemindersQuery, RemindersQueryVariables>;
export const CountRemindersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countReminders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countReminders" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountRemindersQuery, CountRemindersQueryVariables>;
export const ReminderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "reminder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reminder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Reminder" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReminderQuery, ReminderQueryVariables>;
export const MutateReminderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateReminder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ReminderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateReminder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Reminder" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateReminderMutation,
  MutateReminderMutationVariables
>;
export const DeleteReminderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteReminder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteReminder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Reminder" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteReminderMutation,
  DeleteReminderMutationVariables
>;
export const ReminderNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "reminderNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ReminderNotificationFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reminderNotifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ReminderNotification" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReminderNotification" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ReminderNotification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reminder" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Reminder" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reminderId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReminderNotificationsQuery,
  ReminderNotificationsQueryVariables
>;
export const CountReminderNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countReminderNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ReminderNotificationFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countReminderNotifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountReminderNotificationsQuery,
  CountReminderNotificationsQueryVariables
>;
export const MarkReminderNotificationDoneDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markReminderNotificationDone" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markReminderNotificationDone" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ReminderNotification" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReminderNotification" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ReminderNotification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reminder" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Reminder" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reminderId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkReminderNotificationDoneMutation,
  MarkReminderNotificationDoneMutationVariables
>;
export const DeleteReminderNotificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteReminderNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteReminderNotification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ReminderNotification" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Reminder" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Reminder" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReminderNotification" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ReminderNotification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reminder" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Reminder" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reminderId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteReminderNotificationMutation,
  DeleteReminderNotificationMutationVariables
>;
export const ResidualLeavesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "residualLeaves" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ResidualLeaveListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "residualLeaves" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResidualLeave" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResidualLeave" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResidualLeave" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "year" } },
          { kind: "Field", name: { kind: "Name", value: "daysLeft" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResidualLeavesQuery, ResidualLeavesQueryVariables>;
export const ResidualLeaveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "residualLeave" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "residualLeave" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResidualLeave" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResidualLeave" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResidualLeave" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "year" } },
          { kind: "Field", name: { kind: "Name", value: "daysLeft" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResidualLeaveQuery, ResidualLeaveQueryVariables>;
export const MutateResidualLeaveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateResidualLeave" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ResidualLeaveInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateResidualLeave" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ResidualLeave" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ResidualLeave" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ResidualLeave" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "year" } },
          { kind: "Field", name: { kind: "Name", value: "daysLeft" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateResidualLeaveMutation,
  MutateResidualLeaveMutationVariables
>;
export const DeleteResidualLeaveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteResidualLeave" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteResidualLeave" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteResidualLeaveMutation,
  DeleteResidualLeaveMutationVariables
>;
export const RosterAttendanceTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterAttendanceTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterAttendanceTypeFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterAttendanceTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterAttendanceTypesQuery,
  RosterAttendanceTypesQueryVariables
>;
export const CountRosterAttendanceTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countRosterAttendanceTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterAttendanceTypeFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countRosterAttendanceTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountRosterAttendanceTypesQuery,
  CountRosterAttendanceTypesQueryVariables
>;
export const RosterAttendanceTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterAttendanceType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterAttendanceType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterAttendanceTypeQuery,
  RosterAttendanceTypeQueryVariables
>;
export const RosterStandardAttendanceTypeValidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterStandardAttendanceTypeValid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterStandardAttendanceTypeValid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterStandardAttendanceTypeValidQuery,
  RosterStandardAttendanceTypeValidQueryVariables
>;
export const MutateRosterAttendanceTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateRosterAttendanceType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RosterAttendanceTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateRosterAttendanceType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateRosterAttendanceTypeMutation,
  MutateRosterAttendanceTypeMutationVariables
>;
export const DeleteRosterAttendanceTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteRosterAttendanceType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRosterAttendanceType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRosterAttendanceTypeMutation,
  DeleteRosterAttendanceTypeMutationVariables
>;
export const ArchiveRosterAttendanceTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "archiveRosterAttendanceType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "archiveRosterAttendanceType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArchiveRosterAttendanceTypeMutation,
  ArchiveRosterAttendanceTypeMutationVariables
>;
export const RosterTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterTaskFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterTasks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterTasksQuery, RosterTasksQueryVariables>;
export const CountRosterTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countRosterTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterTaskFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countRosterTasks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountRosterTasksQuery,
  CountRosterTasksQueryVariables
>;
export const RosterTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterTaskQuery, RosterTaskQueryVariables>;
export const MutateRosterTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateRosterTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RosterTaskInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateRosterTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateRosterTaskMutation,
  MutateRosterTaskMutationVariables
>;
export const DeleteRosterTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteRosterTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRosterTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRosterTaskMutation,
  DeleteRosterTaskMutationVariables
>;
export const ArchiveRosterTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "archiveRosterTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "archiveRosterTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArchiveRosterTaskMutation,
  ArchiveRosterTaskMutationVariables
>;
export const RosterGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterGroupFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterGroup" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterGroupsQuery, RosterGroupsQueryVariables>;
export const RosterGroupsForFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterGroupsForForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterGroupFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterGroupsForFormQuery,
  RosterGroupsForFormQueryVariables
>;
export const RosterGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterGroup" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterGroupQuery, RosterGroupQueryVariables>;
export const MutateRosterGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateRosterGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RosterGroupInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateRosterGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterGroup" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateRosterGroupMutation,
  MutateRosterGroupMutationVariables
>;
export const DeleteRosterGroupDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteRosterGroup" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRosterGroup" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterGroup" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterGroup" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRosterGroupMutation,
  DeleteRosterGroupMutationVariables
>;
export const MutateRosterGroupsForUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateRosterGroupsForUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "groupIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "StringNumber" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateRosterGroupsForUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "groupIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "groupIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateRosterGroupsForUserMutation,
  MutateRosterGroupsForUserMutationVariables
>;
export const RosterStandardAttendancesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterStandardAttendances" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterStandardAttendanceFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterStandardAttendances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterStandardAttendancesQuery,
  RosterStandardAttendancesQueryVariables
>;
export const MutateRosterStandardAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateRosterStandardAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RosterStandardAttendanceInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateRosterStandardAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateRosterStandardAttendanceMutation,
  MutateRosterStandardAttendanceMutationVariables
>;
export const DeleteRosterStandardAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteRosterStandardAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRosterStandardAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRosterStandardAttendanceMutation,
  DeleteRosterStandardAttendanceMutationVariables
>;
export const RosterStandardDaysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterStandardDays" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterStandardDayFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterStandardDays" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardDay" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardDay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardDay" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hours" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardHour" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterStandardDaysQuery,
  RosterStandardDaysQueryVariables
>;
export const MutateRosterStandardDayDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateRosterStandardDay" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RosterStandardDayInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateRosterStandardDay" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardDay" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardDay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardDay" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hours" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardHour" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateRosterStandardDayMutation,
  MutateRosterStandardDayMutationVariables
>;
export const ShiftRosterStandardDayHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "shiftRosterStandardDayHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "standardDayId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "minutes" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftRosterStandardDayHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "standardDayId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "standardDayId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "minutes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "minutes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftRosterStandardDayHoursMutation,
  ShiftRosterStandardDayHoursMutationVariables
>;
export const CopyRosterStandardDayDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "copyRosterStandardDay" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RosterStandardDayInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "copyRosterStandardDay" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardDay" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardDay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardDay" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hours" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardHour" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CopyRosterStandardDayMutation,
  CopyRosterStandardDayMutationVariables
>;
export const DeleteRosterStandardDayDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteRosterStandardDay" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRosterStandardDay" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardDay" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "notifyUser" } },
          { kind: "Field", name: { kind: "Name", value: "notifyMinutes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterStandardDay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterStandardDay" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "weekDay" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendanceType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hours" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterStandardHour" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRosterStandardDayMutation,
  DeleteRosterStandardDayMutationVariables
>;
export const RosterAttendancesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterAttendances" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterAttendanceFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterAttendances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterAttendancesQuery,
  RosterAttendancesQueryVariables
>;
export const RosterAttendancesWithTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterAttendancesWithType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterAttendanceFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterAttendances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attendanceType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterAttendancesWithTypeQuery,
  RosterAttendancesWithTypeQueryVariables
>;
export const RosterAttendancesWithUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterAttendancesWithUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterAttendanceFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterAttendances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterAttendancesWithUserQuery,
  RosterAttendancesWithUserQueryVariables
>;
export const RosterAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterAttendanceQuery,
  RosterAttendanceQueryVariables
>;
export const MutateRosterAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateRosterAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RosterAttendanceInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateRosterAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateRosterAttendanceMutation,
  MutateRosterAttendanceMutationVariables
>;
export const PlanStandardRosterAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "planStandardRosterAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planStandardRosterAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlanStandardRosterAttendanceMutation,
  PlanStandardRosterAttendanceMutationVariables
>;
export const DeleteRosterAttendanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteRosterAttendance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRosterAttendance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRosterAttendanceMutation,
  DeleteRosterAttendanceMutationVariables
>;
export const BatchDeleteRosterAttendancesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "batchDeleteRosterAttendances" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchDeleteRosterAttendances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BatchDeleteRosterAttendancesMutation,
  BatchDeleteRosterAttendancesMutationVariables
>;
export const ConfirmRosterAttendancesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmRosterAttendances" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "StringNumber" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmRosterAttendances" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterAttendance" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendance" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendance" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "day" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "attendanceTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmRosterAttendancesMutation,
  ConfirmRosterAttendancesMutationVariables
>;
export const RosterHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterHourFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterHoursQuery, RosterHoursQueryVariables>;
export const MutateRosterHourDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateRosterHour" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RosterHourInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateRosterHour" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateRosterHourMutation,
  MutateRosterHourMutationVariables
>;
export const ShiftRosterHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "shiftRosterHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "day" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "minutes" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shiftRosterHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "day" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "day" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "minutes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "minutes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ShiftRosterHoursMutation,
  ShiftRosterHoursMutationVariables
>;
export const ConfirmRosterHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmRosterHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "StringNumber" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "day" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmRosterHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "day" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "day" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmRosterHoursMutation,
  ConfirmRosterHoursMutationVariables
>;
export const PlanStandardRosterHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "planStandardRosterHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "day" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planStandardRosterHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "day" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "day" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlanStandardRosterHoursMutation,
  PlanStandardRosterHoursMutationVariables
>;
export const DeleteRosterHourDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteRosterHour" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteRosterHour" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRosterHourMutation,
  DeleteRosterHourMutationVariables
>;
export const BatchDeleteRosterHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "batchDeleteRosterHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "day" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchDeleteRosterHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "day" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "day" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BatchDeleteRosterHoursMutation,
  BatchDeleteRosterHoursMutationVariables
>;
export const CopyRosterHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "copyRosterHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sourceDay" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "targetDay" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "copyRosterHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sourceDay" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sourceDay" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetDay" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "targetDay" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CopyRosterHoursMutation,
  CopyRosterHoursMutationVariables
>;
export const RosterMonthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterMonth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterMonthFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterMonth" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "sum" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "days" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stopTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pauseTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mostUsedTaskId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attendanceType" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "RosterAttendanceType",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterAttendanceType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterAttendanceType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "char" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "isStandard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ignoreForSickNotes" },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RosterMonthQuery, RosterMonthQueryVariables>;
export const RosterHoursMonthSumsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterHoursMonthSums" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "groupIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "StringNumber" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterHoursMonthSums" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "groupIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "groupIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "sum" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterHoursMonthSumsQuery,
  RosterHoursMonthSumsQueryVariables
>;
export const RosterNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "rosterNotifications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RosterNotificationFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rosterNotifications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterNotification" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterNotification" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterNotification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RosterNotificationsQuery,
  RosterNotificationsQueryVariables
>;
export const MarkRosterNotificationDoneDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markRosterNotificationDone" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markRosterNotificationDone" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterNotification" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterNotification" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterNotification" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkRosterNotificationDoneMutation,
  MarkRosterNotificationDoneMutationVariables
>;
export const NotifyRosterHourDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "notifyRosterHour" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notifyRosterHour" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RosterHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "task" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RosterHour" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RosterHour" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "hour" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "toBeDeleted" } },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NotifyRosterHourSubscription,
  NotifyRosterHourSubscriptionVariables
>;
export const SecretsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "secrets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListSecretsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "secrets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Secret" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Secret" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Secret" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SecretsQuery, SecretsQueryVariables>;
export const CountSecretsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countSecrets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListSecretsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countSecrets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountSecretsQuery, CountSecretsQueryVariables>;
export const MutateSecretDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateSecret" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SecretInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateSecret" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Secret" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Secret" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Secret" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "validUntil" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateSecretMutation,
  MutateSecretMutationVariables
>;
export const DeleteSecretDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteSecret" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteSecret" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSecretMutation,
  DeleteSecretMutationVariables
>;
export const VersionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "versions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "versions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "frontend" } },
                { kind: "Field", name: { kind: "Name", value: "backend" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VersionsSubscription,
  VersionsSubscriptionVariables
>;
export const LoginDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "login" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "username" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "password" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "otp" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "login" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "username" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "username" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "password" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "otp" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "otp" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const TokenForUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "tokenForUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tokenForUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TokenForUserMutation,
  TokenForUserMutationVariables
>;
export const RequestChallengeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "requestChallenge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "number" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestChallenge" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "number" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "number" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestChallengeMutation,
  RequestChallengeMutationVariables
>;
export const VerifyChallengeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "verifyChallenge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "number" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "response" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyChallenge" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "number" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "number" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "response" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "response" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyChallengeMutation,
  VerifyChallengeMutationVariables
>;
export const RefreshUserProtocolBeaconDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "refreshUserProtocolBeacon" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refreshUserProtocolBeacon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshUserProtocolBeaconMutation,
  RefreshUserProtocolBeaconMutationVariables
>;
export const SessionDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "sessionData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerIdentifier" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sessionData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerIdentifier" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerIdentifier" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SessionUser" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SessionCustomer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "flags" } },
          { kind: "Field", name: { kind: "Name", value: "teamLeader" } },
          { kind: "Field", name: { kind: "Name", value: "isJumper" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerIds" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultProject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionCustomer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerAdministrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SessionDataQuery, SessionDataQueryVariables>;
export const RefreshDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "refresh" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerIdentifier" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refresh" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerIdentifier" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerIdentifier" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SessionUser" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SessionCustomer" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "flags" } },
          { kind: "Field", name: { kind: "Name", value: "teamLeader" } },
          { kind: "Field", name: { kind: "Name", value: "isJumper" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerIds" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultProject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionCustomer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerAdministrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefreshMutation, RefreshMutationVariables>;
export const SessionCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "sessionCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "identifier" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "identifier" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "identifier" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionCustomer" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionCustomer" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Customer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerAdministrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SessionCustomerQuery,
  SessionCustomerQueryVariables
>;
export const UsersSetCurrentBillingCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "usersSetCurrentBillingCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "usersSetCurrentBillingCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionUser" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "flags" } },
          { kind: "Field", name: { kind: "Name", value: "teamLeader" } },
          { kind: "Field", name: { kind: "Name", value: "isJumper" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerIds" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultProject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UsersSetCurrentBillingCustomerMutation,
  UsersSetCurrentBillingCustomerMutationVariables
>;
export const PresettlementsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "presettlements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PresettlementListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "presettlements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partialWage" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "wageModifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "modification" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PresettlementsQuery, PresettlementsQueryVariables>;
export const CountPresettlementsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countPresettlements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countPresettlements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountPresettlementsQuery,
  CountPresettlementsQueryVariables
>;
export const PresettlementValidationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "presettlementValidation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "presettlementValidation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PresettlementValidationQuery,
  PresettlementValidationQueryVariables
>;
export const PresettlementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "presettlement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "presettlement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Presettlement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Presettlement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Presettlement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "entries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
                { kind: "Field", name: { kind: "Name", value: "wage" } },
                { kind: "Field", name: { kind: "Name", value: "partialWage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regularHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "illnessHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacationHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "sundayHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feastDayHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "wageModifications" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modification" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PresettlementQuery, PresettlementQueryVariables>;
export const PresettlementSuggestionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "presettlementSuggestion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "presettlementSuggestion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
                { kind: "Field", name: { kind: "Name", value: "wage" } },
                { kind: "Field", name: { kind: "Name", value: "partialWage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regularHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "illnessHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacationHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "sundayHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feastDayHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PresettlementSuggestionQuery,
  PresettlementSuggestionQueryVariables
>;
export const MutatePresettlementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutatePresettlement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PresettlementInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutatePresettlement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Presettlement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Presettlement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Presettlement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "entries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "hourlyWage" } },
                { kind: "Field", name: { kind: "Name", value: "wage" } },
                { kind: "Field", name: { kind: "Name", value: "partialWage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regularHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "illnessHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacationHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "sundayHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feastDayHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "wageModifications" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modification" },
                },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutatePresettlementMutation,
  MutatePresettlementMutationVariables
>;
export const DeletePresettlementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deletePresettlement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePresettlement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePresettlementMutation,
  DeletePresettlementMutationVariables
>;
export const SettlementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "settlement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "settlement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Settlement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Settlement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Settlement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "isVisible" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inflationBonus" } },
          { kind: "Field", name: { kind: "Name", value: "couponBonus" } },
          { kind: "Field", name: { kind: "Name", value: "ticketBonus" } },
          { kind: "Field", name: { kind: "Name", value: "travelCosts" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "visibleAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "posType" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "corrections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "taskId" } },
                { kind: "Field", name: { kind: "Name", value: "hours" } },
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "contractId" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettlementQuery, SettlementQueryVariables>;
export const SettlementsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "settlements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SettlementsListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "settlements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "isVisible" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "visibleAt" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "editor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettlementsQuery, SettlementsQueryVariables>;
export const CountSettlementsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countSettlements" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SettlementsListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countSettlements" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountSettlementsQuery,
  CountSettlementsQueryVariables
>;
export const MutateSettlementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateSettlement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SettlementInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateSettlement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Settlement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Settlement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Settlement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "isVisible" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inflationBonus" } },
          { kind: "Field", name: { kind: "Name", value: "couponBonus" } },
          { kind: "Field", name: { kind: "Name", value: "ticketBonus" } },
          { kind: "Field", name: { kind: "Name", value: "travelCosts" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "visibleAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "posType" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "corrections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "taskId" } },
                { kind: "Field", name: { kind: "Name", value: "hours" } },
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "contractId" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateSettlementMutation,
  MutateSettlementMutationVariables
>;
export const MarkSettlementReadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markSettlementRead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markSettlementRead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Settlement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Settlement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Settlement" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "month" } },
          { kind: "Field", name: { kind: "Name", value: "isVisible" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "inflationBonus" } },
          { kind: "Field", name: { kind: "Name", value: "couponBonus" } },
          { kind: "Field", name: { kind: "Name", value: "ticketBonus" } },
          { kind: "Field", name: { kind: "Name", value: "travelCosts" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "visibleAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "positions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "posType" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "corrections" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "taskId" } },
                { kind: "Field", name: { kind: "Name", value: "hours" } },
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "contractId" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkSettlementReadMutation,
  MarkSettlementReadMutationVariables
>;
export const DeleteSettlementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteSettlement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteSettlement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSettlementMutation,
  DeleteSettlementMutationVariables
>;
export const SettlementDayHoursDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "settlementDayHours" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "settlementDayHours" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dayHours" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "day" } },
                      { kind: "Field", name: { kind: "Name", value: "paid" } },
                      { kind: "Field", name: { kind: "Name", value: "work" } },
                      { kind: "Field", name: { kind: "Name", value: "pause" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "illness" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "childSick" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sickNoPayment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holidays" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holidaysUnpaid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "compensation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feastday" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feastdayOff" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sum" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviation" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sums" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "paid" } },
                      { kind: "Field", name: { kind: "Name", value: "work" } },
                      { kind: "Field", name: { kind: "Name", value: "pause" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "illness" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "childSick" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sickNoPayment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holidays" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holidaysUnpaid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "compensation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feastday" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feastdayOff" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sum" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SettlementDayHoursQuery,
  SettlementDayHoursQueryVariables
>;
export const SettlementsGenerateAccountantOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "settlementsGenerateAccountantOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "settlementsGenerateAccountantOverview",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "JobResult" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "JobResult" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "JobResult" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "module" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "seen" } },
          { kind: "Field", name: { kind: "Name", value: "hasAttachment" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "report" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SettlementsGenerateAccountantOverviewMutation,
  SettlementsGenerateAccountantOverviewMutationVariables
>;
export const StaffShareLinkByShareIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "staffShareLinkByShareId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "shareId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffShareLinkByShareId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "shareId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "shareId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffShareLink" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLinkFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLinkFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLink" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "shareId" } },
          { kind: "Field", name: { kind: "Name", value: "validForDays" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "files" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffShareLinkFile" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffShareLinkByShareIdQuery,
  StaffShareLinkByShareIdQueryVariables
>;
export const MutateStaffShareLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateStaffShareLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffShareLinkInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateStaffShareLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffShareLink" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLinkFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLinkFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLink" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "shareId" } },
          { kind: "Field", name: { kind: "Name", value: "validForDays" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "files" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffShareLinkFile" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateStaffShareLinkMutation,
  MutateStaffShareLinkMutationVariables
>;
export const SendStaffShareLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendStaffShareLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "recipient" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffShareLinkSendInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendStaffShareLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipient" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "recipient" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffShareLink" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PersonalFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PersonalFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "mimeType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFileTypeId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "fileType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "required" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "pubDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLinkFile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLinkFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "personalFile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PersonalFile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffShareLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffShareLink" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "shareId" } },
          { kind: "Field", name: { kind: "Name", value: "validForDays" } },
          { kind: "Field", name: { kind: "Name", value: "note" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "files" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffShareLinkFile" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendStaffShareLinkMutation,
  SendStaffShareLinkMutationVariables
>;
export const SickNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "sickNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SickNoteListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sickNotes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SickNote" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SickNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SickNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasSickCertificate" },
          },
          { kind: "Field", name: { kind: "Name", value: "childSick" } },
          { kind: "Field", name: { kind: "Name", value: "payment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sickCertificateType" },
          },
          { kind: "Field", name: { kind: "Name", value: "voucherType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SickNotesQuery, SickNotesQueryVariables>;
export const CountSickNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countSickNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SickNoteListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countSickNotes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountSickNotesQuery, CountSickNotesQueryVariables>;
export const SickNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "sickNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sickNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SickNote" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SickNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SickNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasSickCertificate" },
          },
          { kind: "Field", name: { kind: "Name", value: "childSick" } },
          { kind: "Field", name: { kind: "Name", value: "payment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sickCertificateType" },
          },
          { kind: "Field", name: { kind: "Name", value: "voucherType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SickNoteQuery, SickNoteQueryVariables>;
export const SickNoteNeedsCertificateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "sickNoteNeedsCertificate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "starts" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "childSick" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sickNoteNeedsCertificate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "starts" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "starts" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "childSick" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "childSick" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SickNoteNeedsCertificateQuery,
  SickNoteNeedsCertificateQueryVariables
>;
export const SickNoteNoPaymentCandidateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "sickNoteNoPaymentCandidate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sickNoteNoPaymentCandidate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SickNoteNoPaymentCandidateQuery,
  SickNoteNoPaymentCandidateQueryVariables
>;
export const MutateSickNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateSickNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SickNoteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateSickNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SickNote" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SickNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SickNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasSickCertificate" },
          },
          { kind: "Field", name: { kind: "Name", value: "childSick" } },
          { kind: "Field", name: { kind: "Name", value: "payment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sickCertificateType" },
          },
          { kind: "Field", name: { kind: "Name", value: "voucherType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateSickNoteMutation,
  MutateSickNoteMutationVariables
>;
export const DeleteSickNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteSickNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteSickNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSickNoteMutation,
  DeleteSickNoteMutationVariables
>;
export const ConfirmSickNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmSickNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmSickNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "payment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SickNote" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SickNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SickNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasSickCertificate" },
          },
          { kind: "Field", name: { kind: "Name", value: "childSick" } },
          { kind: "Field", name: { kind: "Name", value: "payment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sickCertificateType" },
          },
          { kind: "Field", name: { kind: "Name", value: "voucherType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmSickNoteMutation,
  ConfirmSickNoteMutationVariables
>;
export const DeclineSickNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "declineSickNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "declineSickNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SickNote" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SickNote" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SickNote" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasSickCertificate" },
          },
          { kind: "Field", name: { kind: "Name", value: "childSick" } },
          { kind: "Field", name: { kind: "Name", value: "payment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sickCertificateType" },
          },
          { kind: "Field", name: { kind: "Name", value: "voucherType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeclineSickNoteMutation,
  DeclineSickNoteMutationVariables
>;
export const WorktimesSupervisorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesSupervisor" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SupervisorFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesSupervisor" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "taskId" } },
                { kind: "Field", name: { kind: "Name", value: "starts" } },
                { kind: "Field", name: { kind: "Name", value: "dayStart" } },
                { kind: "Field", name: { kind: "Name", value: "stops" } },
                { kind: "Field", name: { kind: "Name", value: "worktime" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "task" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesSupervisorQuery,
  WorktimesSupervisorQueryVariables
>;
export const StaffAbsenceOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "staffAbsenceOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StaffAbsenceOverviewFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffAbsenceOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "year" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "year" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "months" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "month" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sickTotal" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "absentWoPermission" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "yearSickTotal" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "yearAbsentWoPermission" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaffAbsenceOverviewQuery,
  StaffAbsenceOverviewQueryVariables
>;
export const ProductiveHourGoalsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "productiveHourGoals" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ProductiveHourGoalListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "productiveHourGoals" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProductiveHourGoal" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductiveHourGoal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProductiveHourGoal" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "wantedHours" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductiveHourGoalsQuery,
  ProductiveHourGoalsQueryVariables
>;
export const CountProductiveHourGoalsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countProductiveHourGoals" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ProductiveHourGoalListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countProductiveHourGoals" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountProductiveHourGoalsQuery,
  CountProductiveHourGoalsQueryVariables
>;
export const ProductiveHourGoalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "productiveHourGoal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "productiveHourGoal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProductiveHourGoal" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductiveHourGoal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProductiveHourGoal" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "wantedHours" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductiveHourGoalQuery,
  ProductiveHourGoalQueryVariables
>;
export const ProductiveHourGoalPeriodValidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "productiveHourGoalPeriodValid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ProductiveHourGoalValidationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "productiveHourGoalPeriodValid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "valid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "goals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ProductiveHourGoal" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductiveHourGoal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProductiveHourGoal" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "wantedHours" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductiveHourGoalPeriodValidQuery,
  ProductiveHourGoalPeriodValidQueryVariables
>;
export const MutateProductiveHourGoalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateProductiveHourGoal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProductiveHourGoalInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateProductiveHourGoal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProductiveHourGoal" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProductiveHourGoal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProductiveHourGoal" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "wantedHours" } },
          { kind: "Field", name: { kind: "Name", value: "period" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateProductiveHourGoalMutation,
  MutateProductiveHourGoalMutationVariables
>;
export const MutateFteGoalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateFteGoal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FteGoalInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateFteGoal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "teamId" } },
                { kind: "Field", name: { kind: "Name", value: "wantedFte" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateFteGoalMutation,
  MutateFteGoalMutationVariables
>;
export const MutateStaffHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateStaffHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StaffHistoryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateStaffHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffHistory" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffHistory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffHistory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "nextTalk" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateStaffHistoryMutation,
  MutateStaffHistoryMutationVariables
>;
export const DeleteStaffHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteStaffHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteStaffHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffHistory" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffHistory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffHistory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "nextTalk" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteStaffHistoryMutation,
  DeleteStaffHistoryMutationVariables
>;
export const StaffHistoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "staffHistories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StaffHistoriesListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffHistories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffHistory" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffHistory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffHistory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "nextTalk" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffHistoriesQuery, StaffHistoriesQueryVariables>;
export const CountStaffHistoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countStaffHistories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StaffHistoriesListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countStaffHistories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountStaffHistoriesQuery,
  CountStaffHistoriesQueryVariables
>;
export const StaffHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "staffHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "staffHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StaffHistory" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StaffHistory" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StaffHistory" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "htype" } },
          { kind: "Field", name: { kind: "Name", value: "text" } },
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "nextTalk" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StaffHistoryQuery, StaffHistoryQueryVariables>;
export const ProjectStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "projectStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "args" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "JSON" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ProjectStatsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "args" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectStatsQuery, ProjectStatsQueryVariables>;
export const WorkerStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "workerStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WorkerStatsFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "workerStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkerStatsQuery, WorkerStatsQueryVariables>;
export const DataPoolStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "dataPoolStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DataPoolStatsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dataPoolStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "groupName" } },
                { kind: "Field", name: { kind: "Name", value: "statusName" } },
                { kind: "Field", name: { kind: "Name", value: "cnt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataPoolStatsQuery, DataPoolStatsQueryVariables>;
export const DataPoolByProjectStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "dataPoolByProjectStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dataPoolByProjectStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "status" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "position" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "project" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataPoolByProjectStatsQuery,
  DataPoolByProjectStatsQueryVariables
>;
export const TicketStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ticketStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "start" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDateTime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stop" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDateTime" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "start" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "start" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stop" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stop" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byCustomer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effort" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cnt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "thumb" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "medium" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byOwner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effort" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cnt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "User" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byReporter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effort" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cnt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "User" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effort" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cnt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bySolution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "effort" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cnt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "solution" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TicketStatsQuery, TicketStatsQueryVariables>;
export const HotseatStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "hotseatStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "HotseatStatsFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hotseatStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cats" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cnt" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "catsByUser" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subCatsByCat" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HotseatStatsQuery, HotseatStatsQueryVariables>;
export const RecruitingContactsCreatedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "recruitingContactsCreated" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DashboardStatsFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recruitingContactsCreated" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RecruitingContactsCreatedQuery,
  RecruitingContactsCreatedQueryVariables
>;
export const AppointmentStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "appointmentStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AppointmentStatsFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "appointmentStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "created" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cleared" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "storno" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shifted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notTookPlace" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feedbacks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "new" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shifted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "missing" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AppointmentStatsQuery,
  AppointmentStatsQueryVariables
>;
export const ProductiveHourOverviewStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "productiveHourOverviewStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "starts" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stops" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "productiveHourOverviewStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "starts" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "starts" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stops" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stops" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "wantedHours" } },
                { kind: "Field", name: { kind: "Name", value: "paidHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "forecastedProductiveHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "forecastedPaidHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "productiveHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "adminHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holidayHoursApproved" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holidayHoursPending" },
                },
                { kind: "Field", name: { kind: "Name", value: "sickHours" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductiveHourOverviewStatsQuery,
  ProductiveHourOverviewStatsQueryVariables
>;
export const ProductiveHourStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "productiveHourStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "starts" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stops" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "productiveHourStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "starts" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "starts" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stops" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stops" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "wantedHours" } },
                { kind: "Field", name: { kind: "Name", value: "paidHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "forecastedPaidHours" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "productiveHours" },
                },
                { kind: "Field", name: { kind: "Name", value: "adminHours" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holidayHoursApproved" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holidayHoursPending" },
                },
                { kind: "Field", name: { kind: "Name", value: "sickHours" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductiveHourStatsQuery,
  ProductiveHourStatsQueryVariables
>;
export const SickDaysStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "sickDaysStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "starts" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stops" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sickDaysStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "starts" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "starts" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stops" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stops" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "total" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeUsers" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sickUsers" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sickDays" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "perCustomer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeUsers" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sickUsers" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sickDays" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "thumb" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "medium" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SickDaysStatsQuery, SickDaysStatsQueryVariables>;
export const TaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "task" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Task" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaireType" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "reactionNeeded" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "isCompany" } },
                { kind: "Field", name: { kind: "Name", value: "statusId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "primaryAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "atype" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "zip" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cityPart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "itype" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskQuery, TaskQueryVariables>;
export const QuestionnaireTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "questionnaireTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "questionnaireType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "questionnaireTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "questionnaireType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "questionnaireType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Task" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaireType" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "reactionNeeded" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "isCompany" } },
                { kind: "Field", name: { kind: "Name", value: "statusId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "primaryAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "atype" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "zip" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cityPart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "itype" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QuestionnaireTaskQuery,
  QuestionnaireTaskQueryVariables
>;
export const MutateTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TaskInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Task" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaireType" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "reactionNeeded" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "isCompany" } },
                { kind: "Field", name: { kind: "Name", value: "statusId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "primaryAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "atype" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "zip" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cityPart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "itype" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirmedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutateTaskMutation, MutateTaskMutationVariables>;
export const TasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "tasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TaskListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tasks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskListFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskListFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Task" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaireType" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "reactionNeeded" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "points" } },
          { kind: "Field", name: { kind: "Name", value: "wantedPoints" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TasksQuery, TasksQueryVariables>;
export const CountTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TaskListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countTasks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountTasksQuery, CountTasksQueryVariables>;
export const DeleteTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const SendTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskListFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskListFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Task" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "questionnaireType" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "reactionNeeded" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "reason" } },
          { kind: "Field", name: { kind: "Name", value: "points" } },
          { kind: "Field", name: { kind: "Name", value: "wantedPoints" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendTaskMutation, SendTaskMutationVariables>;
export const TaskOffersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "taskOffers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TaskOfferListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "taskOffers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "TaskOfferWithProductsFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferWithProductsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TaskOfferFragment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "products" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskProductFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskOffersQuery, TaskOffersQueryVariables>;
export const CountTaskOffersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countTaskOffers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TaskOfferListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countTaskOffers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountTaskOffersQuery,
  CountTaskOffersQueryVariables
>;
export const TaskOfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "taskOffer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "taskOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "TaskOfferWithProductsFragment",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferWithProductsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TaskOfferFragment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "products" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskProductFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskOfferQuery, TaskOfferQueryVariables>;
export const MutateTaskOfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateTaskOffer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TaskOfferInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateTaskOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskOfferFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateTaskOfferMutation,
  MutateTaskOfferMutationVariables
>;
export const DeleteTaskOfferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTaskOffer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTaskOffer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTaskOfferMutation,
  DeleteTaskOfferMutationVariables
>;
export const TaskProductsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "taskProducts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TaskProductListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "taskProducts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskProductFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskProductsQuery, TaskProductsQueryVariables>;
export const TaskProductDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "taskProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "taskProduct" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskProductWithOfferFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskOffer" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductWithOfferFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "TaskProductFragment" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "offer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskOfferFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskProductQuery, TaskProductQueryVariables>;
export const MutateTaskProductDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateTaskProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TaskProductInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateTaskProduct" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TaskProductFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TaskProductFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TaskProduct" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "price" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateTaskProductMutation,
  MutateTaskProductMutationVariables
>;
export const DeleteTaskProductDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTaskProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTaskProduct" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTaskProductMutation,
  DeleteTaskProductMutationVariables
>;
export const ExportTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "exportTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TaskListFilters" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fields" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fieldNames" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exportTasks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fields" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fields" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fieldNames" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fieldNames" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportTasksMutation, ExportTasksMutationVariables>;
export const RecalculateTaskPointsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "recalculateTaskPoints" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "starts" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDateTime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stops" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDateTime" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recalculateTaskPoints" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "starts" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "starts" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stops" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stops" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RecalculateTaskPointsMutation,
  RecalculateTaskPointsMutationVariables
>;
export const TasksByHourStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "tasksByHourStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "field" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TaskStatsField" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TaskStatsFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tasksByHourStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "field" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "field" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "hour" } },
                { kind: "Field", name: { kind: "Name", value: "val" } },
                { kind: "Field", name: { kind: "Name", value: "cnt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TasksByHourStatsQuery,
  TasksByHourStatsQueryVariables
>;
export const TasksAttrStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "tasksAttrStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "attr" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TaskAttrStatsFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tasksAttrStats" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "attr" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "attr" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TasksAttrStatsQuery, TasksAttrStatsQueryVariables>;
export const TeamsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "teams" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TeamsListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TeamListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamsQuery, TeamsQueryVariables>;
export const CountTeamsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countTeams" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countTeams" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountTeamsQuery, CountTeamsQueryVariables>;
export const TeamsWithUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "teamsWithUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TeamWithUsers" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamWithUsers" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamsWithUsersQuery, TeamsWithUsersQueryVariables>;
export const TeamsWithUsersAndForeignUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "teamsWithUsersAndForeignUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teams" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TeamWithUsersAndForeignUsers" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamWithUsersAndForeignUsers" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TeamsWithUsersAndForeignUsersQuery,
  TeamsWithUsersAndForeignUsersQueryVariables
>;
export const CopyTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "copyTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teamId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "copyTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teamId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TeamListItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "project" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CopyTeamMutation, CopyTeamMutationVariables>;
export const DeleteTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const IsTeamLeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "isTeamLeader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "StringNumber" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "isTeamLeader" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userIds" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IsTeamLeaderQuery, IsTeamLeaderQueryVariables>;
export const RecruitingTeamOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "recruitingTeamOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recruitingTeamOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "date" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RecruitingSummary" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RecruitingSummary" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RecruitingSummary" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "teamId" } },
          { kind: "Field", name: { kind: "Name", value: "wanted" } },
          { kind: "Field", name: { kind: "Name", value: "planned" } },
          { kind: "Field", name: { kind: "Name", value: "employed" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RecruitingTeamOverviewQuery,
  RecruitingTeamOverviewQueryVariables
>;
export const TeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "team" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "team" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TeamDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignLeaders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamQuery, TeamQueryVariables>;
export const MutateTeamDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateTeam" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "team" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TeamInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateTeam" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "team" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "team" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TeamDetail" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TeamDetail" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Team" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignUsers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignLeaders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutateTeamMutation, MutateTeamMutationVariables>;
export const TeamsForCustomersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "teamsForCustomers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "StringNumber" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "teamsForCustomers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "project" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TeamsForCustomersQuery,
  TeamsForCustomersQueryVariables
>;
export const TermitelContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "termitelContracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "termitelContracts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContract" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContractAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContractAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contractId" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "contract" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderDataProcessing" },
          },
          { kind: "Field", name: { kind: "Name", value: "letterOfIndemnity" } },
          { kind: "Field", name: { kind: "Name", value: "runtime" } },
          { kind: "Field", name: { kind: "Name", value: "runtimeType" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriod" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriodType" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoal" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoalType" } },
          { kind: "Field", name: { kind: "Name", value: "deletionPeriod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletionPeriodType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextPossibleTermination" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContractAttachment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TermitelContractsQuery,
  TermitelContractsQueryVariables
>;
export const TermitelContractOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "termitelContractOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "termitelContractOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContract" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContractAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContractAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contractId" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "contract" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderDataProcessing" },
          },
          { kind: "Field", name: { kind: "Name", value: "letterOfIndemnity" } },
          { kind: "Field", name: { kind: "Name", value: "runtime" } },
          { kind: "Field", name: { kind: "Name", value: "runtimeType" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriod" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriodType" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoal" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoalType" } },
          { kind: "Field", name: { kind: "Name", value: "deletionPeriod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletionPeriodType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextPossibleTermination" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContractAttachment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TermitelContractOverviewQuery,
  TermitelContractOverviewQueryVariables
>;
export const MutateTermitelContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateTermitelContract" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TermitelContractInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateTermitelContract" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContract" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContractAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContractAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contractId" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "contract" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderDataProcessing" },
          },
          { kind: "Field", name: { kind: "Name", value: "letterOfIndemnity" } },
          { kind: "Field", name: { kind: "Name", value: "runtime" } },
          { kind: "Field", name: { kind: "Name", value: "runtimeType" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriod" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriodType" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoal" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoalType" } },
          { kind: "Field", name: { kind: "Name", value: "deletionPeriod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletionPeriodType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextPossibleTermination" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContractAttachment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateTermitelContractMutation,
  MutateTermitelContractMutationVariables
>;
export const DeleteTermitelContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTermitelContract" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTermitelContract" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContract" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContractAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContractAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contractId" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContract" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContract" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "ends" } },
          { kind: "Field", name: { kind: "Name", value: "contract" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderDataProcessing" },
          },
          { kind: "Field", name: { kind: "Name", value: "letterOfIndemnity" } },
          { kind: "Field", name: { kind: "Name", value: "runtime" } },
          { kind: "Field", name: { kind: "Name", value: "runtimeType" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriod" } },
          { kind: "Field", name: { kind: "Name", value: "noticePeriodType" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoal" } },
          { kind: "Field", name: { kind: "Name", value: "paymentGoalType" } },
          { kind: "Field", name: { kind: "Name", value: "deletionPeriod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deletionPeriodType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextPossibleTermination" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContractAttachment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTermitelContractMutation,
  DeleteTermitelContractMutationVariables
>;
export const AttachTermitelContractDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "attachTermitelContractDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TermitelContractAttachmentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attachTermitelContractDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TermitelContractAttachment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TermitelContractAttachment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TermitelContractAttachment" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "contractId" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AttachTermitelContractDocumentMutation,
  AttachTermitelContractDocumentMutationVariables
>;
export const DeleteTermitelContractDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTermitelContractDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contractId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTermitelContractDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contractId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contractId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTermitelContractDocumentMutation,
  DeleteTermitelContractDocumentMutationVariables
>;
export const TicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "tickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TicketListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Ticket" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Ticket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Ticket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "forecastedEffort" } },
          { kind: "Field", name: { kind: "Name", value: "realEffort" } },
          { kind: "Field", name: { kind: "Name", value: "solution" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reporterId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reporter" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "orderedById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "nextStepById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextStepBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TicketsQuery, TicketsQueryVariables>;
export const CountTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TicketCountFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countTickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountTicketsQuery, CountTicketsQueryVariables>;
export const TicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ticket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Ticket" },
                },
                { kind: "Field", name: { kind: "Name", value: "subscribed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Ticket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Ticket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "forecastedEffort" } },
          { kind: "Field", name: { kind: "Name", value: "realEffort" } },
          { kind: "Field", name: { kind: "Name", value: "solution" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reporterId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reporter" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "orderedById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "nextStepById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextStepBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TicketQuery, TicketQueryVariables>;
export const DeleteTicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTicket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTicket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTicketMutation,
  DeleteTicketMutationVariables
>;
export const MutateTicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateTicket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TicketInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateTicket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Ticket" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Ticket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Ticket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "forecastedEffort" } },
          { kind: "Field", name: { kind: "Name", value: "realEffort" } },
          { kind: "Field", name: { kind: "Name", value: "solution" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reporterId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reporter" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "orderedById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "nextStepById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextStepBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateTicketMutation,
  MutateTicketMutationVariables
>;
export const OrderTicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "orderTicket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderTicket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Ticket" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CustomerLogo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomerLogo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Ticket" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Ticket" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "priority" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "forecastedEffort" } },
          { kind: "Field", name: { kind: "Name", value: "realEffort" } },
          { kind: "Field", name: { kind: "Name", value: "solution" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "document" } },
          { kind: "Field", name: { kind: "Name", value: "mdContent" } },
          { kind: "Field", name: { kind: "Name", value: "visible" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "dueDate" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "reporterId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reporter" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "orderedById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderedBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "nextStepById" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextStepBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CustomerLogo" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "relevantProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "relevantProject" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderTicketMutation, OrderTicketMutationVariables>;
export const SubscribeTicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "subscribeTicket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "subscribeTicket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ticketId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscribeTicketMutation,
  SubscribeTicketMutationVariables
>;
export const UnsubscribeTicketDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "unsubscribeTicket" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unsubscribeTicket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ticketId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnsubscribeTicketMutation,
  UnsubscribeTicketMutationVariables
>;
export const TicketTimelineDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ticketTimeline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ticketId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketTimeline" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ticketId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ticketId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TicketTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "effort" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TicketTimelineQuery, TicketTimelineQueryVariables>;
export const MutateTicketTimelineEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateTicketTimelineEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ticketId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TicketTimelineEntryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateTicketTimelineEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ticketId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ticketId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TicketTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "effort" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateTicketTimelineEntryMutation,
  MutateTicketTimelineEntryMutationVariables
>;
export const DeleteTicketTimelineEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTicketTimelineEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTicketTimelineEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimelineEntry" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimelineEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TicketTimelineEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "effort" } },
          { kind: "Field", name: { kind: "Name", value: "content" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteTicketTimelineEntryMutation,
  DeleteTicketTimelineEntryMutationVariables
>;
export const TimesheetOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "timesheetOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "start" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stop" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "timesheetOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "start" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "start" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stop" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stop" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "worktime" } },
                { kind: "Field", name: { kind: "Name", value: "productive" } },
                { kind: "Field", name: { kind: "Name", value: "sunday" } },
                { kind: "Field", name: { kind: "Name", value: "feastday" } },
                { kind: "Field", name: { kind: "Name", value: "feastdayOff" } },
                { kind: "Field", name: { kind: "Name", value: "paidTime" } },
                { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unplannedHomeoffice" },
                },
                { kind: "Field", name: { kind: "Name", value: "office" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "byType" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seconds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "task" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TimesheetOverviewQuery,
  TimesheetOverviewQueryVariables
>;
export const TimesheetPresencesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "timesheetPresences" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "start" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stop" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "timesheetPresences" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "start" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "start" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stop" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stop" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacationTaken" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacationEntitled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacationPlanned" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacationInSpan" },
                },
                { kind: "Field", name: { kind: "Name", value: "sickYear" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "childSickYear" },
                },
                { kind: "Field", name: { kind: "Name", value: "sickInSpan" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "childSickInSpan" },
                },
                { kind: "Field", name: { kind: "Name", value: "hoursWorked" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "absentWoPermission" },
                },
                { kind: "Field", name: { kind: "Name", value: "expected" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workedInSpan" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TimesheetPresencesQuery,
  TimesheetPresencesQueryVariables
>;
export const TimesheetYearOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "timesheetYearOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "timesheetYearOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "year" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "year" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unplannedHomeoffice" },
                },
                { kind: "Field", name: { kind: "Name", value: "office" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "days" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "TimesheetYearOverviewDay",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimesheetYearOverviewDay" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimesheetYearOverviewDay" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "date" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TimesheetYearOverviewQuery,
  TimesheetYearOverviewQueryVariables
>;
export const TodosDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "todos" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TodoListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "sent" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "creatorId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "allDone" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "todos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "file" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "owner" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "User" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodosQuery, TodosQueryVariables>;
export const TodosForContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "todosForContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TodoListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TodosForContactsQuery,
  TodosForContactsQueryVariables
>;
export const CountTodosDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countTodos" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TodoListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countTodos" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountTodosQuery, CountTodosQueryVariables>;
export const TodoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "todo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "todo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TodoDetailFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TodoQuery, TodoQueryVariables>;
export const MutateTodoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateTodo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TodoInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateTodo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TodoDetailFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutateTodoMutation, MutateTodoMutationVariables>;
export const SendTodoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendTodo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendTodo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TodoDetailFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendTodoMutation, SendTodoMutationVariables>;
export const OwnTodoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ownTodo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownTodo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TodoDetailFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnTodoMutation, OwnTodoMutationVariables>;
export const DeleteTodoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteTodo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteTodo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTodoMutation, DeleteTodoMutationVariables>;
export const ArchiveTodoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "archiveTodo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ArchiveTodoInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "archiveTodo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TodoDetailFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchiveTodoMutation, ArchiveTodoMutationVariables>;
export const CreateTodoNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createTodoNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "todoId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TodoNoteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTodoNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "todoId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "todoId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTodoNoteMutation,
  CreateTodoNoteMutationVariables
>;
export const AssignTodoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "assignTodo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "assignTodo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TodoDetailFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignTodoMutation, AssignTodoMutationVariables>;
export const TodoEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "todoEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "todoEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "todo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "TodoDetailFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TodoEventsSubscription,
  TodoEventsSubscriptionVariables
>;
export const ExportTodosDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "exportTodos" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TodoListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "exportTodos" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportTodosMutation, ExportTodosMutationVariables>;
export const ConfirmTodoWithTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmTodoWithToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "token" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmTodoWithToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "token" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TodoDetailFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TodoDetailFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Todo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "allDone" } },
          { kind: "Field", name: { kind: "Name", value: "done" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneText" } },
          { kind: "Field", name: { kind: "Name", value: "sent" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "statusAssignedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusAttrs" } },
          { kind: "Field", name: { kind: "Name", value: "ownerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "contactId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "todos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "done" } },
                { kind: "Field", name: { kind: "Name", value: "doneAt" } },
                { kind: "Field", name: { kind: "Name", value: "doneText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "doneBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "notes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
                { kind: "Field", name: { kind: "Name", value: "file" } },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "todoId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmTodoWithTokenMutation,
  ConfirmTodoWithTokenMutationVariables
>;
export const TtDashboardContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ttDashboardContracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ttDashboardContracts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "starts" } },
                { kind: "Field", name: { kind: "Name", value: "ends" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TtDashboardContractsQuery,
  TtDashboardContractsQueryVariables
>;
export const TtDashboardBirthdaysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ttDashboardBirthdays" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ttDashboardBirthdays" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TtDashboardBirthdaysQuery,
  TtDashboardBirthdaysQueryVariables
>;
export const TtDashboardWorktimesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ttDashboardWorktimes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ttDashboardWorktimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "worktime" } },
                { kind: "Field", name: { kind: "Name", value: "sickDays" } },
                { kind: "Field", name: { kind: "Name", value: "sunday" } },
                { kind: "Field", name: { kind: "Name", value: "feastday" } },
                { kind: "Field", name: { kind: "Name", value: "vacation" } },
                { kind: "Field", name: { kind: "Name", value: "expected" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedUntilYesterday" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TtDashboardWorktimesQuery,
  TtDashboardWorktimesQueryVariables
>;
export const TtDashboardRosterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ttDashboardRoster" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ttDashboardRoster" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "start" } },
                { kind: "Field", name: { kind: "Name", value: "stop" } },
                { kind: "Field", name: { kind: "Name", value: "pause" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TtDashboardRosterQuery,
  TtDashboardRosterQueryVariables
>;
export const TtDashboardProbationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ttDashboardProbations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ttDashboardProbations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "probationEnding" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TtDashboardProbationsQuery,
  TtDashboardProbationsQueryVariables
>;
export const TtDashboardFileExchangeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ttDashboardFileExchange" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ttDashboardFileExchange" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "filename" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "projectId" } },
                { kind: "Field", name: { kind: "Name", value: "ownerId" } },
                { kind: "Field", name: { kind: "Name", value: "creatorId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creator" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TtDashboardFileExchangeQuery,
  TtDashboardFileExchangeQueryVariables
>;
export const UploadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "uploads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ListProjectUploadsFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Upload" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Upload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectUpload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "imported" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadsQuery, UploadsQueryVariables>;
export const CountUploadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countUploads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countUploads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountUploadsQuery, CountUploadsQueryVariables>;
export const UploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "upload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Upload" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Upload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectUpload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "imported" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadQuery, UploadQueryVariables>;
export const MutateUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProjectUploadInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Upload" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Upload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectUpload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "imported" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateUploadMutation,
  MutateUploadMutationVariables
>;
export const DeleteUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Upload" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Upload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectUpload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "imported" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteUploadMutation,
  DeleteUploadMutationVariables
>;
export const MarkUploadDoneDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markUploadDone" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MarkUploadDoneInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markUploadDone" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Upload" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Upload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProjectUpload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "file" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
          { kind: "Field", name: { kind: "Name", value: "imported" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "doneAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "owner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "doneBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkUploadDoneMutation,
  MarkUploadDoneMutationVariables
>;
export const MutateSessionUserPasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateSessionUserPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "password" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateUserPassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "password" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionUser" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "flags" } },
          { kind: "Field", name: { kind: "Name", value: "teamLeader" } },
          { kind: "Field", name: { kind: "Name", value: "isJumper" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerIds" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultProject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateSessionUserPasswordMutation,
  MutateSessionUserPasswordMutationVariables
>;
export const MutateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "user" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "options" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UserMutationOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "user" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "options" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "options" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutateUserMutation, MutateUserMutationVariables>;
export const MutateUserProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateUserProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bio" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateUserProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "bio" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bio" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateUserProfileMutation,
  MutateUserProfileMutationVariables
>;
export const EnableOtpDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "enableOtp" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "enableOtp" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnableOtpMutation, EnableOtpMutationVariables>;
export const DeleteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inheritorId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inheritorId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inheritorId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const MutateUserPasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateUserPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "password" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateUserPassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "password" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateUserPasswordMutation,
  MutateUserPasswordMutationVariables
>;
export const MutateUserAvatarDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateUserAvatar" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "avatar" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Upload" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateUserAvatar" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "avatar" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "avatar" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateUserAvatarMutation,
  MutateUserAvatarMutationVariables
>;
export const DisableOtpDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "disableOtp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "otp" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "disableOtp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "otp" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "otp" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionUser" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionProject" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Project" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "identifier" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SessionUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "flags" } },
          { kind: "Field", name: { kind: "Name", value: "teamLeader" } },
          { kind: "Field", name: { kind: "Name", value: "isJumper" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerIds" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "thumb" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "medium" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "thumb" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SessionProject" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultProject" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "attrs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DisableOtpMutation, DisableOtpMutationVariables>;
export const DisableOtpForUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "disableOtpForUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "disableOtpForUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DisableOtpForUserMutation,
  DisableOtpForUserMutationVariables
>;
export const UserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "user" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const UserWithBillingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "userWithBilling" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserWithBilling" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserWithBilling" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "User" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentBillingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserWithBillingQuery,
  UserWithBillingQueryVariables
>;
export const UserWithDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "userWithDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserWithDetails" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserWithDetails" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "User" } },
          { kind: "Field", name: { kind: "Name", value: "isJumper" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerIds" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isCompany" } },
                { kind: "Field", name: { kind: "Name", value: "salutation" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "itype" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "normalizedValue" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "attrs" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projects" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "adminCustomers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "userTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaderTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignUserTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "foreignLeaderTeams" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserWithDetailsQuery,
  UserWithDetailsQueryVariables
>;
export const UsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "users" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UsersListFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const CountUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UsersCountFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountUsersQuery, CountUsersQueryVariables>;
export const UsernameUniqueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "usernameUnique" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "username" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "usernameUnique" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "username" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "username" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsernameUniqueQuery, UsernameUniqueQueryVariables>;
export const ResetUserPasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "resetUserPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "emailLang" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sendAs" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserPasswortSendAs" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "template" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserPasswordMailType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resetUserPassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailLang" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "emailLang" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sendAs" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sendAs" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "template" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "template" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;
export const ApiTokenForUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "apiTokenForUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "apiTokenForUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApiTokenForUserMutation,
  ApiTokenForUserMutationVariables
>;
export const SetUserDefaultProjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "setUserDefaultProject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "defaultProjectId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setUserDefaultProject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "defaultProjectId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "defaultProjectId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetUserDefaultProjectMutation,
  SetUserDefaultProjectMutationVariables
>;
export const VacationPlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "vacationPlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "month" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "VacationPlanFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "vacationPlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "month" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "month" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vacation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VacationPlanQuery, VacationPlanQueryVariables>;
export const VacationRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "vacationRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "VacationRequestListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "vacationRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "VacationRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VacationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VacationRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "halfDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VacationRequestsQuery,
  VacationRequestsQueryVariables
>;
export const CountVacationRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countVacationRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "VacationRequestListOptions" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countVacationRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountVacationRequestsQuery,
  CountVacationRequestsQueryVariables
>;
export const VacationRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "vacationRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "vacationRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "VacationRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VacationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VacationRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "halfDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VacationRequestQuery,
  VacationRequestQueryVariables
>;
export const DeleteVacationRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteVacationRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteVacationRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteVacationRequestMutation,
  DeleteVacationRequestMutationVariables
>;
export const MutateVacationRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateVacationRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "VacationRequestInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateVacationRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "VacationRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VacationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VacationRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "halfDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateVacationRequestMutation,
  MutateVacationRequestMutationVariables
>;
export const MutateVacationRequestCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateVacationRequestComment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateVacationRequestComment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "VacationRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VacationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VacationRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "halfDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateVacationRequestCommentMutation,
  MutateVacationRequestCommentMutationVariables
>;
export const FinalizeVacationRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "finalizeVacationRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "VacationRequestStatusInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "finalizeVacationRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "VacationRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VacationRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VacationRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "from" } },
          { kind: "Field", name: { kind: "Name", value: "to" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "halfDay" } },
          { kind: "Field", name: { kind: "Name", value: "startTime" } },
          { kind: "Field", name: { kind: "Name", value: "endTime" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "creatorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creator" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "editorId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "editor" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FinalizeVacationRequestMutation,
  FinalizeVacationRequestMutationVariables
>;
export const VacationOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "vacationOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "VacationOverviewFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "vacationOverview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "year" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "year" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "january" } },
                { kind: "Field", name: { kind: "Name", value: "february" } },
                { kind: "Field", name: { kind: "Name", value: "march" } },
                { kind: "Field", name: { kind: "Name", value: "april" } },
                { kind: "Field", name: { kind: "Name", value: "may" } },
                { kind: "Field", name: { kind: "Name", value: "june" } },
                { kind: "Field", name: { kind: "Name", value: "july" } },
                { kind: "Field", name: { kind: "Name", value: "august" } },
                { kind: "Field", name: { kind: "Name", value: "september" } },
                { kind: "Field", name: { kind: "Name", value: "october" } },
                { kind: "Field", name: { kind: "Name", value: "november" } },
                { kind: "Field", name: { kind: "Name", value: "december" } },
                { kind: "Field", name: { kind: "Name", value: "byContract" } },
                { kind: "Field", name: { kind: "Name", value: "entitled" } },
                { kind: "Field", name: { kind: "Name", value: "planned" } },
                { kind: "Field", name: { kind: "Name", value: "taken" } },
                { kind: "Field", name: { kind: "Name", value: "left" } },
                { kind: "Field", name: { kind: "Name", value: "residual" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VacationOverviewQuery,
  VacationOverviewQueryVariables
>;
export const VacationAvailableDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "vacationAvailable" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "VacationAvailableInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "vacationAvailable" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VacationAvailableQuery,
  VacationAvailableQueryVariables
>;
export const AvailableVacationDaysDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "availableVacationDays" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "year" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "availableVacationDays" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "year" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "year" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableVacationDaysQuery,
  AvailableVacationDaysQueryVariables
>;
export const WorktimesTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesTasks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimeTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "productive" } },
          { kind: "Field", name: { kind: "Name", value: "sidebar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowInCorrections" },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimesTasksQuery, WorktimesTasksQueryVariables>;
export const WorktimesTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimeTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "productive" } },
          { kind: "Field", name: { kind: "Name", value: "sidebar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowInCorrections" },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimesTaskQuery, WorktimesTaskQueryVariables>;
export const MutateWorktimesTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateWorktimesTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WorktimesTaskInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateWorktimesTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimeTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "productive" } },
          { kind: "Field", name: { kind: "Name", value: "sidebar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowInCorrections" },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateWorktimesTaskMutation,
  MutateWorktimesTaskMutationVariables
>;
export const DeleteWorktimesTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteWorktimesTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteWorktimesTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimeTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "productive" } },
          { kind: "Field", name: { kind: "Name", value: "sidebar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowInCorrections" },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteWorktimesTaskMutation,
  DeleteWorktimesTaskMutationVariables
>;
export const WorktimesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WorktimesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Worktime" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Worktime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerReviewDone" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimesQuery, WorktimesQueryVariables>;
export const WorktimesWithBillingCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesWithBillingCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WorktimesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Worktime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingCustomer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Worktime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerReviewDone" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesWithBillingCustomerQuery,
  WorktimesWithBillingCustomerQueryVariables
>;
export const CountWorktimesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countWorktimes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WorktimesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countWorktimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountWorktimesQuery, CountWorktimesQueryVariables>;
export const WorktimesWithoutUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesWithoutUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WorktimesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimeWoUser" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeWoUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesWithoutUserQuery,
  WorktimesWithoutUserQueryVariables
>;
export const SubscribeWorktimeDayStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "subscribeWorktimeDayStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimeDayStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "worktime" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "runningTask" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WorktimeWoUser" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeWoUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscribeWorktimeDayStatusSubscription,
  SubscribeWorktimeDayStatusSubscriptionVariables
>;
export const WorktimeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktime" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktime" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Worktime" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Worktime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerReviewDone" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorktimeQuery, WorktimeQueryVariables>;
export const WorktimeWithBillingCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimeWithBillingCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktime" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Worktime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingCustomer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Worktime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerReviewDone" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimeWithBillingCustomerQuery,
  WorktimeWithBillingCustomerQueryVariables
>;
export const WorktimeStartEndValidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimeStartEndValid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WorktimeValidationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimeStartEndValid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "valid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "worktimes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Worktime" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Worktime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerReviewDone" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimeStartEndValidQuery,
  WorktimeStartEndValidQueryVariables
>;
export const WorktimeMutationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "worktimeMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "worktime" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WorktimeInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "byContract" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "days" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateWorktime" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "worktime" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "worktime" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "byContract" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "byContract" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "days" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "days" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Worktime" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Worktime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerReviewDone" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimeMutationMutation,
  WorktimeMutationMutationVariables
>;
export const DeleteWorktimeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteWorktime" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteWorktime" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteWorktimeMutation,
  DeleteWorktimeMutationVariables
>;
export const StartWorktimeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "startWorktime" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "taskId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startWorktime" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "taskId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "taskId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimeWoUser" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeWoUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartWorktimeMutation,
  StartWorktimeMutationVariables
>;
export const StopCurrentWorktimeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "stopCurrentWorktime" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stopCurrentWorktime" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimeWoUser" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeWoUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StopCurrentWorktimeMutation,
  StopCurrentWorktimeMutationVariables
>;
export const ConfirmDayWorktimesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmDayWorktimes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmDayWorktimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "date" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmDayWorktimesMutation,
  ConfirmDayWorktimesMutationVariables
>;
export const DeclineDayWorktimesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "declineDayWorktimes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "date" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NaiveDate" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reason" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "declineDayWorktimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "date" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "date" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reason" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeclineDayWorktimesMutation,
  DeclineDayWorktimesMutationVariables
>;
export const WorktimesWithCustomerDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesWithCustomerData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WorktimesListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Worktime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billingCustomer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Worktime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "customerReviewDone" },
          },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taskId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesWithCustomerDataQuery,
  WorktimesWithCustomerDataQueryVariables
>;
export const WorktimesByCustomerSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesByCustomerSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WorktimesByCustomerFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesByCustomerSummary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customerId" } },
                { kind: "Field", name: { kind: "Name", value: "seconds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "productiveSeconds" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "worktimesCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumb" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "medium" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesByCustomerSummaryQuery,
  WorktimesByCustomerSummaryQueryVariables
>;
export const WorktimesByCustomerPerUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesByCustomerPerUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "targetCustomerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WorktimesByCustomerFilters" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesByCustomerPerUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetCustomerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "targetCustomerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "seconds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "productiveSeconds" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "worktimesCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "User" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesByCustomerPerUserQuery,
  WorktimesByCustomerPerUserQueryVariables
>;
export const WorktimesConfirmCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "worktimesConfirmCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "worktimeIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "StringNumber" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesConfirmCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "worktimeIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "worktimeIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesConfirmCustomerMutation,
  WorktimesConfirmCustomerMutationVariables
>;
export const WorktimesMutateCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "worktimesMutateCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "WorktimesCustomerInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesMutateCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesMutateCustomerMutation,
  WorktimesMutateCustomerMutationVariables
>;
export const WorktimeDayStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimeDayStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimeDayStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "worktime" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "runningTask" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WorktimeWoUser" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimeWoUser" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Worktime" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "declined" } },
          { kind: "Field", name: { kind: "Name", value: "declineReason" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "paid" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimeDayStatusQuery,
  WorktimeDayStatusQueryVariables
>;
export const WorktimesChangeRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesChangeRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WorktimesChangeRequestListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesChangeRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimesChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesChangeRequestsQuery,
  WorktimesChangeRequestsQueryVariables
>;
export const CountWorktimesChangeRequestsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "countWorktimesChangeRequests" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WorktimesChangeRequestListFilters" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countWorktimesChangeRequests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountWorktimesChangeRequestsQuery,
  CountWorktimesChangeRequestsQueryVariables
>;
export const WorktimesChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "worktimesChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "worktimesChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimesChangeRequest" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "WorktimesChangeRequestEntry",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequestTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "paid" } },
          { kind: "Field", name: { kind: "Name", value: "productive" } },
          { kind: "Field", name: { kind: "Name", value: "sidebar" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "allowInCorrections" },
          },
          { kind: "Field", name: { kind: "Name", value: "position" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "acdId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequestEntry" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequestEntry" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "starts" } },
          { kind: "Field", name: { kind: "Name", value: "stops" } },
          { kind: "Field", name: { kind: "Name", value: "billingCustomerId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "task" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimesChangeRequestTask" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingCustomer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WorktimesChangeRequestQuery,
  WorktimesChangeRequestQueryVariables
>;
export const MutateWorktimesChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateWorktimesChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StringNumber" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "values" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WorktimesChangeRequestInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateWorktimesChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "values" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "values" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimesChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateWorktimesChangeRequestMutation,
  MutateWorktimesChangeRequestMutationVariables
>;
export const DeleteWorktimesChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteWorktimesChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteWorktimesChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteWorktimesChangeRequestMutation,
  DeleteWorktimesChangeRequestMutationVariables
>;
export const InquireWorktimesChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "inquireWorktimesChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inquireWorktimesChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimesChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InquireWorktimesChangeRequestMutation,
  InquireWorktimesChangeRequestMutationVariables
>;
export const RejectWorktimesChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "rejectWorktimesChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rejectWorktimesChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "comment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "comment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimesChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RejectWorktimesChangeRequestMutation,
  RejectWorktimesChangeRequestMutationVariables
>;
export const ApproveWorktimesChangeRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "approveWorktimesChangeRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StringNumber" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "approveWorktimesChangeRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "WorktimesChangeRequest" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserAvatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UserAvatar" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "thumb" } },
          { kind: "Field", name: { kind: "Name", value: "medium" } },
          { kind: "Field", name: { kind: "Name", value: "original" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "User" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "username" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "active" } },
          { kind: "Field", name: { kind: "Name", value: "retired" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "homeoffice" } },
          { kind: "Field", name: { kind: "Name", value: "bio" } },
          { kind: "Field", name: { kind: "Name", value: "customerId" } },
          { kind: "Field", name: { kind: "Name", value: "attrs" } },
          { kind: "Field", name: { kind: "Name", value: "lastSeenAt" } },
          { kind: "Field", name: { kind: "Name", value: "passwordReset" } },
          { kind: "Field", name: { kind: "Name", value: "otp" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billableCustomerId" },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultProjectId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserAvatar" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstname" } },
                { kind: "Field", name: { kind: "Name", value: "lastname" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "birthdate" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WorktimesChangeRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WorktimesChangeRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "comment" } },
          { kind: "Field", name: { kind: "Name", value: "adminComment" } },
          { kind: "Field", name: { kind: "Name", value: "insertedAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "User" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApproveWorktimesChangeRequestMutation,
  ApproveWorktimesChangeRequestMutationVariables
>;
